import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
  Token: any;
  Upload: any;
};

export type AccessCode = {
  __typename?: 'AccessCode';
  cardCode?: Maybe<Scalars['String']>;
  controllerUnitAccessCodes: Array<ControllerUnitAccessCode>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  fullAccessToDoorGroups: Array<ControllerDoorGroup>;
  fullAccessToDoors: Array<ControllerDoor>;
  id: Scalars['String'];
  latestSyncAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pinCode: Scalars['String'];
  type: AccessCodeType;
  usedCount: Scalars['Int'];
  user?: Maybe<User>;
};


export type AccessCodeControllerUnitAccessCodesArgs = {
  after?: InputMaybe<ControllerUnitAccessCodeWhereUniqueInput>;
  before?: InputMaybe<ControllerUnitAccessCodeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AccessCodeAccessTime = {
  __typename?: 'AccessCodeAccessTime';
  accessCode: AccessCode;
  createdAt: Scalars['DateTime'];
  doorGroups: Array<ControllerDoorGroup>;
  doors: Array<ControllerDoor>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  resourceBooking?: Maybe<ResourceBooking>;
  resourceBookingAttendee?: Maybe<ResourceBookingAttendee>;
  startDate: Scalars['DateTime'];
  workshopDay?: Maybe<WorkshopDay>;
};


export type AccessCodeAccessTimeDoorGroupsArgs = {
  after?: InputMaybe<ControllerDoorGroupWhereUniqueInput>;
  before?: InputMaybe<ControllerDoorGroupWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type AccessCodeAccessTimeDoorsArgs = {
  after?: InputMaybe<ControllerDoorWhereUniqueInput>;
  before?: InputMaybe<ControllerDoorWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AccessCodeAccessTimesFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type AccessCodeAccessTimesResult = Pagination & {
  __typename?: 'AccessCodeAccessTimesResult';
  data: Array<AccessCodeAccessTime>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type AccessCodeCreate = {
  cardCode?: InputMaybe<Scalars['String']>;
  fullAccessToDoorGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fullAccessToDoors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name: Scalars['String'];
  pinCode: Scalars['String'];
};

export type AccessCodeDataMessage = {
  __typename?: 'AccessCodeDataMessage';
  currentBooking?: Maybe<ResourceBooking>;
  name: Scalars['String'];
  nextBooking?: Maybe<ResourceBooking>;
};

export enum AccessCodeType {
  Company = 'Company',
  Custom = 'Custom',
  User = 'User'
}

export type AccessCodeUpdate = {
  cardCode?: InputMaybe<Scalars['String']>;
  controllerUnitId?: InputMaybe<Scalars['String']>;
  fullAccessToDoorGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fullAccessToDoors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  noxVersion?: InputMaybe<NoxVersion>;
  pinCode?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type AccessCodeUsage = {
  __typename?: 'AccessCodeUsage';
  accessCode: AccessCode;
  createdAt: Scalars['DateTime'];
  door: ControllerDoor;
  id: Scalars['String'];
};

export type AccessCodeUsageSubscriptionPayload = {
  __typename?: 'AccessCodeUsageSubscriptionPayload';
  accessCodeUsage: AccessCodeUsage;
  dataForMessage: AccessCodeDataMessage;
};

export type AccessCodeUsagesFiltering = {
  accessCode?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
};

export type AccessCodeUsagesResult = Pagination & {
  __typename?: 'AccessCodeUsagesResult';
  data: Array<AccessCodeUsage>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type AccessCodesFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type AccessCodesResult = Pagination & {
  __typename?: 'AccessCodesResult';
  data: Array<AccessCode>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type AccountingLine = {
  __typename?: 'AccountingLine';
  accountingProgramExternalUrl?: Maybe<Scalars['String']>;
  dineroVoucherId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  registeredInAccountingProgram?: Maybe<AccountingProgram>;
};

export enum AccountingProgram {
  Dinero = 'Dinero',
  Economic = 'Economic',
  ManualEmail = 'ManualEmail',
  MsBusinessCentral = 'MsBusinessCentral'
}

export type AdditionalService = {
  __typename?: 'AdditionalService';
  additionalInfo: Array<AdditionalServiceInfoType>;
  additionalInfoRequired?: Maybe<Scalars['Boolean']>;
  capacity?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  product: Product;
  resourceCategory?: Maybe<ResourceCategory>;
};

export type AdditionalServiceCreate = {
  capacity?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  resourceCategoryId?: InputMaybe<Scalars['String']>;
};

export enum AdditionalServiceInfoType {
  AgeChild = 'AgeChild',
  NameChild = 'NameChild'
}

export type AdditionalServiceUpdate = {
  capacity?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  resourceCategoryId?: InputMaybe<Scalars['String']>;
};

export type Agreement = {
  __typename?: 'Agreement';
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  documentUrl: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  name: Scalars['String'];
  requiredAccept: Scalars['Boolean'];
  showWhen: AgreementShowWhen;
  type: AgreementType;
  updatedAt: Scalars['DateTime'];
  updatedDates: Array<Scalars['DateTime']>;
  userAccptedAgreementsCount: Scalars['Int'];
  userAgreements: Array<UserAgreement>;
  userAgreementsCount: Scalars['Int'];
  usersTotal: Scalars['Int'];
};


export type AgreementUserAgreementsArgs = {
  after?: InputMaybe<UserAgreementWhereUniqueInput>;
  before?: InputMaybe<UserAgreementWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AgreementCreate = {
  description?: InputMaybe<Scalars['String']>;
  document: Scalars['Upload'];
  name: Scalars['String'];
  requiredAccept?: InputMaybe<Scalars['Boolean']>;
  showWhen: AgreementShowWhen;
  type: AgreementType;
};

export enum AgreementShowWhen {
  CreateUserProductSubscription = 'CreateUserProductSubscription',
  None = 'None',
  UserSignUpCompany = 'UserSignUpCompany'
}

export enum AgreementType {
  Newsletter = 'Newsletter',
  PrivacyPolicy = 'PrivacyPolicy',
  TermsOfTrade = 'TermsOfTrade',
  UserSubscription = 'UserSubscription'
}

export type AgreementUpdate = {
  createNewLastUpdated: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AgreementsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type AgreementsForUserFiltering = {
  search?: InputMaybe<Scalars['String']>;
  showWhen?: InputMaybe<AgreementShowWhen>;
  type?: InputMaybe<AgreementType>;
  userHasAccpted?: InputMaybe<Scalars['Boolean']>;
  userHasMadeDecision?: InputMaybe<Scalars['Boolean']>;
};

export type AgreementsResult = Pagination & {
  __typename?: 'AgreementsResult';
  data: Array<Agreement>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type Analytic = {
  __typename?: 'Analytic';
  activeMemberBookingsCount: Scalars['Int'];
  activeMembersResourceBookingHours: Scalars['Float'];
  appRealTimeUsers: Scalars['Int'];
  appSessionsChart: Array<Chart>;
  appSessionsCount: Scalars['Int'];
  applicationFeeAvgPrPayment: Scalars['Float'];
  applicationFeeSum: Scalars['Float'];
  applicationFeeSumChart: Array<Chart>;
  avgRevenuePrUser: Scalars['Float'];
  companiesCount: Scalars['Int'];
  company?: Maybe<Scalars['ID']>;
  franchise?: Maybe<Scalars['ID']>;
  fromDate: Scalars['String'];
  futureMessagesCount: Scalars['Int'];
  messagesCount: Scalars['Int'];
  newResourceBookingsCount: Scalars['Int'];
  newResourceBookingsCountChart: Array<Chart>;
  newResourceBookingsHours: Scalars['Float'];
  newUsersChart: Array<Chart>;
  newUsersCount: Scalars['Int'];
  newWorkshopBookingsCount: Scalars['Int'];
  paymentMethodsApplicationFee: Array<PaymentMethodApplicationFeeAnalytic>;
  paymentMethodsUsage: Array<AnalyticTitleValue>;
  paymentsCount: Scalars['Int'];
  paymentsCountChart: Array<Chart>;
  paymentsSum: Scalars['Float'];
  paymentsSumChart: Array<Chart>;
  pointUsageSum: Scalars['Int'];
  pointsRatio: Scalars['Float'];
  pointsTotalAmount: Scalars['Float'];
  possiblePercentageResourceBooked: Scalars['Float'];
  possiblePercentageResourceBookedChart: Scalars['String'];
  refundsCount: Scalars['Int'];
  refundsCountChart: Array<Chart>;
  refundsSum: Scalars['Float'];
  refundsSumChart: Array<Chart>;
  resourceBookingCreateSteps: Array<AnalyticTitleValue>;
  resourceBookingsAvgBetweenCreatedAndStart: Scalars['Float'];
  resourceBookingsAvgDurationMinutes: Scalars['Float'];
  resourceBookingsCancledHours: Scalars['Float'];
  resourceBookingsCount: Scalars['Int'];
  resourceBookingsCreatedChart: Scalars['String'];
  resourceBookingsHours: Scalars['Float'];
  resourceBookingsHoursChart: Array<Chart>;
  resourceBookingsPrUserPrWeek: Scalars['Float'];
  signInMethods: Array<AnalyticTitleValue>;
  subscriptionsActivityChart: Array<Chart>;
  subscriptionsActivityCount: Scalars['Int'];
  subscriptionsFuturePaymentsValue: Scalars['Float'];
  subscriptionsIncomeSumChart: Array<Chart>;
  subscriptionsIncomeSumMonthly: Scalars['Float'];
  subscriptionsIncomeSumYearly: Scalars['Float'];
  subscriptionsStatusCount: Scalars['Int'];
  subscriptionsStatusPieChart: Array<AnalyticTitleValueStatus>;
  toDate: Scalars['String'];
  user?: Maybe<Scalars['ID']>;
  usersAge: Array<Scalars['Int']>;
  usersAgeAvg: Scalars['Float'];
  usersCount: Scalars['Int'];
  usersCountDefaultLocation: Scalars['Int'];
  usersGender: Array<AnalyticTitleValue>;
  usersLocation: Scalars['String'];
};


export type AnalyticActiveMembersResourceBookingHoursArgs = {
  status?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
};


export type AnalyticPaymentsCountArgs = {
  user?: InputMaybe<Scalars['ID']>;
};


export type AnalyticPaymentsSumArgs = {
  onlyResourceBookings?: InputMaybe<Scalars['Boolean']>;
};


export type AnalyticPointsRatioArgs = {
  beforeDate?: InputMaybe<Scalars['DateTime']>;
};


export type AnalyticPossiblePercentageResourceBookedChartArgs = {
  resourceType?: InputMaybe<Scalars['ID']>;
};


export type AnalyticRefundsCountArgs = {
  user?: InputMaybe<Scalars['ID']>;
};


export type AnalyticResourceBookingsCountArgs = {
  status?: InputMaybe<BookingStatus>;
};


export type AnalyticResourceBookingsHoursArgs = {
  status?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
};


export type AnalyticResourceBookingsPrUserPrWeekArgs = {
  dontCountUsersWithZeroBookings?: InputMaybe<Scalars['Boolean']>;
};


export type AnalyticSubscriptionsActivityChartArgs = {
  type?: InputMaybe<UserProductSubscriptionActivityType>;
};


export type AnalyticSubscriptionsActivityCountArgs = {
  type?: InputMaybe<UserProductSubscriptionActivityType>;
};


export type AnalyticSubscriptionsFuturePaymentsValueArgs = {
  valueAfterDate?: InputMaybe<Scalars['DateTime']>;
};


export type AnalyticSubscriptionsStatusCountArgs = {
  status?: InputMaybe<Array<InputMaybe<UserProductSubscriptionStatus>>>;
};


export type AnalyticUsersCountDefaultLocationArgs = {
  location?: InputMaybe<Scalars['ID']>;
};

export type AnalyticBookingSlots = {
  date: Scalars['DateTime'];
  location?: InputMaybe<Scalars['ID']>;
  targetType: BookingSlotTargetTypes;
};

export type AnalyticCompanySinceCreatedAt = {
  __typename?: 'AnalyticCompanySinceCreatedAt';
  for: Scalars['String'];
  result: Scalars['String'];
};

export type AnalyticSmart = {
  __typename?: 'AnalyticSmart';
  avgBasedOnDays: Scalars['Int'];
  for: Scalars['String'];
  lifeTimeValueBasedOnDays: Scalars['Int'];
  result: Scalars['String'];
};

export type AnalyticTitleValue = {
  __typename?: 'AnalyticTitleValue';
  title: Scalars['String'];
  value: Scalars['Float'];
};

export type AnalyticTitleValueStatus = {
  __typename?: 'AnalyticTitleValueStatus';
  status: Scalars['String'];
  title: Scalars['String'];
  value: Scalars['Float'];
};

export type AppleSignInInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type AuthPlacesForSignUpResult = CompanyForSignUp | FranchiseForSignUp;

export type AuthUrlSlugResponse = Company | Franchise;

export type BlockedPhone = {
  __typename?: 'BlockedPhone';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  phoneNumber: Scalars['String'];
  reason: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Booking = ResourceBooking | WorkshopBooking;

export enum BookingFlow {
  Standard = 'Standard'
}

export enum BookingSlotTargetTypes {
  A = 'A',
  AllDay = 'AllDay',
  B = 'B',
  C = 'C',
  D = 'D'
}

export enum BookingStatus {
  Booked = 'Booked',
  Canceled = 'Canceled',
  ReservationCanceled = 'ReservationCanceled',
  ReservedCompany = 'ReservedCompany',
  ReservedUser = 'ReservedUser',
  ReservedUserGroup = 'ReservedUserGroup'
}

export enum BookingType {
  ResourceBooking = 'ResourceBooking',
  WorkshopBooking = 'WorkshopBooking'
}

export type BookingsFiltering = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
  type?: InputMaybe<BookingType>;
  user?: InputMaybe<Scalars['ID']>;
};

export type BookliCamera = {
  __typename?: 'BookliCamera';
  id: Scalars['String'];
  location: Location;
  milestoneCameraId?: Maybe<Scalars['String']>;
  milestoneWebClientCamUrl: Scalars['String'];
  name: Scalars['String'];
  resourceCamera: Array<Resource>;
  stillImage?: Maybe<Scalars['String']>;
  stillImageUrl?: Maybe<Scalars['String']>;
  type: BookliCameraType;
};


export type BookliCameraResourceCameraArgs = {
  after?: InputMaybe<ResourceWhereUniqueInput>;
  before?: InputMaybe<ResourceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type BookliCameraCreate = {
  location: Scalars['ID'];
  milestoneWebClientCamUrl: Scalars['String'];
  name: Scalars['String'];
  stillImage?: InputMaybe<Scalars['Upload']>;
};

export type BookliCameraServer = {
  __typename?: 'BookliCameraServer';
  cameras: Array<BookliCamera>;
  exportIsEnabled: Scalars['Boolean'];
  id: Scalars['String'];
  location: Location;
  locationId: Scalars['String'];
  milestoneClientUrl: Scalars['String'];
  milestoneServerPassword?: Maybe<Scalars['String']>;
  milestoneServerUrl?: Maybe<Scalars['String']>;
  milestoneServerUsername?: Maybe<Scalars['String']>;
  type: BookliCameraServerType;
};

export type BookliCameraServerCreate = {
  location: Scalars['ID'];
  milestoneFileServerUrl?: InputMaybe<Scalars['String']>;
  milestoneServerPassword?: InputMaybe<Scalars['String']>;
  milestoneServerUrl?: InputMaybe<Scalars['String']>;
  milestoneServerUsername?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<BookliCameraServerType>;
};

export enum BookliCameraServerType {
  Milestone = 'Milestone'
}

export enum BookliCameraType {
  Milestone = 'Milestone'
}

export type BookliCameraUpdate = {
  name?: InputMaybe<Scalars['String']>;
};

export type BookliCameraWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  milestoneCameraId?: InputMaybe<Scalars['String']>;
};

export type BookliCamerasFiltering = {
  company?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  resource?: InputMaybe<Scalars['ID']>;
};

export type BookliCamerasResult = Pagination & {
  __typename?: 'BookliCamerasResult';
  data: Array<BookliCamera>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type BookliDevice = {
  __typename?: 'BookliDevice';
  id: Scalars['ID'];
};

export type BookliDeviceUpdate = {
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type BookliDeviceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BookliDevicesFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type BookliDevicesResult = Pagination & {
  __typename?: 'BookliDevicesResult';
  data: Array<BookliDevice>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type BookliNetwork = {
  __typename?: 'BookliNetwork';
  id: Scalars['ID'];
};

export type BookliScreenHealthSubscriptionPayload = {
  __typename?: 'BookliScreenHealthSubscriptionPayload';
  shouldReload: Scalars['Boolean'];
};

export type BookliSound = {
  __typename?: 'BookliSound';
  id: Scalars['String'];
  location: Location;
  name: Scalars['String'];
  play: Scalars['Boolean'];
  volume: Scalars['Int'];
  youtubePlayId: Scalars['String'];
};

export type BookliSoundCreate = {
  location: Scalars['ID'];
  name: Scalars['String'];
  youtubePlayId: Scalars['String'];
};

export type BookliSoundWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BookliVideo = {
  __typename?: 'BookliVideo';
  allowedToEdit: Scalars['Boolean'];
  allowedToView: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  masterVideo?: Maybe<BookliVideo>;
  muxPlaybackId?: Maybe<Scalars['String']>;
  resourceBooking?: Maybe<ResourceBooking>;
  resourceBookingId?: Maybe<Scalars['String']>;
  state: BookliVideoState;
  streamUrl?: Maybe<Scalars['String']>;
  subClips: Array<BookliVideo>;
  type: BookliVideoType;
  videoEndDate?: Maybe<Scalars['DateTime']>;
  videoReadyAt: Scalars['DateTime'];
  videoStartDate?: Maybe<Scalars['DateTime']>;
};


export type BookliVideoSubClipsArgs = {
  after?: InputMaybe<BookliVideoWhereUniqueInput>;
  before?: InputMaybe<BookliVideoWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type BookliVideoCreateSubClip = {
  bookliVideo: Scalars['ID'];
  endTimeSeconds: Scalars['Float'];
  startTimeSeconds: Scalars['Float'];
};

export enum BookliVideoState {
  Deleted = 'Deleted',
  Done = 'Done',
  MuxError = 'MuxError',
  MuxProcessing = 'MuxProcessing',
  New = 'New'
}

export enum BookliVideoType {
  Master = 'Master',
  SubClip = 'SubClip'
}

export type BookliVideoWhereUniqueInput = {
  downloadUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  muxAssetId?: InputMaybe<Scalars['String']>;
  muxPlaybackId?: InputMaybe<Scalars['String']>;
  resourceBookingId?: InputMaybe<Scalars['String']>;
};

export type BusinessUser = {
  __typename?: 'BusinessUser';
  businessName: Scalars['String'];
  id: Scalars['ID'];
  vatNumber: Scalars['String'];
};

export type CanCreateSmallResult = {
  __typename?: 'CanCreateSmallResult';
  endDate: Scalars['DateTime'];
  resource: Resource;
  startDate: Scalars['DateTime'];
};

export type Chart = {
  __typename?: 'Chart';
  x: Scalars['String'];
  y: Scalars['Float'];
};

export type ChartGeneratorResult = {
  __typename?: 'ChartGeneratorResult';
  categories: Array<Scalars['String']>;
  series: Array<ChartGeneratorResultSeries>;
};

export type ChartGeneratorResultSeries = {
  __typename?: 'ChartGeneratorResultSeries';
  data: Array<Scalars['Float']>;
  value: Scalars['String'];
};

export enum ChartTimeType {
  Day = 'Day',
  HalfHour = 'HalfHour',
  Hour = 'Hour'
}

export type CompaniesFiltering = {
  allowSignUps?: InputMaybe<Scalars['Boolean']>;
  franchise?: InputMaybe<Scalars['ID']>;
};

export type CompaniesResult = Pagination & {
  __typename?: 'CompaniesResult';
  data: Array<Company>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type Company = {
  __typename?: 'Company';
  analyticApplicationFee: CompanyApplicationFeeAnalytic;
  analyticPaymentRevenue: CompanyPaymentRevenueAnalytic;
  analyticUsers: CompanyUsersAnalytic;
  city: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  country: SupportedCountries;
  currency: Currency;
  dopagoIntegration?: Maybe<DopagoIntegration>;
  email: Scalars['String'];
  footerImageInMail?: Maybe<Scalars['String']>;
  footerImageInMailUrl?: Maybe<Scalars['String']>;
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  location: Location;
  locations: Array<Location>;
  locationsHasMoreThanOne: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  mapIcon?: Maybe<Scalars['String']>;
  mapIconUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner: UserPlatformConnection;
  phoneNumber: Scalars['String'];
  pointAccountUsingFranchise: Scalars['Boolean'];
  pointProductsUsingFranchise: Scalars['Boolean'];
  resourceBookings: Array<ResourceBooking>;
  resourceTypes: Array<ResourceType>;
  resources: Array<Resource>;
  settings?: Maybe<CompanySetting>;
  slug: Scalars['String'];
  streetName: Scalars['String'];
  stripeConnection?: Maybe<StripeConnection>;
  subscriptionProducts: Array<SubscriptionProduct>;
  timezone: Timezone;
  userPlatformConnection?: Maybe<UserPlatformConnection>;
  userPlatformConnectionTokens: Array<UserPlatformConnectionToken>;
  userPlatformConnections: Array<UserPlatformConnection>;
  usingEcom: Scalars['Boolean'];
  usingMobilePayInvoice: Scalars['Boolean'];
  usingPointProducts: Scalars['Boolean'];
  usingStripe: Scalars['Boolean'];
  usingSubscriptionProducts: Scalars['Boolean'];
  workshopBookings: Array<WorkshopBooking>;
  zipCode: Scalars['String'];
};


export type CompanyAnalyticApplicationFeeArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type CompanyAnalyticPaymentRevenueArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type CompanyAnalyticUsersArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type CompanyLocationsArgs = {
  after?: InputMaybe<LocationWhereUniqueInput>;
  before?: InputMaybe<LocationWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyResourceBookingsArgs = {
  after?: InputMaybe<ResourceBookingWhereUniqueInput>;
  before?: InputMaybe<ResourceBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyResourceTypesArgs = {
  after?: InputMaybe<ResourceTypeWhereUniqueInput>;
  before?: InputMaybe<ResourceTypeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyResourcesArgs = {
  after?: InputMaybe<ResourceWhereUniqueInput>;
  before?: InputMaybe<ResourceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanySubscriptionProductsArgs = {
  after?: InputMaybe<SubscriptionProductWhereUniqueInput>;
  before?: InputMaybe<SubscriptionProductWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyUserPlatformConnectionArgs = {
  prefereUserRole?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyUserPlatformConnectionTokensArgs = {
  after?: InputMaybe<UserPlatformConnectionTokenWhereUniqueInput>;
  before?: InputMaybe<UserPlatformConnectionTokenWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyUserPlatformConnectionsArgs = {
  after?: InputMaybe<UserPlatformConnectionWhereUniqueInput>;
  before?: InputMaybe<UserPlatformConnectionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyWorkshopBookingsArgs = {
  after?: InputMaybe<WorkshopBookingWhereUniqueInput>;
  before?: InputMaybe<WorkshopBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CompanyApplicationFeeAnalytic = {
  __typename?: 'CompanyApplicationFeeAnalytic';
  avgPrResource: Scalars['Float'];
  company: Company;
  fromDate: Scalars['String'];
  sum: Scalars['Float'];
  toDate: Scalars['String'];
};

export type CompanyCreate = {
  city: Scalars['String'];
  country: SupportedCountries;
  email: Scalars['String'];
  language: Language;
  name: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  slug: Scalars['String'];
  streetName: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CompanyCreateInvitation = {
  __typename?: 'CompanyCreateInvitation';
  connectToFranchise?: Maybe<Scalars['String']>;
  createFranchise: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy: CompanyCreateInvitationCreatedBy;
  email: Scalars['String'];
  id: Scalars['String'];
  token: Scalars['String'];
};

export enum CompanyCreateInvitationCreatedBy {
  Admin = 'Admin',
  Franchise = 'Franchise',
  Manually = 'Manually'
}

export type CompanyCreateInvitationSend = {
  createFranchise?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
};

export type CompanyCreateInvitationsFiltering = {
  createdBy?: InputMaybe<CompanyCreateInvitationCreatedBy>;
};

export type CompanyCreateInvitationsResult = Pagination & {
  __typename?: 'CompanyCreateInvitationsResult';
  data: Array<CompanyCreateInvitation>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type CompanyForSignUp = {
  __typename?: 'CompanyForSignUp';
  id: Scalars['ID'];
  isCompany: Scalars['Boolean'];
  locations: Array<Location>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  streetName: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CompanyLang = {
  __typename?: 'CompanyLang';
  language: Language;
};

export type CompanyPaymentRevenueAnalytic = {
  __typename?: 'CompanyPaymentRevenueAnalytic';
  avgPrResource: Scalars['Float'];
  company: Company;
  fromDate: Scalars['String'];
  sum: Scalars['Float'];
  toDate: Scalars['String'];
};

export type CompanySetting = {
  __typename?: 'CompanySetting';
  appBackgroundImage?: Maybe<Scalars['String']>;
  appBackgroundImageUrl?: Maybe<Scalars['String']>;
  company: Company;
  companyId: Scalars['String'];
  id: Scalars['String'];
  messagePointBuy?: Maybe<Scalars['String']>;
  messageResourceBookingCreated?: Maybe<Scalars['String']>;
  messageResourceBookingReminder?: Maybe<Scalars['String']>;
  messageUserWelcome?: Maybe<Scalars['String']>;
  pointTransactionPlatformFeePercentage: Scalars['Float'];
  pointTransactionPlatformStatic: Scalars['Float'];
  primaryColor?: Maybe<Scalars['String']>;
  userHomeAdSpace1ImgUrl?: Maybe<Scalars['String']>;
  userHomeAdSpace1Link?: Maybe<Scalars['String']>;
  userHomeAdSpaceImage?: Maybe<Scalars['String']>;
};

export type CompanySettingUpdate = {
  id?: InputMaybe<Scalars['ID']>;
  messagePointBuy?: InputMaybe<Scalars['String']>;
  messageResourceBookingCreated?: InputMaybe<Scalars['String']>;
  messageResourceBookingReminder?: InputMaybe<Scalars['String']>;
  messageUserWelcome?: InputMaybe<Scalars['String']>;
  pointTransactionPlatformFeePercentage?: InputMaybe<Scalars['Float']>;
  pointTransactionPlatformStatic?: InputMaybe<Scalars['Float']>;
  userHomeAdSpace1Img?: InputMaybe<Scalars['Upload']>;
  userHomeAdSpace1Link?: InputMaybe<Scalars['String']>;
};

export type CompanyUpdate = {
  footerImageInMailImage?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CompanyUsersAnalytic = {
  __typename?: 'CompanyUsersAnalytic';
  avgPrResource: Scalars['Float'];
  company: Company;
  fromDate: Scalars['String'];
  sum: Scalars['Float'];
  toDate: Scalars['String'];
};

export type CompanyWhereUniqueInput = {
  dineroConnectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  manualAccountingConnectionId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  userPlatformConnectionId?: InputMaybe<Scalars['String']>;
};

export type CompanyWithFees = {
  __typename?: 'CompanyWithFees';
  companySettings: CompanySetting;
  currency: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  stripeConnection?: Maybe<StripeConnection>;
};

export type ControllerDoor = {
  __typename?: 'ControllerDoor';
  camera?: Maybe<BookliCamera>;
  controller: ControllerUnit;
  defaultOpenSeconds: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  noxAreaDoorId?: Maybe<Scalars['Int']>;
  noxAreaDoorName?: Maybe<Scalars['String']>;
  visibleForCompany: Scalars['Boolean'];
};

export type ControllerDoorCreate = {
  location: Scalars['ID'];
  name: Scalars['String'];
  noxAreaDoorId: Scalars['Int'];
  noxAreaDoorName: Scalars['String'];
};

export type ControllerDoorGroup = {
  __typename?: 'ControllerDoorGroup';
  doors: Array<ControllerDoor>;
  id: Scalars['String'];
  name: Scalars['String'];
};


export type ControllerDoorGroupDoorsArgs = {
  after?: InputMaybe<ControllerDoorWhereUniqueInput>;
  before?: InputMaybe<ControllerDoorWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ControllerDoorGroupCreate = {
  doors: Array<Scalars['ID']>;
  name: Scalars['String'];
};

export type ControllerDoorGroupUpdate = {
  controllerUnitId?: InputMaybe<Scalars['ID']>;
  fullAccessToDoors?: InputMaybe<Array<Scalars['String']>>;
  noxVersion?: InputMaybe<NoxVersion>;
};

export type ControllerDoorGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ControllerDoorGroupsResult = Pagination & {
  __typename?: 'ControllerDoorGroupsResult';
  data: Array<ControllerDoorGroup>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ControllerDoorLog = {
  __typename?: 'ControllerDoorLog';
  changedBy: Scalars['String'];
  createdAt: Scalars['DateTime'];
  door: ControllerDoor;
  newState: Scalars['Int'];
};

export type ControllerDoorSetState = {
  autoSwitchOff?: InputMaybe<Scalars['Boolean']>;
  controllerDoor: Scalars['ID'];
  controllerUrl?: InputMaybe<Scalars['String']>;
  noxAreaId?: InputMaybe<Scalars['Int']>;
  noxVersion?: InputMaybe<NoxVersion>;
  secondsOpen?: InputMaybe<Scalars['Int']>;
  unlock?: InputMaybe<Scalars['Boolean']>;
};

export type ControllerDoorUpdate = {
  name?: InputMaybe<Scalars['String']>;
  noxAreaDoorId?: InputMaybe<Scalars['Int']>;
  noxAreaDoorName?: InputMaybe<Scalars['String']>;
};

export type ControllerDoorWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  keyExternalId?: InputMaybe<Scalars['String']>;
};

export type ControllerDoorsFiltering = {
  location?: InputMaybe<Scalars['ID']>;
  onlyShowAllowedDoors?: InputMaybe<Scalars['Boolean']>;
};

export type ControllerDoorsResult = Pagination & {
  __typename?: 'ControllerDoorsResult';
  data: Array<ControllerDoor>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ControllerNoxArea = {
  __typename?: 'ControllerNoxArea';
  allowedAreaStates: Array<Scalars['Int']>;
  areaId: Scalars['ID'];
  areaStateId: Scalars['Int'];
  areasLastUpdatedAt: Scalars['DateTime'];
  lastAreaStateChangeDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ControllerNoxTimeprofile = {
  __typename?: 'ControllerNoxTimeprofile';
  noxTimeprofileId: Scalars['Int'];
  noxTimeprofileName: Scalars['String'];
};

export type ControllerOnOff = {
  __typename?: 'ControllerOnOff';
  controller: ControllerUnit;
  id: Scalars['String'];
  noxAreaId?: Maybe<Scalars['Int']>;
  noxAreaName?: Maybe<Scalars['String']>;
  onOffTimeprofile?: Maybe<ControllerOnOffTimeprofile>;
  resource?: Maybe<Resource>;
  type: ControllerOnOffType;
};

export enum ControllerOnOffChangedBy {
  Controller = 'Controller',
  System = 'System',
  Unknown = 'Unknown',
  User = 'User'
}

export type ControllerOnOffLog = {
  __typename?: 'ControllerOnOffLog';
  changedBy: ControllerOnOffChangedBy;
  controllerOnOff: ControllerOnOff;
  createdAt: Scalars['DateTime'];
  newState: Scalars['Boolean'];
};

export type ControllerOnOffNoxStateChangeSubscriptionPayload = {
  __typename?: 'ControllerOnOffNoxStateChangeSubscriptionPayload';
  controllerUnitUrl: Scalars['String'];
  timeOfLastAreaStateChange: Scalars['DateTime'];
};

export type ControllerOnOffState = {
  __typename?: 'ControllerOnOffState';
  changedBy?: Maybe<ControllerOnOffChangedBy>;
  id: Scalars['ID'];
  noxAreaId: Scalars['Int'];
  state: Scalars['Boolean'];
};

export type ControllerOnOffTimeprofile = {
  __typename?: 'ControllerOnOffTimeprofile';
  id: Scalars['String'];
  noxTimeprofileId?: Maybe<Scalars['Int']>;
  noxTimeprofileName?: Maybe<Scalars['String']>;
};

export enum ControllerOnOffType {
  Custom = 'Custom',
  Resource = 'Resource'
}

export type ControllerOnOffUpdate = {
  noxAreaId: Scalars['Int'];
  noxTimeProfileId?: InputMaybe<Scalars['Int']>;
};

export type ControllerOnOffWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ControllerUnit = {
  __typename?: 'ControllerUnit';
  doorControllers: Array<ControllerDoor>;
  id: Scalars['String'];
  isOnline: Scalars['Boolean'];
  location: Location;
  noxVersion: NoxVersion;
  onOffControllers: Array<ControllerOnOff>;
  type: ControllerUnitType;
  url: Scalars['String'];
};


export type ControllerUnitDoorControllersArgs = {
  after?: InputMaybe<ControllerDoorWhereUniqueInput>;
  before?: InputMaybe<ControllerDoorWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ControllerUnitOnOffControllersArgs = {
  after?: InputMaybe<ControllerOnOffWhereUniqueInput>;
  before?: InputMaybe<ControllerOnOffWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ControllerUnitAccessCode = {
  __typename?: 'ControllerUnitAccessCode';
  accessCodeId: Scalars['String'];
  activatedOnUnitAt?: Maybe<Scalars['DateTime']>;
  controllerUnit: ControllerUnit;
  createdAt: Scalars['DateTime'];
  doors: Array<ControllerDoor>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status: ControllerUnitAccessCodeStatus;
  syncedToControllerUnit?: Maybe<SyncedToControllerUnitStatus>;
};


export type ControllerUnitAccessCodeDoorsArgs = {
  after?: InputMaybe<ControllerDoorWhereUniqueInput>;
  before?: InputMaybe<ControllerDoorWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ControllerUnitAccessCodeAccessCodeIdControllerUnitIdCompoundUniqueInput = {
  accessCodeId: Scalars['String'];
  controllerUnitId: Scalars['String'];
};

export enum ControllerUnitAccessCodeStatus {
  Active = 'Active',
  Error = 'Error',
  ToActive = 'ToActive',
  ToDeleted = 'ToDeleted'
}

export type ControllerUnitAccessCodeWhereUniqueInput = {
  accessCodeId_controllerUnitId?: InputMaybe<ControllerUnitAccessCodeAccessCodeIdControllerUnitIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type ControllerUnitCreate = {
  friendlyName?: InputMaybe<Scalars['String']>;
  location: Scalars['ID'];
  noxLogin?: InputMaybe<Scalars['String']>;
  noxVersion: NoxVersion;
  type: ControllerUnitType;
  url: Scalars['String'];
};

export enum ControllerUnitType {
  Nox = 'NOX'
}

export type ControllerUnitUpdate = {
  friendlyName?: InputMaybe<Scalars['String']>;
  noxVersion?: InputMaybe<NoxVersion>;
  url: Scalars['String'];
};

export type ControllerUnitsFiltering = {
  type?: InputMaybe<Array<InputMaybe<ControllerUnitType>>>;
};

export type ControllerUnitsResult = Pagination & {
  __typename?: 'ControllerUnitsResult';
  data: Array<ControllerUnit>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type Coupon = {
  __typename?: 'Coupon';
  active: Scalars['Boolean'];
  amountOff?: Maybe<Scalars['Float']>;
  bookingHoursOff?: Maybe<Scalars['Float']>;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  discountIsOnlyForBuyer: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  maximumResourceBookingHoursPrMonthUsage?: Maybe<Scalars['Float']>;
  maximumUsages?: Maybe<Scalars['Int']>;
  maximumUsagesPrCustomer?: Maybe<Scalars['Int']>;
  maximumUsagesPrCustomerPrMonth?: Maybe<Scalars['Boolean']>;
  mode: CouponMode;
  onlyForUserGroups: Array<UserGroup>;
  percentOff?: Maybe<Scalars['Int']>;
  resourceBookingEndDateAfter?: Maybe<Scalars['DateTime']>;
  resourceBookingEndDateBefore?: Maybe<Scalars['DateTime']>;
  resourceBookingTimeRanges: Array<CouponResourceBookingTimeRange>;
  slug: Scalars['String'];
  subscriptionProductCoupon?: Maybe<SubscriptionProduct>;
  subscriptionProductCouponEvents?: Maybe<SubscriptionProduct>;
  totalUsedDiscountAmount: Scalars['Float'];
  type: CouponType;
  usages: Array<CouponUsage>;
  usagesCount: Scalars['Int'];
};


export type CouponOnlyForUserGroupsArgs = {
  after?: InputMaybe<UserGroupWhereUniqueInput>;
  before?: InputMaybe<UserGroupWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CouponResourceBookingTimeRangesArgs = {
  after?: InputMaybe<CouponResourceBookingTimeRangeWhereUniqueInput>;
  before?: InputMaybe<CouponResourceBookingTimeRangeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CouponTotalUsedDiscountAmountArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type CouponUsagesArgs = {
  after?: InputMaybe<CouponUsageWhereUniqueInput>;
  before?: InputMaybe<CouponUsageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CouponUsagesCountArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type CouponAndPrice = {
  __typename?: 'CouponAndPrice';
  amountWithCoupon: Scalars['Float'];
  amountWithoutCoupon: Scalars['Float'];
  coupon: Coupon;
  discount: Scalars['Float'];
};

export type CouponCreate = {
  amountOff?: InputMaybe<Scalars['Float']>;
  bookingHoursOff?: InputMaybe<Scalars['Float']>;
  connectedToUserGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  discountIsOnlyForBuyer?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  maximumResourceBookingHoursPrMonthUsage?: InputMaybe<Scalars['Int']>;
  maximumUsages?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomer?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomerPrMonth?: InputMaybe<Scalars['Boolean']>;
  mode?: CouponMode;
  onlyForSpecificResourceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  percentOff?: InputMaybe<Scalars['Int']>;
  resourceBookingEndDateAfter?: InputMaybe<Scalars['DateTime']>;
  resourceBookingEndDateBefore?: InputMaybe<Scalars['DateTime']>;
  resourceBookingTimeRanges?: InputMaybe<Array<InputMaybe<CouponResourceBookingTimeRangeCreate>>>;
  slug: Scalars['String'];
  type: CouponType;
};

export type CouponGetUserAutoCouponsFiltering = {
  abc?: InputMaybe<Scalars['String']>;
};

export enum CouponMode {
  Automatic = 'Automatic',
  Hidden = 'Hidden',
  Manual = 'Manual'
}

export type CouponPurchaseDetails = {
  productId: Scalars['ID'];
  resoruceBookingStartDate?: InputMaybe<Scalars['DateTime']>;
  resourceBookingEndDate?: InputMaybe<Scalars['DateTime']>;
  resourceId?: InputMaybe<Scalars['ID']>;
};

export type CouponResourceBookingTimeRange = {
  __typename?: 'CouponResourceBookingTimeRange';
  coupon: Coupon;
  days: Array<Day>;
  endTime: Scalars['String'];
  id: Scalars['String'];
  startTime: Scalars['String'];
};

export type CouponResourceBookingTimeRangeCreate = {
  days: Array<Day>;
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type CouponResourceBookingTimeRangeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum CouponType {
  Amount = 'Amount',
  BookingHours = 'BookingHours',
  Percent = 'Percent'
}

export type CouponUpdate = {
  active?: InputMaybe<Scalars['Boolean']>;
  amountOff?: InputMaybe<Scalars['Float']>;
  bookingHoursOff?: InputMaybe<Scalars['Float']>;
  connectedToUserGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  discountIsOnlyForBuyer?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  maximumResourceBookingHoursPrMonthUsage?: InputMaybe<Scalars['Int']>;
  maximumUsages?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomer?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomerPrMonth?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<CouponMode>;
  percentOff?: InputMaybe<Scalars['Int']>;
  resourceBookingEndDateAfter?: InputMaybe<Scalars['DateTime']>;
  resourceBookingEndDateBefore?: InputMaybe<Scalars['DateTime']>;
  resourceBookingTimeRanges?: InputMaybe<Array<InputMaybe<CouponResourceBookingTimeRangeCreate>>>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CouponType>;
};

export type CouponUsage = {
  __typename?: 'CouponUsage';
  coupon: Coupon;
  createdAt: Scalars['DateTime'];
  discountAmount: Scalars['Float'];
  id: Scalars['String'];
  isUsed: Scalars['Boolean'];
  payment: Payment;
  paymentLine: PaymentLine;
  user: User;
};

export type CouponUsageWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  paymentLineId?: InputMaybe<Scalars['String']>;
};

export type CouponUsagesResult = Pagination & {
  __typename?: 'CouponUsagesResult';
  data: Array<CouponUsage>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type CouponUseagesFiltering = {
  coupon?: InputMaybe<Scalars['ID']>;
};

export type CouponWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type CouponsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type CouponsResult = Pagination & {
  __typename?: 'CouponsResult';
  data: Array<Coupon>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type CreateResourceTypePriceDate = {
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
};

export type CreateStripePayment = {
  id?: InputMaybe<Scalars['String']>;
};

export enum Currency {
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export enum CustomerOrderItemType {
  AdminFee = 'ADMIN_FEE',
  Default = 'DEFAULT',
  PaymentFee = 'PAYMENT_FEE',
  PrePayment = 'PRE_PAYMENT',
  ShippingFee = 'SHIPPING_FEE'
}

export type CustomerOrderType = {
  __typename?: 'CustomerOrderType';
  addressContainer: TrinityAddressContainer;
  createdUtc?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items?: Maybe<Array<TrinityItems>>;
  totalSum: Scalars['Float'];
};

export enum Day {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DineroConnection = {
  __typename?: 'DineroConnection';
  apiKey: Scalars['String'];
  bankAccountNumber: Scalars['Int'];
  company?: Maybe<Company>;
  id: Scalars['String'];
  mobilePayInvoiceAccountNumber: Scalars['Int'];
  organizationId: Scalars['Int'];
  organizations: Array<DineroOrganization>;
  stripeAccountNumber: Scalars['Int'];
};

export type DineroConnectionCreate = {
  apiKey: Scalars['String'];
  bankAccountNumber?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
};

export type DineroOrganization = {
  __typename?: 'DineroOrganization';
  id: Scalars['Int'];
  isPro: Scalars['Boolean'];
  name: Scalars['String'];
};

export type DopagoIntegration = {
  __typename?: 'DopagoIntegration';
  companyId?: Maybe<Scalars['String']>;
  dopagoLocationId: Scalars['String'];
  id: Scalars['String'];
};

export type EmailAndPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Feedback = {
  __typename?: 'Feedback';
  checkedByAdmin: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  logRocketSessionUrl?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  url: Scalars['String'];
  user: User;
};

export type FeedbackCreate = {
  logRocketSessionUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  url: Scalars['String'];
};

export type Franchise = {
  __typename?: 'Franchise';
  city: Scalars['String'];
  companies: Array<Company>;
  currency: Currency;
  franchiseLogo?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  streetName: Scalars['String'];
  userPlatformConnectionTokens: Array<UserPlatformConnectionToken>;
  userPlatformConnections: Array<UserPlatformConnection>;
  zipCode: Scalars['String'];
};


export type FranchiseCompaniesArgs = {
  after?: InputMaybe<CompanyWhereUniqueInput>;
  before?: InputMaybe<CompanyWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type FranchiseUserPlatformConnectionTokensArgs = {
  after?: InputMaybe<UserPlatformConnectionTokenWhereUniqueInput>;
  before?: InputMaybe<UserPlatformConnectionTokenWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type FranchiseUserPlatformConnectionsArgs = {
  after?: InputMaybe<UserPlatformConnectionWhereUniqueInput>;
  before?: InputMaybe<UserPlatformConnectionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type FranchiseCompanyInvitationSend = {
  email: Scalars['String'];
};

export type FranchiseCreate = {
  city: Scalars['String'];
  country: SupportedCountries;
  email: Scalars['String'];
  language: Language;
  name: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  slug: Scalars['String'];
  streetName: Scalars['String'];
  zipCode: Scalars['String'];
};

export type FranchiseForSignUp = {
  __typename?: 'FranchiseForSignUp';
  id: Scalars['ID'];
  isFranchise: Scalars['Boolean'];
  locations: Array<Location>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  streetName: Scalars['String'];
  zipCode: Scalars['String'];
};

export enum FranchiseOrCompany {
  Company = 'Company',
  Franchise = 'Franchise'
}

export type FranchiseSetting = {
  __typename?: 'FranchiseSetting';
  franchise: Franchise;
  franchiseId: Scalars['String'];
  id: Scalars['String'];
  pointTransactionPlatformFeePercentage: Scalars['Float'];
  pointTransactionPlatformStatic: Scalars['Float'];
};

export type FranchiseSettingUpdate = {
  id?: InputMaybe<Scalars['ID']>;
  pointTransactionPlatformFeePercentage?: InputMaybe<Scalars['Float']>;
  pointTransactionPlatformStatic?: InputMaybe<Scalars['Float']>;
};

export type FranchiseWithFees = {
  __typename?: 'FranchiseWithFees';
  currency: Scalars['String'];
  franchiseSettings: FranchiseSetting;
  id: Scalars['ID'];
  name: Scalars['String'];
  stripeConnection?: Maybe<StripeConnection>;
};

export type FriendsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type FriendsPossibleToAddFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type FriendsPossibleToAddResult = Pagination & {
  __typename?: 'FriendsPossibleToAddResult';
  data: Array<User>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type FriendsResult = Pagination & {
  __typename?: 'FriendsResult';
  data: Array<User>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type Friendship = {
  __typename?: 'Friendship';
  friend: User;
  id: Scalars['String'];
  status: FriendshipStatus;
};

export enum FriendshipStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
  Pending = 'Pending'
}

export enum GenderType {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other'
}

export type GiftCard = {
  __typename?: 'GiftCard';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isUsed: Scalars['Boolean'];
  pointsAmount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  usedBy?: Maybe<User>;
};

export type GiftCardCreate = {
  createGiftCardsCount?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  pointsAmount: Scalars['Int'];
};

export type GiftCardsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type GiftCardsResult = Pagination & {
  __typename?: 'GiftCardsResult';
  data: Array<GiftCard>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type InvoicePaidSubscriptionPayload = {
  __typename?: 'InvoicePaidSubscriptionPayload';
  invoiceId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  status: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export enum KpiExportPeriodType {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week'
}

export enum Language {
  DaDk = 'da_DK',
  DeDe = 'de_DE',
  EnGb = 'en_GB',
  FiFi = 'fi_FI'
}

export type Location = {
  __typename?: 'Location';
  allowSignUps: Scalars['Boolean'];
  bookliCameraServer?: Maybe<BookliCameraServer>;
  bookliCameras: Array<BookliCamera>;
  bookliDevices: Array<BookliDevice>;
  bookliNetwork?: Maybe<BookliNetwork>;
  bookliSounds: Array<BookliSound>;
  city: Scalars['String'];
  company: Company;
  controllerUnit?: Maybe<ControllerUnit>;
  id: Scalars['String'];
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  locationLogo?: Maybe<Scalars['String']>;
  locationOverviewSvg?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameShort?: Maybe<Scalars['String']>;
  overviewSvg?: Maybe<Scalars['String']>;
  overviewSvgImageUrl?: Maybe<Scalars['String']>;
  quickInfoUrl?: Maybe<Scalars['String']>;
  quickInfoUrlFull?: Maybe<Scalars['String']>;
  resources: Array<Resource>;
  resourcesCount: Scalars['Int'];
  screenWelcomeMessage?: Maybe<Scalars['String']>;
  streetName: Scalars['String'];
  userWelcomeMessage?: Maybe<Scalars['String']>;
  userWelcomeMessageLastUpdated?: Maybe<Scalars['DateTime']>;
  wannasportConnection?: Maybe<WannasportConnection>;
  zipCode: Scalars['String'];
};


export type LocationBookliCamerasArgs = {
  after?: InputMaybe<BookliCameraWhereUniqueInput>;
  before?: InputMaybe<BookliCameraWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type LocationBookliDevicesArgs = {
  after?: InputMaybe<BookliDeviceWhereUniqueInput>;
  before?: InputMaybe<BookliDeviceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type LocationBookliSoundsArgs = {
  after?: InputMaybe<BookliSoundWhereUniqueInput>;
  before?: InputMaybe<BookliSoundWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type LocationOverviewSvgArgs = {
  highlightResourceId?: InputMaybe<Scalars['String']>;
  showCurrentBooking?: InputMaybe<Scalars['Boolean']>;
  showResourceName?: InputMaybe<Scalars['Boolean']>;
};


export type LocationResourcesArgs = {
  after?: InputMaybe<ResourceWhereUniqueInput>;
  before?: InputMaybe<ResourceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LocationChangeResult = {
  __typename?: 'LocationChangeResult';
  changePlatformToken: Scalars['Boolean'];
  location: Location;
  userPlatformConnection?: Maybe<Scalars['ID']>;
};

export type LocationCreate = {
  city: Scalars['String'];
  name: Scalars['String'];
  overviewSvgImage?: InputMaybe<Scalars['Upload']>;
  streetName: Scalars['String'];
  zipCode: Scalars['String'];
};

export type LocationScreenWelcomeMessageSubscriptionPayload = {
  __typename?: 'LocationScreenWelcomeMessageSubscriptionPayload';
  location: Scalars['ID'];
  message: Scalars['String'];
};

export type LocationUpdate = {
  allowSignUps?: InputMaybe<Scalars['Boolean']>;
  footerImageInMailImage?: InputMaybe<Scalars['Upload']>;
  logoImage?: InputMaybe<Scalars['Upload']>;
  overviewSvgImage?: InputMaybe<Scalars['Upload']>;
  screenWelcomeMessage?: InputMaybe<Scalars['String']>;
  userWelcomeMessage?: InputMaybe<Scalars['String']>;
};

export type LocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  quickInfoClubId?: InputMaybe<Scalars['String']>;
  quickInfoUrl?: InputMaybe<Scalars['String']>;
  userDefaultControllerDoorGroupId?: InputMaybe<Scalars['String']>;
};

export type LocationsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type LocationsForSignUpResult = Pagination & {
  __typename?: 'LocationsForSignUpResult';
  data: Array<Location>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type LocationsResult = Pagination & {
  __typename?: 'LocationsResult';
  data: Array<Location>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type Me = {
  __typename?: 'Me';
  appBackgroundImageUrl?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  country: SupportedCountries;
  currency?: Maybe<Currency>;
  franchise?: Maybe<Franchise>;
  franchiseId?: Maybe<Scalars['String']>;
  hasAdminRole: Scalars['Boolean'];
  isPartOfFranchise: Scalars['Boolean'];
  location?: Maybe<Location>;
  pointAccount: PointAccount;
  pointAccountsOutsideOfCurrentCompany: Array<PointAccount>;
  role: UserRole;
  user: User;
  userActiveProductSubscription: Array<UserProductSubscription>;
  userGroupsPointAccount: Array<PointAccount>;
  userPlatformConnection: UserPlatformConnection;
};

export type Message = {
  __typename?: 'Message';
  emailClickCount: Scalars['Int'];
  emailOpensCount?: Maybe<Scalars['Int']>;
  emailRecipients: Array<Scalars['String']>;
  id: Scalars['String'];
  platform: MessagePlatform;
  readBy: Array<User>;
  sender?: Maybe<User>;
  source: Scalars['String'];
  status: MessageStatus;
  userRecipients: Array<User>;
};


export type MessageReadByArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MessageUserRecipientsArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MessageCreate = {
  body: Scalars['String'];
  messageGroup?: InputMaybe<Scalars['Int']>;
  newsLetterAgreements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  platform: MessagePlatform;
  /** Can be either id of a user or a email */
  recipients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendTime?: InputMaybe<Scalars['DateTime']>;
  sendToMany?: InputMaybe<SendToMany>;
  subject?: InputMaybe<Scalars['String']>;
  subscriptionProducts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  workshops?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum MessagePlatform {
  Email = 'Email',
  InApp = 'InApp',
  Notification = 'Notification',
  Sms = 'Sms'
}

export enum MessageStatus {
  Canceled = 'Canceled',
  Error = 'Error',
  New = 'New',
  Sending = 'Sending',
  Sent = 'Sent'
}

export type MessageWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type MessagesFiltering = {
  isNotRead?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<MessagesType>;
};

export type MessagesResult = Pagination & {
  __typename?: 'MessagesResult';
  data: Array<Message>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export enum MessagesType {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export type MobilePayConnection = {
  __typename?: 'MobilePayConnection';
  id: Scalars['String'];
  invoicePayBeforeMinutes: Scalars['Int'];
};

export type MobilePayInvoice = {
  __typename?: 'MobilePayInvoice';
  id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  UserPlatformConnectionCreateMultiple: MutationResult;
  accessCodeAccessTimesForFutureBookingsCreate: MutationResult;
  accessCodeCreate: AccessCode;
  accessCodeDelete: Scalars['Boolean'];
  accessCodeUpdate: AccessCode;
  additionalService: Scalars['Boolean'];
  additionalServiceCreate: MutationResult;
  additionalServiceUpdate: MutationResult;
  agreementCreate: Agreement;
  agreementUpdate: Agreement;
  analyticCreateKPIExport: MutationResult;
  authChangeEmail: User;
  authChangePassword: MutationResult;
  authSendPasswordResetEmail: MutationResult;
  authSendVerificationEmail: MutationResult;
  authSignInPlatform: Scalars['String'];
  authSignInUser: Scalars['String'];
  authUpdatePassword: Scalars['Boolean'];
  authVerifyEmail: MutationResult;
  bookingReportCreate: MutationResult;
  bookliCameraCreate: BookliCamera;
  bookliCameraServerCreate: BookliCameraServer;
  bookliCameraServerReloadCameras: BookliCameraServer;
  bookliCameraUpdate: BookliCamera;
  bookliDeviceRegister: BookliDevice;
  bookliDeviceUpdate: BookliDevice;
  bookliSoundCreate: BookliSound;
  bookliVideoCreateSubClip: BookliVideo;
  companyCreate: Company;
  companyCreateInvitationDelete: MutationResult;
  companyCreateInvitationSend: MutationResult;
  companyDelete: MutationResult;
  companySettingUpdate: CompanySetting;
  companyUpdate: Company;
  companyUploadAppImage: CompanySetting;
  companyUploadLogo: Company;
  controllerDoorCreate: ControllerDoor;
  controllerDoorGroupCreate: ControllerDoorGroup;
  controllerDoorGroupUpdate: ControllerDoorGroup;
  controllerDoorSetState: MutationResult;
  controllerDoorUpdate: ControllerDoor;
  controllerOnOffSetState: MutationResult;
  controllerOnOffTimeProfileItemsForFutureBookingsCreate: MutationResult;
  controllerOnOffUpdate: ControllerOnOff;
  controllerUnitCreate: ControllerUnit;
  controllerUnitUpdate: ControllerUnit;
  couponCreate: Coupon;
  couponDisable: Coupon;
  couponUpdate: Coupon;
  createBlockedPhone: BlockedPhone;
  deleteBlockedPhone: BlockedPhone;
  deleteUserFCMToken: Scalars['Boolean'];
  dineroAddMobilePayInvoice: DineroConnection;
  dineroAddStripe: DineroConnection;
  dineroConnectionCreate: DineroConnection;
  dineroConnectionDelete: Scalars['Boolean'];
  feedbackCreate: Feedback;
  franchiseCompanyInvitationSend: MutationResult;
  franchiseCreate: Franchise;
  franchiseSettingUpdate: FranchiseSetting;
  franchiseUploadLogo: Franchise;
  friendshipCreate: Friendship;
  friendshipDelete: Scalars['Boolean'];
  friendshipHandleReq: Friendship;
  giftCardCreate: Array<GiftCard>;
  giftCardUse: Scalars['Int'];
  locationChangeUser: LocationChangeResult;
  locationCreate: Location;
  locationUpdate: Location;
  locationUserDefaultChange: Location;
  messageCancel: Message;
  messageCreate: Message;
  messageCreateSendTest: Message;
  messageMarkAsRead?: Maybe<MutationResult>;
  nextActionUrl?: Maybe<Scalars['String']>;
  payPalConfirmPayment: Scalars['Boolean'];
  payPalCreateConnection: MutationResult;
  paymentCancelReservedProduct: Scalars['Boolean'];
  paymentCheckReversal: Scalars['Boolean'];
  paymentGetXlsxList: MutationResult;
  paymentInvoice: Scalars['String'];
  paymentRefund: Payment;
  paymentReserveProduct: PaymentReserveProduct;
  paymentTokenConfirm: MutationResult;
  paymentTokenCreate: PaymentToken;
  paymentTokenFailed: PaymentToken;
  platformFeesUpdate: Scalars['Boolean'];
  platformInvoiceGetForPeriod: Array<Scalars['String']>;
  pointAccountGetNumbersXlsx: Scalars['String'];
  pointAccountUpdate: PointAccount;
  pointAccountsCompanyGetNumbers: MutationResult;
  pointProductCreate: PointProduct;
  pointProductDelete: PointProduct;
  pointProductUpdate: PointProduct;
  pointTransactionUpdate: PointTransaction;
  pointsAddOrRemove: PointTransaction;
  priceffModelCreate: PriceffModel;
  priceffModelUpdate: PriceffModel;
  priceffParameterCreate: PriceffParameter;
  priceffParameterUpdate: PriceffParameter;
  resourceAddCamera: Resource;
  resourceAddLightController: Resource;
  resourceBookingAttendeeAdd: ResourceBooking;
  resourceBookingAttendeeDelete: ResourceBooking;
  resourceBookingBookliVideoCreate: BookliVideo;
  resourceBookingCancel: ResourceBooking;
  resourceBookingCreateCompanyReservation: ResourceBookingCreateCompanyReservationResult;
  resourceBookingRecurringCreate: ResourceBookingRecurring;
  resourceBookingRecurringDelete: ResourceBookingRecurring;
  resourceBookingRecurringUpdate: ResourceBookingRecurring;
  resourceBookingUpdate: ResourceBooking;
  resourceCategoryCreate: ResourceCategory;
  resourceCategoryUpdate: ResourceCategory;
  resourceCreate: Resource;
  resourceRemoveCamera: Resource;
  resourceTypeConnectPriceffModel: ResourceType;
  resourceTypeCreate: ResourceType;
  resourceTypePriceCreate: ResourceTypePrice;
  resourceTypePriceDateAdd: ResourceTypePrice;
  resourceTypePriceDateDelete: Scalars['Boolean'];
  resourceTypePriceDelete: Scalars['Boolean'];
  resourceTypePriceUpdate: ResourceTypePrice;
  resourceTypePriceffUpdate: ResourceType;
  resourceTypeUpdate: ResourceType;
  resourceUpdate: Resource;
  saEvent: Scalars['Boolean'];
  sendMigrationFile: Scalars['Boolean'];
  setUserFCMToken: User;
  stripeConnectionUpdate: StripeConnection;
  stripePaymentMetodAdded: Scalars['Boolean'];
  stripeRemoveConnect: Scalars['Boolean'];
  stripeReportGenerate: Array<StripeReport>;
  stripeUserRemovePaymentMethod: MutationResult;
  subscriptionProductCategoryCreate: SubscriptionProductCategory;
  subscriptionProductCreate: SubscriptionProduct;
  subscriptionProductGiftCardCreate: Array<SubscriptionProductGiftCard>;
  subscriptionProductStartDateForFirstPaymentCreate: SubscriptionProduct;
  subscriptionProductUpdate: SubscriptionProduct;
  supportTicketCreate: MutationResult;
  trinityEComCreateCheckout: TrinityEComCheckoutSession;
  trinityEComCreateCheckoutPayPal: TrinityEComCheckoutSession;
  trinityEComUpdateCheckoutDeliveryOption: TrinityEComCheckoutSession;
  trinityEComUpdateCheckoutDeliveryOptionsPostCode: TrinityEComCheckoutSession;
  trinityEComUpdateCheckoutPaymentType: TrinityEComCheckoutSession;
  updatePaymentStatus: Payment;
  uploadMigrationFile: UploadMigrationFileResult;
  userAcceptAgreements: Array<UserAgreement>;
  userAgreementAcceptUpdatedAgreements: Array<UserAgreement>;
  userCreate: User;
  userDelete: MutationResult;
  userGroupAddAutomaticSubscriptionProduct: UserGroup;
  userGroupAddPointAccount: UserGroup;
  userGroupAddUsers: UserGroup;
  userGroupAdminAdd: UserGroup;
  userGroupAdminRemove: UserGroup;
  userGroupCreate: UserGroup;
  userGroupDelete: Scalars['Boolean'];
  userGroupRemoveAutomaticSubscriptionProduct: UserGroup;
  userGroupRemovePointAccount: UserGroup;
  userGroupRemoveUsers: UserGroup;
  userGroupUpdate: UserGroup;
  userPlatformConnectionCreate: UserPlatformConnection;
  userPlatformConnectionDelete: MutationResult;
  userPlatformConnectionTokenCreate: UserPlatformConnectionTokenCreateResult;
  userPlatformConnectionTokenDelete: MutationResult;
  userProductSubscriptionCancel: UserProductSubscription;
  userProductSubscriptionCanceleByAdmin: UserProductSubscription;
  userProductSubscriptionCreateByAdmin: UserProductSubscription;
  userProductSubscriptionReactivate: MutationResult;
  userProductSubscriptionsToExcel: Scalars['String'];
  userUpdate: User;
  userUploadProfileImg: User;
  wannasportConnectionChangePossibleTimeSlots: WannasportConnection;
  wannasportConnectionCreate: WannasportConnectionCreated;
  workshopBookingCancel: WorkshopBooking;
  workshopBookingCreateAdmin: Array<WorkshopBooking>;
  workshopBookingCreateUserReservation: WorkshopBooking;
  workshopCancele: Workshop;
  workshopCreate: Array<Workshop>;
  workshopDayCreate: WorkshopDay;
  workshopDayDelete: Workshop;
  workshopDayUpdate: WorkshopDay;
  workshopUpdate: Workshop;
  workshopWaitlistCancel: MutationResult;
  workshopWaitlistJoin: WorkshopWaitlistItem;
};


export type MutationUserPlatformConnectionCreateMultipleArgs = {
  data: UserPlatformConnectionCreateMultiple;
};


export type MutationAccessCodeAccessTimesForFutureBookingsCreateArgs = {
  controllerUnitId?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['ID'];
};


export type MutationAccessCodeCreateArgs = {
  data: AccessCodeCreate;
};


export type MutationAccessCodeDeleteArgs = {
  accessCode?: InputMaybe<Scalars['ID']>;
  noxVersion?: InputMaybe<NoxVersion>;
};


export type MutationAccessCodeUpdateArgs = {
  data: AccessCodeUpdate;
  id: Scalars['ID'];
};


export type MutationAdditionalServiceArgs = {
  additionalServiceId?: InputMaybe<Scalars['ID']>;
  resourceBookingEndDate?: InputMaybe<Scalars['String']>;
  resourceBookingStartDate?: InputMaybe<Scalars['String']>;
};


export type MutationAdditionalServiceCreateArgs = {
  additionalServiceData: AdditionalServiceCreate;
};


export type MutationAdditionalServiceUpdateArgs = {
  additionalServiceData: AdditionalServiceUpdate;
};


export type MutationAgreementCreateArgs = {
  data: AgreementCreate;
};


export type MutationAgreementUpdateArgs = {
  agreement: Scalars['ID'];
  data: AgreementUpdate;
};


export type MutationAnalyticCreateKpiExportArgs = {
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  periodType: KpiExportPeriodType;
  sendToEmail: Scalars['String'];
};


export type MutationAuthChangeEmailArgs = {
  newEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationAuthChangePasswordArgs = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};


export type MutationAuthSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationAuthSendVerificationEmailArgs = {
  email: Scalars['String'];
};


export type MutationAuthSignInPlatformArgs = {
  userPlatformConnection: Scalars['ID'];
};


export type MutationAuthSignInUserArgs = {
  appleSignIn?: InputMaybe<AppleSignInInput>;
  emailAndPassword?: InputMaybe<EmailAndPasswordInput>;
  facebookAuthToken?: InputMaybe<Scalars['String']>;
};


export type MutationAuthUpdatePasswordArgs = {
  password: Scalars['String'];
};


export type MutationAuthVerifyEmailArgs = {
  token: Scalars['String'];
};


export type MutationBookingReportCreateArgs = {
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  sendToEmail: Scalars['String'];
};


export type MutationBookliCameraCreateArgs = {
  data: BookliCameraCreate;
};


export type MutationBookliCameraServerCreateArgs = {
  data: BookliCameraServerCreate;
};


export type MutationBookliCameraServerReloadCamerasArgs = {
  id: Scalars['ID'];
};


export type MutationBookliCameraUpdateArgs = {
  data: BookliCameraUpdate;
  id: Scalars['ID'];
};


export type MutationBookliDeviceRegisterArgs = {
  token: Scalars['String'];
};


export type MutationBookliDeviceUpdateArgs = {
  data: BookliDeviceUpdate;
  id: Scalars['String'];
};


export type MutationBookliSoundCreateArgs = {
  data: BookliSoundCreate;
};


export type MutationBookliVideoCreateSubClipArgs = {
  data: BookliVideoCreateSubClip;
};


export type MutationCompanyCreateArgs = {
  companyCreateInvitationToken?: InputMaybe<Scalars['String']>;
  companyData: CompanyCreate;
  franchiseData?: InputMaybe<FranchiseCreate>;
  userAuthToken?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<UserCreate>;
};


export type MutationCompanyCreateInvitationDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCompanyCreateInvitationSendArgs = {
  data: CompanyCreateInvitationSend;
};


export type MutationCompanyDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCompanySettingUpdateArgs = {
  data: CompanySettingUpdate;
};


export type MutationCompanyUpdateArgs = {
  data: CompanyUpdate;
};


export type MutationCompanyUploadAppImageArgs = {
  file: Scalars['Upload'];
};


export type MutationCompanyUploadLogoArgs = {
  file: Scalars['Upload'];
};


export type MutationControllerDoorCreateArgs = {
  data: ControllerDoorCreate;
};


export type MutationControllerDoorGroupCreateArgs = {
  data: ControllerDoorGroupCreate;
};


export type MutationControllerDoorGroupUpdateArgs = {
  data: ControllerDoorGroupUpdate;
  id: Scalars['ID'];
};


export type MutationControllerDoorSetStateArgs = {
  data?: InputMaybe<ControllerDoorSetState>;
};


export type MutationControllerDoorUpdateArgs = {
  data: ControllerDoorUpdate;
  id: Scalars['ID'];
};


export type MutationControllerOnOffSetStateArgs = {
  controllerOnOff: Scalars['ID'];
  newState?: InputMaybe<Scalars['Boolean']>;
};


export type MutationControllerOnOffTimeProfileItemsForFutureBookingsCreateArgs = {
  locationId: Scalars['ID'];
};


export type MutationControllerOnOffUpdateArgs = {
  data: ControllerOnOffUpdate;
  id: Scalars['ID'];
};


export type MutationControllerUnitCreateArgs = {
  data: ControllerUnitCreate;
};


export type MutationControllerUnitUpdateArgs = {
  controllerId: Scalars['ID'];
  data: ControllerUnitUpdate;
};


export type MutationCouponCreateArgs = {
  data: CouponCreate;
};


export type MutationCouponDisableArgs = {
  id: Scalars['ID'];
};


export type MutationCouponUpdateArgs = {
  coupon: Scalars['ID'];
  data: CouponUpdate;
};


export type MutationCreateBlockedPhoneArgs = {
  phoneNumber: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteBlockedPhoneArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserFcmTokenArgs = {
  userId: Scalars['ID'];
};


export type MutationDineroAddMobilePayInvoiceArgs = {
  mobilePayInvoiceAccountNumber: Scalars['Int'];
};


export type MutationDineroAddStripeArgs = {
  stripeAccountNumber: Scalars['Int'];
};


export type MutationDineroConnectionCreateArgs = {
  data: DineroConnectionCreate;
};


export type MutationFeedbackCreateArgs = {
  data: FeedbackCreate;
};


export type MutationFranchiseCompanyInvitationSendArgs = {
  data: FranchiseCompanyInvitationSend;
};


export type MutationFranchiseCreateArgs = {
  data: FranchiseCreate;
};


export type MutationFranchiseSettingUpdateArgs = {
  data: FranchiseSettingUpdate;
};


export type MutationFranchiseUploadLogoArgs = {
  file: Scalars['Upload'];
};


export type MutationFriendshipCreateArgs = {
  friendUserId: Scalars['ID'];
};


export type MutationFriendshipDeleteArgs = {
  friendUserId: Scalars['ID'];
};


export type MutationGiftCardCreateArgs = {
  data: GiftCardCreate;
};


export type MutationGiftCardUseArgs = {
  giftCardCode?: InputMaybe<Scalars['String']>;
};


export type MutationLocationChangeUserArgs = {
  newLocation: Scalars['ID'];
};


export type MutationLocationCreateArgs = {
  data: LocationCreate;
};


export type MutationLocationUpdateArgs = {
  data: LocationUpdate;
  location: Scalars['ID'];
};


export type MutationLocationUserDefaultChangeArgs = {
  newDefaultLocation: Scalars['ID'];
};


export type MutationMessageCancelArgs = {
  message: Scalars['ID'];
};


export type MutationMessageCreateArgs = {
  data: MessageCreate;
};


export type MutationMessageCreateSendTestArgs = {
  data: MessageCreate;
  sendTo: Array<Scalars['String']>;
};


export type MutationMessageMarkAsReadArgs = {
  id: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationNextActionUrlArgs = {
  confirmationTokenId: Scalars['String'];
  paymentIntentId: Scalars['String'];
};


export type MutationPayPalConfirmPaymentArgs = {
  payPalInvoiceId: Scalars['String'];
  payPalOrderId: Scalars['String'];
};


export type MutationPayPalCreateConnectionArgs = {
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
};


export type MutationPaymentCancelReservedProductArgs = {
  data: PaymentCancelReservedProduct;
};


export type MutationPaymentCheckReversalArgs = {
  paymentId: Scalars['ID'];
};


export type MutationPaymentGetXlsxListArgs = {
  createdAtEndDate: Scalars['DateTime'];
  createdAtStartDate: Scalars['DateTime'];
  sendToEmail: Scalars['String'];
};


export type MutationPaymentInvoiceArgs = {
  payment: Scalars['ID'];
};


export type MutationPaymentRefundArgs = {
  cancelAdditionalService?: InputMaybe<Scalars['Boolean']>;
  canceleProduct?: InputMaybe<Scalars['Boolean']>;
  forceRefundAsPoints?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  refundPartialPayment?: InputMaybe<Scalars['Boolean']>;
  refundPartialPaymentAmount?: InputMaybe<Scalars['Float']>;
  refundPayment?: InputMaybe<Scalars['Boolean']>;
  refundRemainingAmount?: InputMaybe<Scalars['Boolean']>;
  refundServiceFee?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPaymentReserveProductArgs = {
  paymentPriceToken: Scalars['String'];
};


export type MutationPaymentTokenConfirmArgs = {
  id: Scalars['ID'];
};


export type MutationPaymentTokenCreateArgs = {
  data: PaymentTokenCreate;
  paymentType: PaymentTokenPaymentType;
};


export type MutationPaymentTokenFailedArgs = {
  cancelReservation: Scalars['Boolean'];
  failedReason: PaymentTokenFaildReason;
  id: Scalars['ID'];
};


export type MutationPlatformFeesUpdateArgs = {
  companySettings?: InputMaybe<CompanySettingUpdate>;
  franchiseSettings?: InputMaybe<FranchiseSettingUpdate>;
  stripeConnection?: InputMaybe<StripeConnectionUpdate>;
};


export type MutationPlatformInvoiceGetForPeriodArgs = {
  data: PlatformInvoiceGetForPeriod;
};


export type MutationPointAccountGetNumbersXlsxArgs = {
  pointAccount: Scalars['ID'];
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationPointAccountUpdateArgs = {
  data: PointAccountUpdate;
  pointAccount: Scalars['ID'];
};


export type MutationPointAccountsCompanyGetNumbersArgs = {
  sendToEmail: Scalars['String'];
  toDate: Scalars['DateTime'];
};


export type MutationPointProductCreateArgs = {
  data: PointProductCreate;
};


export type MutationPointProductDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationPointProductUpdateArgs = {
  data: PointProductUpdate;
  id: Scalars['ID'];
};


export type MutationPointTransactionUpdateArgs = {
  data: PointTransactionUpdate;
  id: Scalars['ID'];
};


export type MutationPointsAddOrRemoveArgs = {
  amount: Scalars['Int'];
  isOneToOne?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  pointAccount: Scalars['ID'];
  realValue?: InputMaybe<Scalars['Float']>;
  skipPlatformFees?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPriceffModelCreateArgs = {
  data: PriceffModelCreate;
};


export type MutationPriceffModelUpdateArgs = {
  data: PriceffModelUpdate;
  id: Scalars['ID'];
};


export type MutationPriceffParameterCreateArgs = {
  data: PriceffParameterCreate;
};


export type MutationPriceffParameterUpdateArgs = {
  data: PriceffParameterUpdate;
  id: Scalars['ID'];
};


export type MutationResourceAddCameraArgs = {
  camera: Scalars['ID'];
  resource: Scalars['ID'];
};


export type MutationResourceAddLightControllerArgs = {
  noxAreaId: Scalars['Int'];
  noxTimeProfileId?: InputMaybe<Scalars['Int']>;
  resource: Scalars['ID'];
};


export type MutationResourceBookingAttendeeAddArgs = {
  resourceBooking: Scalars['ID'];
  users: Array<Scalars['ID']>;
};


export type MutationResourceBookingAttendeeDeleteArgs = {
  resourceBooking: Scalars['ID'];
  resourceBookingAttendees: Array<Scalars['ID']>;
};


export type MutationResourceBookingBookliVideoCreateArgs = {
  resourceBooking: Scalars['ID'];
};


export type MutationResourceBookingCancelArgs = {
  id: Scalars['ID'];
  refundPayment?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResourceBookingCreateCompanyReservationArgs = {
  data: ResourceBookingCreateCompanyReservation;
};


export type MutationResourceBookingRecurringCreateArgs = {
  data: ResourceBookingRecurringCreate;
};


export type MutationResourceBookingRecurringDeleteArgs = {
  deleteAllFutureBookings?: InputMaybe<Scalars['Boolean']>;
  resourceBookingRecurring: Scalars['ID'];
};


export type MutationResourceBookingRecurringUpdateArgs = {
  data: ResourceBookingRecurringUpdate;
  id: Scalars['ID'];
};


export type MutationResourceBookingUpdateArgs = {
  data: ResourceBookingUpdateData;
  resourceBooking: Scalars['ID'];
};


export type MutationResourceCategoryCreateArgs = {
  data: ResourceCategoryCreate;
};


export type MutationResourceCategoryUpdateArgs = {
  data: ResourceCategoryUpdate;
  resourceCategory?: InputMaybe<Scalars['ID']>;
};


export type MutationResourceCreateArgs = {
  data: ResourceCreate;
};


export type MutationResourceRemoveCameraArgs = {
  resource: Scalars['ID'];
};


export type MutationResourceTypeConnectPriceffModelArgs = {
  priceffModel: Scalars['ID'];
  resourceType: Scalars['ID'];
};


export type MutationResourceTypeCreateArgs = {
  data: ResourceTypeCreate;
};


export type MutationResourceTypePriceCreateArgs = {
  data: ResourceTypePriceCreate;
};


export type MutationResourceTypePriceDateAddArgs = {
  date?: InputMaybe<CreateResourceTypePriceDate>;
  resourceTypePriceId?: InputMaybe<Scalars['ID']>;
};


export type MutationResourceTypePriceDateDeleteArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationResourceTypePriceDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationResourceTypePriceUpdateArgs = {
  data: ResourceTypePriceUpdate;
  id: Scalars['ID'];
};


export type MutationResourceTypePriceffUpdateArgs = {
  data: ResourceTypePriceffUpdate;
  id: Scalars['ID'];
};


export type MutationResourceTypeUpdateArgs = {
  data: ResourceTypeUpdate;
  resourceType?: InputMaybe<Scalars['ID']>;
};


export type MutationResourceUpdateArgs = {
  data: ResourceUpdate;
  resource: Scalars['ID'];
};


export type MutationSaEventArgs = {
  dimension?: InputMaybe<Scalars['String']>;
  event: Scalars['String'];
  value: Scalars['Float'];
};


export type MutationSendMigrationFileArgs = {
  fileNameGCP: Scalars['String'];
  messageEmail: Scalars['String'];
  sendToTest?: InputMaybe<Scalars['String']>;
};


export type MutationSetUserFcmTokenArgs = {
  fcmToken: Scalars['String'];
};


export type MutationStripeConnectionUpdateArgs = {
  data: StripeConnectionUpdate;
};


export type MutationStripeReportGenerateArgs = {
  data: StripeReportGenerate;
};


export type MutationStripeUserRemovePaymentMethodArgs = {
  id: Scalars['ID'];
};


export type MutationSubscriptionProductCategoryCreateArgs = {
  data: SubscriptionProductCategoryCreate;
};


export type MutationSubscriptionProductCreateArgs = {
  data: SubscriptionProductCreate;
};


export type MutationSubscriptionProductGiftCardCreateArgs = {
  data: SubscriptionProductGiftCardCreate;
};


export type MutationSubscriptionProductStartDateForFirstPaymentCreateArgs = {
  data: SubscriptionProductStartDateForFirstPaymentCreate;
};


export type MutationSubscriptionProductUpdateArgs = {
  data: SubscriptionProductUpdate;
  id: Scalars['ID'];
};


export type MutationSupportTicketCreateArgs = {
  data: SupportTicketCreate;
};


export type MutationTrinityEComCreateCheckoutArgs = {
  cartItems: Array<InputMaybe<TrinityEComCartItem>>;
  country: SupportedCountries;
  postCode: Scalars['String'];
};


export type MutationTrinityEComCreateCheckoutPayPalArgs = {
  country: SupportedCountries;
  customerBillingAddress: TrinityCustomerBillingAddressInput;
  customerEmail: Scalars['String'];
  customerTelephone: Scalars['String'];
  token: Scalars['String'];
};


export type MutationTrinityEComUpdateCheckoutDeliveryOptionArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  configurationId: Scalars['String'];
  country: SupportedCountries;
  deliveryOptionId: Scalars['String'];
  token: Scalars['String'];
  vendor: Scalars['Int'];
};


export type MutationTrinityEComUpdateCheckoutDeliveryOptionsPostCodeArgs = {
  country: SupportedCountries;
  postCode: Scalars['String'];
  token: Scalars['String'];
  vendor: Scalars['Int'];
};


export type MutationTrinityEComUpdateCheckoutPaymentTypeArgs = {
  country: SupportedCountries;
  paymentTypeId: Scalars['Int'];
  token: Scalars['String'];
};


export type MutationUpdatePaymentStatusArgs = {
  id: Scalars['ID'];
  status: PaymentStatus;
};


export type MutationUploadMigrationFileArgs = {
  file: Scalars['Upload'];
};


export type MutationUserAcceptAgreementsArgs = {
  acceptedAgreements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  declinedAgreements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationUserCreateArgs = {
  company?: InputMaybe<Scalars['ID']>;
  defaultLocation?: InputMaybe<Scalars['ID']>;
  ref?: InputMaybe<Scalars['String']>;
  userData: UserCreate;
  userPlatformConnectionToken?: InputMaybe<Scalars['String']>;
};


export type MutationUserDeleteArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationUserGroupAddAutomaticSubscriptionProductArgs = {
  subscriptionProduct: Scalars['ID'];
  userGroup: Scalars['ID'];
};


export type MutationUserGroupAddPointAccountArgs = {
  userGroup: Scalars['ID'];
};


export type MutationUserGroupAddUsersArgs = {
  userGroup: Scalars['ID'];
  users: Array<Scalars['ID']>;
};


export type MutationUserGroupAdminAddArgs = {
  user: Scalars['ID'];
  userGroup: Scalars['ID'];
};


export type MutationUserGroupAdminRemoveArgs = {
  user: Scalars['ID'];
  userGroup: Scalars['ID'];
};


export type MutationUserGroupCreateArgs = {
  data: UserGroupCreate;
};


export type MutationUserGroupDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationUserGroupRemoveAutomaticSubscriptionProductArgs = {
  userGroup: Scalars['ID'];
};


export type MutationUserGroupRemovePointAccountArgs = {
  userGroup: Scalars['ID'];
};


export type MutationUserGroupRemoveUsersArgs = {
  userGroup: Scalars['ID'];
  users: Array<Scalars['ID']>;
};


export type MutationUserGroupUpdateArgs = {
  data: UserGroupUpdate;
  id: Scalars['ID'];
};


export type MutationUserPlatformConnectionCreateArgs = {
  company?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  userAuthToken?: InputMaybe<Scalars['String']>;
  userPlatformConnectionToken?: InputMaybe<Scalars['String']>;
};


export type MutationUserPlatformConnectionDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationUserPlatformConnectionTokenCreateArgs = {
  data: UserPlatformConnectionTokenCreate;
};


export type MutationUserPlatformConnectionTokenDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationUserProductSubscriptionCancelArgs = {
  cancelImmediately?: InputMaybe<Scalars['Boolean']>;
  deleteBookings?: InputMaybe<Scalars['Boolean']>;
  refundLatestPayment?: InputMaybe<Scalars['Boolean']>;
  userProductSubscription: Scalars['ID'];
};


export type MutationUserProductSubscriptionCanceleByAdminArgs = {
  deleteBookings?: InputMaybe<Scalars['Boolean']>;
  userProductSubscription: Scalars['ID'];
};


export type MutationUserProductSubscriptionCreateByAdminArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  shouldBePaidSubscription?: InputMaybe<Scalars['Boolean']>;
  subscriptionProduct: Scalars['ID'];
  user: Scalars['ID'];
};


export type MutationUserProductSubscriptionReactivateArgs = {
  userProductSubscription: Scalars['ID'];
};


export type MutationUserProductSubscriptionsToExcelArgs = {
  filtering?: InputMaybe<UserProductSubscriptionsFiltering>;
};


export type MutationUserUpdateArgs = {
  data: UserUpdate;
  user?: InputMaybe<Scalars['ID']>;
};


export type MutationUserUploadProfileImgArgs = {
  file: Scalars['Upload'];
};


export type MutationWannasportConnectionChangePossibleTimeSlotsArgs = {
  timeSlots: Array<InputMaybe<WannasportPossibleTimeSlotInput>>;
  wannasportConnection: Scalars['ID'];
};


export type MutationWannasportConnectionCreateArgs = {
  data: WannasportConnectionCreate;
};


export type MutationWorkshopBookingCancelArgs = {
  refundPayment?: InputMaybe<Scalars['Boolean']>;
  workshopBooking: Scalars['ID'];
};


export type MutationWorkshopBookingCreateAdminArgs = {
  users: Array<Scalars['ID']>;
  workshop: Scalars['ID'];
};


export type MutationWorkshopBookingCreateUserReservationArgs = {
  userBookingNote?: InputMaybe<Scalars['String']>;
  workshop: Scalars['ID'];
};


export type MutationWorkshopCanceleArgs = {
  id: Scalars['ID'];
};


export type MutationWorkshopCreateArgs = {
  data: WorkshopCreate;
};


export type MutationWorkshopDayCreateArgs = {
  data: WorkshopDayCreate;
  workshop: Scalars['ID'];
};


export type MutationWorkshopDayDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationWorkshopDayUpdateArgs = {
  data: WorkshopDayUpdate;
  id: Scalars['ID'];
};


export type MutationWorkshopUpdateArgs = {
  data: WorkshopUpdate;
  id: Scalars['ID'];
};


export type MutationWorkshopWaitlistCancelArgs = {
  workshopId?: InputMaybe<Scalars['ID']>;
};


export type MutationWorkshopWaitlistJoinArgs = {
  workshop: Scalars['ID'];
};

export type MutationResult = {
  __typename?: 'MutationResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MutationResultCustom = {
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum NoxVersion {
  R7 = 'R7',
  R8 = 'R8',
  RestApi = 'RestApi'
}

export enum OrderHandlingStatusType {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type Pagination = {
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PaginationInput = {
  first: Scalars['Int'];
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PayPalClientData = {
  __typename?: 'PayPalClientData';
  clientId: Scalars['String'];
  currency: Currency;
};

export type PayPalConnection = {
  __typename?: 'PayPalConnection';
  id: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  additionalServiceId?: Maybe<Scalars['String']>;
  additionalServiceValue: Scalars['Float'];
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  connectedPayment?: Maybe<Payment>;
  connectedPayments: Array<Payment>;
  connectedTo: FranchiseOrCompany;
  coupon?: Maybe<CouponUsage>;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  customer: User;
  customerId: Scalars['String'];
  id: Scalars['String'];
  invoiceUrl?: Maybe<Scalars['String']>;
  lines: Array<PaymentLine>;
  mobilePayInvoice: MobilePayInvoice;
  mobilePayInvoiceId?: Maybe<Scalars['String']>;
  moneyValue?: Maybe<Scalars['Float']>;
  paymentMethod: PaymentMethod;
  platformFeeAmount: Scalars['Float'];
  pointBounty?: Maybe<PointTransaction>;
  pointTransaction?: Maybe<PointTransaction>;
  pointValue?: Maybe<Scalars['Float']>;
  priceffDynamicPriceUsages: Array<PriceffDynamicPriceResourceUsage>;
  product: Product;
  productPointTransaction?: Maybe<PointTransaction>;
  productResourceBooking?: Maybe<ResourceBooking>;
  productUserProductSubscription?: Maybe<UserProductSubscription>;
  productValue: Scalars['Float'];
  productWorkshopBooking?: Maybe<WorkshopBooking>;
  quantity: Scalars['Float'];
  status: PaymentStatus;
  stripeInvoice?: Maybe<StripeInvoice>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userProductSubscription?: Maybe<UserProductSubscription>;
  value: Scalars['Float'];
};


export type PaymentConnectedPaymentsArgs = {
  after?: InputMaybe<PaymentWhereUniqueInput>;
  before?: InputMaybe<PaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PaymentLinesArgs = {
  after?: InputMaybe<PaymentLineWhereUniqueInput>;
  before?: InputMaybe<PaymentLineWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PaymentPriceffDynamicPriceUsagesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PaymentCalculatePriceInput = {
  additionalServicesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companyId?: InputMaybe<Scalars['String']>;
  couponSlug?: InputMaybe<Scalars['String']>;
  pointProduct?: InputMaybe<Scalars['ID']>;
  productType: ProductType;
  resourceBookingAttendeeBuyOut?: InputMaybe<ResourceBookingAttendeeBuyOutInput>;
  resourceBookingInfo?: InputMaybe<PaymentCalculatePriceResourceBookingInfoInput>;
  restPointsPointAccount?: InputMaybe<Scalars['ID']>;
  subscriptionProduct?: InputMaybe<Scalars['ID']>;
  subscriptionProductGiftCardCode?: InputMaybe<Scalars['String']>;
  useDiscounts?: InputMaybe<Scalars['Boolean']>;
  userProductSubscriptionId?: InputMaybe<Scalars['ID']>;
  workshopBookingInfo?: InputMaybe<PaymentCalculatePriceWorkshopBookingInfoInput>;
};

export type PaymentCalculatePriceResourceBookingInfoInput = {
  additionalServices?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  attendees?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['DateTime'];
  internalNotes?: InputMaybe<Scalars['String']>;
  resource: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type PaymentCalculatePriceWorkshopBookingInfoInput = {
  userBookingNote?: InputMaybe<Scalars['String']>;
  workshop: Scalars['ID'];
};

export type PaymentCancelReservedProduct = {
  productType: ProductType;
  resourceBooking?: InputMaybe<Scalars['ID']>;
  workshopBooking?: InputMaybe<Scalars['ID']>;
};

export type PaymentLine = {
  __typename?: 'PaymentLine';
  accountingLine?: Maybe<AccountingLine>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  payment: Payment;
  type: PaymentLineType;
  value: Scalars['Float'];
};

export enum PaymentLineType {
  CouponUsed = 'CouponUsed',
  Created = 'Created',
  Failed = 'Failed',
  Paid = 'Paid',
  PartialRefunded = 'PartialRefunded',
  PaymentPointBounty = 'PaymentPointBounty',
  PlatformFee = 'PlatformFee',
  Refund = 'Refund',
  RefundAsPoints = 'RefundAsPoints',
  ReversedPaymentPointBounty = 'ReversedPaymentPointBounty'
}

export type PaymentLineWhereUniqueInput = {
  accountingLineId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  pointTransactionId?: InputMaybe<Scalars['String']>;
};

export type PaymentLinesFiltering = {
  payment?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};

export type PaymentLinesResult = Pagination & {
  __typename?: 'PaymentLinesResult';
  data: Array<PaymentLine>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export enum PaymentMethod {
  ConnectedPayments = 'ConnectedPayments',
  Coupon = 'Coupon',
  External = 'External',
  Free = 'Free',
  MobilePayInvoice = 'MobilePayInvoice',
  MobilePaySubscription = 'MobilePaySubscription',
  MobilePaySubscriptionOneOff = 'MobilePaySubscriptionOneOff',
  NotSet = 'NotSet',
  PayPal = 'PayPal',
  Points = 'Points',
  ProductSubscription = 'ProductSubscription',
  Stripe = 'Stripe',
  StripeInvoice = 'StripeInvoice',
  StripeSubscription = 'StripeSubscription',
  UserProductSubscription = 'UserProductSubscription'
}

export type PaymentMethodApplicationFeeAnalytic = {
  __typename?: 'PaymentMethodApplicationFeeAnalytic';
  avg: Scalars['Float'];
  count: Scalars['Int'];
  paymentMethod: Scalars['String'];
  sum: Scalars['Float'];
};

export type PaymentPrice = {
  __typename?: 'PaymentPrice';
  additionalServicesPriceAmount?: Maybe<Scalars['Float']>;
  amountToPay: Scalars['Float'];
  amountWithoutAdditionalServices?: Maybe<Scalars['Float']>;
  amountWithoutCoupon: Scalars['Float'];
  amountWithoutRestPoints: Scalars['Float'];
  discount: Scalars['Float'];
  paymentPriceToken: Scalars['String'];
  platformFee?: Maybe<Scalars['Float']>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  resourceBookingInfo?: Maybe<PaymentPriceResourceBookingInfo>;
  useConnectedPayments?: Maybe<Scalars['Boolean']>;
  validToUseCoupon: Scalars['Boolean'];
};

export type PaymentPriceResourceBookingInfo = {
  __typename?: 'PaymentPriceResourceBookingInfo';
  attendees: Array<ResourceBookingPaymentAttendee>;
  resourceBookingAttendeesToken: Scalars['String'];
};

export type PaymentReserveProduct = {
  __typename?: 'PaymentReserveProduct';
  resourceBooking?: Maybe<ResourceBooking>;
  workshopBooking?: Maybe<WorkshopBooking>;
};

export enum PaymentStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Paid = 'Paid',
  PartialRefunded = 'PartialRefunded',
  Pending = 'Pending',
  PendingPayment = 'PendingPayment',
  Refunded = 'Refunded',
  Unpaid = 'Unpaid',
  WaitingStatus = 'WaitingStatus'
}

export type PaymentToken = {
  __typename?: 'PaymentToken';
  amountToPay: Scalars['Float'];
  attemptCount: Scalars['Int'];
  company: Company;
  country: SupportedCountries;
  currency: Currency;
  failedReason?: Maybe<PaymentTokenFaildReason>;
  id: Scalars['String'];
  label: Scalars['String'];
  lastFailureReason?: Maybe<Scalars['String']>;
  method?: Maybe<PaymentTokenMethod>;
  mobilePayConnection?: Maybe<MobilePayConnection>;
  payPalConnection?: Maybe<PayPalConnection>;
  payPalInvoiceId?: Maybe<Scalars['String']>;
  payPalPaymentId?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
  paymentType: PaymentTokenPaymentType;
  state: PaymentTokenState;
  stripeClientSecret?: Maybe<Scalars['String']>;
  stripeConnection?: Maybe<StripeConnection>;
  stripeConnectionId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentMethod?: Maybe<Scalars['String']>;
  type: PaymentTokenType;
  user: User;
  userId: Scalars['String'];
};

export type PaymentTokenCreate = {
  paymentPriceToken: Scalars['String'];
  pointAccountId?: InputMaybe<Scalars['ID']>;
  resourceBookingRef?: InputMaybe<Scalars['ID']>;
  workshopBookingRef?: InputMaybe<Scalars['ID']>;
};

export enum PaymentTokenFaildReason {
  Auth = 'Auth',
  Canceled = 'Canceled',
  CanceledPaymentIsInFuture = 'CanceledPaymentIsInFuture',
  CanceledTime = 'CanceledTime',
  Expired = 'Expired',
  Invalid = 'Invalid',
  Rejected = 'Rejected',
  Unknown = 'Unknown'
}

export enum PaymentTokenMethod {
  Free = 'Free',
  MobilePayInvoice = 'MobilePayInvoice',
  Points = 'Points',
  Stripe = 'Stripe',
  UserProductSubscription = 'UserProductSubscription'
}

export enum PaymentTokenPaymentType {
  Free = 'Free',
  MobilePayInvoice = 'MobilePayInvoice',
  NotSet = 'NotSet',
  PayPal = 'PayPal',
  Points = 'Points',
  Stripe = 'Stripe',
  StripeApplePay = 'StripeApplePay',
  StripeCard = 'StripeCard',
  StripeGooglePay = 'StripeGooglePay',
  StripeInvoice = 'StripeInvoice',
  StripeSavedCard = 'StripeSavedCard',
  UserProductSubscription = 'UserProductSubscription'
}

export enum PaymentTokenState {
  Faild = 'Faild',
  Paid = 'Paid',
  PaymentAttemptFailed = 'PaymentAttemptFailed',
  WaitingCancel = 'WaitingCancel',
  WaitingPayment = 'WaitingPayment'
}

export type PaymentTokenSubscriptionPayload = {
  __typename?: 'PaymentTokenSubscriptionPayload';
  id: Scalars['ID'];
  paymentToken: PaymentToken;
};

export enum PaymentTokenType {
  Product = 'Product',
  ResourceBooking = 'ResourceBooking',
  ResourceBookingAttendeeBuyOut = 'ResourceBookingAttendeeBuyOut',
  SubscriptionProduct = 'SubscriptionProduct',
  WorkshopBooking = 'WorkshopBooking'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  paymentMethod: PaymentMethod;
  paymentType: PaymentTokenPaymentType;
};

export type PaymentUserAllowedPaymentTypes = {
  __typename?: 'PaymentUserAllowedPaymentTypes';
  paymentTypes: Array<PaymentType>;
  pointAccounts: Array<PointAccount>;
  selectedUserProductSubscription?: Maybe<Scalars['ID']>;
};

export type PaymentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  mobilePayInvoiceId?: InputMaybe<Scalars['String']>;
  mobilePayInvouceReferenceId?: InputMaybe<Scalars['String']>;
  mobilePaySubscriptionOneOffPaymentId?: InputMaybe<Scalars['String']>;
  mobilePaySubscriptionPaymentId?: InputMaybe<Scalars['String']>;
  productResourceBookingNoShowFeeId?: InputMaybe<Scalars['String']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  stripeInvoiceItemId?: InputMaybe<Scalars['String']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']>;
};

export type PaymentsFiltering = {
  company?: InputMaybe<Scalars['ID']>;
  connectedToPayment?: InputMaybe<Scalars['ID']>;
  franchise?: InputMaybe<Scalars['ID']>;
  hidePaymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
  paidWithUserProductSubscription?: InputMaybe<Scalars['ID']>;
  productType?: InputMaybe<ProductType>;
  productUserProductSubscription?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  showConnectedPayments?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<PaymentStatus>;
  stripeInvoice?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type PaymentsResult = Pagination & {
  __typename?: 'PaymentsResult';
  data: Array<Payment>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PlatformFees = {
  __typename?: 'PlatformFees';
  companies: Array<CompanyWithFees>;
  franchises: Array<FranchiseWithFees>;
};

export type PlatformInvoice = {
  __typename?: 'PlatformInvoice';
  endDate: Scalars['DateTime'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceNumber: Scalars['Int'];
  startDate: Scalars['DateTime'];
};

export type PlatformInvoiceGetForPeriod = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type PlatformInvoicesFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type PlatformInvoicesResult = Pagination & {
  __typename?: 'PlatformInvoicesResult';
  data: Array<PlatformInvoice>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PointAccount = {
  __typename?: 'PointAccount';
  accountNumbers: PointAccountNumbers;
  active: Scalars['Boolean'];
  automaticAddPointsAmount?: Maybe<Scalars['Int']>;
  automaticPointsActive: Scalars['Boolean'];
  automaticPointsInsertOnTheFirstOfMonth: Scalars['Boolean'];
  automaticPointsInsertTimesPrYear: Scalars['Int'];
  company?: Maybe<Company>;
  connectedTo: FranchiseOrCompany;
  enoughPointsForPayment?: Maybe<Scalars['Boolean']>;
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  pointAccountConnectedTo: PointAccountConnectedTo;
  pointsAmount: Scalars['Int'];
  removeDiscountToDoPayment?: Maybe<Scalars['Boolean']>;
  resetPointsOnAutomaticRecharge: Scalars['Boolean'];
  transactions: Array<PointTransaction>;
  usedTheLastXDays: Scalars['Float'];
  user?: Maybe<User>;
  userGroup?: Maybe<UserGroup>;
};


export type PointAccountTransactionsArgs = {
  after?: InputMaybe<PointTransactionWhereUniqueInput>;
  before?: InputMaybe<PointTransactionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PointAccountUsedTheLastXDaysArgs = {
  days?: InputMaybe<Scalars['Int']>;
};

export type PointAccountCanUseRestPointsForPaymentResult = {
  __typename?: 'PointAccountCanUseRestPointsForPaymentResult';
  canDo: Scalars['Boolean'];
  pointAccount: PointAccount;
  pointAccountId?: Maybe<Scalars['ID']>;
  pointsAmount?: Maybe<Scalars['Float']>;
};

export enum PointAccountConnectedTo {
  Company = 'Company',
  Franchise = 'Franchise',
  UserGroup = 'UserGroup'
}

export type PointAccountNumbers = {
  __typename?: 'PointAccountNumbers';
  pointAmountOtOFalse: Scalars['Float'];
  pointAmountOtOFalseRatio: Scalars['Float'];
  pointAmountOtOMixRatio: Scalars['Float'];
  pointAmountOtOTrue: Scalars['Float'];
};

export type PointAccountTransactionsFiltering = {
  afterCreatedAt?: InputMaybe<Scalars['DateTime']>;
  beforeCreatedAt?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
};

export type PointAccountTransactionsResult = Pagination & {
  __typename?: 'PointAccountTransactionsResult';
  data: Array<PointTransaction>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PointAccountUpdate = {
  automaticAddPointsAmount?: InputMaybe<Scalars['Int']>;
  automaticPointsActive?: InputMaybe<Scalars['Boolean']>;
  automaticPointsInsertOnTheFirstOfMonth?: InputMaybe<Scalars['Boolean']>;
  automaticPointsInsertTimesPrYear?: InputMaybe<Scalars['Int']>;
  pointAccountActive?: InputMaybe<Scalars['Boolean']>;
  resetPointsOnAutomaticRecharge?: InputMaybe<Scalars['Boolean']>;
};

export type PointProduct = {
  __typename?: 'PointProduct';
  company?: Maybe<Company>;
  connectedTo: FranchiseOrCompany;
  discountPercent: Scalars['Int'];
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pointTransactions: Array<PointTransaction>;
  pointsAmount: Scalars['Int'];
  product: Product;
  title?: Maybe<Scalars['String']>;
};


export type PointProductPointTransactionsArgs = {
  after?: InputMaybe<PointTransactionWhereUniqueInput>;
  before?: InputMaybe<PointTransactionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PointProductCreate = {
  order?: InputMaybe<Scalars['Int']>;
  pointsAmount: Scalars['Int'];
  price: Scalars['Float'];
  title?: InputMaybe<Scalars['String']>;
};

export type PointProductUpdate = {
  order?: InputMaybe<Scalars['Int']>;
  pointsAmount?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PointProductsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type PointProductsResult = Pagination & {
  __typename?: 'PointProductsResult';
  data: Array<PointProduct>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PointTransaction = {
  __typename?: 'PointTransaction';
  amount: Scalars['Int'];
  connectedToPaymentLine?: Maybe<PaymentLine>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isOneToOne: Scalars['Boolean'];
  manualTransactionBy?: Maybe<User>;
  notes?: Maybe<Scalars['String']>;
  paidWithPoints?: Maybe<Payment>;
  payment?: Maybe<Payment>;
  paymentPointBounty?: Maybe<Payment>;
  platformFeeAmount: Scalars['Float'];
  pointAccount: PointAccount;
  pointAccountId: Scalars['String'];
  realValue?: Maybe<Scalars['Float']>;
  type: PointTransactionType;
  usedOnCompany?: Maybe<Company>;
  user?: Maybe<User>;
  valueRatio: Scalars['Float'];
};

export enum PointTransactionType {
  AutomaticPoints = 'AutomaticPoints',
  BuyPoints = 'BuyPoints',
  BuyPointsRefunded = 'BuyPointsRefunded',
  Manual = 'Manual',
  PaymentRefunded = 'PaymentRefunded',
  PointBounty = 'PointBounty',
  PointPayment = 'PointPayment',
  RefundForResourceBookingAddedSubscriptionPayment = 'RefundForResourceBookingAddedSubscriptionPayment'
}

export type PointTransactionUpdate = {
  realValue?: InputMaybe<Scalars['Int']>;
};

export type PointTransactionWhereUniqueInput = {
  connectedToPointTransactionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  paidWithPointsId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  paymentPointBountyId?: InputMaybe<Scalars['String']>;
  platformFeeAccountingLineId?: InputMaybe<Scalars['String']>;
};

export type PriceffAnalytic = {
  __typename?: 'PriceffAnalytic';
  a: Scalars['Int'];
};

export type PriceffAnalyticDynamicChart = {
  __typename?: 'PriceffAnalyticDynamicChart';
  parameters: Array<PriceffAnalyticDynamicChartParameter>;
};

export type PriceffAnalyticDynamicChartConversions = {
  __typename?: 'PriceffAnalyticDynamicChartConversions';
  avgProcentage: Scalars['Float'];
  chart: ChartGeneratorResult;
};

export type PriceffAnalyticDynamicChartParameter = {
  __typename?: 'PriceffAnalyticDynamicChartParameter';
  conversions: PriceffAnalyticDynamicChartConversions;
  id: Scalars['ID'];
  price: PriceffAnalyticDynamicChartPrice;
  sales: PriceffAnalyticDynamicChartSales;
};

export type PriceffAnalyticDynamicChartPrice = {
  __typename?: 'PriceffAnalyticDynamicChartPrice';
  avgPrice: Scalars['Float'];
  chart: ChartGeneratorResult;
  maxPrice: Scalars['Float'];
  minPrice: Scalars['Float'];
};

export type PriceffAnalyticDynamicChartSales = {
  __typename?: 'PriceffAnalyticDynamicChartSales';
  avgIndex: Scalars['Float'];
  chart: ChartGeneratorResult;
  targetIndex: Scalars['Float'];
};

export type PriceffAnalyticKpiItem = {
  __typename?: 'PriceffAnalyticKPIItem';
  price: PriceffAnalyticKpiPrice;
  sales: PriceffAnalyticKpiSales;
  text: Scalars['String'];
};

export type PriceffAnalyticKpiPrice = {
  __typename?: 'PriceffAnalyticKPIPrice';
  avgIndex: Scalars['Float'];
  percentageAtMax: Scalars['Float'];
  percentageAtMin: Scalars['Float'];
};

export type PriceffAnalyticKpiSales = {
  __typename?: 'PriceffAnalyticKPISales';
  avgDiffPrice: Scalars['Float'];
  avgIndex: Scalars['Float'];
  salesCount: Scalars['Int'];
  totalRevenue: Scalars['Float'];
};

export type PriceffAnalyticSummaryChart = {
  __typename?: 'PriceffAnalyticSummaryChart';
  parameters: Array<PriceffAnalyticSummaryChartParameter>;
};

export type PriceffAnalyticSummaryChartConversions = {
  __typename?: 'PriceffAnalyticSummaryChartConversions';
  avgProcentage: Scalars['Float'];
  chart: ChartGeneratorResult;
};

export type PriceffAnalyticSummaryChartParameter = {
  __typename?: 'PriceffAnalyticSummaryChartParameter';
  conversions: PriceffAnalyticSummaryChartConversions;
  id: Scalars['ID'];
  price: PriceffAnalyticSummaryChartPrice;
  sales: PriceffAnalyticSummaryChartSales;
};

export type PriceffAnalyticSummaryChartPrice = {
  __typename?: 'PriceffAnalyticSummaryChartPrice';
  avgPriceIndex: Scalars['Float'];
  chart: ChartGeneratorResult;
  maxPriceIndex: Scalars['Float'];
  minPriceIndex: Scalars['Float'];
  orginalPriceIndex: Scalars['Float'];
};

export type PriceffAnalyticSummaryChartSales = {
  __typename?: 'PriceffAnalyticSummaryChartSales';
  avgIndex: Scalars['Float'];
  chart: ChartGeneratorResult;
  targetIndex: Scalars['Float'];
};

export type PriceffDynamicPriceResource = {
  __typename?: 'PriceffDynamicPriceResource';
  capacityLeft: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currentPrice?: Maybe<PriceffDynamicPriceResourcePrice>;
  dates: Array<PriceffDynamicPriceResourceDate>;
  id: Scalars['String'];
  maxCapacity: Scalars['Int'];
  parameters: PriceffParameter;
  priceUsageChart: Scalars['String'];
  priceffDashboardLink: Scalars['String'];
  priceffModel: PriceffModel;
  priceffSalesBatchId: Scalars['String'];
  prices: Array<PriceffDynamicPriceResourcePrice>;
  pricesCount: Scalars['Int'];
  resourceType: ResourceType;
  usages: Array<PriceffDynamicPriceResourceUsage>;
  usagesCount: Scalars['Int'];
  utilizationPercentage: Scalars['Int'];
};


export type PriceffDynamicPriceResourceDatesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourceDateWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourceDateWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PriceffDynamicPriceResourcePriceUsageChartArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type PriceffDynamicPriceResourcePricesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourcePriceWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourcePriceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PriceffDynamicPriceResourceUsagesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PriceffDynamicPriceResourceDate = {
  __typename?: 'PriceffDynamicPriceResourceDate';
  dynamicPriceResource: PriceffDynamicPriceResource;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type PriceffDynamicPriceResourceDateGrouped = {
  __typename?: 'PriceffDynamicPriceResourceDateGrouped';
  date: Scalars['DateTime'];
  dates: Array<PriceffDynamicPriceResourceDate>;
};

export type PriceffDynamicPriceResourceDateWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PriceffDynamicPriceResourcePrice = {
  __typename?: 'PriceffDynamicPriceResourcePrice';
  createdAt: Scalars['DateTime'];
  dynamicPriceResource: PriceffDynamicPriceResource;
  dynamicPriceResourceId: Scalars['String'];
  id: Scalars['String'];
  orginalPriceDiff: Scalars['Float'];
  originalPrice?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  toNextLimit: Scalars['Float'];
  usages: Array<PriceffDynamicPriceResourceUsage>;
};


export type PriceffDynamicPriceResourcePriceUsagesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PriceffDynamicPriceResourcePriceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PriceffDynamicPriceResourceUsage = {
  __typename?: 'PriceffDynamicPriceResourceUsage';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  price: PriceffDynamicPriceResourcePrice;
  priceffDynamicPriceResource: PriceffDynamicPriceResource;
  quantity: Scalars['Int'];
};

export type PriceffDynamicPriceResourceUsageWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PriceffDynamicPriceResourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  priceffSalesBatchId?: InputMaybe<Scalars['String']>;
};

export type PriceffModel = {
  __typename?: 'PriceffModel';
  data: Array<PriceffModelDateSlot>;
  dataJson: Scalars['String'];
  generateDynamicPricesWeeksAhead: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PriceffModelCreate = {
  data: Array<PriceffModelDateSlotInput>;
  generateDynamicPricesWeeksAhead: Scalars['Int'];
  name: Scalars['String'];
};

export type PriceffModelDateSlot = {
  __typename?: 'PriceffModelDateSlot';
  daySlots: Array<PriceffModelDaysSlot>;
  endDayOfYear: Scalars['Int'];
  startDayOfYear: Scalars['Int'];
};

export type PriceffModelDateSlotInput = {
  daySlots?: InputMaybe<Array<InputMaybe<PriceffModelDaysSlotInput>>>;
  endDayOfYear: Scalars['Int'];
  startDayOfYear: Scalars['Int'];
};

export type PriceffModelDaysSlot = {
  __typename?: 'PriceffModelDaysSlot';
  days: Array<Day>;
  timeSlots: Array<PriceffModelTimeSlot>;
};

export type PriceffModelDaysSlotInput = {
  days: Array<Day>;
  timeSlots: Array<PriceffModelTimeSlotInput>;
};

export type PriceffModelTimeSlot = {
  __typename?: 'PriceffModelTimeSlot';
  asOneSalesBatch: Scalars['Boolean'];
  endTime: Scalars['String'];
  priceffParameter: PriceffParameter;
  priceffParameterId: Scalars['String'];
  startTime: Scalars['String'];
};

export type PriceffModelTimeSlotInput = {
  asOneSalesBatch: Scalars['Boolean'];
  endTime: Scalars['String'];
  priceffParameterId: Scalars['ID'];
  startTime: Scalars['String'];
};

export type PriceffModelUpdate = {
  data?: InputMaybe<Array<InputMaybe<PriceffModelDateSlotInput>>>;
  generateDynamicPricesWeeksAhead?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PriceffModelsResult = Pagination & {
  __typename?: 'PriceffModelsResult';
  data: Array<PriceffModel>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PriceffParameter = {
  __typename?: 'PriceffParameter';
  id: Scalars['String'];
  name: Scalars['String'];
  priceffParameters: PriceffParametersCustom;
  priceffParametersJson: Scalars['String'];
};

export type PriceffParameterCreate = {
  name: Scalars['String'];
  priceffParameters: PriceffParametersCustomInput;
};

export type PriceffParameterResult = Pagination & {
  __typename?: 'PriceffParameterResult';
  data: Array<PriceffParameter>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PriceffParameterUpdate = {
  name?: InputMaybe<Scalars['String']>;
  priceffParameters?: InputMaybe<PriceffParametersCustomInput>;
};

export type PriceffParametersCustom = {
  __typename?: 'PriceffParametersCustom';
  acvExpected?: Maybe<Scalars['Float']>;
  amountRolling?: Maybe<Scalars['Int']>;
  customProfile?: Maybe<Array<Scalars['Float']>>;
  discovery?: Maybe<Scalars['Float']>;
  elasticity?: Maybe<Scalars['Float']>;
  elasticity2?: Maybe<Scalars['Float']>;
  maxPriceIndex?: Maybe<Scalars['Float']>;
  minPriceIndex?: Maybe<Scalars['Float']>;
  priceType?: Maybe<PriceffPriceType>;
  profile?: Maybe<Scalars['Int']>;
  round?: Maybe<Scalars['Float']>;
  roundingOffset?: Maybe<Scalars['Float']>;
  startPriceIndex?: Maybe<Scalars['Float']>;
  targetAmountIndex?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PriceffParametersCustomInput = {
  acvExpected?: InputMaybe<Scalars['Float']>;
  amountRolling?: InputMaybe<Scalars['Int']>;
  customProfile?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  discovery?: InputMaybe<Scalars['Float']>;
  elasticity?: InputMaybe<Scalars['Float']>;
  elasticity2?: InputMaybe<Scalars['Float']>;
  maxPriceIndex?: InputMaybe<Scalars['Float']>;
  minPriceIndex?: InputMaybe<Scalars['Float']>;
  priceType?: InputMaybe<PriceffPriceType>;
  profile?: InputMaybe<Scalars['Int']>;
  round?: InputMaybe<Scalars['Float']>;
  roundingOffset?: InputMaybe<Scalars['Float']>;
  startPriceIndex?: InputMaybe<Scalars['Float']>;
  targetAmountIndex?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type PriceffPriceAnalytic = {
  __typename?: 'PriceffPriceAnalytic';
  a: Scalars['Int'];
};

export enum PriceffPriceBehavior {
  Down = 'DOWN',
  Normal = 'NORMAL',
  Up = 'UP'
}

export enum PriceffPriceType {
  A = 'A',
  B = 'B'
}

export type Product = {
  __typename?: 'Product';
  category?: Maybe<ProductCategory>;
  companyId?: Maybe<Scalars['String']>;
  connectedTo: FranchiseOrCompany;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  description: Scalars['String'];
  franchiseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  payWithSubscriptionIsOfAType: Scalars['Boolean'];
  paymentType: ProductPaymentType;
  payments: Array<Payment>;
  price: Scalars['Float'];
  productSubscriptionProduct?: Maybe<SubscriptionProduct>;
  type: ProductType;
  validToUseCoupon: Scalars['Boolean'];
};


export type ProductPaymentsArgs = {
  after?: InputMaybe<PaymentWhereUniqueInput>;
  before?: InputMaybe<PaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  allowedPaymentMethods: Array<PaymentMethod>;
  id: Scalars['String'];
};

export enum ProductPaymentType {
  OneTime = 'OneTime',
  ProductSubscription = 'ProductSubscription'
}

export enum ProductType {
  AdditionalService = 'AdditionalService',
  PlatformPlan = 'PlatformPlan',
  PointProduct = 'PointProduct',
  ResourceBooking = 'ResourceBooking',
  ResourceBookingAttendeeBuyOut = 'ResourceBookingAttendeeBuyOut',
  SubscriptionProduct = 'SubscriptionProduct',
  SubscriptionProductSignUpFee = 'SubscriptionProductSignUpFee',
  Workshop = 'Workshop'
}

export type Query = {
  __typename?: 'Query';
  accessCode: AccessCode;
  accessCodeAccessTimes: AccessCodeAccessTimesResult;
  accessCodeUsages: AccessCodeUsagesResult;
  accessCodes: AccessCodesResult;
  additionalService: AdditionalService;
  additionalServices: Array<AdditionalService>;
  agreements: AgreementsResult;
  agreementsForCompanyIsUpdated?: Maybe<Array<Maybe<Agreement>>>;
  agreementsForCompanySignUp: Array<Agreement>;
  agreementsForCreateUserProductSubscription: Array<Agreement>;
  agreementsForUser: Array<Agreement>;
  analytic: Analytic;
  analyticBookingSlots: Array<Chart>;
  analyticCompanySinceCreatedAt: Array<AnalyticCompanySinceCreatedAt>;
  analyticSmart: Array<AnalyticSmart>;
  authIsValidToken: Scalars['Boolean'];
  authPlacesForSignIn: Array<UserPlatformConnection>;
  authPlacesForSignUp: Array<AuthPlacesForSignUpResult>;
  authPlatformTokenData: UserPlatformConnection;
  authUrlSlugData: AuthUrlSlugResponse;
  blockedPhones: Array<BlockedPhone>;
  bookings: Array<Booking>;
  bookliCameras: BookliCamerasResult;
  bookliDevice: BookliDevice;
  bookliDeviceGetLink: Scalars['String'];
  bookliDevices: BookliDevicesResult;
  bookliSound: BookliSound;
  bookliVideo: BookliVideo;
  companies: CompaniesResult;
  company: Company;
  companyCreateInvitationData: CompanyCreateInvitation;
  companyCreateInvitations: CompanyCreateInvitationsResult;
  companyLanguage: CompanyLang;
  companySettings: CompanySetting;
  controllerDoorGroups: ControllerDoorGroupsResult;
  controllerDoorLogs?: Maybe<Array<ControllerDoorLog>>;
  controllerDoors: ControllerDoorsResult;
  controllerNoxAreas: Array<ControllerNoxArea>;
  controllerNoxTimeprofiles: Array<ControllerNoxTimeprofile>;
  controllerOnOff: ControllerOnOff;
  controllerOnOffLogs?: Maybe<Array<ControllerOnOffLog>>;
  controllerOnOffStatuses: Array<ControllerOnOffState>;
  controllerUnit?: Maybe<ControllerUnit>;
  controllerUnits: ControllerUnitsResult;
  coupon: Coupon;
  couponGetUserAutoCoupons: Array<CouponAndPrice>;
  couponIsValid: Scalars['Boolean'];
  couponUsages: CouponUsagesResult;
  coupons: CouponsResult;
  dineroConnected: Scalars['Boolean'];
  emailOptions: Array<SendGridSuppressionGroup>;
  franchiseCompanies: Array<Company>;
  friends: FriendsResult;
  friendsPossibleToAdd: FriendsPossibleToAddResult;
  getAllShortStringMappings: Array<ShortStringMapping>;
  giftCards: GiftCardsResult;
  iCalBookingsUrl: Scalars['String'];
  isPhoneBlocked: Scalars['Boolean'];
  location: Location;
  locationScreenWelcomeMessage?: Maybe<Scalars['String']>;
  locationUserDefault?: Maybe<Location>;
  locations: LocationsResult;
  locationsForSignUp: LocationsForSignUpResult;
  me: Me;
  message: Message;
  messages: MessagesResult;
  metabaseDashboard: Scalars['String'];
  metabaseQuestion: Scalars['String'];
  migration: UserMigrationSignUpLink;
  mobilePayConnectLink: Scalars['String'];
  mobilePayConnected: Scalars['Boolean'];
  myAccessCode: AccessCode;
  payPalConnected: Scalars['Boolean'];
  payPalGetClientData?: Maybe<PayPalClientData>;
  payment: Payment;
  paymentCalculatePrice: PaymentPrice;
  paymentLines: PaymentLinesResult;
  paymentToken: PaymentToken;
  paymentUserAllowedPaymentTypes: PaymentUserAllowedPaymentTypes;
  payments: PaymentsResult;
  platformFees: PlatformFees;
  platformInvoices: PlatformInvoicesResult;
  pointAccount: PointAccount;
  pointAccountCanUseRestPointsForPayment: PointAccountCanUseRestPointsForPaymentResult;
  pointAccountTransactions: PointAccountTransactionsResult;
  pointProduct: PointProduct;
  pointProducts: PointProductsResult;
  priceffAnalytic: PriceffAnalytic;
  priceffAnalyticDynamicChart: PriceffAnalyticDynamicChart;
  priceffAnalyticKPI: Array<PriceffAnalyticKpiItem>;
  priceffAnalyticSummaryChart: PriceffAnalyticSummaryChart;
  priceffDynamicPriceResource: PriceffDynamicPriceResource;
  priceffDynamicPriceResourceDatesGrouped: Array<PriceffDynamicPriceResourceDateGrouped>;
  priceffModel: PriceffModel;
  priceffModels: PriceffModelsResult;
  priceffParameter: PriceffParameter;
  priceffParameters: PriceffParameterResult;
  product: Product;
  ranglisten: RanglistenSignUpLink;
  resource: Resource;
  resourceBooking: ResourceBooking;
  resourceBookingAttendeesPayment: Array<ResourceBookingAttendeePayment>;
  resourceBookingCanCreateSmall?: Maybe<CanCreateSmallResult>;
  resourceBookingIsValid: Scalars['Boolean'];
  resourceBookingRecurring: ResourceBookingRecurring;
  resourceBookingRecurrings: ResourceBookingRecurringsResult;
  resourceBookingValidateCancellation: ResourceBookingValidateCancellationResult;
  resourceBookings: ResourceBookingsResult;
  resourceBookingsConflicting: Array<ResourceBooking>;
  resourceCategories: ResourceCategoriesResult;
  resourceType: ResourceType;
  resourceTypePriceGetForDate: Array<ResourceTypePriceForDate>;
  resourceTypes: ResourceTypesResult;
  resources: ResourcesResult;
  resourcesAvailableTimeSchema: ResourceTypeSchema;
  resourcesGetAvailable: Array<Resource>;
  resourcesLocationTimeline: ResourcesLocationTimelineData;
  scriptableIntegrationCode: Scalars['String'];
  signInMethod: SignInMethod;
  signedUrl: Scalars['String'];
  stripeConnectLink: Scalars['String'];
  stripeConnected: Scalars['Boolean'];
  stripeDashboardLink: Scalars['String'];
  stripeGetSetupIntent: StripeGetSetupIntentType;
  stripeInvoice: StripeInvoice;
  stripeReport: StripeReport;
  stripeReports: StripeReportsResult;
  subscriptionProduct: SubscriptionProduct;
  subscriptionProductCategories: SubscriptionProductCategoriesResult;
  subscriptionProductCategory: SubscriptionProductCategory;
  subscriptionProductGiftCardValidate?: Maybe<Scalars['DateTime']>;
  subscriptionProductGiftCards: SubscriptionProductGiftCardsResult;
  subscriptionProducts: SubscriptionProductsResult;
  trinityEComGetProduct: TrinityEcomProduct;
  trinityEComGetProductCatalog: TrinityEComProductCatalog;
  trinityEComGetTermsAndConditions: TrinityEComPageContent;
  trinityEComReferenceData: TrinityEComReferenceData;
  trinityEcomCheckoutOrder: Array<TrinityEComCheckout>;
  trinityEcomOrderHistory: Array<TrinityEComOrderHistory>;
  user: User;
  userActivities: UserActivitiesResult;
  userAgreements: UserAgreementsResult;
  userAskForMoreInfo?: Maybe<Array<Maybe<UserExtraInfoFields>>>;
  userCompanies: Array<Company>;
  userGroup: UserGroup;
  userGroups: UserGroupsResult;
  userHasFcmToken: Scalars['Boolean'];
  userPlatformConnectionCheckExists: Scalars['Boolean'];
  userPlatformConnectionTokenData: UserPlatformConnectionToken;
  userPlatformConnectionTokens: UserPlatformConnectionTokensResult;
  userPlatformConnections: UserPlatformConnectionsResult;
  userPlatformConnectionsBySignedInUser: Array<UserPlatformConnection>;
  userPoints: Scalars['Int'];
  userProductSubscription: UserProductSubscription;
  userProductSubscriptionActivity: UserProductSubscriptionActivityResult;
  userProductSubscriptionPaymentUserCanDo: UserProductSubscriptionPaymentUserCanDoResult;
  userProductSubscriptions: UserProductSubscriptionsResult;
  users: UsersResult;
  usersTop: UsersTopResult;
  wannasportConnection?: Maybe<WannasportConnection>;
  wannasportPointCheck?: Maybe<Scalars['Boolean']>;
  workshop: Workshop;
  workshopBooking: WorkshopBooking;
  workshopBookings: WorkshopBookingsResult;
  workshopWaitlist: WorkshopWaitlistResult;
  workshops: WorkshopsResult;
};


export type QueryAccessCodeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAccessCodeAccessTimesArgs = {
  accessCode: Scalars['ID'];
  filtering?: InputMaybe<AccessCodeAccessTimesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAccessCodeUsagesArgs = {
  filtering?: InputMaybe<AccessCodeUsagesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAccessCodesArgs = {
  filtering?: InputMaybe<AccessCodesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdditionalServiceArgs = {
  additionalServiceId?: InputMaybe<Scalars['ID']>;
};


export type QueryAdditionalServicesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  resourceCategoryId?: InputMaybe<Scalars['String']>;
};


export type QueryAgreementsArgs = {
  filtering?: InputMaybe<AgreementsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAgreementsForCompanySignUpArgs = {
  company?: InputMaybe<Scalars['ID']>;
};


export type QueryAgreementsForUserArgs = {
  filtering?: InputMaybe<AgreementsForUserFiltering>;
};


export type QueryAnalyticArgs = {
  company?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type QueryAnalyticBookingSlotsArgs = {
  data: AnalyticBookingSlots;
};


export type QueryAnalyticSmartArgs = {
  datePeriodEnd?: InputMaybe<Scalars['DateTime']>;
  datePeriodStart?: InputMaybe<Scalars['DateTime']>;
};


export type QueryAuthIsValidTokenArgs = {
  token: Scalars['String'];
};


export type QueryAuthUrlSlugDataArgs = {
  slug: Scalars['String'];
};


export type QueryBookingsArgs = {
  filtering?: InputMaybe<BookingsFiltering>;
};


export type QueryBookliCamerasArgs = {
  filtering?: InputMaybe<BookliCamerasFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBookliDeviceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBookliDeviceGetLinkArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBookliDevicesArgs = {
  filtering?: InputMaybe<BookliDevicesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBookliSoundArgs = {
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
};


export type QueryBookliVideoArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCompaniesArgs = {
  filtering?: InputMaybe<CompaniesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCompanyArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCompanyCreateInvitationDataArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryCompanyCreateInvitationsArgs = {
  filtering?: InputMaybe<CompanyCreateInvitationsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCompanyLanguageArgs = {
  id: Scalars['ID'];
};


export type QueryCompanySettingsArgs = {
  company?: InputMaybe<Scalars['ID']>;
};


export type QueryControllerDoorGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryControllerDoorLogsArgs = {
  controllerUnitId: Scalars['ID'];
};


export type QueryControllerDoorsArgs = {
  filtering?: InputMaybe<ControllerDoorsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryControllerNoxAreasArgs = {
  controllerUnit: Scalars['ID'];
};


export type QueryControllerNoxTimeprofilesArgs = {
  controllerUnitUrl: Scalars['String'];
};


export type QueryControllerOnOffArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryControllerOnOffLogsArgs = {
  controllerUnitId: Scalars['ID'];
};


export type QueryControllerOnOffStatusesArgs = {
  controller?: InputMaybe<Scalars['String']>;
};


export type QueryControllerUnitArgs = {
  location?: InputMaybe<Scalars['ID']>;
};


export type QueryControllerUnitsArgs = {
  filtering?: InputMaybe<ControllerUnitsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCouponArgs = {
  id: Scalars['ID'];
};


export type QueryCouponGetUserAutoCouponsArgs = {
  amountToPay: Scalars['Float'];
  couponPurchaseDetails?: InputMaybe<CouponPurchaseDetails>;
};


export type QueryCouponIsValidArgs = {
  couponPurchaseDetails: CouponPurchaseDetails;
  couponSlug: Scalars['String'];
};


export type QueryCouponUsagesArgs = {
  filtering?: InputMaybe<CouponUseagesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCouponsArgs = {
  filtering?: InputMaybe<CouponsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFranchiseCompaniesArgs = {
  franchise?: InputMaybe<Scalars['ID']>;
};


export type QueryFriendsArgs = {
  filtering?: InputMaybe<FriendsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFriendsPossibleToAddArgs = {
  filtering?: InputMaybe<FriendsPossibleToAddFiltering>;
  pagination?: InputMaybe<PaginationInput>;
  search: Scalars['String'];
};


export type QueryGiftCardsArgs = {
  filtering?: InputMaybe<GiftCardsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryIsPhoneBlockedArgs = {
  phoneNumber: Scalars['String'];
};


export type QueryLocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryLocationScreenWelcomeMessageArgs = {
  location?: InputMaybe<Scalars['ID']>;
};


export type QueryLocationsArgs = {
  company?: InputMaybe<Scalars['ID']>;
  filtering?: InputMaybe<LocationsFiltering>;
  inFranchise?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  showAll?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLocationsForSignUpArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMessageArgs = {
  id: Scalars['ID'];
};


export type QueryMessagesArgs = {
  filtering?: InputMaybe<MessagesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMetabaseDashboardArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMetabaseQuestionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMigrationArgs = {
  encryptedData?: InputMaybe<Scalars['String']>;
};


export type QueryMobilePayConnectLinkArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentCalculatePriceArgs = {
  data?: InputMaybe<PaymentCalculatePriceInput>;
};


export type QueryPaymentLinesArgs = {
  filtering?: InputMaybe<PaymentLinesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPaymentTokenArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentUserAllowedPaymentTypesArgs = {
  paymentPriceToken?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentsArgs = {
  filtering?: InputMaybe<PaymentsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPlatformInvoicesArgs = {
  filtering?: InputMaybe<PlatformInvoicesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPointAccountArgs = {
  company?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type QueryPointAccountCanUseRestPointsForPaymentArgs = {
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  product?: InputMaybe<Scalars['ID']>;
};


export type QueryPointAccountTransactionsArgs = {
  filtering?: InputMaybe<PointAccountTransactionsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
  pointAccount: Scalars['ID'];
};


export type QueryPointProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPointProductsArgs = {
  filtering?: InputMaybe<PointProductsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPriceffAnalyticArgs = {
  fromDate: Scalars['DateTime'];
  priceffParameter?: InputMaybe<Scalars['ID']>;
  toDate: Scalars['DateTime'];
};


export type QueryPriceffAnalyticDynamicChartArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  parameterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timeType?: InputMaybe<ChartTimeType>;
};


export type QueryPriceffAnalyticKpiArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  parameterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryPriceffAnalyticSummaryChartArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  parameterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timeType?: InputMaybe<ChartTimeType>;
};


export type QueryPriceffDynamicPriceResourceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPriceffDynamicPriceResourceDatesGroupedArgs = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  resourceType: Scalars['ID'];
};


export type QueryPriceffModelArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPriceffModelsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPriceffParameterArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPriceffParametersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRanglistenArgs = {
  locationId: Scalars['ID'];
  userFirstName: Scalars['String'];
  userId: Scalars['ID'];
  userLastName: Scalars['String'];
};


export type QueryResourceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryResourceBookingArgs = {
  id: Scalars['ID'];
};


export type QueryResourceBookingAttendeesPaymentArgs = {
  resourceBooking: Scalars['ID'];
};


export type QueryResourceBookingIsValidArgs = {
  endDate: Scalars['DateTime'];
  resource: Scalars['ID'];
  startDate: Scalars['DateTime'];
};


export type QueryResourceBookingRecurringArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryResourceBookingRecurringsArgs = {
  filtering?: InputMaybe<ResourceBookingRecurringsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryResourceBookingValidateCancellationArgs = {
  id: Scalars['ID'];
  refundPayment?: InputMaybe<Scalars['Boolean']>;
};


export type QueryResourceBookingsArgs = {
  filtering?: InputMaybe<ResourceBookingsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryResourceCategoriesArgs = {
  filtering?: InputMaybe<ResourceCategoriesFiltering>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryResourceTypeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryResourceTypePriceGetForDateArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<Scalars['ID']>;
};


export type QueryResourceTypesArgs = {
  filtering?: InputMaybe<ResourceTypesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryResourcesArgs = {
  filtering?: InputMaybe<ResourcesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryResourcesAvailableTimeSchemaArgs = {
  date: Scalars['DateTime'];
  durationMinuts: Scalars['Int'];
  location: Scalars['ID'];
  resourceType: Scalars['ID'];
};


export type QueryResourcesGetAvailableArgs = {
  endDate: Scalars['DateTime'];
  location: Scalars['ID'];
  startDate: Scalars['DateTime'];
};


export type QueryResourcesLocationTimelineArgs = {
  date: Scalars['DateTime'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['ID'];
  resourceCategory?: InputMaybe<Scalars['ID']>;
};


export type QuerySignInMethodArgs = {
  emailAddress?: InputMaybe<Scalars['String']>;
};


export type QuerySignedUrlArgs = {
  fileName?: InputMaybe<Scalars['String']>;
};


export type QueryStripeInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryStripeReportArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryStripeReportsArgs = {
  filtering?: InputMaybe<StripeReportsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySubscriptionProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerySubscriptionProductCategoriesArgs = {
  filtering?: InputMaybe<SubscriptionProductCategoriesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySubscriptionProductCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerySubscriptionProductGiftCardValidateArgs = {
  subscriptionProduct: Scalars['ID'];
  subscriptionProductGiftCardCode: Scalars['String'];
};


export type QuerySubscriptionProductGiftCardsArgs = {
  filtering?: InputMaybe<SubscriptionProductGiftCardsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
  subscriptionProduct: Scalars['ID'];
};


export type QuerySubscriptionProductsArgs = {
  filtering?: InputMaybe<SubscriptionProductsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryTrinityEComGetProductArgs = {
  country: SupportedCountries;
  product: Scalars['Int'];
};


export type QueryTrinityEComGetProductCatalogArgs = {
  category: Scalars['Int'];
  categoryType: TrinityEcomCategoryType;
  country: SupportedCountries;
  parameters: TrinityEComProductCatalogParameters;
};


export type QueryTrinityEComGetTermsAndConditionsArgs = {
  country: SupportedCountries;
};


export type QueryTrinityEComReferenceDataArgs = {
  country: SupportedCountries;
};


export type QueryTrinityEcomCheckoutOrderArgs = {
  checkoutToken: Scalars['String'];
  country: SupportedCountries;
};


export type QueryTrinityEcomOrderHistoryArgs = {
  country: SupportedCountries;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
  idEmailPhone?: InputMaybe<Scalars['String']>;
};


export type QueryUserActivitiesArgs = {
  filtering?: InputMaybe<UserActivitiesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUserAgreementsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUserCompaniesArgs = {
  email?: InputMaybe<Scalars['String']>;
  userAuthToken?: InputMaybe<Scalars['String']>;
};


export type QueryUserGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserGroupsArgs = {
  filtering?: InputMaybe<UserGroupsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUserPlatformConnectionCheckExistsArgs = {
  company: Scalars['ID'];
};


export type QueryUserPlatformConnectionTokenDataArgs = {
  token: Scalars['String'];
};


export type QueryUserPlatformConnectionTokensArgs = {
  filtering?: InputMaybe<UserPlatformConnectionTokensFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUserPlatformConnectionsArgs = {
  filtering?: InputMaybe<UserPlatformConnectionsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUserPlatformConnectionsBySignedInUserArgs = {
  userId: Scalars['ID'];
};


export type QueryUserPointsArgs = {
  user?: InputMaybe<Scalars['ID']>;
};


export type QueryUserProductSubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserProductSubscriptionActivityArgs = {
  filtering?: InputMaybe<UserProductSubscriptionActivityFiltering>;
  pagination?: InputMaybe<PaginationInput>;
  userProductSubscription: Scalars['ID'];
};


export type QueryUserProductSubscriptionPaymentUserCanDoArgs = {
  product?: InputMaybe<Scalars['ID']>;
};


export type QueryUserProductSubscriptionsArgs = {
  filtering?: InputMaybe<UserProductSubscriptionsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUsersArgs = {
  company?: InputMaybe<Scalars['ID']>;
  filtering?: InputMaybe<UsersFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryUsersTopArgs = {
  filtering?: InputMaybe<UsersTopFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWannasportConnectionArgs = {
  location: Scalars['ID'];
};


export type QueryWorkshopArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkshopBookingArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopBookingsArgs = {
  filtering?: InputMaybe<WorkshopBookingsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
  workshop: Scalars['ID'];
};


export type QueryWorkshopWaitlistArgs = {
  filtering?: InputMaybe<WorkshopWaitlistFiltering>;
  pagination?: InputMaybe<PaginationInput>;
  workshop: Scalars['ID'];
};


export type QueryWorkshopsArgs = {
  filtering?: InputMaybe<WorkshopsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
};

export type QuickInfoUserChangeSubscriptionPayload = {
  __typename?: 'QuickInfoUserChangeSubscriptionPayload';
  user: Scalars['ID'];
};

export type RanglistenSignUpLink = {
  __typename?: 'RanglistenSignUpLink';
  signUpLink: Scalars['String'];
};

export enum ReasonCode {
  ATime = 'ATime',
  BTime = 'BTime',
  BetweenCompanies = 'BetweenCompanies',
  CancelStartdate = 'CancelStartdate',
  Canceled = 'Canceled',
  Details = 'Details',
  DoubleBooking = 'DoubleBooking',
  Event = 'Event',
  Franchise = 'Franchise',
  InvalidStartdate = 'InvalidStartdate',
  MatchedSubscription = 'MatchedSubscription',
  MaxMonth = 'MaxMonth',
  MaxTotal = 'MaxTotal',
  NoEvent = 'NoEvent',
  NoSubscription = 'NoSubscription',
  NotValid = 'NotValid',
  OtherCompanies = 'OtherCompanies',
  OtherResourceBooking = 'OtherResourceBooking',
  ResourceBooking = 'ResourceBooking',
  ResourceType = 'ResourceType',
  RuleStartdate = 'RuleStartdate',
  Timeframe = 'Timeframe',
  WrongCompany = 'WrongCompany',
  WrongFranchise = 'WrongFranchise'
}

export enum ReservationType {
  BeforeOpening = 'BeforeOpening',
  Closed = 'Closed',
  EventOutsideOfBookingSystem = 'EventOutsideOfBookingSystem',
  ManuelUserBooking = 'ManuelUserBooking',
  Other = 'Other',
  ResourceMaintenance = 'ResourceMaintenance',
  UserBooking = 'UserBooking',
  UserBookingWithAdditionalService = 'UserBookingWithAdditionalService',
  Workshop = 'Workshop'
}

export type Resource = {
  __typename?: 'Resource';
  bookings: Array<ResourceBooking>;
  camera?: Maybe<BookliCamera>;
  company: Company;
  currentBooking?: Maybe<ResourceBooking>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  lightController?: Maybe<ControllerOnOff>;
  location: Location;
  logoUrl?: Maybe<Scalars['String']>;
  maxAttendees: Scalars['Int'];
  name: Scalars['String'];
  nextBooking?: Maybe<ResourceBooking>;
  popularity: Scalars['Int'];
  resourceLogo?: Maybe<Scalars['String']>;
  shortName: Scalars['String'];
  type: ResourceType;
  typeId: Scalars['String'];
};


export type ResourceBookingsArgs = {
  after?: InputMaybe<ResourceBookingWhereUniqueInput>;
  before?: InputMaybe<ResourceBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResourceBooking = {
  __typename?: 'ResourceBooking';
  accessCodeAccessTime?: Maybe<AccessCodeAccessTime>;
  additionalService?: Maybe<AdditionalService>;
  allowAddingAttendees: Scalars['Boolean'];
  attendees: Array<User>;
  attendeesCount: Scalars['Int'];
  attendeesTokenData: Array<ResourceBookingAttendeeTokenData>;
  bookingAttendees: Array<ResourceBookingAttendee>;
  bookingValue: Scalars['Float'];
  bookliVideo?: Maybe<BookliVideo>;
  canGenerateBookliVideo: ResourceBookingCanGenerateBookliVideo;
  comments?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  duractionMinuts: Scalars['Int'];
  dynamicPriceUsages: Array<PriceffDynamicPriceResourceUsage>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  isBookingOwner: Scalars['Boolean'];
  lightsWillTurnOn: Scalars['Boolean'];
  myAttendee?: Maybe<ResourceBookingAttendee>;
  owner: User;
  ownerId: Scalars['String'];
  partOfRecurringResourceBooking?: Maybe<ResourceBookingRecurring>;
  payment?: Maybe<Payment>;
  paymentIsSubscriptionPayment?: Maybe<Scalars['Boolean']>;
  paymentsFormated: Array<ResourceBookingPaymentFormated>;
  personShowedUp?: Maybe<Scalars['Boolean']>;
  reservationType?: Maybe<ReservationType>;
  resource: Resource;
  resourceBookingAttendeesToken?: Maybe<Scalars['String']>;
  resourceBookingAttendeesTokenData: Scalars['String'];
  resourceId: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: BookingStatus;
  userCanCancelBooking: Scalars['Boolean'];
  workshopDay?: Maybe<WorkshopDay>;
};


export type ResourceBookingAttendeesArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ResourceBookingBookingAttendeesArgs = {
  after?: InputMaybe<ResourceBookingAttendeeWhereUniqueInput>;
  before?: InputMaybe<ResourceBookingAttendeeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ResourceBookingDynamicPriceUsagesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourceUsageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResourceBookingAttendee = {
  __typename?: 'ResourceBookingAttendee';
  ableToPayDiscountedPayment?: Maybe<Scalars['String']>;
  accessCodeAccessTime?: Maybe<AccessCodeAccessTime>;
  canBeDeleted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  payments: Array<Payment>;
  resourceBooking: ResourceBooking;
  resourceBookingId: Scalars['String'];
  tokenData: ResourceBookingAttendeeTokenData;
  user: User;
  userId: Scalars['String'];
};


export type ResourceBookingAttendeePaymentsArgs = {
  after?: InputMaybe<PaymentWhereUniqueInput>;
  before?: InputMaybe<PaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResourceBookingAttendeeBuyOutInput = {
  attendeeUserId: Scalars['ID'];
  resourceBookingId: Scalars['ID'];
};

export type ResourceBookingAttendeePayment = {
  __typename?: 'ResourceBookingAttendeePayment';
  attendeeNumber: Scalars['String'];
  isDummyUser: Scalars['Boolean'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['ID']>;
  restMoneyValue: Scalars['Float'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  value: Scalars['Float'];
};

export type ResourceBookingAttendeeTokenData = {
  __typename?: 'ResourceBookingAttendeeTokenData';
  discountValue: Scalars['Float'];
  isUser: Scalars['Boolean'];
  messageLines: Array<Scalars['String']>;
  number: Scalars['Int'];
  restMoneyValue: Scalars['Float'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  value: Scalars['Float'];
};

export type ResourceBookingAttendeeWhereUniqueInput = {
  accessCodeAccessTimeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export enum ResourceBookingCanGenerateBookliVideo {
  IsBeforeBookingEnd = 'IsBeforeBookingEnd',
  IsCreated = 'IsCreated',
  ResourceCantVideoExport = 'ResourceCantVideoExport',
  ToLongAfterResourceBookingStartDate = 'ToLongAfterResourceBookingStartDate',
  Yes = 'Yes'
}

export type ResourceBookingCreateCompanyReservation = {
  addAccessCodeToBooking?: InputMaybe<Scalars['Boolean']>;
  addCreatorAsAttendee?: InputMaybe<Scalars['Boolean']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  comments: Scalars['String'];
  dates: Array<ResourceBookingCreateCompanyReservationDate>;
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceSettings?: InputMaybe<ResourceBookingCreateCompanyReservationInvoice>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  reservationType?: InputMaybe<ReservationType>;
  resources: Array<Scalars['ID']>;
  turnOnLightsAtStart?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceBookingCreateCompanyReservationDate = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type ResourceBookingCreateCompanyReservationInvoice = {
  customPrice?: InputMaybe<Scalars['Float']>;
  dueDate?: InputMaybe<Scalars['Int']>;
  payingAttendee?: InputMaybe<Scalars['String']>;
};

export type ResourceBookingCreateCompanyReservationResult = {
  __typename?: 'ResourceBookingCreateCompanyReservationResult';
  errorWhileCreating: Array<Resource>;
  successfulCreatedBookings: Array<ResourceBooking>;
};

export type ResourceBookingPaymentAttendee = {
  __typename?: 'ResourceBookingPaymentAttendee';
  coupon?: Maybe<Scalars['ID']>;
  discountValue: Scalars['Float'];
  isOwner: Scalars['Boolean'];
  isUser: Scalars['Boolean'];
  messageLines: Array<Scalars['String']>;
  restMoneyValue: Scalars['Float'];
  user?: Maybe<User>;
  userProductSubscription?: Maybe<UserProductSubscription>;
  value: Scalars['Float'];
};

export type ResourceBookingPaymentFormated = {
  __typename?: 'ResourceBookingPaymentFormated';
  additionalServiceValue: Scalars['Float'];
  createdAtFormated: Scalars['String'];
  displayName: Scalars['String'];
  paidFormated: Scalars['String'];
  payment: Payment;
  paymentMethodFormated: Scalars['String'];
  statusFormated: Scalars['String'];
  user: User;
};

export type ResourceBookingRecurring = {
  __typename?: 'ResourceBookingRecurring';
  active: Scalars['Boolean'];
  attendees: Array<User>;
  connectedTo: ResourceBookingRecurringConnectedTo;
  connectedToUser?: Maybe<User>;
  connectedToUserGroup?: Maybe<UserGroup>;
  createCyclesInAdvance: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  creator: User;
  days: Array<Day>;
  endCreateDate?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['String'];
  endTimeDate: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  reservationType?: Maybe<ReservationType>;
  resourceBookings: Array<ResourceBooking>;
  resources: Array<Resource>;
  setBookingStatus: BookingStatus;
  startCreateDate?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['String'];
  startTimeDate: Scalars['DateTime'];
};


export type ResourceBookingRecurringAttendeesArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ResourceBookingRecurringResourcesArgs = {
  after?: InputMaybe<ResourceWhereUniqueInput>;
  before?: InputMaybe<ResourceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum ResourceBookingRecurringConnectedTo {
  User = 'User',
  UserGroup = 'UserGroup'
}

export type ResourceBookingRecurringCreate = {
  attendees?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  connectedToUser?: InputMaybe<Scalars['ID']>;
  connectedToUserGroup?: InputMaybe<Scalars['ID']>;
  createAllBookings?: InputMaybe<Scalars['Boolean']>;
  createAsReservation?: InputMaybe<Scalars['Boolean']>;
  createCyclesInAdvance?: InputMaybe<Scalars['Int']>;
  days: Array<Day>;
  endCreateDate?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['String'];
  lockAttendeesChange?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  reservationType: ReservationType;
  resources: Array<Scalars['ID']>;
  startCreateDate?: InputMaybe<Scalars['DateTime']>;
  startTime: Scalars['String'];
};

export type ResourceBookingRecurringUpdate = {
  attendees?: InputMaybe<Array<Scalars['ID']>>;
  createCyclesInAdvance?: InputMaybe<Scalars['Int']>;
  days?: InputMaybe<Array<Day>>;
  endCreateDate?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  reservationType?: InputMaybe<ReservationType>;
  resources?: InputMaybe<Array<Scalars['ID']>>;
  startCreateDate?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type ResourceBookingRecurringsFiltering = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceBookingRecurringsResult = Pagination & {
  __typename?: 'ResourceBookingRecurringsResult';
  data: Array<ResourceBookingRecurring>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ResourceBookingTimeline = {
  __typename?: 'ResourceBookingTimeline';
  color: Scalars['String'];
  description: Scalars['String'];
  endDate: Scalars['DateTime'];
  hasInternalNotes: Scalars['Boolean'];
  id: Scalars['ID'];
  isTraningSession: Scalars['Boolean'];
  resourceId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type ResourceBookingUpdateData = {
  comments?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  newEndDate?: InputMaybe<Scalars['DateTime']>;
  newResource?: InputMaybe<Scalars['ID']>;
  newStartDate?: InputMaybe<Scalars['DateTime']>;
  reservationType?: InputMaybe<ReservationType>;
  sendMessageToUser?: InputMaybe<Scalars['Boolean']>;
  turnOnLightsAtStart?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceBookingValidateCancellationResult = {
  __typename?: 'ResourceBookingValidateCancellationResult';
  canCancel: Scalars['Boolean'];
  canGetFullRefund?: Maybe<Scalars['Boolean']>;
  deductedAmount?: Maybe<Scalars['Int']>;
  refundAmount?: Maybe<Scalars['Int']>;
};

export type ResourceBookingWhereUniqueInput = {
  accessCodeAccessTimeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  onOffTimeProfileId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  resourceBookingAttendeesToken?: InputMaybe<Scalars['String']>;
};

export type ResourceBookingsFiltering = {
  company?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  franchise?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  notStatus?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ResourceBookingsResult = Pagination & {
  __typename?: 'ResourceBookingsResult';
  data: Array<ResourceBooking>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ResourceCategoriesFiltering = {
  location?: InputMaybe<Scalars['ID']>;
};

export type ResourceCategoriesResult = Pagination & {
  __typename?: 'ResourceCategoriesResult';
  data: Array<ResourceCategory>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ResourceCategory = {
  __typename?: 'ResourceCategory';
  accessMinutesAfterBooking: Scalars['Int'];
  accessMinutsBeforeBooking: Scalars['Int'];
  bookingFlow: BookingFlow;
  bookingsAllowedDurationTimeGaps: Scalars['Int'];
  company: Company;
  defaultDurationMinutes: Scalars['Int'];
  defaultToATime: Scalars['Boolean'];
  description: Scalars['String'];
  durationIntervalMinutes?: Maybe<Scalars['Int']>;
  durationMinutesIntervals: Array<Scalars['Int']>;
  id: Scalars['String'];
  maxDaysCreateResourceBookingAhead: Scalars['Int'];
  maxDaysCreateResourceBookingAheadUser: Scalars['Int'];
  maxGapIntervalsCount: Scalars['Int'];
  maxMinutsBeforeCancellation: Scalars['Int'];
  name: Scalars['String'];
  popularity: Scalars['Int'];
  types: Array<ResourceType>;
  weekdayOpenTime: Array<Scalars['String']>;
  weekendOpenTime: Array<Scalars['String']>;
};


export type ResourceCategoryTypesArgs = {
  after?: InputMaybe<ResourceTypeWhereUniqueInput>;
  before?: InputMaybe<ResourceTypeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResourceCategoryCreate = {
  accessMinutesAfterBooking?: InputMaybe<Scalars['Int']>;
  accessMinutsBeforeBooking?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  maxMinutsBeforeCancellation?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  weekdayOpenTime: Array<Scalars['String']>;
  weekendOpenTime: Array<Scalars['String']>;
};

export type ResourceCategoryUpdate = {
  accessMinutesAfterBooking?: InputMaybe<Scalars['Int']>;
  accessMinutsBeforeBooking?: InputMaybe<Scalars['Int']>;
  bookingsAllowedDurationTimeGaps?: InputMaybe<Scalars['Int']>;
  defaultToATime?: InputMaybe<Scalars['Boolean']>;
  durationIntervalMinutes?: InputMaybe<Scalars['Int']>;
  durationMinutesIntervals?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  maxDaysCreateResourceBookingAhead?: InputMaybe<Scalars['Int']>;
  maxGapIntervalsCount?: InputMaybe<Scalars['Int']>;
  maxMinutsBeforeCancellation?: InputMaybe<Scalars['Int']>;
  popularity?: InputMaybe<Scalars['Int']>;
  weekdayOpenTime?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weekendOpenTime?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourceChangeSubscriptionPayload = {
  __typename?: 'ResourceChangeSubscriptionPayload';
  changeType: ResourceChangeTypeSubscription;
  resource: Resource;
  resourceBookingId?: Maybe<Scalars['String']>;
};

export enum ResourceChangeTypeSubscription {
  ResourceBookingCreated = 'ResourceBookingCreated',
  ResourceBookingDeleted = 'ResourceBookingDeleted',
  ResourceBookingEnd = 'ResourceBookingEnd',
  ResourceBookingStart = 'ResourceBookingStart',
  ResourceCreated = 'ResourceCreated',
  ResourceDataChange = 'ResourceDataChange'
}

export type ResourceCreate = {
  location: Scalars['ID'];
  logo?: InputMaybe<Scalars['Upload']>;
  maxAttendees?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  resourceType: Scalars['ID'];
  shortName: Scalars['String'];
};

export type ResourceType = {
  __typename?: 'ResourceType';
  category: ResourceCategory;
  company: Company;
  companyId: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  popularity: Scalars['Int'];
  priceTableAWeekdayTabel: Scalars['String'];
  priceTableAWeekendTabel: Scalars['String'];
  priceffDynamicPrices: Array<PriceffDynamicPriceResource>;
  priceffGearing?: Maybe<Scalars['Float']>;
  priceffGeneratedPricesTo?: Maybe<Scalars['DateTime']>;
  priceffModel?: Maybe<PriceffModel>;
  prices: Array<ResourceTypePrice>;
  pricesForDate: Array<ResourceTypePriceForDate>;
  resources: Array<Resource>;
  standardPriceA: Product;
  standardPriceB: Product;
  typeNamePlural: Scalars['String'];
  typeNameSingular: Scalars['String'];
  usePriceffDynamicPricing: Scalars['Boolean'];
};


export type ResourceTypePriceffDynamicPricesArgs = {
  after?: InputMaybe<PriceffDynamicPriceResourceWhereUniqueInput>;
  before?: InputMaybe<PriceffDynamicPriceResourceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ResourceTypePricesArgs = {
  after?: InputMaybe<ResourceTypePriceWhereUniqueInput>;
  before?: InputMaybe<ResourceTypePriceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ResourceTypePricesForDateArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['ID']>;
};


export type ResourceTypeResourcesArgs = {
  after?: InputMaybe<ResourceWhereUniqueInput>;
  before?: InputMaybe<ResourceWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResourceTypeCreate = {
  category: Scalars['ID'];
  description: Scalars['String'];
  name: Scalars['String'];
  standardPriceA: Scalars['Float'];
  standardPriceB: Scalars['Float'];
};

export type ResourceTypePrice = {
  __typename?: 'ResourceTypePrice';
  dates: Array<ResourceTypePriceDate>;
  days: Array<Day>;
  endTime: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isUsingDates: Scalars['Boolean'];
  product: Product;
  resourceType: ResourceType;
  startTime: Scalars['String'];
  type: ResourceTypePriceType;
};


export type ResourceTypePriceDatesArgs = {
  after?: InputMaybe<ResourceTypePriceDateWhereUniqueInput>;
  before?: InputMaybe<ResourceTypePriceDateWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ResourceTypePriceCreate = {
  dates: Array<CreateResourceTypePriceDate>;
  days: Array<Day>;
  endTime: Scalars['String'];
  isUsingDates?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  resourceType: Scalars['ID'];
  startTime: Scalars['String'];
  type?: InputMaybe<ResourceTypePriceType>;
};

export type ResourceTypePriceDate = {
  __typename?: 'ResourceTypePriceDate';
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  periodEnd: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  resourceTypePrice: ResourceTypePrice;
};

export type ResourceTypePriceDateWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ResourceTypePriceForDate = {
  __typename?: 'ResourceTypePriceForDate';
  endDate: Scalars['DateTime'];
  price: Scalars['Float'];
  pricePerHour: Scalars['Float'];
  pricePerHourString: Scalars['String'];
  priceType: ResourceTypePriceType;
  productId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export enum ResourceTypePriceType {
  A = 'A',
  B = 'B',
  Special = 'Special'
}

export type ResourceTypePriceUpdate = {
  days?: InputMaybe<Array<Day>>;
  endTime?: InputMaybe<Scalars['String']>;
  isUsingDates?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ResourceTypePriceType>;
};

export type ResourceTypePriceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};

export type ResourceTypePriceffUpdate = {
  priceffAPrice?: InputMaybe<Scalars['Float']>;
  priceffBPrice?: InputMaybe<Scalars['Float']>;
  priceffGearing?: InputMaybe<Scalars['Float']>;
};

export type ResourceTypeSchema = {
  __typename?: 'ResourceTypeSchema';
  date: Scalars['DateTime'];
  durationMinuts: Scalars['Int'];
  location: Scalars['ID'];
  resourceType: Scalars['ID'];
  times: Array<ResourceTypeSchemaTime>;
};

export type ResourceTypeSchemaTime = {
  __typename?: 'ResourceTypeSchemaTime';
  availableForBooking: Scalars['Boolean'];
  availableResources: Array<Resource>;
  endDate: Scalars['DateTime'];
  price: ResourceTypeSchemaTimePrice;
  priceWithActiveCoupon?: Maybe<Scalars['Float']>;
  resourceType: Scalars['ID'];
  startDate: Scalars['DateTime'];
  unAvailable: Array<ResourceBooking>;
  utcTime: Scalars['String'];
};

export type ResourceTypeSchemaTimePrice = {
  __typename?: 'ResourceTypeSchemaTimePrice';
  isDynamicPrice: Scalars['Boolean'];
  price: Scalars['Float'];
  priceType: ResourceTypePriceType;
  productId: Scalars['ID'];
};

export type ResourceTypeUpdate = {
  name?: InputMaybe<Scalars['String']>;
  popularity?: InputMaybe<Scalars['Int']>;
  priceTableAWeekdayTabel?: InputMaybe<Scalars['String']>;
  priceTableAWeekendTabel?: InputMaybe<Scalars['String']>;
  standardPriceA?: InputMaybe<Scalars['Float']>;
  standardPriceB?: InputMaybe<Scalars['Float']>;
  usePriceffDynamicPricing?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  standardPriceAId?: InputMaybe<Scalars['String']>;
  standardPriceBId?: InputMaybe<Scalars['String']>;
};

export type ResourceTypesFiltering = {
  company?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  resourceCategory?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  usingPriceff?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceTypesResult = Pagination & {
  __typename?: 'ResourceTypesResult';
  data: Array<ResourceType>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ResourceUpdate = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  popularity?: InputMaybe<Scalars['Int']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type ResourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  lightControllerId?: InputMaybe<Scalars['String']>;
};

export type ResourcesFiltering = {
  company?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  resourceCategory?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<Scalars['ID']>;
};

export type ResourcesLocationTimelineData = {
  __typename?: 'ResourcesLocationTimelineData';
  closeTimeUtc: Scalars['String'];
  latestDateForBooking: Scalars['DateTime'];
  openTimeUtc: Scalars['String'];
  reservationTypeColors: Scalars['String'];
  resourceBookings: Array<ResourceBookingTimeline>;
  resourceTypes: Array<ResourceType>;
  resources: Array<Resource>;
  timezone: Timezone;
};

export type ResourcesResult = Pagination & {
  __typename?: 'ResourcesResult';
  data: Array<Resource>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type SendGridSuppressionGroup = {
  __typename?: 'SendGridSuppressionGroup';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum SendToMany {
  AllCompanyUsers = 'AllCompanyUsers'
}

export type ShortStringMapping = {
  __typename?: 'ShortStringMapping';
  fullString: Scalars['String'];
  shortString: Scalars['String'];
};

export type SignInMethod = {
  __typename?: 'SignInMethod';
  userSignInMethod: Scalars['String'];
};

export type StripeConnect = {
  __typename?: 'StripeConnect';
  id: Scalars['ID'];
};

export type StripeConnection = {
  __typename?: 'StripeConnection';
  balanceAvailable?: Maybe<Scalars['Float']>;
  balancePending?: Maybe<Scalars['Float']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  connectState?: Maybe<Scalars['String']>;
  connectUserId?: Maybe<Scalars['String']>;
  connectedTo: FranchiseOrCompany;
  franchise?: Maybe<Franchise>;
  franchsieId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoicePaymentPlatformFeePercentage: Scalars['Float'];
  invoicePaymentPlatformFeeStatic: Scalars['Float'];
  paymentPlatformFeePercentage: Scalars['Float'];
  paymentPlatformFeeStatic: Scalars['Float'];
  subscriptionPlarformFeeSecondaryPercentage: Scalars['Float'];
  subscriptionPlarformFeeSecondaryStatic: Scalars['Float'];
  subscriptionPlatformFeePrimaryPercentage: Scalars['Float'];
  subscriptionPlatformFeePrimaryStatic: Scalars['Float'];
};

export type StripeConnectionUpdate = {
  id: Scalars['ID'];
  invoicePaymentPlatformFeePercentage?: InputMaybe<Scalars['Float']>;
  invoicePaymentPlatformFeeStatic?: InputMaybe<Scalars['Float']>;
  paymentPlatformFeePercentage?: InputMaybe<Scalars['Float']>;
  paymentPlatformFeeStatic?: InputMaybe<Scalars['Float']>;
  subscriptionPlarformFeeSecondaryPercentage?: InputMaybe<Scalars['Float']>;
  subscriptionPlarformFeeSecondaryStatic?: InputMaybe<Scalars['Float']>;
  subscriptionPlatformFeePrimaryPercentage?: InputMaybe<Scalars['Float']>;
  subscriptionPlatformFeePrimaryStatic?: InputMaybe<Scalars['Float']>;
};

export type StripeGetSetupIntentType = {
  __typename?: 'StripeGetSetupIntentType';
  stripeCustomerId: Scalars['String'];
  stripeEphemeralKey: Scalars['String'];
  stripeIntentClientSecret: Scalars['String'];
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amountDue: Scalars['Float'];
  amountPaid: Scalars['Float'];
  attemptCount: Scalars['Int'];
  customerId: Scalars['String'];
  id: Scalars['ID'];
  payments: Array<Payment>;
  status: StripeInvoiceStatus;
  total: Scalars['Float'];
  user: User;
};

export type StripeInvoiceItem = {
  __typename?: 'StripeInvoiceItem';
  id: Scalars['ID'];
};

export enum StripeInvoiceStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type StripePayment = {
  __typename?: 'StripePayment';
  id: Scalars['ID'];
};

export type StripeReport = {
  __typename?: 'StripeReport';
  createdAt: Scalars['DateTime'];
  fileName?: Maybe<Scalars['String']>;
  generatedByUser?: Maybe<User>;
  id: Scalars['String'];
  intervalEnd: Scalars['DateTime'];
  intervalStart: Scalars['DateTime'];
  result?: Maybe<Scalars['String']>;
  status: StripeReportStatus;
  stripeConnection: StripeConnection;
  type: StripeReportType;
};

export type StripeReportGenerate = {
  intervalEnd: Scalars['DateTime'];
  intervalStart: Scalars['DateTime'];
  types: Array<StripeReportType>;
};

export enum StripeReportStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export enum StripeReportType {
  BalanceChangeFromActivitySummary1 = 'BalanceChangeFromActivitySummary1',
  BalanceSummary1 = 'BalanceSummary1',
  PayoutsSummary1 = 'PayoutsSummary1'
}

export type StripeReportsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type StripeReportsResult = Pagination & {
  __typename?: 'StripeReportsResult';
  data: Array<StripeReport>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type StripeSource = {
  __typename?: 'StripeSource';
  brand: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  id: Scalars['ID'];
  isDefaultCard: Scalars['Boolean'];
  last4: Scalars['Int'];
};

export type Subscription = {
  __typename?: 'Subscription';
  accessCodeUsage: AccessCodeUsageSubscriptionPayload;
  bookliScreenHealth: BookliScreenHealthSubscriptionPayload;
  bookliVideo: BookliVideo;
  controllerOnOffNoxStateChange: ControllerOnOffNoxStateChangeSubscriptionPayload;
  invoicePaid: InvoicePaidSubscriptionPayload;
  locationScreenWelcomeMessage: Scalars['String'];
  paymentToken: PaymentTokenSubscriptionPayload;
  quickInfoUserChange: QuickInfoUserChangeSubscriptionPayload;
  resourceChange: ResourceChangeSubscriptionPayload;
  workshopsFutureChanged: WorkshopsFutureSubscriptionPayload;
};


export type SubscriptionAccessCodeUsageArgs = {
  accessCode?: InputMaybe<Scalars['ID']>;
  controllerDoor?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionBookliScreenHealthArgs = {
  location?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionBookliVideoArgs = {
  id: Scalars['ID'];
};


export type SubscriptionControllerOnOffNoxStateChangeArgs = {
  controllerUnitUrl: Scalars['String'];
};


export type SubscriptionInvoicePaidArgs = {
  subscriptionId: Scalars['String'];
};


export type SubscriptionLocationScreenWelcomeMessageArgs = {
  location: Scalars['ID'];
};


export type SubscriptionPaymentTokenArgs = {
  paymentToken: Scalars['ID'];
};


export type SubscriptionQuickInfoUserChangeArgs = {
  user?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionResourceChangeArgs = {
  location?: InputMaybe<Scalars['ID']>;
  onlyForActiveBookings?: InputMaybe<Scalars['Boolean']>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type SubscriptionWorkshopsFutureChangedArgs = {
  location: Scalars['ID'];
};

export enum SubscriptionPlatform {
  ByAdmin = 'ByAdmin',
  MobilePaySubscription = 'MobilePaySubscription',
  StripeSubscription = 'StripeSubscription'
}

export enum SubscriptionProducPaymentDiscountType {
  Amount = 'Amount',
  AmountPrBookingInterval = 'AmountPrBookingInterval',
  Percentage = 'Percentage'
}

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  accessCodeDoorGroup?: Maybe<Scalars['String']>;
  activeBeforeFirstPayment: Scalars['Boolean'];
  allowPublicSignUp: Scalars['Boolean'];
  canBeUsedOnWorkshops: Scalars['Boolean'];
  category: SubscriptionProductCategory;
  company?: Maybe<Company>;
  countUserSubscriptions: Scalars['Int'];
  couponOnEvents?: Maybe<Coupon>;
  couponOnOtherPayments?: Maybe<Coupon>;
  createdAt: Scalars['DateTime'];
  daysBeforeFirstPayment?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  giftCards: Array<SubscriptionProductGiftCard>;
  id: Scalars['String'];
  maxActiveBookings: Scalars['Int'];
  maxDaysCreateResourceBookingAhead: Scalars['Int'];
  maxNumberOfActiveSubscriptions?: Maybe<Scalars['Int']>;
  maximumPaymentValueOnSubscription?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  onlyPayOnResourceTypes: Array<ResourceType>;
  paymentCyclesAfterCancele: Scalars['Int'];
  paymentDiscountAmount?: Maybe<Scalars['Int']>;
  paymentDiscountAmountPrBookingInterval?: Maybe<Scalars['Float']>;
  paymentDiscountIsOnlyInBTime: Scalars['Boolean'];
  paymentDiscountPercentage?: Maybe<Scalars['Int']>;
  paymentDiscountType: SubscriptionProducPaymentDiscountType;
  paymentMaxActiveBookingsPerMonth?: Maybe<Scalars['Int']>;
  paymentMaxCoverType: SubscriptionProductPaymentMaxCoverType;
  paymentMaxHoursCovered?: Maybe<Scalars['Float']>;
  paymentMaxValueCovered?: Maybe<Scalars['Float']>;
  paymentOnTheFirstOfMonth: Scalars['Boolean'];
  paymentTimesPrYear: Scalars['Int'];
  product: Product;
  signUpFeeProduct: Product;
  signUpRules: Array<SubscriptionProductSignUpRule>;
  startDateForFirstPayment?: Maybe<Scalars['DateTime']>;
  startDateForFirstPaymentCompanies: Array<SubscriptionProductStartDateForFirstPayment>;
  startDateForFirstPaymentUser?: Maybe<Scalars['DateTime']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeSignUpPriceId?: Maybe<Scalars['String']>;
  usageRules: Array<SubscriptionProductUsageRule>;
  userAllowedToSignUp: Scalars['Boolean'];
  userGroupAutomatic: Array<UserGroup>;
  userProductSubscription?: Maybe<UserProductSubscription>;
  userSubscriptions: Array<UserProductSubscription>;
};


export type SubscriptionProductGiftCardsArgs = {
  after?: InputMaybe<SubscriptionProductGiftCardWhereUniqueInput>;
  before?: InputMaybe<SubscriptionProductGiftCardWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionProductOnlyPayOnResourceTypesArgs = {
  after?: InputMaybe<ResourceTypeWhereUniqueInput>;
  before?: InputMaybe<ResourceTypeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionProductSignUpRulesArgs = {
  after?: InputMaybe<SubscriptionProductSignUpRuleWhereUniqueInput>;
  before?: InputMaybe<SubscriptionProductSignUpRuleWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionProductStartDateForFirstPaymentCompaniesArgs = {
  after?: InputMaybe<SubscriptionProductStartDateForFirstPaymentWhereUniqueInput>;
  before?: InputMaybe<SubscriptionProductStartDateForFirstPaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionProductStartDateForFirstPaymentUserArgs = {
  subscriptionProductGiftCardCode?: InputMaybe<Scalars['String']>;
};


export type SubscriptionProductUsageRulesArgs = {
  after?: InputMaybe<SubscriptionProductUsageRuleWhereUniqueInput>;
  before?: InputMaybe<SubscriptionProductUsageRuleWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionProductUserGroupAutomaticArgs = {
  after?: InputMaybe<UserGroupWhereUniqueInput>;
  before?: InputMaybe<UserGroupWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SubscriptionProductUserSubscriptionsArgs = {
  after?: InputMaybe<UserProductSubscriptionWhereUniqueInput>;
  before?: InputMaybe<UserProductSubscriptionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionProductCategoriesFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductCategoriesResult = Pagination & {
  __typename?: 'SubscriptionProductCategoriesResult';
  data: Array<SubscriptionProductCategory>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type SubscriptionProductCategory = {
  __typename?: 'SubscriptionProductCategory';
  company?: Maybe<Company>;
  connectedTo: FranchiseOrCompany;
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  name: Scalars['String'];
  subscriptionProducts: Array<SubscriptionProduct>;
  userProductSubscriptionConnectedTo: FranchiseOrCompany;
};


export type SubscriptionProductCategorySubscriptionProductsArgs = {
  after?: InputMaybe<SubscriptionProductWhereUniqueInput>;
  before?: InputMaybe<SubscriptionProductWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionProductCategoryCreate = {
  name: Scalars['String'];
};

export type SubscriptionProductCreate = {
  activeBeforeFirstPayment?: InputMaybe<Scalars['Boolean']>;
  allowPublicSignUp?: InputMaybe<Scalars['Boolean']>;
  allowUsageOnWorkshopBookings?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  daysBeforeFirstPayment?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  discountOnEvents?: InputMaybe<Scalars['Int']>;
  discountOnlyAvailableInResourceBookingTimeRanges?: InputMaybe<Array<InputMaybe<CouponResourceBookingTimeRangeCreate>>>;
  maxActiveBookings?: InputMaybe<Scalars['Int']>;
  maxDaysCreateResourceBookingAhead?: InputMaybe<Scalars['Int']>;
  maxNumberOfActiveSubscriptions?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomer?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomerPrMonth?: InputMaybe<Scalars['Boolean']>;
  monthlyPrice: Scalars['Float'];
  name: Scalars['String'];
  onlyPayOnResourceTypes?: InputMaybe<Array<Scalars['ID']>>;
  paymentCyclesAfterCancele?: InputMaybe<Scalars['Int']>;
  paymentDiscountAmount?: InputMaybe<Scalars['Int']>;
  paymentDiscountAmountPrBookingInterval?: InputMaybe<Scalars['Float']>;
  paymentDiscountIsOnlyInBTime?: InputMaybe<Scalars['Boolean']>;
  paymentDiscountPercentage?: InputMaybe<Scalars['Int']>;
  paymentDiscountType?: InputMaybe<SubscriptionProducPaymentDiscountType>;
  paymentMaxActiveBookingsPerMonth?: InputMaybe<Scalars['Int']>;
  paymentMaxCoverType?: InputMaybe<SubscriptionProductPaymentMaxCoverType>;
  paymentMaxHoursCovered?: InputMaybe<Scalars['Float']>;
  paymentMaxValueCovered?: InputMaybe<Scalars['Float']>;
  paymentOnTheFirstOfMonth?: InputMaybe<Scalars['Boolean']>;
  paymentTimesPrYear?: InputMaybe<Scalars['Int']>;
  percentDiscountOnOtherPayments?: InputMaybe<Scalars['Int']>;
  percentageDiscountOnSubscriptionPayment?: InputMaybe<Scalars['Int']>;
  signUpFee?: InputMaybe<Scalars['Float']>;
  signUpRules?: InputMaybe<Array<InputMaybe<SubscriptionProductSignUpRuleCreate>>>;
  startDateForFirstPayment?: InputMaybe<Scalars['DateTime']>;
  usageRules?: InputMaybe<Array<InputMaybe<SubscriptionProductUsageRuleCreate>>>;
  useOnAllCompanies?: InputMaybe<Scalars['Boolean']>;
};

export type SubscriptionProductGiftCard = {
  __typename?: 'SubscriptionProductGiftCard';
  code: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  startAfterPeriods: Scalars['Int'];
  subscriptionProduct: SubscriptionProduct;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionProductGiftCardCreate = {
  code?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Array<Scalars['ID']>>;
  createCount?: InputMaybe<Scalars['Int']>;
  maxUsageTimes?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  startAfterPeriods: Scalars['Int'];
  subscriptionProduct: Scalars['ID'];
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type SubscriptionProductGiftCardWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductGiftCardsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductGiftCardsResult = Pagination & {
  __typename?: 'SubscriptionProductGiftCardsResult';
  data: Array<SubscriptionProductGiftCard>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export enum SubscriptionProductPaymentMaxCoverType {
  All = 'All',
  Hours = 'Hours',
  None = 'None',
  Value = 'Value'
}

export type SubscriptionProductSignUpRule = {
  __typename?: 'SubscriptionProductSignUpRule';
  id: Scalars['String'];
  ruleAge?: Maybe<Scalars['Int']>;
  ruleAgeType?: Maybe<SubscriptionProductSignUpRuleAgeType>;
  subscriptionProduct: SubscriptionProduct;
  type: SubscriptionProductSignUpRuleType;
};

export enum SubscriptionProductSignUpRuleAgeType {
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan'
}

export type SubscriptionProductSignUpRuleCreate = {
  ruleAge?: InputMaybe<Scalars['Int']>;
  ruleAgeType?: InputMaybe<SubscriptionProductSignUpRuleAgeType>;
  type: SubscriptionProductSignUpRuleType;
  userGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum SubscriptionProductSignUpRuleType {
  Age = 'Age',
  NotInCompanyId = 'NotInCompanyId',
  UserGroup = 'UserGroup'
}

export type SubscriptionProductSignUpRuleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductStartDateForFirstPayment = {
  __typename?: 'SubscriptionProductStartDateForFirstPayment';
  companies: Array<Company>;
  id: Scalars['String'];
  startAfterPeriods?: Maybe<Scalars['Int']>;
  subscriptionProduct: SubscriptionProduct;
  toDate?: Maybe<Scalars['DateTime']>;
  validEndDate: Scalars['DateTime'];
  validStartDate: Scalars['DateTime'];
};


export type SubscriptionProductStartDateForFirstPaymentCompaniesArgs = {
  after?: InputMaybe<CompanyWhereUniqueInput>;
  before?: InputMaybe<CompanyWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionProductStartDateForFirstPaymentCreate = {
  companies: Array<Scalars['ID']>;
  startAfterPeriods?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  subscriptionProduct: Scalars['ID'];
  validEndDate: Scalars['DateTime'];
  validStartDate: Scalars['DateTime'];
};

export type SubscriptionProductStartDateForFirstPaymentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductUpdate = {
  accessCodeDoorGroup?: InputMaybe<Scalars['String']>;
  allowPublicSignUp?: InputMaybe<Scalars['Boolean']>;
  canBeUsedOnWorkshops?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  discountOnWorkshops?: InputMaybe<Scalars['String']>;
  maxActiveBookings?: InputMaybe<Scalars['Int']>;
  maxNumberOfActiveSubscriptions?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomer?: InputMaybe<Scalars['Int']>;
  maximumUsagesPrCustomerPrMonth?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  newRecurringPrice?: InputMaybe<Scalars['Int']>;
  newSignUpFee?: InputMaybe<Scalars['Int']>;
  paymentDiscountAmount?: InputMaybe<Scalars['Int']>;
  paymentDiscountAmountPrBookingInterval?: InputMaybe<Scalars['Float']>;
  paymentDiscountIsOnlyInBTime?: InputMaybe<Scalars['Boolean']>;
  paymentDiscountPercentage?: InputMaybe<Scalars['Int']>;
  paymentDiscountType?: InputMaybe<SubscriptionProducPaymentDiscountType>;
  paymentMaxCoverType?: InputMaybe<SubscriptionProductPaymentMaxCoverType>;
  paymentMaxHoursCovered?: InputMaybe<Scalars['Float']>;
  paymentMaxValueCovered?: InputMaybe<Scalars['Float']>;
  percentDiscountOnOtherPayments?: InputMaybe<Scalars['Int']>;
  updateExistingSubscriptions?: InputMaybe<Scalars['Boolean']>;
  updateExistingSubscriptionsAfterNextInvoice?: InputMaybe<Scalars['Boolean']>;
  updatePrices?: InputMaybe<Scalars['Boolean']>;
};

export type SubscriptionProductUsageRule = {
  __typename?: 'SubscriptionProductUsageRule';
  id: Scalars['String'];
  resourceBookingDays: Array<Day>;
  resourceBookingEndTime?: Maybe<Scalars['String']>;
  resourceBookingStartTime?: Maybe<Scalars['String']>;
  type: SubscriptionProductUsageRuleType;
};

export type SubscriptionProductUsageRuleCreate = {
  resourceBookingDays?: InputMaybe<Array<InputMaybe<Day>>>;
  resourceBookingEndTime?: InputMaybe<Scalars['String']>;
  resourceBookingStartTime?: InputMaybe<Scalars['String']>;
  type: SubscriptionProductUsageRuleType;
};

export enum SubscriptionProductUsageRuleType {
  DiscoutCanNotBeUsedByOtherCompanies = 'DiscoutCanNotBeUsedByOtherCompanies',
  ResourceBookingStartDate = 'ResourceBookingStartDate'
}

export type SubscriptionProductUsageRuleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductWhereUniqueInput = {
  couponOnEventsId?: InputMaybe<Scalars['String']>;
  couponOnOtherPaymentsId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  signUpFeeProductId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type SubscriptionProductsResult = Pagination & {
  __typename?: 'SubscriptionProductsResult';
  data: Array<SubscriptionProduct>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type SupportTicketCreate = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  currentUrl?: InputMaybe<Scalars['String']>;
  issueType?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  resourceBooking?: InputMaybe<Scalars['ID']>;
  urlToIssue?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export enum SupportedCountries {
  At = 'AT',
  De = 'DE',
  Dk = 'DK',
  Es = 'ES',
  Fi = 'FI',
  Gb = 'GB',
  No = 'NO',
  Se = 'SE',
  Us = 'US'
}

export enum SyncedToControllerUnitStatus {
  ConnectionError = 'ConnectionError',
  NotAvailableOnControllerType = 'NotAvailableOnControllerType',
  NotSynced = 'NotSynced',
  Synced = 'Synced'
}

export enum Timezone {
  Berlin = 'Berlin',
  Copenhagen = 'Copenhagen',
  Helsinki = 'Helsinki',
  London = 'London',
  Oslo = 'Oslo',
  Stockholm = 'Stockholm',
  Utc = 'UTC',
  Vienna = 'Vienna'
}

export type TrinityAddressContainer = {
  __typename?: 'TrinityAddressContainer';
  billingAddress: TrinityBillingAddress;
  deliveryAddress?: Maybe<TrinityBillingAddress>;
  hasSeparateDeliveryAddress: Scalars['Boolean'];
};

export type TrinityBillingAddress = {
  __typename?: 'TrinityBillingAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
};

export type TrinityCustomerBillingAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
};

export type TrinityDeliveryInfo = {
  __typename?: 'TrinityDeliveryInfo';
  createdUtc: Scalars['String'];
  deliveryDate: Scalars['String'];
  erpDeliveryNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items: Array<TrinityDeliveryItem>;
  shipmentReference?: Maybe<Scalars['String']>;
  trackingReference?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export type TrinityDeliveryItem = {
  __typename?: 'TrinityDeliveryItem';
  deliveredQuantity: Scalars['Int'];
  id: Scalars['Int'];
  sku?: Maybe<Scalars['String']>;
};

export type TrinityEComBrand = {
  __typename?: 'TrinityEComBrand';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type TrinityEComCartItem = {
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type TrinityEComCategory = {
  __typename?: 'TrinityEComCategory';
  id: Scalars['Int'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  type: TrinityEcomCategoryType;
};

export type TrinityEComCheckout = {
  __typename?: 'TrinityEComCheckout';
  customerOrder: CustomerOrderType;
  success: Scalars['Boolean'];
};

export type TrinityEComCheckoutSession = {
  __typename?: 'TrinityEComCheckoutSession';
  checkoutToken: Scalars['String'];
  deliveryCheckoutServiceConfiguration: TrinityEcomDeliveryCheckoutServiceConfiguration;
  deliveryCheckoutVendor: Scalars['Int'];
  deliveryConfiguration?: Maybe<Scalars['String']>;
  deliveryPostCode?: Maybe<Scalars['String']>;
  discountSum: Scalars['Float'];
  paymentMode: Scalars['Int'];
  paymentServiceContainer?: Maybe<TrinityEComPaymentServiceContainer>;
  paymentTypes?: Maybe<Array<TrinityEComPaymentType>>;
  selectedPaymentTypeId?: Maybe<Scalars['Int']>;
  selectedPaymentTypeName?: Maybe<Scalars['String']>;
  shoppingCart: TrinityEComShoppingCart;
  totalSum: Scalars['Float'];
  totalSumBeforeDiscounts: Scalars['Float'];
  totalSumExcludingServices: Scalars['Float'];
  totalVatSum: Scalars['Float'];
};

export type TrinityEComOrderHistory = {
  __typename?: 'TrinityEComOrderHistory';
  addressContainer: TrinityAddressContainer;
  cartToken?: Maybe<Scalars['String']>;
  catalogueId: Scalars['Int'];
  checkoutToken?: Maybe<Scalars['String']>;
  createdUtc?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  customerName?: Maybe<Scalars['String']>;
  customerTelephone?: Maybe<Scalars['String']>;
  deliveries?: Maybe<Array<TrinityDeliveryInfo>>;
  discountCode?: Maybe<Scalars['String']>;
  discountSum: Scalars['Float'];
  erpOrderNumber?: Maybe<Scalars['String']>;
  externalOrderId?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['String']>;
  handlingStatus: OrderHandlingStatusType;
  id: Scalars['Int'];
  items?: Maybe<Array<TrinityItems>>;
  paymentFee: Scalars['Float'];
  paymentFeeVat: Scalars['Float'];
  paymentName?: Maybe<Scalars['String']>;
  shippingFee: Scalars['Float'];
  shippingFeeVat: Scalars['Float'];
  shippingName?: Maybe<Scalars['String']>;
  totalSum: Scalars['Float'];
  vatSum: Scalars['Float'];
};

export type TrinityEComPageContent = {
  __typename?: 'TrinityEComPageContent';
  bodyHtml?: Maybe<Scalars['String']>;
};

export type TrinityEComPaymentServiceContainer = {
  __typename?: 'TrinityEComPaymentServiceContainer';
  embeddedCheckoutHtmlSnippet?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  externalRedirectUrl?: Maybe<Scalars['String']>;
  methodType: Scalars['Int'];
  paymentReferenceCode?: Maybe<Scalars['String']>;
  properties?: Maybe<TrinityEComPaymentServiceContainerProperties>;
  serviceType: Scalars['Int'];
};

export type TrinityEComPaymentServiceContainerProperties = {
  __typename?: 'TrinityEComPaymentServiceContainerProperties';
  clientId?: Maybe<Scalars['String']>;
};

export type TrinityEComPaymentType = {
  __typename?: 'TrinityEComPaymentType';
  description?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentTypeId: Scalars['Int'];
  shortDescription?: Maybe<Scalars['String']>;
  supportsZeroSum: Scalars['Boolean'];
  vendor: Scalars['Int'];
};

export type TrinityEComProductCatalog = {
  __typename?: 'TrinityEComProductCatalog';
  currentPage: Scalars['Int'];
  pageSize: Scalars['Int'];
  products: Array<TrinityEcomProduct>;
  totalCount: Scalars['Int'];
  totalPageCount: Scalars['Int'];
};

export type TrinityEComProductCatalogParameters = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  propertyFilterValues?: InputMaybe<Array<InputMaybe<TrinityEComPropertyValue>>>;
  sortBy?: InputMaybe<Scalars['String']>;
  stocks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type TrinityEComProperty = {
  __typename?: 'TrinityEComProperty';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type TrinityEComPropertyValue = {
  filterValues: Array<Scalars['String']>;
  id: Scalars['Int'];
};

export type TrinityEComReferenceData = {
  __typename?: 'TrinityEComReferenceData';
  brands: Array<TrinityEComBrand>;
  categories: Array<TrinityEComCategory>;
  currencyCode: Scalars['String'];
  properties: Array<TrinityEComProperty>;
  shippingTypes: Array<TrinityEComShippingType>;
  stocks: Array<TrinityEComStock>;
};

export type TrinityEComShippingFee = {
  __typename?: 'TrinityEComShippingFee';
  name?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  sku?: Maybe<Scalars['String']>;
  thresholdOrderAmount: Scalars['Float'];
  vatPercent?: Maybe<Scalars['Float']>;
  vatSum?: Maybe<Scalars['Float']>;
};

export type TrinityEComShippingType = {
  __typename?: 'TrinityEComShippingType';
  description: Scalars['String'];
  id: Scalars['Int'];
  imageFileName: Scalars['String'];
  name: Scalars['String'];
  shippingFees: Array<TrinityEComShippingFee>;
  shippingGroupId: Scalars['Int'];
  sortOrder: Scalars['Int'];
};

export type TrinityEComShoppingCart = {
  __typename?: 'TrinityEComShoppingCart';
  createdUtc: Scalars['String'];
  discountSum: Scalars['Float'];
  expiresUtc: Scalars['String'];
  externalOrderId: Scalars['String'];
  externalSourceName: Scalars['String'];
  externalStoreCode: Scalars['String'];
  externalStoreId: Scalars['String'];
  hasStockWarning: Scalars['Boolean'];
  id: Scalars['Int'];
  items: Array<TrinityEComShoppingCartItem>;
  sumBeforeDiscounts: Scalars['Float'];
  token: Scalars['String'];
  totalQuantity: Scalars['Int'];
  totalSum: Scalars['Float'];
  updatedUtc: Scalars['String'];
  vatSum: Scalars['Float'];
};

export type TrinityEComShoppingCartItem = {
  __typename?: 'TrinityEComShoppingCartItem';
  articleGroupName: Scalars['String'];
  articleName: Scalars['String'];
  discountCodeId: Scalars['Int'];
  id: Scalars['Int'];
  itemDiscountSum: Scalars['Float'];
  itemSumBeforeDiscounts: Scalars['Float'];
  itemTotalSum: Scalars['Float'];
  itemVatPercent: Scalars['Float'];
  itemVatSum: Scalars['Float'];
  name: Scalars['String'];
  productArticleId: Scalars['Int'];
  productId: Scalars['Int'];
  productImageUrl: Scalars['String'];
  productName: Scalars['String'];
  productPathName: Scalars['String'];
  quantity: Scalars['Int'];
  shippingGroupId: Scalars['Int'];
  shippingGroupPriority: Scalars['Int'];
  sku: Scalars['String'];
  stockInfo: TrinityEComShoppingCartItemStockInfo;
  type: Scalars['Int'];
  unitPrice: Scalars['Float'];
  unitPriceBeforeDiscount: Scalars['Float'];
};

export type TrinityEComShoppingCartItemStockInfo = {
  __typename?: 'TrinityEComShoppingCartItemStockInfo';
  deliveryDaysMax: Scalars['Int'];
  deliveryDaysMin: Scalars['Int'];
  hasOnHandWarning: Scalars['Boolean'];
  isBackorderEnabled: Scalars['Boolean'];
  onHand: Scalars['Int'];
  status: Scalars['Int'];
};

export type TrinityEComStock = {
  __typename?: 'TrinityEComStock';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum TrinityEcomCategoryType {
  Category = 'CATEGORY',
  Productlist = 'PRODUCTLIST'
}

export type TrinityEcomDeliveryCheckoutServiceConfiguration = {
  __typename?: 'TrinityEcomDeliveryCheckoutServiceConfiguration';
  id?: Maybe<Scalars['String']>;
  jsonData?: Maybe<Scalars['String']>;
  messsage?: Maybe<Scalars['String']>;
  options?: Maybe<Array<TrinityEcomDeliveryOption>>;
  postCode?: Maybe<Scalars['String']>;
  postCodeIsValid: Scalars['Boolean'];
  selectedConfiguration?: Maybe<Scalars['String']>;
  selectedOption: TrinityEcomDeliveryOption;
  selectedServiceId?: Maybe<Scalars['String']>;
  vendor: Scalars['Int'];
};

export type TrinityEcomDeliveryOption = {
  __typename?: 'TrinityEcomDeliveryOption';
  agentId?: Maybe<Scalars['String']>;
  agents?: Maybe<Array<TrinityEcomDeliveryOptionAgent>>;
  deliveryInterval?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vatPercent: Scalars['Float'];
};

export type TrinityEcomDeliveryOptionAgent = {
  __typename?: 'TrinityEcomDeliveryOptionAgent';
  address?: Maybe<TrinityEcomDeliveryOptionAgentAddress>;
  estimatedDeliveryDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mapLatitude?: Maybe<Scalars['Float']>;
  mapLongitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type TrinityEcomDeliveryOptionAgentAddress = {
  __typename?: 'TrinityEcomDeliveryOptionAgentAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
};

export type TrinityEcomProduct = {
  __typename?: 'TrinityEcomProduct';
  articles?: Maybe<Array<TrinityEcomProductArticles>>;
  basePrice: Scalars['Float'];
  brand: Scalars['String'];
  catalogueId: Scalars['Int'];
  deliverableStockValue: Scalars['Int'];
  deliveryDaysMax: Scalars['Int'];
  deliveryDaysMin: Scalars['Int'];
  description: TrinityEcomProductDescription;
  filterData: TrinityEcomProductFilterData;
  id: Scalars['Int'];
  images: Array<Scalars['String']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  primaryCategoryId: Scalars['Int'];
  primaryImageSmallUrl?: Maybe<Scalars['String']>;
  propertyValues: Array<TrinityEcomProductPropertyValues>;
  ribbon?: Maybe<TrinityEcomProductRibbon>;
  shippingGroupId: Scalars['Int'];
  sku?: Maybe<Scalars['String']>;
  stockValues: Array<TrinityEcomStockValues>;
  storeStockValue: Scalars['Int'];
};

export type TrinityEcomProductArticles = {
  __typename?: 'TrinityEcomProductArticles';
  deliverableStockValue: Scalars['Int'];
  name: Scalars['String'];
  sku: Scalars['String'];
  storeStockValue: Scalars['Int'];
};

export type TrinityEcomProductDescription = {
  __typename?: 'TrinityEcomProductDescription';
  fullDescription?: Maybe<Scalars['String']>;
  lead?: Maybe<Scalars['String']>;
  listDescription: Scalars['String'];
};

export type TrinityEcomProductFilterData = {
  __typename?: 'TrinityEcomProductFilterData';
  categories?: Maybe<Array<Scalars['Int']>>;
  propertyItems?: Maybe<Scalars['String']>;
  propertyToggles?: Maybe<Scalars['String']>;
  rangeAttributes?: Maybe<Scalars['String']>;
  stockOnHand?: Maybe<Scalars['String']>;
};

export type TrinityEcomProductPropertyValueItems = {
  __typename?: 'TrinityEcomProductPropertyValueItems';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
};

export type TrinityEcomProductPropertyValues = {
  __typename?: 'TrinityEcomProductPropertyValues';
  descriptionEnabled: Scalars['Boolean'];
  filterEnabled: Scalars['Boolean'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  specificationEnabled: Scalars['Boolean'];
  summaryEnabled: Scalars['Boolean'];
  type: Scalars['Int'];
  value?: Maybe<Scalars['String']>;
  valueItems: Array<TrinityEcomProductPropertyValueItems>;
};

export type TrinityEcomProductRibbon = {
  __typename?: 'TrinityEcomProductRibbon';
  title?: Maybe<Scalars['String']>;
};

export type TrinityEcomStockValues = {
  __typename?: 'TrinityEcomStockValues';
  articleId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  sku: Scalars['String'];
  stockId: Scalars['Int'];
  value: Scalars['Int'];
};

export type TrinityItems = {
  __typename?: 'TrinityItems';
  articleId?: Maybe<Scalars['Int']>;
  articleName?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['Int']>;
  brandName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemTotalSum: Scalars['Float'];
  itemVatSum: Scalars['Float'];
  modelName?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryCategoryId?: Maybe<Scalars['Int']>;
  primaryCategoryName?: Maybe<Scalars['String']>;
  primaryCategoryParentName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  sku?: Maybe<Scalars['String']>;
  type: CustomerOrderItemType;
  unitPrice: Scalars['Float'];
  variantName?: Maybe<Scalars['String']>;
  vatPercent: Scalars['Float'];
};

export type UploadMigrationFileResult = {
  __typename?: 'UploadMigrationFileResult';
  fileName: Scalars['String'];
  invalidColumns: Array<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  accessCode?: Maybe<AccessCode>;
  activity: Array<UserActivity>;
  attendeeOnResourceBookings: Array<ResourceBookingAttendee>;
  bookingNext?: Maybe<Booking>;
  businessUser?: Maybe<BusinessUser>;
  city?: Maybe<Scalars['String']>;
  country: SupportedCountries;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  groups: Array<UserGroup>;
  haveSavedStripeSource: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isFriends: Scalars['Boolean'];
  language: Language;
  lastName?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  /** From 0 to 100 */
  loyaltyScore: Scalars['Int'];
  messages: Array<Message>;
  name?: Maybe<Scalars['String']>;
  payments: Array<Payment>;
  paymentsSum: Scalars['Float'];
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberWithoutCountryCode?: Maybe<Scalars['String']>;
  platformConnections: Array<UserPlatformConnection>;
  recurringBookingsAttendee: Array<ResourceBookingRecurring>;
  resourceBookings: Array<ResourceBooking>;
  resourceBookingsCount: Scalars['Int'];
  resourceBookingsPrWeek: UserResourceBookingsPrWeek;
  sentMessages: Array<Message>;
  streetName?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeCustomerUrl?: Maybe<Scalars['String']>;
  stripeEphemeralKey: Scalars['String'];
  stripeSources: Array<StripeSource>;
  userProductSubscriptions: Array<UserProductSubscription>;
  userSignInMethod: UserSingInMethod;
  usingPasswordV2: Scalars['Boolean'];
  wannasportConnections: Array<WannasportConnection>;
  workshopBookings: Array<WorkshopBooking>;
  zipCode?: Maybe<Scalars['String']>;
};


export type UserActivityArgs = {
  after?: InputMaybe<UserActivityWhereUniqueInput>;
  before?: InputMaybe<UserActivityWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserAttendeeOnResourceBookingsArgs = {
  after?: InputMaybe<ResourceBookingAttendeeWhereUniqueInput>;
  before?: InputMaybe<ResourceBookingAttendeeWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserMessagesArgs = {
  after?: InputMaybe<MessageWhereUniqueInput>;
  before?: InputMaybe<MessageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserPaymentsArgs = {
  after?: InputMaybe<PaymentWhereUniqueInput>;
  before?: InputMaybe<PaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserPlatformConnectionsArgs = {
  after?: InputMaybe<UserPlatformConnectionWhereUniqueInput>;
  before?: InputMaybe<UserPlatformConnectionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserResourceBookingsArgs = {
  after?: InputMaybe<ResourceBookingWhereUniqueInput>;
  before?: InputMaybe<ResourceBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserSentMessagesArgs = {
  after?: InputMaybe<MessageWhereUniqueInput>;
  before?: InputMaybe<MessageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserWannasportConnectionsArgs = {
  after?: InputMaybe<WannasportConnectionWhereUniqueInput>;
  before?: InputMaybe<WannasportConnectionWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserWorkshopBookingsArgs = {
  after?: InputMaybe<WorkshopBookingWhereUniqueInput>;
  before?: InputMaybe<WorkshopBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserActivitiesFiltering = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type UserActivitiesResult = Pagination & {
  __typename?: 'UserActivitiesResult';
  data: Array<UserActivity>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UserActivity = {
  __typename?: 'UserActivity';
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  type: UserActivityType;
  user: User;
  value?: Maybe<Scalars['String']>;
};

export enum UserActivityType {
  CompanyCreated = 'COMPANY_CREATED',
  CouponUsage = 'COUPON_USAGE',
  EmailChanged = 'EMAIL_CHANGED',
  EmailResetSent = 'EMAIL_RESET_SENT',
  EmailVerificationSent = 'EMAIL_VERIFICATION_SENT',
  EmailVerified = 'EMAIL_VERIFIED',
  MessageCanceld = 'MESSAGE_CANCELD',
  MessageCreated = 'MESSAGE_CREATED',
  PasswordResetSent = 'PASSWORD_RESET_SENT',
  PasswrodChanged = 'PASSWROD_CHANGED',
  PaymentMobilepayInvoiceCreated = 'PAYMENT_MOBILEPAY_INVOICE_CREATED',
  PaymentStripePaid = 'PAYMENT_STRIPE_PAID',
  PlatformConnectionCreated = 'PlatformConnectionCreated',
  SignIn = 'SIGN_IN',
  UserCreated = 'USER_CREATED',
  UserUpdated = 'USER_UPDATED'
}

export type UserActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserAgreement = {
  __typename?: 'UserAgreement';
  accepted: Scalars['Boolean'];
  agreement: Agreement;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  lastAccepted: Scalars['DateTime'];
  user: User;
};

export type UserAgreementWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserAgreementsResult = Pagination & {
  __typename?: 'UserAgreementsResult';
  data: Array<UserAgreement>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UserCreate = {
  birthday?: InputMaybe<Scalars['DateTime']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country: SupportedCountries;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<GenderType>;
  isBusinessUser?: InputMaybe<Scalars['Boolean']>;
  language: Language;
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum UserExtraInfoFields {
  Address = 'Address',
  Birthday = 'Birthday',
  Email = 'Email',
  Gender = 'Gender',
  Name = 'Name',
  PhoneNumber = 'PhoneNumber'
}

export type UserGroup = {
  __typename?: 'UserGroup';
  admins: Array<User>;
  adminsCanHandleUsers: Scalars['Boolean'];
  automaticAddUsersWithEmailEnding?: Maybe<Scalars['String']>;
  automaticSubscriptionProduct?: Maybe<SubscriptionProduct>;
  company?: Maybe<Company>;
  connectedTo: FranchiseOrCompany;
  coupons: Array<Coupon>;
  createdAt: Scalars['DateTime'];
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  maxDaysCreateResourceBookingAhead?: Maybe<Scalars['Int']>;
  maxUserLimit?: Maybe<Scalars['Int']>;
  messages: Array<Message>;
  name: Scalars['String'];
  pointAccount?: Maybe<PointAccount>;
  userIsGroupAdmin: Scalars['Boolean'];
  users: Array<UserGroupUser>;
  usersCount: Scalars['Int'];
};


export type UserGroupAdminsArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserGroupCouponsArgs = {
  after?: InputMaybe<CouponWhereUniqueInput>;
  before?: InputMaybe<CouponWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserGroupMessagesArgs = {
  after?: InputMaybe<MessageWhereUniqueInput>;
  before?: InputMaybe<MessageWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserGroupCreate = {
  adminsCanHandleUsers?: InputMaybe<Scalars['Boolean']>;
  automaticAddUsersWithEmailEnding?: InputMaybe<Scalars['String']>;
  maxDaysCreateResourceBookingAhead?: InputMaybe<Scalars['Int']>;
  maxUserLimit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type UserGroupUpdate = {
  adminsCanHandleUsers?: InputMaybe<Scalars['Boolean']>;
  automaticAddUsersWithEmailEnding?: InputMaybe<Scalars['String']>;
  maxDaysCreateResourceBookingAhead?: InputMaybe<Scalars['Int']>;
  maxUserLimit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UserGroupUser = {
  __typename?: 'UserGroupUser';
  isGroupAdmin: Scalars['Boolean'];
  pointUsage: Scalars['Float'];
  user: User;
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type UserGroupUserPointUsageArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type UserGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserGroupsFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type UserGroupsResult = Pagination & {
  __typename?: 'UserGroupsResult';
  data: Array<UserGroup>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UserMigrationSignUpLink = {
  __typename?: 'UserMigrationSignUpLink';
  userInformation: Scalars['String'];
};

export type UserPlatformConnection = {
  __typename?: 'UserPlatformConnection';
  company?: Maybe<Company>;
  franchise?: Maybe<Franchise>;
  id: Scalars['String'];
  locationDefault?: Maybe<Location>;
  niceRole: Scalars['String'];
  role: UserRole;
  user: User;
};

export type UserPlatformConnectionCreate = {
  company: Scalars['ID'];
  user?: InputMaybe<Scalars['ID']>;
};

export type UserPlatformConnectionCreateMultiple = {
  companyConnections: Array<InputMaybe<Scalars['String']>>;
  franchiseConnections: Array<InputMaybe<Scalars['String']>>;
  systemAdminConnections: Array<InputMaybe<UserRole>>;
  userId: Scalars['String'];
};

export type UserPlatformConnectionToken = {
  __typename?: 'UserPlatformConnectionToken';
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  role: UserRole;
};

export type UserPlatformConnectionTokenCreate = {
  email: Scalars['String'];
  userRole?: InputMaybe<UserRole>;
};

export type UserPlatformConnectionTokenCreateResult = UserPlatformConnection | UserPlatformConnectionToken;

export type UserPlatformConnectionTokenWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type UserPlatformConnectionTokensFiltering = {
  userRoleType?: InputMaybe<UserRole>;
};

export type UserPlatformConnectionTokensResult = Pagination & {
  __typename?: 'UserPlatformConnectionTokensResult';
  data: Array<UserPlatformConnectionToken>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UserPlatformConnectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserPlatformConnectionsFiltering = {
  userRoleType?: InputMaybe<UserRole>;
};

export type UserPlatformConnectionsResult = Pagination & {
  __typename?: 'UserPlatformConnectionsResult';
  data: Array<UserPlatformConnection>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UserProductSubscription = {
  __typename?: 'UserProductSubscription';
  activity: Array<UserProductSubscriptionActivity>;
  addedByUserGroup?: Maybe<UserGroup>;
  cancelDate?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']>;
  connectedTo: FranchiseOrCompany;
  createdAt: Scalars['DateTime'];
  createdByAdmin?: Maybe<User>;
  franchise?: Maybe<Franchise>;
  franchiseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  latestPayment?: Maybe<Payment>;
  latestSuccessfulPayment?: Maybe<Payment>;
  mobilePaySubscriptionAgreementId?: Maybe<Scalars['String']>;
  payments: Array<Payment>;
  paymentsSum: Scalars['Float'];
  posibleCancelDate?: Maybe<Scalars['DateTime']>;
  status: UserProductSubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionPlatform: SubscriptionPlatform;
  subscriptionProduct: SubscriptionProduct;
  usedOnPayments: Array<Payment>;
  usedOnPaymentsCount: Scalars['Int'];
  user: User;
  userCanCancel: Scalars['Boolean'];
  userId: Scalars['String'];
};


export type UserProductSubscriptionActivityArgs = {
  after?: InputMaybe<UserProductSubscriptionActivityWhereUniqueInput>;
  before?: InputMaybe<UserProductSubscriptionActivityWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProductSubscriptionPaymentsArgs = {
  after?: InputMaybe<PaymentWhereUniqueInput>;
  before?: InputMaybe<PaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserProductSubscriptionUsedOnPaymentsArgs = {
  after?: InputMaybe<PaymentWhereUniqueInput>;
  before?: InputMaybe<PaymentWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserProductSubscriptionActivity = {
  __typename?: 'UserProductSubscriptionActivity';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  type: UserProductSubscriptionActivityType;
  userProductSubscription: UserProductSubscription;
};

export type UserProductSubscriptionActivityFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type UserProductSubscriptionActivityResult = Pagination & {
  __typename?: 'UserProductSubscriptionActivityResult';
  data: Array<UserProductSubscriptionActivity>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export enum UserProductSubscriptionActivityType {
  Activated = 'Activated',
  CanceledBySystem = 'CanceledBySystem',
  CanceledByUser = 'CanceledByUser',
  Created = 'Created',
  Deactivated = 'Deactivated',
  GiftCardUsed = 'GiftCardUsed',
  RenewFailed = 'RenewFailed',
  Renewed = 'Renewed',
  ToActive = 'ToActive',
  ToCancele = 'ToCancele'
}

export type UserProductSubscriptionActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserProductSubscriptionPaymentUserCanDoResult = {
  __typename?: 'UserProductSubscriptionPaymentUserCanDoResult';
  canDo: Scalars['Boolean'];
  discountAmount?: Maybe<Scalars['Float']>;
  userProductSubscription?: Maybe<UserProductSubscription>;
  userProductSubscriptionId?: Maybe<Scalars['ID']>;
};

export enum UserProductSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  PastDue = 'PastDue',
  PendingActive = 'PendingActive',
  PendingCancele = 'PendingCancele',
  PendingStatus = 'PendingStatus',
  ToActive = 'ToActive',
  ToCancele = 'ToCancele',
  Unpaid = 'Unpaid'
}

export type UserProductSubscriptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  mobilePaySubscriptionAgreementId?: InputMaybe<Scalars['String']>;
  signUpFeePaymentTokenId?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type UserProductSubscriptionsFiltering = {
  status?: InputMaybe<UserProductSubscriptionStatus>;
  subscriptionPlatform?: InputMaybe<SubscriptionPlatform>;
  subscriptionProduct?: InputMaybe<Scalars['String']>;
};

export type UserProductSubscriptionsResult = Pagination & {
  __typename?: 'UserProductSubscriptionsResult';
  data: Array<UserProductSubscription>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UserResourceBookingsPrWeek = {
  __typename?: 'UserResourceBookingsPrWeek';
  averageRatio: Scalars['Float'];
  diffBetweenPastWeekAndAverageRatio: Scalars['Float'];
  pastWeekCount: Scalars['Int'];
  pastWeekRatio: Scalars['Float'];
  prWeekRatio: Array<Scalars['Float']>;
  totalCount: Scalars['Int'];
  userWeeksOld: Scalars['Int'];
};

export enum UserRole {
  Admin = 'Admin',
  Company = 'Company',
  Franchise = 'Franchise',
  Priceff = 'Priceff',
  System = 'System',
  Technician = 'Technician',
  User = 'User'
}

export enum UserSingInMethod {
  Apple = 'Apple',
  EmailAndPassword = 'EmailAndPassword',
  Facebook = 'Facebook',
  None = 'None'
}

export enum UserType {
  BusinessUser = 'BusinessUser',
  User = 'User'
}

export type UserUpdate = {
  birthday?: InputMaybe<Scalars['DateTime']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<SupportedCountries>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  isBusinessUser?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UserWhereUniqueInput = {
  accessCodeId?: InputMaybe<Scalars['String']>;
  appleUserId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebookUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

export type UsersFiltering = {
  partOfGroup?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
};

export type UsersResult = Pagination & {
  __typename?: 'UsersResult';
  data: Array<User>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type UsersTopFiltering = {
  search?: InputMaybe<Scalars['String']>;
};

export type UsersTopResult = Pagination & {
  __typename?: 'UsersTopResult';
  data: Array<User>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type WannasportConnection = {
  __typename?: 'WannasportConnection';
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  location: Location;
  locationId: Scalars['String'];
  pointAccount: PointAccount;
  possibleTimeSlots: Scalars['String'];
  possibleTimeSlotsFormated: Array<WannasportPossibleTimeSlot>;
  user: User;
  userId: Scalars['String'];
};

export type WannasportConnectionCreate = {
  location: Scalars['ID'];
  timeSlots: Array<InputMaybe<WannasportPossibleTimeSlotInput>>;
};

export type WannasportConnectionCreated = {
  __typename?: 'WannasportConnectionCreated';
  token: Scalars['String'];
  wannasportConnection: WannasportConnection;
};

export type WannasportConnectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type WannasportPossibleTimeSlot = {
  __typename?: 'WannasportPossibleTimeSlot';
  days: Array<Day>;
  times: Array<Array<Scalars['String']>>;
};

export type WannasportPossibleTimeSlotInput = {
  days: Array<InputMaybe<Day>>;
  times: Array<InputMaybe<Array<InputMaybe<Scalars['String']>>>>;
};

export type Workshop = {
  __typename?: 'Workshop';
  allowUserProductSubscriptionPayment: Scalars['Boolean'];
  bookings: Array<WorkshopBooking>;
  bookingsCount: Scalars['Int'];
  company: Company;
  createdAt: Scalars['DateTime'];
  days: Array<WorkshopDay>;
  daysCount: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['String'];
  lastRegistrationDate: Scalars['DateTime'];
  location: Location;
  maxRegistrations: Scalars['Int'];
  nextDay?: Maybe<WorkshopDay>;
  notifyUsersOnBooking: Array<User>;
  participantList: Array<WorkshopBooking>;
  paymentsSum: Scalars['Float'];
  privateWorkshop: Scalars['Boolean'];
  privateWorkshopKey?: Maybe<Scalars['String']>;
  product: Product;
  requireUserBookingNote: Scalars['Boolean'];
  requiredUserBookingNoteTitle?: Maybe<Scalars['String']>;
  status: WorkshopStatus;
  title: Scalars['String'];
  type: WorkshopType;
  typeColor: Scalars['String'];
  userBooking?: Maybe<WorkshopBooking>;
  userCanCreateBooking: Scalars['Boolean'];
  userIsOnWaitlist?: Maybe<Scalars['Boolean']>;
  waitlist: Array<WorkshopWaitlistItem>;
  waitlistCount: Scalars['Int'];
};


export type WorkshopBookingsArgs = {
  after?: InputMaybe<WorkshopBookingWhereUniqueInput>;
  before?: InputMaybe<WorkshopBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type WorkshopDaysArgs = {
  after?: InputMaybe<WorkshopDayWhereUniqueInput>;
  before?: InputMaybe<WorkshopDayWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type WorkshopNotifyUsersOnBookingArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type WorkshopWaitlistArgs = {
  isUsed?: InputMaybe<Scalars['Boolean']>;
};


export type WorkshopWaitlistCountArgs = {
  isUsed?: InputMaybe<Scalars['Boolean']>;
};

export type WorkshopBooking = {
  __typename?: 'WorkshopBooking';
  company: Company;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  payment?: Maybe<Payment>;
  status: BookingStatus;
  user: User;
  userBookingNote?: Maybe<Scalars['String']>;
  userCanCancelBooking: Scalars['Boolean'];
  workshop: Workshop;
};

export type WorkshopBookingWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
};

export type WorkshopBookingsFiltering = {
  status?: InputMaybe<BookingStatus>;
};

export type WorkshopBookingsResult = Pagination & {
  __typename?: 'WorkshopBookingsResult';
  data: Array<WorkshopBooking>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type WorkshopCreate = {
  allowUserProductSubscriptionPayment?: InputMaybe<Scalars['Boolean']>;
  allowUserProductSubscriptionPaymentIsOfAType?: InputMaybe<Scalars['Boolean']>;
  createAccessCodeAccessTime?: InputMaybe<Scalars['Boolean']>;
  createManyDates?: InputMaybe<Array<WorkshopCreateManyDates>>;
  days?: InputMaybe<Array<WorkshopDayCreate>>;
  description: Scalars['String'];
  lastRegistrationDate?: InputMaybe<Scalars['DateTime']>;
  lastRegistrationDateShouldBeFirstDay?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['ID'];
  maxRegistrations: Scalars['Int'];
  notifyUsersOnBooking?: InputMaybe<Array<Scalars['ID']>>;
  price: Scalars['Float'];
  privateWorkshop?: InputMaybe<Scalars['Boolean']>;
  privateWorkshopKey?: InputMaybe<Scalars['String']>;
  requireUserBookingNote?: InputMaybe<Scalars['Boolean']>;
  requiredUserBookingNoteTitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: WorkshopType;
};

export type WorkshopCreateManyDates = {
  createBookingOnResources: Array<Scalars['ID']>;
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type WorkshopDay = {
  __typename?: 'WorkshopDay';
  attendees: Array<User>;
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  resourceBookings: Array<ResourceBooking>;
  startDate: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  userWorkshopBookingAccessCode?: Maybe<AccessCode>;
  workshop: Workshop;
  workshopId: Scalars['String'];
};


export type WorkshopDayAttendeesArgs = {
  after?: InputMaybe<UserWhereUniqueInput>;
  before?: InputMaybe<UserWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type WorkshopDayResourceBookingsArgs = {
  after?: InputMaybe<ResourceBookingWhereUniqueInput>;
  before?: InputMaybe<ResourceBookingWhereUniqueInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type WorkshopDayCreate = {
  controllerUnitId?: InputMaybe<Scalars['ID']>;
  createBookingOnResources?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  noxVersion?: InputMaybe<NoxVersion>;
  startDate: Scalars['DateTime'];
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type WorkshopDayUpdate = {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type WorkshopDayWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum WorkshopStatus {
  Active = 'Active',
  Canceled = 'Canceled'
}

export enum WorkshopType {
  Coach = 'Coach',
  Event = 'Event',
  Tournament = 'Tournament'
}

export type WorkshopUpdate = {
  allowUserProductSubscriptionPayment?: InputMaybe<Scalars['Boolean']>;
  allowUserProductSubscriptionPaymentIsOfAType?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  lastRegistrationDate?: InputMaybe<Scalars['DateTime']>;
  maxRegistrations?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WorkshopType>;
};

export type WorkshopWaitlistFiltering = {
  isUsed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type WorkshopWaitlistItem = {
  __typename?: 'WorkshopWaitlistItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user: User;
  workshop: Workshop;
};

export type WorkshopWaitlistResult = Pagination & {
  __typename?: 'WorkshopWaitlistResult';
  data: Array<WorkshopWaitlistItem>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type WorkshopsFiltering = {
  ableToBook?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<WorkshopType>;
  underLastBookingDate?: InputMaybe<Scalars['Boolean']>;
  userHasBooking?: InputMaybe<Scalars['Boolean']>;
};

export type WorkshopsFutureSubscriptionPayload = {
  __typename?: 'WorkshopsFutureSubscriptionPayload';
  workshops: Array<Workshop>;
};

export type WorkshopsResult = Pagination & {
  __typename?: 'WorkshopsResult';
  data: Array<Workshop>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type AccessCodeCreateMutationVariables = Exact<{
  data: AccessCodeCreate;
}>;


export type AccessCodeCreateMutation = { __typename?: 'Mutation', accessCodeCreate: { __typename?: 'AccessCode', id: string } };

export type AccessCodeDeleteMutationVariables = Exact<{
  accessCode: Scalars['ID'];
  noxVersion?: InputMaybe<NoxVersion>;
}>;


export type AccessCodeDeleteMutation = { __typename?: 'Mutation', accessCodeDelete: boolean };

export type AccessCodeUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: AccessCodeUpdate;
}>;


export type AccessCodeUpdateMutation = { __typename?: 'Mutation', accessCodeUpdate: { __typename?: 'AccessCode', id: string } };

export type AdditionalServiceCreateMutationVariables = Exact<{
  additionalServiceData: AdditionalServiceCreate;
}>;


export type AdditionalServiceCreateMutation = { __typename?: 'Mutation', additionalServiceCreate: { __typename?: 'MutationResult', success: boolean, message?: string | null } };

export type AdditionalServiceUpdateMutationVariables = Exact<{
  additionalServiceData: AdditionalServiceUpdate;
}>;


export type AdditionalServiceUpdateMutation = { __typename?: 'Mutation', additionalServiceUpdate: { __typename?: 'MutationResult', success: boolean, message?: string | null } };

export type AnalyticCreateKpiExportMutationVariables = Exact<{
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  periodType: KpiExportPeriodType;
  sendToEmail: Scalars['String'];
}>;


export type AnalyticCreateKpiExportMutation = { __typename?: 'Mutation', analyticCreateKPIExport: { __typename?: 'MutationResult', success: boolean } };

export type AuthChangePasswordMutationVariables = Exact<{
  token: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type AuthChangePasswordMutation = { __typename?: 'Mutation', authChangePassword: { __typename?: 'MutationResult', success: boolean } };

export type AuthSendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AuthSendPasswordResetEmailMutation = { __typename?: 'Mutation', authSendPasswordResetEmail: { __typename?: 'MutationResult', message?: string | null, success: boolean } };

export type AuthSignInPlatformMutationVariables = Exact<{
  userPlatformConnection: Scalars['ID'];
}>;


export type AuthSignInPlatformMutation = { __typename?: 'Mutation', authSignInPlatform: string };

export type AuthSignInUserMutationVariables = Exact<{
  emailAndPassword?: InputMaybe<EmailAndPasswordInput>;
  facebookAuthToken?: InputMaybe<Scalars['String']>;
  appleSignIn?: InputMaybe<AppleSignInInput>;
}>;


export type AuthSignInUserMutation = { __typename?: 'Mutation', authSignInUser: string };

export type AuthUpdatePasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type AuthUpdatePasswordMutation = { __typename?: 'Mutation', authUpdatePassword: boolean };

export type AuthVerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AuthVerifyEmailMutation = { __typename?: 'Mutation', authVerifyEmail: { __typename?: 'MutationResult', success: boolean } };

export type BookingReportCreateMutationVariables = Exact<{
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  sendToEmail: Scalars['String'];
}>;


export type BookingReportCreateMutation = { __typename?: 'Mutation', bookingReportCreate: { __typename?: 'MutationResult', success: boolean, message?: string | null } };

export type BookliCameraCreateMutationVariables = Exact<{
  data: BookliCameraCreate;
}>;


export type BookliCameraCreateMutation = { __typename?: 'Mutation', bookliCameraCreate: { __typename?: 'BookliCamera', id: string } };

export type BookliCameraUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: BookliCameraUpdate;
}>;


export type BookliCameraUpdateMutation = { __typename?: 'Mutation', bookliCameraUpdate: { __typename?: 'BookliCamera', id: string, name: string } };

export type BookliCameraServerCreateMutationVariables = Exact<{
  data: BookliCameraServerCreate;
}>;


export type BookliCameraServerCreateMutation = { __typename?: 'Mutation', bookliCameraServerCreate: { __typename?: 'BookliCameraServer', id: string } };

export type BookliCameraServerReloadCamerasMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookliCameraServerReloadCamerasMutation = { __typename?: 'Mutation', bookliCameraServerReloadCameras: { __typename?: 'BookliCameraServer', id: string } };

export type BookliDeviceRegisterMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type BookliDeviceRegisterMutation = { __typename?: 'Mutation', bookliDeviceRegister: { __typename?: 'BookliDevice', id: string } };

export type BookliSoundCreateMutationVariables = Exact<{
  data: BookliSoundCreate;
}>;


export type BookliSoundCreateMutation = { __typename?: 'Mutation', bookliSoundCreate: { __typename?: 'BookliSound', id: string } };

export type BookliVideoCreateSubClipMutationVariables = Exact<{
  data: BookliVideoCreateSubClip;
}>;


export type BookliVideoCreateSubClipMutation = { __typename?: 'Mutation', bookliVideoCreateSubClip: { __typename?: 'BookliVideo', id: string } };

export type CompanyCreateMutationVariables = Exact<{
  userAuthToken?: InputMaybe<Scalars['String']>;
  companyCreateInvitationToken?: InputMaybe<Scalars['String']>;
  companyData: CompanyCreate;
  franchiseData?: InputMaybe<FranchiseCreate>;
  userData?: InputMaybe<UserCreate>;
}>;


export type CompanyCreateMutation = { __typename?: 'Mutation', companyCreate: { __typename?: 'Company', id: string } };

export type CompanyCreateInvitationSendMutationVariables = Exact<{
  data: CompanyCreateInvitationSend;
}>;


export type CompanyCreateInvitationSendMutation = { __typename?: 'Mutation', companyCreateInvitationSend: { __typename?: 'MutationResult', success: boolean } };

export type CompanyCreateInvitationDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanyCreateInvitationDeleteMutation = { __typename?: 'Mutation', companyCreateInvitationDelete: { __typename?: 'MutationResult', success: boolean } };

export type CompanySettingUpdateMutationVariables = Exact<{
  data: CompanySettingUpdate;
}>;


export type CompanySettingUpdateMutation = { __typename?: 'Mutation', companySettingUpdate: { __typename?: 'CompanySetting', id: string } };

export type CompanyUpdateMutationVariables = Exact<{
  data: CompanyUpdate;
}>;


export type CompanyUpdateMutation = { __typename?: 'Mutation', companyUpdate: { __typename?: 'Company', id: string } };

export type CompanyUploadAppImageMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type CompanyUploadAppImageMutation = { __typename?: 'Mutation', companyUploadAppImage: { __typename?: 'CompanySetting', id: string } };

export type CompanyUploadLogoMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type CompanyUploadLogoMutation = { __typename?: 'Mutation', companyUploadLogo: { __typename?: 'Company', id: string } };

export type ControllerDoorCreateMutationVariables = Exact<{
  data: ControllerDoorCreate;
}>;


export type ControllerDoorCreateMutation = { __typename?: 'Mutation', controllerDoorCreate: { __typename?: 'ControllerDoor', id: string } };

export type ControllerDoorSetStateMutationVariables = Exact<{
  data: ControllerDoorSetState;
}>;


export type ControllerDoorSetStateMutation = { __typename?: 'Mutation', controllerDoorSetState: { __typename?: 'MutationResult', success: boolean } };

export type ControllerDoorGroupUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ControllerDoorGroupUpdate;
}>;


export type ControllerDoorGroupUpdateMutation = { __typename?: 'Mutation', controllerDoorGroupUpdate: { __typename?: 'ControllerDoorGroup', id: string } };

export type ControllerDoorGroupCreateMutationVariables = Exact<{
  data: ControllerDoorGroupCreate;
}>;


export type ControllerDoorGroupCreateMutation = { __typename?: 'Mutation', controllerDoorGroupCreate: { __typename?: 'ControllerDoorGroup', id: string } };

export type AddLightControllerResourceMutationVariables = Exact<{
  resource: Scalars['ID'];
  noxAreaId: Scalars['Int'];
  noxTimeprofileId: Scalars['Int'];
}>;


export type AddLightControllerResourceMutation = { __typename?: 'Mutation', resourceAddLightController: { __typename?: 'Resource', id: string } };

export type ControllerOnOffSetStateMutationVariables = Exact<{
  controllerOnOff: Scalars['ID'];
  newState?: InputMaybe<Scalars['Boolean']>;
}>;


export type ControllerOnOffSetStateMutation = { __typename?: 'Mutation', controllerOnOffSetState: { __typename?: 'MutationResult', success: boolean } };

export type ControllerOnOffUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ControllerOnOffUpdate;
}>;


export type ControllerOnOffUpdateMutation = { __typename?: 'Mutation', controllerOnOffUpdate: { __typename?: 'ControllerOnOff', id: string } };

export type ControllerUnitCreateMutationVariables = Exact<{
  data: ControllerUnitCreate;
}>;


export type ControllerUnitCreateMutation = { __typename?: 'Mutation', controllerUnitCreate: { __typename?: 'ControllerUnit', id: string } };

export type CouponCreateMutationVariables = Exact<{
  data: CouponCreate;
}>;


export type CouponCreateMutation = { __typename?: 'Mutation', couponCreate: { __typename?: 'Coupon', id: string } };

export type CouponDisableMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CouponDisableMutation = { __typename?: 'Mutation', couponDisable: { __typename?: 'Coupon', id: string } };

export type CouponUpdateMutationVariables = Exact<{
  coupon: Scalars['ID'];
  data: CouponUpdate;
}>;


export type CouponUpdateMutation = { __typename?: 'Mutation', couponUpdate: { __typename?: 'Coupon', id: string } };

export type DineroConnectionCreateMutationVariables = Exact<{
  data: DineroConnectionCreate;
}>;


export type DineroConnectionCreateMutation = { __typename?: 'Mutation', dineroConnectionCreate: { __typename?: 'DineroConnection', id: string } };

export type DeleteUserFcmTokenMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type DeleteUserFcmTokenMutation = { __typename?: 'Mutation', deleteUserFCMToken: boolean };

export type SetUserFcmTokenMutationVariables = Exact<{
  fcmToken: Scalars['String'];
}>;


export type SetUserFcmTokenMutation = { __typename?: 'Mutation', setUserFCMToken: { __typename?: 'User', id: string } };

export type FeedbackCreateMutationVariables = Exact<{
  data: FeedbackCreate;
}>;


export type FeedbackCreateMutation = { __typename?: 'Mutation', feedbackCreate: { __typename?: 'Feedback', id: string } };

export type FranchiseCompanyInvitationSendMutationVariables = Exact<{
  data: FranchiseCompanyInvitationSend;
}>;


export type FranchiseCompanyInvitationSendMutation = { __typename?: 'Mutation', franchiseCompanyInvitationSend: { __typename?: 'MutationResult', success: boolean } };

export type FranchiseUploadLogoMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type FranchiseUploadLogoMutation = { __typename?: 'Mutation', franchiseUploadLogo: { __typename?: 'Franchise', id: string } };

export type FriendshipCreateMutationVariables = Exact<{
  friendUserId: Scalars['ID'];
}>;


export type FriendshipCreateMutation = { __typename?: 'Mutation', friendshipCreate: { __typename?: 'Friendship', id: string } };

export type FriendshipDeleteMutationVariables = Exact<{
  friendUserId: Scalars['ID'];
}>;


export type FriendshipDeleteMutation = { __typename?: 'Mutation', friendshipDelete: boolean };

export type GiftCardCreateMutationVariables = Exact<{
  data: GiftCardCreate;
}>;


export type GiftCardCreateMutation = { __typename?: 'Mutation', giftCardCreate: Array<{ __typename?: 'GiftCard', id: string, code: string }> };

export type GiftCardUseMutationVariables = Exact<{
  giftCardCode: Scalars['String'];
}>;


export type GiftCardUseMutation = { __typename?: 'Mutation', giftCardUse: number };

export type LocationCreateMutationVariables = Exact<{
  data: LocationCreate;
}>;


export type LocationCreateMutation = { __typename?: 'Mutation', locationCreate: { __typename?: 'Location', id: string } };

export type LocationUpdateMutationVariables = Exact<{
  location: Scalars['ID'];
  data: LocationUpdate;
}>;


export type LocationUpdateMutation = { __typename?: 'Mutation', locationUpdate: { __typename?: 'Location', id: string } };

export type LocationUserDefaultChangeMutationVariables = Exact<{
  newDefaultLocation: Scalars['ID'];
}>;


export type LocationUserDefaultChangeMutation = { __typename?: 'Mutation', locationUserDefaultChange: { __typename?: 'Location', id: string } };

export type MessageCreateMutationVariables = Exact<{
  data: MessageCreate;
}>;


export type MessageCreateMutation = { __typename?: 'Mutation', messageCreate: { __typename?: 'Message', id: string } };

export type MessageCreateSendTestMutationVariables = Exact<{
  data: MessageCreate;
  sendTo: Array<Scalars['String']> | Scalars['String'];
}>;


export type MessageCreateSendTestMutation = { __typename?: 'Mutation', messageCreateSendTest: { __typename?: 'Message', id: string } };

export type PayPalConfirmPaymentMutationVariables = Exact<{
  payPalInvoiceId: Scalars['String'];
  payPalOrderId: Scalars['String'];
}>;


export type PayPalConfirmPaymentMutation = { __typename?: 'Mutation', payPalConfirmPayment: boolean };

export type PayPalCreateConnectionMutationVariables = Exact<{
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
}>;


export type PayPalCreateConnectionMutation = { __typename?: 'Mutation', payPalCreateConnection: { __typename?: 'MutationResult', success: boolean } };

export type PaymentCancelReservedProductMutationVariables = Exact<{
  data: PaymentCancelReservedProduct;
}>;


export type PaymentCancelReservedProductMutation = { __typename?: 'Mutation', paymentCancelReservedProduct: boolean };

export type PaymentGetXlsxListMutationVariables = Exact<{
  createdAtStartDate: Scalars['DateTime'];
  createdAtEndDate: Scalars['DateTime'];
  sendToEmail: Scalars['String'];
}>;


export type PaymentGetXlsxListMutation = { __typename?: 'Mutation', paymentGetXlsxList: { __typename?: 'MutationResult', success: boolean } };

export type GetPaymentInvoiceMutationVariables = Exact<{
  payment: Scalars['ID'];
}>;


export type GetPaymentInvoiceMutation = { __typename?: 'Mutation', paymentInvoice: string };

export type PaymentRefundMutationVariables = Exact<{
  id: Scalars['ID'];
  canceleProduct?: InputMaybe<Scalars['Boolean']>;
  refundPayment?: InputMaybe<Scalars['Boolean']>;
  forceRefundAsPoints?: InputMaybe<Scalars['Boolean']>;
  refundPartialPayment?: InputMaybe<Scalars['Boolean']>;
  refundPartialPaymentAmount?: InputMaybe<Scalars['Float']>;
  cancelAdditionalService?: InputMaybe<Scalars['Boolean']>;
  refundServiceFee?: InputMaybe<Scalars['Boolean']>;
  refundRemainingAmount?: InputMaybe<Scalars['Boolean']>;
}>;


export type PaymentRefundMutation = { __typename?: 'Mutation', paymentRefund: { __typename?: 'Payment', id: string } };

export type PaymentReserveProductMutationVariables = Exact<{
  paymentPriceToken: Scalars['String'];
}>;


export type PaymentReserveProductMutation = { __typename?: 'Mutation', paymentReserveProduct: { __typename?: 'PaymentReserveProduct', resourceBooking?: { __typename?: 'ResourceBooking', id: string, resourceBookingAttendeesToken?: string | null } | null, workshopBooking?: { __typename?: 'WorkshopBooking', id: string } | null } };

export type UpdatePaymentStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: PaymentStatus;
}>;


export type UpdatePaymentStatusMutation = { __typename?: 'Mutation', updatePaymentStatus: { __typename?: 'Payment', id: string } };

export type PaymentTokenCreateMutationVariables = Exact<{
  paymentType: PaymentTokenPaymentType;
  data: PaymentTokenCreate;
}>;


export type PaymentTokenCreateMutation = { __typename?: 'Mutation', paymentTokenCreate: { __typename?: 'PaymentToken', id: string, state: PaymentTokenState, stripePaymentIntentId?: string | null, stripePaymentMethod?: string | null, stripeClientSecret?: string | null, payPalInvoiceId?: string | null, failedReason?: PaymentTokenFaildReason | null, currency: Currency, country: SupportedCountries, label: string, amountToPay: number, lastFailureReason?: string | null, attemptCount: number, mobilePayConnection?: { __typename?: 'MobilePayConnection', invoicePayBeforeMinutes: number } | null, user: { __typename?: 'User', id: string, stripeCustomerId?: string | null, stripeEphemeralKey: string }, company: { __typename?: 'Company', id: string, name: string } } };

export type PaymentTokenFailedMutationVariables = Exact<{
  id: Scalars['ID'];
  failedReason: PaymentTokenFaildReason;
  cancelReservation: Scalars['Boolean'];
}>;


export type PaymentTokenFailedMutation = { __typename?: 'Mutation', paymentTokenFailed: { __typename?: 'PaymentToken', id: string } };

export type PlatformInvoiceGetForPeriodMutationVariables = Exact<{
  data: PlatformInvoiceGetForPeriod;
}>;


export type PlatformInvoiceGetForPeriodMutation = { __typename?: 'Mutation', platformInvoiceGetForPeriod: Array<string> };

export type PointAccountGetNumbersXlsxMutationVariables = Exact<{
  pointAccount: Scalars['ID'];
  toDate: Scalars['DateTime'];
}>;


export type PointAccountGetNumbersXlsxMutation = { __typename?: 'Mutation', pointAccountGetNumbersXlsx: string };

export type PointAccountUpdateMutationVariables = Exact<{
  pointAccount: Scalars['ID'];
  data: PointAccountUpdate;
}>;


export type PointAccountUpdateMutation = { __typename?: 'Mutation', pointAccountUpdate: { __typename?: 'PointAccount', id: string } };

export type PointAccountsCompanyGetNumbersMutationVariables = Exact<{
  toDate: Scalars['DateTime'];
  sendToEmail: Scalars['String'];
}>;


export type PointAccountsCompanyGetNumbersMutation = { __typename?: 'Mutation', pointAccountsCompanyGetNumbers: { __typename?: 'MutationResult', success: boolean } };

export type DoPointTransactionUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: PointTransactionUpdate;
}>;


export type DoPointTransactionUpdateMutation = { __typename?: 'Mutation', pointTransactionUpdate: { __typename?: 'PointTransaction', id: string } };

export type PointsAddOrRemoveMutationVariables = Exact<{
  pointAccount: Scalars['ID'];
  amount: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  isOneToOne: Scalars['Boolean'];
  realValue?: InputMaybe<Scalars['Float']>;
  skipPlatformFees?: InputMaybe<Scalars['Boolean']>;
}>;


export type PointsAddOrRemoveMutation = { __typename?: 'Mutation', pointsAddOrRemove: { __typename?: 'PointTransaction', id: string } };

export type PointProductCreateMutationVariables = Exact<{
  data: PointProductCreate;
}>;


export type PointProductCreateMutation = { __typename?: 'Mutation', pointProductCreate: { __typename?: 'PointProduct', id: string } };

export type PointProductDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PointProductDeleteMutation = { __typename?: 'Mutation', pointProductDelete: { __typename?: 'PointProduct', id: string } };

export type PointProductUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: PointProductUpdate;
}>;


export type PointProductUpdateMutation = { __typename?: 'Mutation', pointProductUpdate: { __typename?: 'PointProduct', id: string } };

export type PriceffModelCreateMutationVariables = Exact<{
  data: PriceffModelCreate;
}>;


export type PriceffModelCreateMutation = { __typename?: 'Mutation', priceffModelCreate: { __typename?: 'PriceffModel', id: string } };

export type PriceffModelUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: PriceffModelUpdate;
}>;


export type PriceffModelUpdateMutation = { __typename?: 'Mutation', priceffModelUpdate: { __typename?: 'PriceffModel', id: string } };

export type PriceffParameterCreateMutationVariables = Exact<{
  data: PriceffParameterCreate;
}>;


export type PriceffParameterCreateMutation = { __typename?: 'Mutation', priceffParameterCreate: { __typename?: 'PriceffParameter', id: string } };

export type PriceffParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: PriceffParameterUpdate;
}>;


export type PriceffParameterUpdateMutation = { __typename?: 'Mutation', priceffParameterUpdate: { __typename?: 'PriceffParameter', id: string } };

export type ResourceTypeConnectPriceffModelMutationVariables = Exact<{
  priceffModel: Scalars['ID'];
  resourceType: Scalars['ID'];
}>;


export type ResourceTypeConnectPriceffModelMutation = { __typename?: 'Mutation', resourceTypeConnectPriceffModel: { __typename?: 'ResourceType', id: string } };

export type ResourceTypePriceffUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ResourceTypePriceffUpdate;
}>;


export type ResourceTypePriceffUpdateMutation = { __typename?: 'Mutation', resourceTypePriceffUpdate: { __typename?: 'ResourceType', id: string } };

export type ResourceCategoryCreateMutationVariables = Exact<{
  data: ResourceCategoryCreate;
}>;


export type ResourceCategoryCreateMutation = { __typename?: 'Mutation', resourceCategoryCreate: { __typename?: 'ResourceCategory', id: string } };

export type ResourceCategoryUpdateMutationVariables = Exact<{
  resourceCategory: Scalars['ID'];
  data: ResourceCategoryUpdate;
}>;


export type ResourceCategoryUpdateMutation = { __typename?: 'Mutation', resourceCategoryUpdate: { __typename?: 'ResourceCategory', id: string } };

export type ResourceCreateMutationVariables = Exact<{
  data: ResourceCreate;
}>;


export type ResourceCreateMutation = { __typename?: 'Mutation', resourceCreate: { __typename?: 'Resource', id: string } };

export type ResourceTypeCreateMutationVariables = Exact<{
  data: ResourceTypeCreate;
}>;


export type ResourceTypeCreateMutation = { __typename?: 'Mutation', resourceTypeCreate: { __typename?: 'ResourceType', id: string } };

export type ResourceTypeUpdateMutationVariables = Exact<{
  resourceType: Scalars['ID'];
  data: ResourceTypeUpdate;
}>;


export type ResourceTypeUpdateMutation = { __typename?: 'Mutation', resourceTypeUpdate: { __typename?: 'ResourceType', id: string } };

export type ResourceUpdateMutationVariables = Exact<{
  resource: Scalars['ID'];
  data: ResourceUpdate;
}>;


export type ResourceUpdateMutation = { __typename?: 'Mutation', resourceUpdate: { __typename?: 'Resource', id: string } };

export type ResourceBookingAttendeeAddMutationVariables = Exact<{
  resourceBooking: Scalars['ID'];
  users: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ResourceBookingAttendeeAddMutation = { __typename?: 'Mutation', resourceBookingAttendeeAdd: { __typename?: 'ResourceBooking', id: string } };

export type ResourceBookingAttendeeDeleteMutationVariables = Exact<{
  resourceBooking: Scalars['ID'];
  resourceBookingAttendees: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ResourceBookingAttendeeDeleteMutation = { __typename?: 'Mutation', resourceBookingAttendeeDelete: { __typename?: 'ResourceBooking', id: string } };

export type ResourceBookingBookliVideoCreateMutationVariables = Exact<{
  resourceBooking: Scalars['ID'];
}>;


export type ResourceBookingBookliVideoCreateMutation = { __typename?: 'Mutation', resourceBookingBookliVideoCreate: { __typename?: 'BookliVideo', id: string } };

export type ResourceBookingCancelMutationVariables = Exact<{
  id: Scalars['ID'];
  refundPayment?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResourceBookingCancelMutation = { __typename?: 'Mutation', resourceBookingCancel: { __typename?: 'ResourceBooking', id: string } };

export type ResourceBookingUpdateMutationVariables = Exact<{
  resourceBooking: Scalars['ID'];
  data: ResourceBookingUpdateData;
}>;


export type ResourceBookingUpdateMutation = { __typename?: 'Mutation', resourceBookingUpdate: { __typename?: 'ResourceBooking', id: string } };

export type ResourceBookingCreateCompanyReservationMutationVariables = Exact<{
  data: ResourceBookingCreateCompanyReservation;
}>;


export type ResourceBookingCreateCompanyReservationMutation = { __typename?: 'Mutation', resourceBookingCreateCompanyReservation: { __typename?: 'ResourceBookingCreateCompanyReservationResult', successfulCreatedBookings: Array<{ __typename?: 'ResourceBooking', id: string }>, errorWhileCreating: Array<{ __typename?: 'Resource', id: string, name: string }> } };

export type ResourceBookingRecurringCreateMutationVariables = Exact<{
  data: ResourceBookingRecurringCreate;
}>;


export type ResourceBookingRecurringCreateMutation = { __typename?: 'Mutation', resourceBookingRecurringCreate: { __typename?: 'ResourceBookingRecurring', id: string } };

export type ResourceBookingRecurringDeleteMutationVariables = Exact<{
  resourceBookingRecurring: Scalars['ID'];
  deleteAllFutureBookings?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResourceBookingRecurringDeleteMutation = { __typename?: 'Mutation', resourceBookingRecurringDelete: { __typename?: 'ResourceBookingRecurring', id: string } };

export type ResourceBookingRecurringUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ResourceBookingRecurringUpdate;
}>;


export type ResourceBookingRecurringUpdateMutation = { __typename?: 'Mutation', resourceBookingRecurringUpdate: { __typename?: 'ResourceBookingRecurring', id: string } };

export type ResourceTypePriceCreateMutationVariables = Exact<{
  data: ResourceTypePriceCreate;
}>;


export type ResourceTypePriceCreateMutation = { __typename?: 'Mutation', resourceTypePriceCreate: { __typename?: 'ResourceTypePrice', id: string } };

export type ResourceTypePriceDateAddMutationVariables = Exact<{
  resourceTypePriceId: Scalars['ID'];
  date: CreateResourceTypePriceDate;
}>;


export type ResourceTypePriceDateAddMutation = { __typename?: 'Mutation', resourceTypePriceDateAdd: { __typename?: 'ResourceTypePrice', id: string } };

export type ResourceTypePriceDateDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceTypePriceDateDeleteMutation = { __typename?: 'Mutation', resourceTypePriceDateDelete: boolean };

export type ResourceTypePriceDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceTypePriceDeleteMutation = { __typename?: 'Mutation', resourceTypePriceDelete: boolean };

export type ResourceTypePriceUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ResourceTypePriceUpdate;
}>;


export type ResourceTypePriceUpdateMutation = { __typename?: 'Mutation', resourceTypePriceUpdate: { __typename?: 'ResourceTypePrice', id: string } };

export type SaEventMutationVariables = Exact<{
  event: Scalars['String'];
  value: Scalars['Float'];
  dimension?: InputMaybe<Scalars['String']>;
}>;


export type SaEventMutation = { __typename?: 'Mutation', saEvent: boolean };

export type ConfirmPaymentIntentMutationVariables = Exact<{
  paymentIntentId: Scalars['String'];
  confirmationTokenId: Scalars['String'];
}>;


export type ConfirmPaymentIntentMutation = { __typename?: 'Mutation', nextActionUrl?: string | null };

export type StripePaymentMetodAddedMutationVariables = Exact<{ [key: string]: never; }>;


export type StripePaymentMetodAddedMutation = { __typename?: 'Mutation', stripePaymentMetodAdded: boolean };

export type StripeUserRemovePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID'];
}>;


export type StripeUserRemovePaymentMethodMutation = { __typename?: 'Mutation', stripeUserRemovePaymentMethod: { __typename?: 'MutationResult', success: boolean } };

export type StripeReportGenerateMutationVariables = Exact<{
  data: StripeReportGenerate;
}>;


export type StripeReportGenerateMutation = { __typename?: 'Mutation', stripeReportGenerate: Array<{ __typename?: 'StripeReport', id: string }> };

export type SubscriptionProductCreateMutationVariables = Exact<{
  data: SubscriptionProductCreate;
}>;


export type SubscriptionProductCreateMutation = { __typename?: 'Mutation', subscriptionProductCreate: { __typename?: 'SubscriptionProduct', id: string } };

export type SubscriptionProductStartDateForFirstPaymentCreateMutationVariables = Exact<{
  data: SubscriptionProductStartDateForFirstPaymentCreate;
}>;


export type SubscriptionProductStartDateForFirstPaymentCreateMutation = { __typename?: 'Mutation', subscriptionProductStartDateForFirstPaymentCreate: { __typename?: 'SubscriptionProduct', id: string } };

export type SubscriptionProductUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: SubscriptionProductUpdate;
}>;


export type SubscriptionProductUpdateMutation = { __typename?: 'Mutation', subscriptionProductUpdate: { __typename?: 'SubscriptionProduct', id: string } };

export type SubscriptionProductCategoryCreateMutationVariables = Exact<{
  data: SubscriptionProductCategoryCreate;
}>;


export type SubscriptionProductCategoryCreateMutation = { __typename?: 'Mutation', subscriptionProductCategoryCreate: { __typename?: 'SubscriptionProductCategory', id: string } };

export type SubscriptionProductGiftCardCreateMutationVariables = Exact<{
  data: SubscriptionProductGiftCardCreate;
}>;


export type SubscriptionProductGiftCardCreateMutation = { __typename?: 'Mutation', subscriptionProductGiftCardCreate: Array<{ __typename?: 'SubscriptionProductGiftCard', id: string, code: string }> };

export type SupportTicketCreateMutationVariables = Exact<{
  data: SupportTicketCreate;
}>;


export type SupportTicketCreateMutation = { __typename?: 'Mutation', supportTicketCreate: { __typename?: 'MutationResult', success: boolean } };

export type TrinityEComCreateCheckoutMutationVariables = Exact<{
  postCode: Scalars['String'];
  cartItems: Array<InputMaybe<TrinityEComCartItem>> | InputMaybe<TrinityEComCartItem>;
  country: SupportedCountries;
}>;


export type TrinityEComCreateCheckoutMutation = { __typename?: 'Mutation', trinityEComCreateCheckout: { __typename?: 'TrinityEComCheckoutSession', checkoutToken: string, paymentMode: number, totalSum: number, deliveryCheckoutVendor: number, paymentServiceContainer?: { __typename?: 'TrinityEComPaymentServiceContainer', serviceType: number, embeddedCheckoutHtmlSnippet?: string | null, externalRedirectUrl?: string | null, errorMessage?: string | null, paymentReferenceCode?: string | null, methodType: number, properties?: { __typename?: 'TrinityEComPaymentServiceContainerProperties', clientId?: string | null } | null } | null, deliveryCheckoutServiceConfiguration: { __typename?: 'TrinityEcomDeliveryCheckoutServiceConfiguration', id?: string | null, postCode?: string | null, postCodeIsValid: boolean, options?: Array<{ __typename?: 'TrinityEcomDeliveryOption', id?: string | null, name?: string | null, title?: string | null, description?: string | null, sku?: string | null, agentId?: string | null, deliveryInterval?: string | null, price: number, vatPercent: number, imageUrl?: string | null, agents?: Array<{ __typename?: 'TrinityEcomDeliveryOptionAgent', id?: string | null, name?: string | null, mapLatitude?: number | null, mapLongitude?: number | null, phone?: string | null, estimatedDeliveryDate?: string | null, address?: { __typename?: 'TrinityEcomDeliveryOptionAgentAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null }> | null }> | null }, paymentTypes?: Array<{ __typename?: 'TrinityEComPaymentType', paymentTypeId: number, vendor: number, name?: string | null, description?: string | null, shortDescription?: string | null, logoImageUrl?: string | null, supportsZeroSum: boolean }> | null, shoppingCart: { __typename?: 'TrinityEComShoppingCart', id: number, token: string, totalQuantity: number } } };

export type TrinityEComCreateCheckoutPayPalMutationVariables = Exact<{
  token: Scalars['String'];
  country: SupportedCountries;
  customerEmail: Scalars['String'];
  customerTelephone: Scalars['String'];
  customerBillingAddress: TrinityCustomerBillingAddressInput;
}>;


export type TrinityEComCreateCheckoutPayPalMutation = { __typename?: 'Mutation', trinityEComCreateCheckoutPayPal: { __typename?: 'TrinityEComCheckoutSession', checkoutToken: string, paymentMode: number, totalSum: number, deliveryCheckoutVendor: number, paymentServiceContainer?: { __typename?: 'TrinityEComPaymentServiceContainer', serviceType: number, embeddedCheckoutHtmlSnippet?: string | null, externalRedirectUrl?: string | null, errorMessage?: string | null, paymentReferenceCode?: string | null, methodType: number, properties?: { __typename?: 'TrinityEComPaymentServiceContainerProperties', clientId?: string | null } | null } | null, deliveryCheckoutServiceConfiguration: { __typename?: 'TrinityEcomDeliveryCheckoutServiceConfiguration', id?: string | null, postCode?: string | null, postCodeIsValid: boolean, options?: Array<{ __typename?: 'TrinityEcomDeliveryOption', id?: string | null, name?: string | null, title?: string | null, description?: string | null, sku?: string | null, agentId?: string | null, deliveryInterval?: string | null, price: number, vatPercent: number, imageUrl?: string | null, agents?: Array<{ __typename?: 'TrinityEcomDeliveryOptionAgent', id?: string | null, name?: string | null, mapLatitude?: number | null, mapLongitude?: number | null, phone?: string | null, estimatedDeliveryDate?: string | null, address?: { __typename?: 'TrinityEcomDeliveryOptionAgentAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null }> | null }> | null }, paymentTypes?: Array<{ __typename?: 'TrinityEComPaymentType', paymentTypeId: number, vendor: number, name?: string | null, description?: string | null, shortDescription?: string | null, logoImageUrl?: string | null, supportsZeroSum: boolean }> | null, shoppingCart: { __typename?: 'TrinityEComShoppingCart', id: number, token: string, totalQuantity: number } } };

export type TrinityEComUpdateCheckoutDeliveryOptionMutationVariables = Exact<{
  token: Scalars['String'];
  selectedDeliveryOptionId: Scalars['String'];
  selectedAgentId?: InputMaybe<Scalars['String']>;
  country: SupportedCountries;
  configurationId: Scalars['String'];
  vendor: Scalars['Int'];
}>;


export type TrinityEComUpdateCheckoutDeliveryOptionMutation = { __typename?: 'Mutation', trinityEComUpdateCheckoutDeliveryOption: { __typename?: 'TrinityEComCheckoutSession', checkoutToken: string, paymentMode: number, totalSum: number, deliveryCheckoutVendor: number, paymentServiceContainer?: { __typename?: 'TrinityEComPaymentServiceContainer', serviceType: number, embeddedCheckoutHtmlSnippet?: string | null, externalRedirectUrl?: string | null, errorMessage?: string | null, paymentReferenceCode?: string | null, methodType: number, properties?: { __typename?: 'TrinityEComPaymentServiceContainerProperties', clientId?: string | null } | null } | null, deliveryCheckoutServiceConfiguration: { __typename?: 'TrinityEcomDeliveryCheckoutServiceConfiguration', id?: string | null, postCode?: string | null, postCodeIsValid: boolean, options?: Array<{ __typename?: 'TrinityEcomDeliveryOption', id?: string | null, name?: string | null, title?: string | null, description?: string | null, sku?: string | null, agentId?: string | null, deliveryInterval?: string | null, price: number, vatPercent: number, imageUrl?: string | null, agents?: Array<{ __typename?: 'TrinityEcomDeliveryOptionAgent', id?: string | null, name?: string | null, mapLatitude?: number | null, mapLongitude?: number | null, phone?: string | null, estimatedDeliveryDate?: string | null, address?: { __typename?: 'TrinityEcomDeliveryOptionAgentAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null }> | null }> | null }, paymentTypes?: Array<{ __typename?: 'TrinityEComPaymentType', paymentTypeId: number, vendor: number, name?: string | null, description?: string | null, shortDescription?: string | null, logoImageUrl?: string | null, supportsZeroSum: boolean }> | null, shoppingCart: { __typename?: 'TrinityEComShoppingCart', id: number, token: string, totalQuantity: number } } };

export type TrinityEComUpdateCheckoutDeliveryOptionsPostCodeMutationVariables = Exact<{
  token: Scalars['String'];
  postCode: Scalars['String'];
  country: SupportedCountries;
  vendor: Scalars['Int'];
}>;


export type TrinityEComUpdateCheckoutDeliveryOptionsPostCodeMutation = { __typename?: 'Mutation', trinityEComUpdateCheckoutDeliveryOptionsPostCode: { __typename?: 'TrinityEComCheckoutSession', deliveryCheckoutServiceConfiguration: { __typename?: 'TrinityEcomDeliveryCheckoutServiceConfiguration', id?: string | null, postCode?: string | null, postCodeIsValid: boolean, options?: Array<{ __typename?: 'TrinityEcomDeliveryOption', id?: string | null, name?: string | null, title?: string | null, description?: string | null, sku?: string | null, agentId?: string | null, deliveryInterval?: string | null, price: number, vatPercent: number, imageUrl?: string | null, agents?: Array<{ __typename?: 'TrinityEcomDeliveryOptionAgent', id?: string | null, name?: string | null, mapLatitude?: number | null, mapLongitude?: number | null, phone?: string | null, estimatedDeliveryDate?: string | null, address?: { __typename?: 'TrinityEcomDeliveryOptionAgentAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null }> | null }> | null } } };

export type TrinityEComUpdateCheckoutPaymentTypeMutationVariables = Exact<{
  token: Scalars['String'];
  country: SupportedCountries;
  paymentTypeId: Scalars['Int'];
}>;


export type TrinityEComUpdateCheckoutPaymentTypeMutation = { __typename?: 'Mutation', trinityEComUpdateCheckoutPaymentType: { __typename?: 'TrinityEComCheckoutSession', checkoutToken: string, paymentMode: number, totalSum: number, deliveryCheckoutVendor: number, paymentServiceContainer?: { __typename?: 'TrinityEComPaymentServiceContainer', serviceType: number, embeddedCheckoutHtmlSnippet?: string | null, externalRedirectUrl?: string | null, errorMessage?: string | null, paymentReferenceCode?: string | null, methodType: number, properties?: { __typename?: 'TrinityEComPaymentServiceContainerProperties', clientId?: string | null } | null } | null, deliveryCheckoutServiceConfiguration: { __typename?: 'TrinityEcomDeliveryCheckoutServiceConfiguration', id?: string | null, postCode?: string | null, postCodeIsValid: boolean, options?: Array<{ __typename?: 'TrinityEcomDeliveryOption', id?: string | null, name?: string | null, title?: string | null, description?: string | null, sku?: string | null, agentId?: string | null, deliveryInterval?: string | null, price: number, vatPercent: number, imageUrl?: string | null, agents?: Array<{ __typename?: 'TrinityEcomDeliveryOptionAgent', id?: string | null, name?: string | null, mapLatitude?: number | null, mapLongitude?: number | null, phone?: string | null, estimatedDeliveryDate?: string | null, address?: { __typename?: 'TrinityEcomDeliveryOptionAgentAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null }> | null }> | null }, paymentTypes?: Array<{ __typename?: 'TrinityEComPaymentType', paymentTypeId: number, vendor: number, name?: string | null, description?: string | null, shortDescription?: string | null, logoImageUrl?: string | null, supportsZeroSum: boolean }> | null, shoppingCart: { __typename?: 'TrinityEComShoppingCart', id: number, token: string, totalQuantity: number } } };

export type UserCreateMutationVariables = Exact<{
  company?: InputMaybe<Scalars['ID']>;
  userPlatformConnectionToken?: InputMaybe<Scalars['String']>;
  defaultLocation?: InputMaybe<Scalars['ID']>;
  userData: UserCreate;
  ref?: InputMaybe<Scalars['String']>;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'User', id: string } };

export type UserDeleteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type UserDeleteMutation = { __typename?: 'Mutation', userDelete: { __typename?: 'MutationResult', success: boolean } };

export type UserUpdateMutationVariables = Exact<{
  data: UserUpdate;
  user?: InputMaybe<Scalars['ID']>;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string } };

export type AgreementCreateMutationVariables = Exact<{
  data: AgreementCreate;
}>;


export type AgreementCreateMutation = { __typename?: 'Mutation', agreementCreate: { __typename?: 'Agreement', id: string } };

export type AgreementUpdateMutationVariables = Exact<{
  agreement: Scalars['ID'];
  data: AgreementUpdate;
}>;


export type AgreementUpdateMutation = { __typename?: 'Mutation', agreementUpdate: { __typename?: 'Agreement', id: string } };

export type UserAcceptAgreementsMutationVariables = Exact<{
  acceptedAgreements: Array<Scalars['ID']> | Scalars['ID'];
  declinedAgreements: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UserAcceptAgreementsMutation = { __typename?: 'Mutation', userAcceptAgreements: Array<{ __typename?: 'UserAgreement', id: string }> };

export type UserAgreementAcceptUpdatedAgreementsMutationVariables = Exact<{ [key: string]: never; }>;


export type UserAgreementAcceptUpdatedAgreementsMutation = { __typename?: 'Mutation', userAgreementAcceptUpdatedAgreements: Array<{ __typename?: 'UserAgreement', id: string }> };

export type UserGroupAddAutomaticSubscriptionProductMutationVariables = Exact<{
  userGroup: Scalars['ID'];
  subscriptionProduct: Scalars['ID'];
}>;


export type UserGroupAddAutomaticSubscriptionProductMutation = { __typename?: 'Mutation', userGroupAddAutomaticSubscriptionProduct: { __typename?: 'UserGroup', id: string } };

export type UserGroupAddPointAccountMutationVariables = Exact<{
  userGroup: Scalars['ID'];
}>;


export type UserGroupAddPointAccountMutation = { __typename?: 'Mutation', userGroupAddPointAccount: { __typename?: 'UserGroup', id: string } };

export type UserGroupAddUsersMutationVariables = Exact<{
  userGroup: Scalars['ID'];
  users: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UserGroupAddUsersMutation = { __typename?: 'Mutation', userGroupAddUsers: { __typename?: 'UserGroup', id: string } };

export type UserGroupCreateMutationVariables = Exact<{
  data: UserGroupCreate;
}>;


export type UserGroupCreateMutation = { __typename?: 'Mutation', userGroupCreate: { __typename?: 'UserGroup', id: string } };

export type UserGroupDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserGroupDeleteMutation = { __typename?: 'Mutation', userGroupDelete: boolean };

export type UserGroupRemoveAutomaticSubscriptionProductMutationVariables = Exact<{
  userGroup: Scalars['ID'];
}>;


export type UserGroupRemoveAutomaticSubscriptionProductMutation = { __typename?: 'Mutation', userGroupRemoveAutomaticSubscriptionProduct: { __typename?: 'UserGroup', id: string } };

export type UserGroupRemovePointAccountMutationVariables = Exact<{
  userGroup: Scalars['ID'];
}>;


export type UserGroupRemovePointAccountMutation = { __typename?: 'Mutation', userGroupRemovePointAccount: { __typename?: 'UserGroup', id: string } };

export type UserGroupRemoveUsersMutationVariables = Exact<{
  userGroup: Scalars['ID'];
  users: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UserGroupRemoveUsersMutation = { __typename?: 'Mutation', userGroupRemoveUsers: { __typename?: 'UserGroup', id: string } };

export type UserGroupUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UserGroupUpdate;
}>;


export type UserGroupUpdateMutation = { __typename?: 'Mutation', userGroupUpdate: { __typename?: 'UserGroup', id: string } };

export type UserGroupAdminAddMutationVariables = Exact<{
  userGroup: Scalars['ID'];
  user: Scalars['ID'];
}>;


export type UserGroupAdminAddMutation = { __typename?: 'Mutation', userGroupAdminAdd: { __typename?: 'UserGroup', id: string } };

export type UserGroupAdminRemoveMutationVariables = Exact<{
  userGroup: Scalars['ID'];
  user: Scalars['ID'];
}>;


export type UserGroupAdminRemoveMutation = { __typename?: 'Mutation', userGroupAdminRemove: { __typename?: 'UserGroup', id: string } };

export type UserPlatformConnectionCreateMutationVariables = Exact<{
  userAuthToken?: InputMaybe<Scalars['String']>;
  userPlatformConnectionToken?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['ID']>;
}>;


export type UserPlatformConnectionCreateMutation = { __typename?: 'Mutation', userPlatformConnectionCreate: { __typename?: 'UserPlatformConnection', id: string } };

export type UserPlatformConnectionCreateMultipleMutationVariables = Exact<{
  data: UserPlatformConnectionCreateMultiple;
}>;


export type UserPlatformConnectionCreateMultipleMutation = { __typename?: 'Mutation', UserPlatformConnectionCreateMultiple: { __typename?: 'MutationResult', success: boolean } };

export type UserPlatformConnectionDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserPlatformConnectionDeleteMutation = { __typename?: 'Mutation', userPlatformConnectionDelete: { __typename?: 'MutationResult', success: boolean } };

export type UserPlatformConnectionTokenCreateMutationVariables = Exact<{
  data: UserPlatformConnectionTokenCreate;
}>;


export type UserPlatformConnectionTokenCreateMutation = { __typename?: 'Mutation', userPlatformConnectionTokenCreate: { __typename?: 'UserPlatformConnection', id: string } | { __typename?: 'UserPlatformConnectionToken', id: string } };

export type UserPlatformConnectionTokenDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserPlatformConnectionTokenDeleteMutation = { __typename?: 'Mutation', userPlatformConnectionTokenDelete: { __typename?: 'MutationResult', success: boolean } };

export type UserProductSubscriptionCancelMutationVariables = Exact<{
  userProductSubscription: Scalars['ID'];
  cancelImmediately?: InputMaybe<Scalars['Boolean']>;
  refundLatestPayment?: InputMaybe<Scalars['Boolean']>;
  deleteBookings?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserProductSubscriptionCancelMutation = { __typename?: 'Mutation', userProductSubscriptionCancel: { __typename?: 'UserProductSubscription', id: string } };

export type UserProductSubscriptionCanceleByAdminMutationVariables = Exact<{
  userProductSubscription: Scalars['ID'];
  deleteBookings?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserProductSubscriptionCanceleByAdminMutation = { __typename?: 'Mutation', userProductSubscriptionCanceleByAdmin: { __typename?: 'UserProductSubscription', id: string } };

export type UserProductSubscriptionCreateByAdminMutationVariables = Exact<{
  subscriptionProduct: Scalars['ID'];
  user: Scalars['ID'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  shouldBePaidSubscription?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserProductSubscriptionCreateByAdminMutation = { __typename?: 'Mutation', userProductSubscriptionCreateByAdmin: { __typename?: 'UserProductSubscription', id: string } };

export type UserProductSubscriptionReactivateMutationVariables = Exact<{
  userProductSubscription: Scalars['ID'];
}>;


export type UserProductSubscriptionReactivateMutation = { __typename?: 'Mutation', userProductSubscriptionReactivate: { __typename?: 'MutationResult', success: boolean } };

export type UserProductSubscriptionsToExcelMutationVariables = Exact<{
  filtering?: InputMaybe<UserProductSubscriptionsFiltering>;
}>;


export type UserProductSubscriptionsToExcelMutation = { __typename?: 'Mutation', userProductSubscriptionsToExcel: string };

export type WannasportConnectionChangePossibleTimeSlotsMutationVariables = Exact<{
  wannasportConnection: Scalars['ID'];
  timeSlots: Array<InputMaybe<WannasportPossibleTimeSlotInput>> | InputMaybe<WannasportPossibleTimeSlotInput>;
}>;


export type WannasportConnectionChangePossibleTimeSlotsMutation = { __typename?: 'Mutation', wannasportConnectionChangePossibleTimeSlots: { __typename?: 'WannasportConnection', id: string } };

export type WannasportConnectionCreateMutationVariables = Exact<{
  data: WannasportConnectionCreate;
}>;


export type WannasportConnectionCreateMutation = { __typename?: 'Mutation', wannasportConnectionCreate: { __typename?: 'WannasportConnectionCreated', token: string, wannasportConnection: { __typename?: 'WannasportConnection', id: string } } };

export type WorkshopBookingCancelMutationVariables = Exact<{
  workshopBooking: Scalars['ID'];
  refundPayment?: InputMaybe<Scalars['Boolean']>;
}>;


export type WorkshopBookingCancelMutation = { __typename?: 'Mutation', workshopBookingCancel: { __typename?: 'WorkshopBooking', id: string, status: BookingStatus } };

export type WorkshopCanceleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkshopCanceleMutation = { __typename?: 'Mutation', workshopCancele: { __typename?: 'Workshop', id: string } };

export type WorkshopCreateMutationVariables = Exact<{
  data: WorkshopCreate;
}>;


export type WorkshopCreateMutation = { __typename?: 'Mutation', workshopCreate: Array<{ __typename?: 'Workshop', id: string }> };

export type WorkshopUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: WorkshopUpdate;
}>;


export type WorkshopUpdateMutation = { __typename?: 'Mutation', workshopUpdate: { __typename?: 'Workshop', id: string } };

export type WorkshopBookingCreateAdminMutationVariables = Exact<{
  users: Array<Scalars['ID']> | Scalars['ID'];
  workshop: Scalars['ID'];
}>;


export type WorkshopBookingCreateAdminMutation = { __typename?: 'Mutation', workshopBookingCreateAdmin: Array<{ __typename?: 'WorkshopBooking', id: string }> };

export type WorkshopDayCreateMutationVariables = Exact<{
  workshop: Scalars['ID'];
  data: WorkshopDayCreate;
}>;


export type WorkshopDayCreateMutation = { __typename?: 'Mutation', workshopDayCreate: { __typename?: 'WorkshopDay', id: string } };

export type WorkshopDayDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkshopDayDeleteMutation = { __typename?: 'Mutation', workshopDayDelete: { __typename?: 'Workshop', id: string } };

export type WorkshopDayUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: WorkshopDayUpdate;
}>;


export type WorkshopDayUpdateMutation = { __typename?: 'Mutation', workshopDayUpdate: { __typename?: 'WorkshopDay', id: string } };

export type WorkshopWaitlistCancelMutationVariables = Exact<{
  workshop: Scalars['ID'];
}>;


export type WorkshopWaitlistCancelMutation = { __typename?: 'Mutation', workshopWaitlistCancel: { __typename?: 'MutationResult', success: boolean } };

export type WorkshopWaitlistJoinMutationVariables = Exact<{
  workshop: Scalars['ID'];
}>;


export type WorkshopWaitlistJoinMutation = { __typename?: 'Mutation', workshopWaitlistJoin: { __typename?: 'WorkshopWaitlistItem', id: string } };

export type GetRanglistenSignUpLinkQueryVariables = Exact<{
  userId: Scalars['ID'];
  locationId: Scalars['ID'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
}>;


export type GetRanglistenSignUpLinkQuery = { __typename?: 'Query', ranglisten: { __typename?: 'RanglistenSignUpLink', signUpLink: string } };

export type GetAccessCodeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAccessCodeQuery = { __typename?: 'Query', accessCode: { __typename?: 'AccessCode', id: string, name?: string | null, pinCode: string, cardCode?: string | null, createdAt: any, usedCount: number, latestSyncAt?: any | null, type: AccessCodeType, createdByUser?: { __typename?: 'User', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, fullAccessToDoors: Array<{ __typename?: 'ControllerDoor', id: string, name: string }>, fullAccessToDoorGroups: Array<{ __typename?: 'ControllerDoorGroup', id: string, name: string, doors: Array<{ __typename?: 'ControllerDoor', id: string, name: string }> }>, controllerUnitAccessCodes: Array<{ __typename?: 'ControllerUnitAccessCode', id: string, startDate?: any | null, endDate?: any | null, activatedOnUnitAt?: any | null, status: ControllerUnitAccessCodeStatus, syncedToControllerUnit?: SyncedToControllerUnitStatus | null, doors: Array<{ __typename?: 'ControllerDoor', id: string, name: string }>, controllerUnit: { __typename?: 'ControllerUnit', id: string, location: { __typename?: 'Location', id: string, name: string } } }> } };

export type GetAccessCodesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<AccessCodesFiltering>;
}>;


export type GetAccessCodesQuery = { __typename?: 'Query', accessCodes: { __typename?: 'AccessCodesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'AccessCode', id: string, name?: string | null, pinCode: string }> } };

export type GetMyAccessCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAccessCodeQuery = { __typename?: 'Query', myAccessCode: { __typename?: 'AccessCode', id: string } };

export type GetAccessCodeAccessTimesQueryVariables = Exact<{
  accessCode: Scalars['ID'];
}>;


export type GetAccessCodeAccessTimesQuery = { __typename?: 'Query', accessCodeAccessTimes: { __typename?: 'AccessCodeAccessTimesResult', data: Array<{ __typename?: 'AccessCodeAccessTime', id: string, startDate: any, endDate: any, createdAt: any, resourceBookingAttendee?: { __typename?: 'ResourceBookingAttendee', id: string, resourceBooking: { __typename?: 'ResourceBooking', id: string } } | null, resourceBooking?: { __typename?: 'ResourceBooking', id: string } | null, doors: Array<{ __typename?: 'ControllerDoor', id: string, name: string }>, doorGroups: Array<{ __typename?: 'ControllerDoorGroup', id: string, name: string }>, workshopDay?: { __typename?: 'WorkshopDay', id: string, workshop: { __typename?: 'Workshop', id: string } } | null }> } };

export type AccessCodeUsagesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<AccessCodeUsagesFiltering>;
}>;


export type AccessCodeUsagesQuery = { __typename?: 'Query', accessCodeUsages: { __typename?: 'AccessCodeUsagesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'AccessCodeUsage', id: string, createdAt: any, door: { __typename?: 'ControllerDoor', id: string, name: string, controller: { __typename?: 'ControllerUnit', id: string, location: { __typename?: 'Location', id: string, name: string } } } }> } };

export type GetAdditionalServiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdditionalServiceQuery = { __typename?: 'Query', additionalService: { __typename?: 'AdditionalService', id: string, name?: string | null, hidden?: boolean | null, product: { __typename?: 'Product', description: string } } };

export type GetAdditionalServiceReservationMutationVariables = Exact<{
  additionalServiceId: Scalars['ID'];
  resourceBookingStartDate: Scalars['String'];
  resourceBookingEndDate: Scalars['String'];
}>;


export type GetAdditionalServiceReservationMutation = { __typename?: 'Mutation', additionalService: boolean };

export type GetAdditionalServicesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']>;
  resourceCategoryId?: InputMaybe<Scalars['String']>;
}>;


export type GetAdditionalServicesQuery = { __typename?: 'Query', additionalServices: Array<{ __typename?: 'AdditionalService', id: string, name?: string | null, capacity?: string | null, additionalInfoRequired?: boolean | null, additionalInfo: Array<AdditionalServiceInfoType>, hidden?: boolean | null, product: { __typename?: 'Product', price: number, description: string }, resourceCategory?: { __typename?: 'ResourceCategory', id: string, name: string } | null }> };

export type GetScriptableIntegrationCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScriptableIntegrationCodeQuery = { __typename?: 'Query', scriptableIntegrationCode: string };

export type GetAnalyticBookingSlotsQueryVariables = Exact<{
  data: AnalyticBookingSlots;
}>;


export type GetAnalyticBookingSlotsQuery = { __typename?: 'Query', analyticBookingSlots: Array<{ __typename?: 'Chart', x: string, y: number }> };

export type GetAnalyticCompanySinceCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticCompanySinceCreatedAtQuery = { __typename?: 'Query', analyticCompanySinceCreatedAt: Array<{ __typename?: 'AnalyticCompanySinceCreatedAt', for: string, result: string }> };

export type GetAnalyticSmartQueryVariables = Exact<{
  datePeriodStart: Scalars['DateTime'];
  datePeriodEnd: Scalars['DateTime'];
}>;


export type GetAnalyticSmartQuery = { __typename?: 'Query', analyticSmart: Array<{ __typename?: 'AnalyticSmart', for: string, result: string }> };

export type GetAuthPlacesForSignInQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthPlacesForSignInQuery = { __typename?: 'Query', authPlacesForSignIn: Array<{ __typename?: 'UserPlatformConnection', id: string, role: UserRole, niceRole: string, company?: { __typename?: 'Company', id: string, name: string, streetName: string, zipCode: string, city: string, currency: Currency } | null, franchise?: { __typename?: 'Franchise', id: string, name: string, streetName: string, zipCode: string, city: string, currency: Currency } | null }> };

export type GetAuthPlacesForSignUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthPlacesForSignUpQuery = { __typename?: 'Query', authPlacesForSignUp: Array<{ __typename?: 'CompanyForSignUp', isCompany: boolean, id: string, name: string, streetName: string, zipCode: string, locations: Array<{ __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string }> } | { __typename?: 'FranchiseForSignUp', isFranchise: boolean, id: string, name: string, streetName: string, zipCode: string, locations: Array<{ __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string, company: { __typename?: 'Company', id: string } }> }> };

export type GetUserPlatformConnectionTokenDataQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetUserPlatformConnectionTokenDataQuery = { __typename?: 'Query', userPlatformConnectionTokenData: { __typename?: 'UserPlatformConnectionToken', id: string, email: string } };

export type GetAuthUrlSlugDataQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetAuthUrlSlugDataQuery = { __typename?: 'Query', authUrlSlugData: { __typename?: 'Company', id: string, name: string } | { __typename?: 'Franchise', id: string, name: string } };

export type GetUserUsingPasswordV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserUsingPasswordV2Query = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, usingPasswordV2: boolean } } };

export type GetBookingsQueryVariables = Exact<{
  filtering?: InputMaybe<BookingsFiltering>;
}>;


export type GetBookingsQuery = { __typename?: 'Query', bookings: Array<{ __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, resource: { __typename?: 'Resource', id: string, name: string, type: { __typename?: 'ResourceType', id: string, name: string }, location: { __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string } } } | { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', id: string, title: string, location: { __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string }, days: Array<{ __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any }> } }> };

export type GetBookingsForUserCalendarQueryVariables = Exact<{
  filtering?: InputMaybe<BookingsFiltering>;
}>;


export type GetBookingsForUserCalendarQuery = { __typename?: 'Query', bookings: Array<{ __typename?: 'ResourceBooking', id: string, startDate: any } | { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', id: string, days: Array<{ __typename?: 'WorkshopDay', id: string, startDate: any }> } }> };

export type GetBookliSoundQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookliSoundQuery = { __typename?: 'Query', bookliSound: { __typename?: 'BookliSound', id: string, youtubePlayId: string, play: boolean, volume: number } };

export type GetBookliCamerasQueryVariables = Exact<{
  filtering?: InputMaybe<BookliCamerasFiltering>;
}>;


export type GetBookliCamerasQuery = { __typename?: 'Query', bookliCameras: { __typename?: 'BookliCamerasResult', data: Array<{ __typename?: 'BookliCamera', milestoneWebClientCamUrl: string, name: string, stillImageUrl?: string | null }> } };

export type GetBookliCamerasLocationMilestoneViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookliCamerasLocationMilestoneViewQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, bookliCameraServer?: { __typename?: 'BookliCameraServer', id: string, milestoneClientUrl: string, milestoneServerUrl?: string | null, milestoneServerUsername?: string | null, milestoneServerPassword?: string | null, cameras: Array<{ __typename?: 'BookliCamera', id: string, name: string, milestoneCameraId?: string | null, stillImageUrl?: string | null }> } | null } };

export type GetBookliDeviceGetLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookliDeviceGetLinkQuery = { __typename?: 'Query', bookliDeviceGetLink: string };

export type GetBookliDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookliDevicesQuery = { __typename?: 'Query', bookliDevices: { __typename?: 'BookliDevicesResult', data: Array<{ __typename?: 'BookliDevice', id: string }> } };

export type GetLocationForScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationForScreenQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, name: string, overviewSvgImageUrl?: string | null, company: { __typename?: 'Company', id: string, logoUrl?: string | null, phoneNumber: string } } };

export type GetResourcesForScreenQueryVariables = Exact<{
  filtering?: InputMaybe<ResourcesFiltering>;
}>;


export type GetResourcesForScreenQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcesResult', data: Array<{ __typename?: 'Resource', id: string, name: string, logoUrl?: string | null, currentBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, workshopDay?: { __typename?: 'WorkshopDay', id: string, workshop: { __typename?: 'Workshop', id: string, title: string } } | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, nextBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, workshopDay?: { __typename?: 'WorkshopDay', id: string, workshop: { __typename?: 'Workshop', id: string, title: string } } | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null }> } };

export type GetWorkshopsForScreenQueryVariables = Exact<{
  filtering?: InputMaybe<WorkshopsFiltering>;
}>;


export type GetWorkshopsForScreenQuery = { __typename?: 'Query', workshops: { __typename?: 'WorkshopsResult', data: Array<{ __typename?: 'Workshop', id: string, title: string, lastRegistrationDate: any, maxRegistrations: number, type: WorkshopType, bookingsCount: number, nextDay?: { __typename?: 'WorkshopDay', id: string, startDate: any, endDate: any } | null, days: Array<{ __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any }>, product: { __typename?: 'Product', id: string, price: number } }> } };

export type GetBookliVideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookliVideoQuery = { __typename?: 'Query', bookliVideo: { __typename?: 'BookliVideo', id: string, videoReadyAt: any, streamUrl?: string | null, state: BookliVideoState, type: BookliVideoType, downloadUrl?: string | null } };

export type GetBookliVideoMainQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBookliVideoMainQuery = { __typename?: 'Query', bookliVideo: { __typename?: 'BookliVideo', id: string, subClips: Array<{ __typename?: 'BookliVideo', id: string }> } };

export type GetCompaniesForSignUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesForSignUpQuery = { __typename?: 'Query', companies: { __typename?: 'CompaniesResult', data: Array<{ __typename?: 'Company', id: string, name: string }> } };

export type GetCompaniesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<CompaniesFiltering>;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', companies: { __typename?: 'CompaniesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'Company', id: string, slug: string, name: string, phoneNumber: string, locations: Array<{ __typename?: 'Location', id: string }>, franchise?: { __typename?: 'Franchise', id: string, name: string } | null }> } };

export type GetCompaniesAnalyticQueryVariables = Exact<{
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
}>;


export type GetCompaniesAnalyticQuery = { __typename?: 'Query', companies: { __typename?: 'CompaniesResult', data: Array<{ __typename?: 'Company', id: string, name: string, analyticApplicationFee: { __typename?: 'CompanyApplicationFeeAnalytic', sum: number, avgPrResource: number }, analyticPaymentRevenue: { __typename?: 'CompanyPaymentRevenueAnalytic', sum: number, avgPrResource: number }, analyticUsers: { __typename?: 'CompanyUsersAnalytic', sum: number, avgPrResource: number } }> } };

export type GetCompaniesForPriceffQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<CompaniesFiltering>;
}>;


export type GetCompaniesForPriceffQuery = { __typename?: 'Query', companies: { __typename?: 'CompaniesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'Company', id: string, slug: string, name: string, resourceTypes: Array<{ __typename?: 'ResourceType', id: string, name: string, priceffGearing?: number | null, priceffGeneratedPricesTo?: any | null, usePriceffDynamicPricing: boolean, standardPriceA: { __typename?: 'Product', id: string, price: number }, standardPriceB: { __typename?: 'Product', id: string, price: number }, priceffModel?: { __typename?: 'PriceffModel', id: string } | null }> }> } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, name: string, streetName: string, email: string, currency: Currency, timezone: Timezone, locations: Array<{ __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string }> } };

export type GetAppBackgrundImageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppBackgrundImageQuery = { __typename?: 'Query', me: { __typename?: 'Me', appBackgroundImageUrl?: string | null } };

export type GetCompanyAppImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyAppImagesQuery = { __typename?: 'Query', companySettings: { __typename?: 'CompanySetting', userHomeAdSpace1ImgUrl?: string | null, userHomeAdSpace1Link?: string | null, appBackgroundImageUrl?: string | null } };

export type GetCompanyCreateInvitationDataQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetCompanyCreateInvitationDataQuery = { __typename?: 'Query', companyCreateInvitationData: { __typename?: 'CompanyCreateInvitation', id: string, createFranchise: boolean, connectToFranchise?: string | null } };

export type GetCompanyCreateInvitationsQueryVariables = Exact<{
  filtering?: InputMaybe<CompanyCreateInvitationsFiltering>;
}>;


export type GetCompanyCreateInvitationsQuery = { __typename?: 'Query', companyCreateInvitations: { __typename?: 'CompanyCreateInvitationsResult', data: Array<{ __typename?: 'CompanyCreateInvitation', id: string, email: string, createdAt: any, createFranchise: boolean, connectToFranchise?: string | null, token: string }> } };

export type GetCompanyDefaultMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyDefaultMessagesQuery = { __typename?: 'Query', companySettings: { __typename?: 'CompanySetting', messageUserWelcome?: string | null, messageResourceBookingCreated?: string | null, messagePointBuy?: string | null, messageResourceBookingReminder?: string | null } };

export type GetCompanyLanguageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyLanguageQuery = { __typename?: 'Query', companyLanguage: { __typename?: 'CompanyLang', language: Language } };

export type GetCompanyLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyLogoQuery = { __typename?: 'Query', me: { __typename?: 'Me', company?: { __typename?: 'Company', id: string, logoUrl?: string | null } | null } };

export type GetCompanyPrimaryColorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyPrimaryColorQuery = { __typename?: 'Query', companySettings: { __typename?: 'CompanySetting', primaryColor?: string | null } };

export type GetCompanyBasicsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetCompanyBasicsQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, name: string, slug: string, email: string, phoneNumber: string, streetName: string, zipCode: string, owner: { __typename?: 'UserPlatformConnection', id: string, user: { __typename?: 'User', id: string, name?: string | null } } } };

export type GetCompanyEssentialsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyEssentialsQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: string, name: string } };

export type GetControllerDoorLogsQueryVariables = Exact<{
  controllerUnitId: Scalars['ID'];
}>;


export type GetControllerDoorLogsQuery = { __typename?: 'Query', controllerDoorLogs?: Array<{ __typename?: 'ControllerDoorLog', createdAt: any, changedBy: string, newState: number, door: { __typename?: 'ControllerDoor', id: string, name: string } }> | null };

export type GetControllerDoorsQueryVariables = Exact<{
  filtering?: InputMaybe<ControllerDoorsFiltering>;
}>;


export type GetControllerDoorsQuery = { __typename?: 'Query', controllerDoors: { __typename?: 'ControllerDoorsResult', data: Array<{ __typename?: 'ControllerDoor', id: string, name: string, defaultOpenSeconds: number, noxAreaDoorId?: number | null }> } };

export type GetControllerDoorGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControllerDoorGroupsQuery = { __typename?: 'Query', controllerDoorGroups: { __typename?: 'ControllerDoorGroupsResult', data: Array<{ __typename?: 'ControllerDoorGroup', id: string, name: string, doors: Array<{ __typename?: 'ControllerDoor', id: string }> }> } };

export type GetControllerNoxAreasQueryVariables = Exact<{
  controllerUnit: Scalars['ID'];
}>;


export type GetControllerNoxAreasQuery = { __typename?: 'Query', controllerNoxAreas: Array<{ __typename?: 'ControllerNoxArea', areaId: string, name: string, areaStateId: number, allowedAreaStates: Array<number>, areasLastUpdatedAt: any }> };

export type GetControllerNoxTimeprofilesQueryVariables = Exact<{
  controllerUnitUrl: Scalars['String'];
}>;


export type GetControllerNoxTimeprofilesQuery = { __typename?: 'Query', controllerNoxTimeprofiles: Array<{ __typename?: 'ControllerNoxTimeprofile', noxTimeprofileId: number, noxTimeprofileName: string }> };

export type GetControllerOnOffLogsQueryVariables = Exact<{
  controllerUnitId: Scalars['ID'];
}>;


export type GetControllerOnOffLogsQuery = { __typename?: 'Query', controllerOnOffLogs?: Array<{ __typename?: 'ControllerOnOffLog', newState: boolean, changedBy: ControllerOnOffChangedBy, createdAt: any, controllerOnOff: { __typename?: 'ControllerOnOff', id: string, noxAreaId?: number | null, resource?: { __typename?: 'Resource', id: string, name: string } | null } }> | null };

export type GetControllerOnOffStatusesQueryVariables = Exact<{
  controller?: InputMaybe<Scalars['String']>;
}>;


export type GetControllerOnOffStatusesQuery = { __typename?: 'Query', controllerOnOffStatuses: Array<{ __typename?: 'ControllerOnOffState', id: string, changedBy?: ControllerOnOffChangedBy | null, state: boolean }> };

export type GetControllerUnitQueryVariables = Exact<{
  location: Scalars['ID'];
}>;


export type GetControllerUnitQuery = { __typename?: 'Query', controllerUnit?: { __typename?: 'ControllerUnit', id: string, url: string, noxVersion: NoxVersion } | null };

export type ControllerUnitUpdateMutationVariables = Exact<{
  controllerId: Scalars['ID'];
  data: ControllerUnitUpdate;
}>;


export type ControllerUnitUpdateMutation = { __typename?: 'Mutation', controllerUnitUpdate: { __typename?: 'ControllerUnit', id: string } };

export type GetControllerUnitsQueryVariables = Exact<{
  filtering?: InputMaybe<ControllerUnitsFiltering>;
}>;


export type GetControllerUnitsQuery = { __typename?: 'Query', controllerUnits: { __typename?: 'ControllerUnitsResult', data: Array<{ __typename?: 'ControllerUnit', id: string, isOnline: boolean, location: { __typename?: 'Location', id: string, name: string } }> } };

export type GetCouponQueryVariables = Exact<{
  id: Scalars['ID'];
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetCouponQuery = { __typename?: 'Query', coupon: { __typename?: 'Coupon', id: string, createdAt: any, active: boolean, maximumUsages?: number | null, maximumUsagesPrCustomer?: number | null, maximumUsagesPrCustomerPrMonth?: boolean | null, percentOff?: number | null, amountOff?: number | null, bookingHoursOff?: number | null, slug: string, type: CouponType, mode: CouponMode, endDate?: any | null, resourceBookingEndDateAfter?: any | null, resourceBookingEndDateBefore?: any | null, maximumResourceBookingHoursPrMonthUsage?: number | null, discountIsOnlyForBuyer: boolean, usagesCount: number, totalUsedDiscountAmount: number, resourceBookingTimeRanges: Array<{ __typename?: 'CouponResourceBookingTimeRange', id: string, startTime: string, endTime: string, days: Array<Day> }>, onlyForUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }>, subscriptionProductCoupon?: { __typename?: 'SubscriptionProduct', id: string, name: string } | null, subscriptionProductCouponEvents?: { __typename?: 'SubscriptionProduct', id: string, name: string } | null } };

export type GetCouponGetUserAutoCouponsQueryVariables = Exact<{
  amountToPay: Scalars['Float'];
  couponPurchaseDetails?: InputMaybe<CouponPurchaseDetails>;
}>;


export type GetCouponGetUserAutoCouponsQuery = { __typename?: 'Query', couponGetUserAutoCoupons: Array<{ __typename?: 'CouponAndPrice', amountWithCoupon: number, amountWithoutCoupon: number, coupon: { __typename?: 'Coupon', id: string, slug: string } }> };

export type GetCouponIsValidQueryVariables = Exact<{
  couponSlug: Scalars['String'];
  couponPurchaseDetails: CouponPurchaseDetails;
}>;


export type GetCouponIsValidQuery = { __typename?: 'Query', couponIsValid: boolean };

export type GetCouponUsagesQueryVariables = Exact<{
  filtering?: InputMaybe<CouponUseagesFiltering>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCouponUsagesQuery = { __typename?: 'Query', couponUsages: { __typename?: 'CouponUsagesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'CouponUsage', id: string, createdAt: any, discountAmount: number, payment: { __typename?: 'Payment', id: string, paymentMethod: PaymentMethod }, user: { __typename?: 'User', id: string, name?: string | null } }> } };

export type GetCouponsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCouponsQuery = { __typename?: 'Query', coupons: { __typename?: 'CouponsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'Coupon', id: string, maximumUsages?: number | null, active: boolean, slug: string, type: CouponType, maximumUsagesPrCustomer?: number | null, amountOff?: number | null, percentOff?: number | null, endDate?: any | null, mode: CouponMode, bookingHoursOff?: number | null, resourceBookingTimeRanges: Array<{ __typename?: 'CouponResourceBookingTimeRange', id: string, startTime: string, endTime: string, days: Array<Day> }> }> } };

export type UserHasFcmTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type UserHasFcmTokenQuery = { __typename?: 'Query', userHasFcmToken: boolean };

export type GetFranchiseLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFranchiseLogoQuery = { __typename?: 'Query', me: { __typename?: 'Me', franchise?: { __typename?: 'Franchise', id: string, logoUrl?: string | null } | null } };

export type GetFriendsQueryVariables = Exact<{
  filtering?: InputMaybe<FriendsFiltering>;
}>;


export type GetFriendsQuery = { __typename?: 'Query', friends: { __typename?: 'FriendsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'User', id: string, name?: string | null, firstName?: string | null, lastName?: string | null }> } };

export type GetFriendsPossibleToAddQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GetFriendsPossibleToAddQuery = { __typename?: 'Query', friendsPossibleToAdd: { __typename?: 'FriendsPossibleToAddResult', data: Array<{ __typename?: 'User', id: string, name?: string | null, isFriends: boolean }> } };

export type GetGiftCardsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetGiftCardsQuery = { __typename?: 'Query', giftCards: { __typename?: 'GiftCardsResult', totalCount: number, hasMore: boolean, data: Array<{ __typename?: 'GiftCard', id: string, createdAt: any, updatedAt: any, code: string, pointsAmount: number, expiryDate?: any | null, createdBy: { __typename?: 'User', id: string, name?: string | null }, usedBy?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type GetSignedUrlQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetSignedUrlQuery = { __typename?: 'Query', signedUrl: string };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, name: string, nameShort?: string | null, logoImageUrl?: string | null, userWelcomeMessage?: string | null, userWelcomeMessageLastUpdated?: any | null, company: { __typename?: 'Company', id: string, name: string, country: SupportedCountries, pointAccountUsingFranchise: boolean, userPlatformConnection?: { __typename?: 'UserPlatformConnection', id: string } | null, franchise?: { __typename?: 'Franchise', id: string, name: string } | null } } };

export type GetLocationAdminQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationAdminQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, streetName: string, zipCode: string, name: string, city: string, bookliCameraServer?: { __typename?: 'BookliCameraServer', id: string, milestoneServerUrl?: string | null } | null, resources: Array<{ __typename?: 'Resource', id: string, name: string, camera?: { __typename?: 'BookliCamera', id: string } | null, lightController?: { __typename?: 'ControllerOnOff', id: string, noxAreaId?: number | null, onOffTimeprofile?: { __typename?: 'ControllerOnOffTimeprofile', id: string, noxTimeprofileId?: number | null } | null } | null }>, controllerUnit?: { __typename?: 'ControllerUnit', id: string, url: string, type: ControllerUnitType, noxVersion: NoxVersion, isOnline: boolean, doorControllers: Array<{ __typename?: 'ControllerDoor', id: string, name: string, noxAreaDoorId?: number | null, noxAreaDoorName?: string | null }> } | null, bookliNetwork?: { __typename?: 'BookliNetwork', id: string } | null, bookliCameras: Array<{ __typename?: 'BookliCamera', id: string, name: string, type: BookliCameraType, stillImageUrl?: string | null, milestoneWebClientCamUrl: string, milestoneCameraId?: string | null }>, bookliSounds: Array<{ __typename?: 'BookliSound', id: string, name: string, youtubePlayId: string }> } };

export type LocationChangeUserMutationVariables = Exact<{
  newLocation: Scalars['ID'];
}>;


export type LocationChangeUserMutation = { __typename?: 'Mutation', locationChangeUser: { __typename?: 'LocationChangeResult', changePlatformToken: boolean, userPlatformConnection?: string | null, location: { __typename?: 'Location', id: string } } };

export type GetLocationOverviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationOverviewQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, overviewSvg?: string | null, overviewSvgImageUrl?: string | null, resources: Array<{ __typename?: 'Resource', id: string, logoUrl?: string | null, name: string, shortName: string, currentBooking?: { __typename?: 'ResourceBooking', id: string, status: BookingStatus, comments?: string | null, owner: { __typename?: 'User', id: string, firstName?: string | null } } | null }> } };

export type GetLocationOverviewV2QueryVariables = Exact<{
  id: Scalars['ID'];
  showCurrentBooking?: InputMaybe<Scalars['Boolean']>;
  showResourceName?: InputMaybe<Scalars['Boolean']>;
  highlightResourceId?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationOverviewV2Query = { __typename?: 'Query', location: { __typename?: 'Location', id: string, overviewSvg?: string | null } };

export type GetLocationScreenWelcomeMessageQueryVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
}>;


export type GetLocationScreenWelcomeMessageQuery = { __typename?: 'Query', locationScreenWelcomeMessage?: string | null };

export type GetLocationUserDefaultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationUserDefaultQuery = { __typename?: 'Query', locationUserDefault?: { __typename?: 'Location', id: string, name: string, nameShort?: string | null, logoImageUrl?: string | null, userWelcomeMessage?: string | null, userWelcomeMessageLastUpdated?: any | null, company: { __typename?: 'Company', id: string, name: string, currency: Currency, pointAccountUsingFranchise: boolean, userPlatformConnection?: { __typename?: 'UserPlatformConnection', id: string } | null, franchise?: { __typename?: 'Franchise', id: string, name: string } | null } } | null };

export type GetLocationsQueryVariables = Exact<{
  inFranchise?: InputMaybe<Scalars['Boolean']>;
  showAll?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<LocationsFiltering>;
}>;


export type GetLocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationsResult', totalCount: number, hasMore: boolean, data: Array<{ __typename?: 'Location', id: string, streetName: string, zipCode: string, name: string, nameShort?: string | null, userWelcomeMessage?: string | null, city: string, screenWelcomeMessage?: string | null, lat?: string | null, lng?: string | null, logoImageUrl?: string | null, resourcesCount: number, allowSignUps: boolean, company: { __typename?: 'Company', id: string } }> } };

export type GetLocationsForSignUpQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationsForSignUpQuery = { __typename?: 'Query', locationsForSignUp: { __typename?: 'LocationsForSignUpResult', data: Array<{ __typename?: 'Location', id: string, streetName: string, zipCode: string, name: string, nameShort?: string | null, city: string, lat?: string | null, lng?: string | null, logoImageUrl?: string | null, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null, country: SupportedCountries, mapIconUrl?: string | null, franchise?: { __typename?: 'Franchise', id: string, name: string, logoUrl?: string | null } | null } }> } };

export type GetEmailOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailOptionsQuery = { __typename?: 'Query', emailOptions: Array<{ __typename?: 'SendGridSuppressionGroup', id: number, name: string, description: string }> };

export type GetMessagesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<MessagesFiltering>;
}>;


export type GetMessagesQuery = { __typename?: 'Query', messages: { __typename?: 'MessagesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'Message', id: string, emailOpensCount?: number | null, source: string, status: MessageStatus, sender?: { __typename?: 'User', id: string, firstName?: string | null } | null }> } };

export type GetUserMigrationInformationQueryVariables = Exact<{
  encryptedData: Scalars['String'];
}>;


export type GetUserMigrationInformationQuery = { __typename?: 'Query', migration: { __typename?: 'UserMigrationSignUpLink', userInformation: string } };

export type SendMigrationFileMutationVariables = Exact<{
  fileNameGCP: Scalars['String'];
  messageEmail: Scalars['String'];
  sendToTest?: InputMaybe<Scalars['String']>;
}>;


export type SendMigrationFileMutation = { __typename?: 'Mutation', sendMigrationFile: boolean };

export type UploadMigrationFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadMigrationFileMutation = { __typename?: 'Mutation', uploadMigrationFile: { __typename?: 'UploadMigrationFileResult', fileName: string, invalidColumns: Array<string> } };

export type GetPayPalGetClientDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayPalGetClientDataQuery = { __typename?: 'Query', payPalGetClientData?: { __typename?: 'PayPalClientData', clientId: string, currency: Currency } | null };

export type GetPaymentTokenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentTokenQuery = { __typename?: 'Query', paymentToken: { __typename?: 'PaymentToken', id: string, state: PaymentTokenState, failedReason?: PaymentTokenFaildReason | null, amountToPay: number, attemptCount: number } };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', id: string, createdAt: any, paymentMethod: PaymentMethod, status: PaymentStatus, value: number, additionalServiceId?: string | null, productValue: number, additionalServiceValue: number, moneyValue?: number | null, stripePaymentIntentId?: string | null, pointValue?: number | null, stripeInvoiceId?: string | null, pointBounty?: { __typename?: 'PointTransaction', id: string, amount: number, pointAccountId: string } | null, priceffDynamicPriceUsages: Array<{ __typename?: 'PriceffDynamicPriceResourceUsage', id: string, quantity: number, price: { __typename?: 'PriceffDynamicPriceResourcePrice', id: string, price: number }, priceffDynamicPriceResource: { __typename?: 'PriceffDynamicPriceResource', id: string } }>, userProductSubscription?: { __typename?: 'UserProductSubscription', id: string } | null, coupon?: { __typename?: 'CouponUsage', id: string, isUsed: boolean, coupon: { __typename?: 'Coupon', id: string, slug: string } } | null, pointTransaction?: { __typename?: 'PointTransaction', id: string, pointAccount: { __typename?: 'PointAccount', id: string, pointAccountConnectedTo: PointAccountConnectedTo } } | null, connectedPayment?: { __typename?: 'Payment', id: string } | null, connectedPayments: Array<{ __typename?: 'Payment', id: string }>, product: { __typename?: 'Product', id: string, name: string, type: ProductType }, customer: { __typename?: 'User', id: string, name?: string | null }, productResourceBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any } | null, productPointTransaction?: { __typename?: 'PointTransaction', id: string, pointAccount: { __typename?: 'PointAccount', id: string } } | null, productWorkshopBooking?: { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', title: string, id: string } } | null, productUserProductSubscription?: { __typename?: 'UserProductSubscription', id: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string } } | null } };

export type PaymentCalculatePriceQueryVariables = Exact<{
  data: PaymentCalculatePriceInput;
}>;


export type PaymentCalculatePriceQuery = { __typename?: 'Query', paymentCalculatePrice: { __typename?: 'PaymentPrice', amountToPay: number, amountWithoutCoupon: number, amountWithoutRestPoints: number, amountWithoutAdditionalServices?: number | null, discount: number, productId: string, validToUseCoupon: boolean, paymentPriceToken: string, platformFee?: number | null, resourceBookingInfo?: { __typename?: 'PaymentPriceResourceBookingInfo', resourceBookingAttendeesToken: string, attendees: Array<{ __typename?: 'ResourceBookingPaymentAttendee', isUser: boolean, isOwner: boolean, value: number, discountValue: number, restMoneyValue: number, coupon?: string | null, messageLines: Array<string>, user?: { __typename?: 'User', id: string, firstName?: string | null } | null, userProductSubscription?: { __typename?: 'UserProductSubscription', id: string } | null }> } | null } };

export type GetPaymentForRefundQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentForRefundQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', id: string, moneyValue?: number | null, paymentMethod: PaymentMethod, status: PaymentStatus, stripePaymentIntentId?: string | null, platformFeeAmount: number, additionalServiceValue: number, productValue: number, pointTransaction?: { __typename?: 'PointTransaction', id: string, amount: number } | null, productResourceBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, status: BookingStatus, additionalService?: { __typename?: 'AdditionalService', id: string, name?: string | null } | null } | null, productWorkshopBooking?: { __typename?: 'WorkshopBooking', id: string, status: BookingStatus, workshop: { __typename?: 'Workshop', id: string, days: Array<{ __typename?: 'WorkshopDay', id: string, endDate: any }> } } | null, lines: Array<{ __typename?: 'PaymentLine', type: PaymentLineType, value: number }>, connectedPayment?: { __typename?: 'Payment', paymentMethod: PaymentMethod, platformFeeAmount: number, productResourceBooking?: { __typename?: 'ResourceBooking', id: string } | null, productWorkshopBooking?: { __typename?: 'WorkshopBooking', id: string } | null, lines: Array<{ __typename?: 'PaymentLine', type: PaymentLineType, value: number }> } | null, connectedPayments: Array<{ __typename?: 'Payment', paymentMethod: PaymentMethod, platformFeeAmount: number, productResourceBooking?: { __typename?: 'ResourceBooking', id: string } | null, productWorkshopBooking?: { __typename?: 'WorkshopBooking', id: string } | null, lines: Array<{ __typename?: 'PaymentLine', type: PaymentLineType, value: number }> }> } };

export type GetPaymentLinesQueryVariables = Exact<{
  filtering?: InputMaybe<PaymentLinesFiltering>;
}>;


export type GetPaymentLinesQuery = { __typename?: 'Query', paymentLines: { __typename?: 'PaymentLinesResult', data: Array<{ __typename?: 'PaymentLine', id: string, value: number, type: PaymentLineType, createdAt: any, accountingLine?: { __typename?: 'AccountingLine', id: string, accountingProgramExternalUrl?: string | null, registeredInAccountingProgram?: AccountingProgram | null } | null }> } };

export type PaymentUserAllowedPaymentTypesQueryVariables = Exact<{
  paymentPriceToken: Scalars['String'];
}>;


export type PaymentUserAllowedPaymentTypesQuery = { __typename?: 'Query', paymentUserAllowedPaymentTypes: { __typename?: 'PaymentUserAllowedPaymentTypes', selectedUserProductSubscription?: string | null, paymentTypes: Array<{ __typename?: 'PaymentType', paymentType: PaymentTokenPaymentType, paymentMethod: PaymentMethod }>, pointAccounts: Array<{ __typename?: 'PointAccount', id: string, pointsAmount: number, removeDiscountToDoPayment?: boolean | null, enoughPointsForPayment?: boolean | null, userGroup?: { __typename?: 'UserGroup', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, name: string } | null, franchise?: { __typename?: 'Franchise', id: string, name: string } | null }> } };

export type GetPaymentsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<PaymentsFiltering>;
}>;


export type GetPaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'PaymentsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'Payment', id: string, status: PaymentStatus, value: number, currency: Currency, moneyValue?: number | null, pointValue?: number | null, createdAt: any, invoiceUrl?: string | null, paymentMethod: PaymentMethod, company?: { __typename?: 'Company', id: string, name: string } | null, customer: { __typename?: 'User', id: string, name?: string | null }, connectedPayment?: { __typename?: 'Payment', id: string, productResourceBooking?: { __typename?: 'ResourceBooking', id: string } | null } | null, connectedPayments: Array<{ __typename?: 'Payment', id: string, value: number, moneyValue?: number | null, paymentMethod: PaymentMethod, status: PaymentStatus, customer: { __typename?: 'User', id: string, firstName?: string | null } }>, product: { __typename?: 'Product', id: string, name: string, type: ProductType }, productResourceBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any } | null, productPointTransaction?: { __typename?: 'PointTransaction', id: string, pointAccount: { __typename?: 'PointAccount', id: string } } | null, productWorkshopBooking?: { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', title: string, id: string } } | null, productUserProductSubscription?: { __typename?: 'UserProductSubscription', id: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string } } | null }> } };

export type GetPlatformFeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformFeesQuery = { __typename?: 'Query', platformFees: { __typename?: 'PlatformFees', companies: Array<{ __typename?: 'CompanyWithFees', id: string, name: string, currency: string, companySettings: { __typename?: 'CompanySetting', id: string, companyId: string, pointTransactionPlatformFeePercentage: number, pointTransactionPlatformStatic: number }, stripeConnection?: { __typename?: 'StripeConnection', id: string, companyId?: string | null, connectedTo: FranchiseOrCompany, paymentPlatformFeeStatic: number, paymentPlatformFeePercentage: number, invoicePaymentPlatformFeeStatic: number, invoicePaymentPlatformFeePercentage: number, subscriptionPlatformFeePrimaryStatic: number, subscriptionPlatformFeePrimaryPercentage: number, subscriptionPlarformFeeSecondaryStatic: number, subscriptionPlarformFeeSecondaryPercentage: number } | null }>, franchises: Array<{ __typename?: 'FranchiseWithFees', id: string, name: string, currency: string, franchiseSettings: { __typename?: 'FranchiseSetting', id: string, franchiseId: string, pointTransactionPlatformFeePercentage: number, pointTransactionPlatformStatic: number }, stripeConnection?: { __typename?: 'StripeConnection', id: string, franchsieId?: string | null, connectedTo: FranchiseOrCompany, paymentPlatformFeeStatic: number, paymentPlatformFeePercentage: number, invoicePaymentPlatformFeeStatic: number, invoicePaymentPlatformFeePercentage: number, subscriptionPlatformFeePrimaryStatic: number, subscriptionPlatformFeePrimaryPercentage: number, subscriptionPlarformFeeSecondaryStatic: number, subscriptionPlarformFeeSecondaryPercentage: number } | null }> } };

export type UpdatePlatformFeesMutationVariables = Exact<{
  companySettings?: InputMaybe<CompanySettingUpdate>;
  franchiseSettings?: InputMaybe<FranchiseSettingUpdate>;
  stripeConnection?: InputMaybe<StripeConnectionUpdate>;
}>;


export type UpdatePlatformFeesMutation = { __typename?: 'Mutation', platformFeesUpdate: boolean };

export type GetPlatformInvoicesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPlatformInvoicesQuery = { __typename?: 'Query', platformInvoices: { __typename?: 'PlatformInvoicesResult', totalCount: number, hasMore: boolean, data: Array<{ __typename?: 'PlatformInvoice', id: string, startDate: any, endDate: any, invoiceNumber: number, fileName?: string | null }> } };

export type GetPointAccountQueryVariables = Exact<{
  user?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetPointAccountQuery = { __typename?: 'Query', pointAccount: { __typename?: 'PointAccount', id: string, pointsAmount: number, pointAccountConnectedTo: PointAccountConnectedTo, automaticPointsActive: boolean, automaticAddPointsAmount?: number | null, resetPointsOnAutomaticRecharge: boolean, automaticPointsInsertTimesPrYear: number, automaticPointsInsertOnTheFirstOfMonth: boolean, accountNumbers: { __typename?: 'PointAccountNumbers', pointAmountOtOTrue: number, pointAmountOtOFalse: number, pointAmountOtOFalseRatio: number, pointAmountOtOMixRatio: number }, user?: { __typename?: 'User', id: string, name?: string | null } | null, userGroup?: { __typename?: 'UserGroup', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, name: string } | null, franchise?: { __typename?: 'Franchise', id: string, name: string } | null } };

export type GetPointAccountBasicQueryVariables = Exact<{
  user?: InputMaybe<Scalars['ID']>;
  company?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetPointAccountBasicQuery = { __typename?: 'Query', pointAccount: { __typename?: 'PointAccount', id: string, pointsAmount: number, userGroup?: { __typename?: 'UserGroup', id: string, name: string } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null } };

export type GetPointAccountCanUseRestPointsForPaymentQueryVariables = Exact<{
  product: Scalars['ID'];
  paymentAmount: Scalars['Float'];
  paymentMethod: PaymentMethod;
}>;


export type GetPointAccountCanUseRestPointsForPaymentQuery = { __typename?: 'Query', pointAccountCanUseRestPointsForPayment: { __typename?: 'PointAccountCanUseRestPointsForPaymentResult', canDo: boolean, pointsAmount?: number | null, pointAccountId?: string | null } };

export type GetPointAccountTransactionsQueryVariables = Exact<{
  pointAccount: Scalars['ID'];
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<PointAccountTransactionsFiltering>;
}>;


export type GetPointAccountTransactionsQuery = { __typename?: 'Query', pointAccountTransactions: { __typename?: 'PointAccountTransactionsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'PointTransaction', id: string, createdAt: any, type: PointTransactionType, notes?: string | null, platformFeeAmount: number, isOneToOne: boolean, valueRatio: number, amount: number, usedOnCompany?: { __typename?: 'Company', id: string, name: string } | null, paymentPointBounty?: { __typename?: 'Payment', id: string } | null, connectedToPaymentLine?: { __typename?: 'PaymentLine', id: string, payment: { __typename?: 'Payment', id: string } } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, manualTransactionBy?: { __typename?: 'User', id: string, name?: string | null } | null, paidWithPoints?: { __typename?: 'Payment', id: string } | null, payment?: { __typename?: 'Payment', id: string } | null }> } };

export type GetPointsAnalyticQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointsAnalyticQuery = { __typename?: 'Query', analytic: { __typename?: 'Analytic', pointsTotalAmount: number, pointsRatio: number } };

export type GetPointProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPointProductQuery = { __typename?: 'Query', pointProduct: { __typename?: 'PointProduct', id: string, connectedTo: FranchiseOrCompany, pointsAmount: number, discountPercent: number, product: { __typename?: 'Product', id: string, price: number } } };

export type GetPointProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointProductsQuery = { __typename?: 'Query', pointProducts: { __typename?: 'PointProductsResult', data: Array<{ __typename?: 'PointProduct', id: string, connectedTo: FranchiseOrCompany, pointsAmount: number, discountPercent: number, title?: string | null, order?: number | null, product: { __typename?: 'Product', id: string, price: number } }> } };

export type GetPriceffDynamicPriceResourceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPriceffDynamicPriceResourceQuery = { __typename?: 'Query', priceffDynamicPriceResource: { __typename?: 'PriceffDynamicPriceResource', id: string, capacityLeft: number, createdAt: any, maxCapacity: number, usagesCount: number, pricesCount: number, priceffSalesBatchId: string, priceffDashboardLink: string, priceUsageChart: string, parameters: { __typename?: 'PriceffParameter', id: string, name: string }, dates: Array<{ __typename?: 'PriceffDynamicPriceResourceDate', id: string, startDate: any, endDate: any }>, currentPrice?: { __typename?: 'PriceffDynamicPriceResourcePrice', id: string, price: number, createdAt: any } | null } };

export type PriceffDynamicPriceResourceDatesGroupedQueryVariables = Exact<{
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  resourceType: Scalars['ID'];
}>;


export type PriceffDynamicPriceResourceDatesGroupedQuery = { __typename?: 'Query', priceffDynamicPriceResourceDatesGrouped: Array<{ __typename?: 'PriceffDynamicPriceResourceDateGrouped', date: any, dates: Array<{ __typename?: 'PriceffDynamicPriceResourceDate', id: string, startDate: any, endDate: any, dynamicPriceResource: { __typename?: 'PriceffDynamicPriceResource', id: string, capacityLeft: number, maxCapacity: number, utilizationPercentage: number, currentPrice?: { __typename?: 'PriceffDynamicPriceResourcePrice', id: string, price: number, orginalPriceDiff: number, toNextLimit: number } | null } }> }> };

export type GetPriceffModelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPriceffModelQuery = { __typename?: 'Query', priceffModel: { __typename?: 'PriceffModel', id: string, name: string, data: Array<{ __typename?: 'PriceffModelDateSlot', startDayOfYear: number, endDayOfYear: number, daySlots: Array<{ __typename?: 'PriceffModelDaysSlot', days: Array<Day>, timeSlots: Array<{ __typename?: 'PriceffModelTimeSlot', startTime: string, endTime: string, asOneSalesBatch: boolean, priceffParameterId: string, priceffParameter: { __typename?: 'PriceffParameter', id: string, name: string } }> }> }> } };

export type GetPriceffModelsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPriceffModelsQuery = { __typename?: 'Query', priceffModels: { __typename?: 'PriceffModelsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'PriceffModel', id: string, name: string, data: Array<{ __typename?: 'PriceffModelDateSlot', startDayOfYear: number, endDayOfYear: number, daySlots: Array<{ __typename?: 'PriceffModelDaysSlot', days: Array<Day>, timeSlots: Array<{ __typename?: 'PriceffModelTimeSlot', startTime: string, endTime: string, asOneSalesBatch: boolean, priceffParameterId: string, priceffParameter: { __typename?: 'PriceffParameter', id: string, name: string } }> }> }> }> } };

export type GetPriceffModelsSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPriceffModelsSimpleQuery = { __typename?: 'Query', priceffModels: { __typename?: 'PriceffModelsResult', data: Array<{ __typename?: 'PriceffModel', id: string, name: string }> } };

export type GetPriceffParameterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPriceffParameterQuery = { __typename?: 'Query', priceffParameter: { __typename?: 'PriceffParameter', id: string, name: string, priceffParameters: { __typename?: 'PriceffParametersCustom', priceType?: PriceffPriceType | null, minPriceIndex?: number | null, startPriceIndex?: number | null, maxPriceIndex?: number | null, targetAmountIndex?: number | null, acvExpected?: number | null, amountRolling?: number | null, customProfile?: Array<number> | null, discovery?: number | null, elasticity?: number | null, elasticity2?: number | null, profile?: number | null, round?: number | null, roundingOffset?: number | null, weight?: number | null } } };

export type GetPriceffParametersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPriceffParametersQuery = { __typename?: 'Query', priceffParameters: { __typename?: 'PriceffParameterResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'PriceffParameter', id: string, name: string }> } };

export type PriceffResourceTypesForPricesQueryVariables = Exact<{
  filtering?: InputMaybe<ResourceTypesFiltering>;
}>;


export type PriceffResourceTypesForPricesQuery = { __typename?: 'Query', resourceTypes: { __typename?: 'ResourceTypesResult', data: Array<{ __typename?: 'ResourceType', id: string, name: string, company: { __typename?: 'Company', id: string, name: string }, priceffModel?: { __typename?: 'PriceffModel', id: string, name: string } | null }> } };

export type GetPriceffAnalyticChartQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  parameterIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  timeType?: InputMaybe<ChartTimeType>;
}>;


export type GetPriceffAnalyticChartQuery = { __typename?: 'Query', priceffAnalyticSummaryChart: { __typename?: 'PriceffAnalyticSummaryChart', parameters: Array<{ __typename?: 'PriceffAnalyticSummaryChartParameter', id: string, sales: { __typename?: 'PriceffAnalyticSummaryChartSales', avgIndex: number, targetIndex: number, chart: { __typename?: 'ChartGeneratorResult', categories: Array<string>, series: Array<{ __typename?: 'ChartGeneratorResultSeries', value: string, data: Array<number> }> } }, price: { __typename?: 'PriceffAnalyticSummaryChartPrice', maxPriceIndex: number, minPriceIndex: number, orginalPriceIndex: number, avgPriceIndex: number, chart: { __typename?: 'ChartGeneratorResult', categories: Array<string>, series: Array<{ __typename?: 'ChartGeneratorResultSeries', value: string, data: Array<number> }> } }, conversions: { __typename?: 'PriceffAnalyticSummaryChartConversions', avgProcentage: number, chart: { __typename?: 'ChartGeneratorResult', categories: Array<string>, series: Array<{ __typename?: 'ChartGeneratorResultSeries', value: string, data: Array<number> }> } } }> } };

export type GetPriceffAnalyticKpiQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  parameterIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetPriceffAnalyticKpiQuery = { __typename?: 'Query', priceffAnalyticKPI: Array<{ __typename?: 'PriceffAnalyticKPIItem', text: string, sales: { __typename?: 'PriceffAnalyticKPISales', salesCount: number, totalRevenue: number, avgIndex: number, avgDiffPrice: number }, price: { __typename?: 'PriceffAnalyticKPIPrice', avgIndex: number, percentageAtMin: number, percentageAtMax: number } }> };

export type GetProductForPayQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductForPayQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, category?: { __typename?: 'ProductCategory', id: string, allowedPaymentMethods: Array<PaymentMethod> } | null } };

export type ProductVaildForCouponQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductVaildForCouponQuery = { __typename?: 'Query', product: { __typename?: 'Product', validToUseCoupon: boolean } };

export type GetQuickInfoLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetQuickInfoLocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, quickInfoUrlFull?: string | null } };

export type GetResourceCategoriesQueryVariables = Exact<{
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetResourceCategoriesQuery = { __typename?: 'Query', resourceCategories: { __typename?: 'ResourceCategoriesResult', data: Array<{ __typename?: 'ResourceCategory', id: string, name: string, description: string, weekdayOpenTime: Array<string>, weekendOpenTime: Array<string>, maxDaysCreateResourceBookingAhead: number, maxDaysCreateResourceBookingAheadUser: number, durationMinutesIntervals: Array<number>, defaultDurationMinutes: number, company: { __typename?: 'Company', id: string, usingPointProducts: boolean } }> } };

export type GetResourceCategoriesFullQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResourceCategoriesFullQuery = { __typename?: 'Query', resourceCategories: { __typename?: 'ResourceCategoriesResult', data: Array<{ __typename?: 'ResourceCategory', id: string, name: string, description: string, weekdayOpenTime: Array<string>, weekendOpenTime: Array<string>, maxMinutsBeforeCancellation: number, durationMinutesIntervals: Array<number>, maxGapIntervalsCount: number, bookingsAllowedDurationTimeGaps: number, accessMinutsBeforeBooking: number, accessMinutesAfterBooking: number, maxDaysCreateResourceBookingAhead: number, durationIntervalMinutes?: number | null, defaultToATime: boolean, popularity: number, types: Array<{ __typename?: 'ResourceType', id: string, name: string, description: string, popularity: number, priceTableAWeekdayTabel: string, priceTableAWeekendTabel: string, standardPriceA: { __typename?: 'Product', id: string, price: number }, standardPriceB: { __typename?: 'Product', id: string, price: number }, resources: Array<{ __typename?: 'Resource', id: string, name: string, shortName: string, logoUrl?: string | null, popularity: number, location: { __typename?: 'Location', id: string, name: string } }>, prices: Array<{ __typename?: 'ResourceTypePrice', id: string, isActive: boolean, startTime: string, endTime: string, isUsingDates: boolean, type: ResourceTypePriceType, days: Array<Day>, product: { __typename?: 'Product', id: string, price: number }, dates: Array<{ __typename?: 'ResourceTypePriceDate', id: string, periodStart: any, periodEnd: any, isActive: boolean }> }> }> }> } };

export type GetResourceTypesQueryVariables = Exact<{
  filtering?: InputMaybe<ResourceTypesFiltering>;
}>;


export type GetResourceTypesQuery = { __typename?: 'Query', resourceTypes: { __typename?: 'ResourceTypesResult', data: Array<{ __typename?: 'ResourceType', id: string, name: string, popularity: number, priceTableAWeekdayTabel: string, priceTableAWeekendTabel: string, standardPriceA: { __typename?: 'Product', id: string, price: number }, standardPriceB: { __typename?: 'Product', id: string, price: number } }> } };

export type GetResourceTypesPriceffQueryVariables = Exact<{
  filtering?: InputMaybe<ResourceTypesFiltering>;
}>;


export type GetResourceTypesPriceffQuery = { __typename?: 'Query', resourceTypes: { __typename?: 'ResourceTypesResult', data: Array<{ __typename?: 'ResourceType', id: string, name: string, usePriceffDynamicPricing: boolean, standardPriceA: { __typename?: 'Product', id: string, price: number }, standardPriceB: { __typename?: 'Product', id: string, price: number } }> } };

export type GetResourceTypesSimpleQueryVariables = Exact<{
  filtering?: InputMaybe<ResourceTypesFiltering>;
}>;


export type GetResourceTypesSimpleQuery = { __typename?: 'Query', resourceTypes: { __typename?: 'ResourceTypesResult', data: Array<{ __typename?: 'ResourceType', id: string, name: string, popularity: number, company: { __typename?: 'Company', id: string, name: string } }> } };

export type GetResourcesQueryVariables = Exact<{
  filtering?: InputMaybe<ResourcesFiltering>;
}>;


export type GetResourcesQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcesResult', data: Array<{ __typename?: 'Resource', id: string, name: string, currentBooking?: { __typename?: 'ResourceBooking', id: string, status: BookingStatus, comments?: string | null, owner: { __typename?: 'User', id: string, firstName?: string | null, name?: string | null } } | null, lightController?: { __typename?: 'ControllerOnOff', id: string } | null }> } };

export type GetResourcesAvailableTimeSchemaQueryVariables = Exact<{
  resourceType: Scalars['ID'];
  location: Scalars['ID'];
  date: Scalars['DateTime'];
  durationMinuts: Scalars['Int'];
}>;


export type GetResourcesAvailableTimeSchemaQuery = { __typename?: 'Query', resourcesAvailableTimeSchema: { __typename?: 'ResourceTypeSchema', durationMinuts: number, location: string, times: Array<{ __typename?: 'ResourceTypeSchemaTime', startDate: any, endDate: any, utcTime: string, availableForBooking: boolean, priceWithActiveCoupon?: number | null, price: { __typename?: 'ResourceTypeSchemaTimePrice', price: number, isDynamicPrice: boolean }, availableResources: Array<{ __typename?: 'Resource', id: string, name: string, logoUrl?: string | null, maxAttendees: number }> }> } };

export type GetResourcesBasicQueryVariables = Exact<{
  filtering?: InputMaybe<ResourcesFiltering>;
}>;


export type GetResourcesBasicQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcesResult', data: Array<{ __typename?: 'Resource', id: string, name: string, location: { __typename?: 'Location', id: string, name: string } }> } };

export type GetResourcesBookliScreenQueryVariables = Exact<{
  filtering?: InputMaybe<ResourcesFiltering>;
}>;


export type GetResourcesBookliScreenQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcesResult', data: Array<{ __typename?: 'Resource', id: string, name: string, logoUrl?: string | null, currentBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, owner: { __typename?: 'User', firstName?: string | null } } | null, nextBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, owner: { __typename?: 'User', firstName?: string | null } } | null }> } };

export type GetResourcesForTimeLineQueryVariables = Exact<{
  filtering?: InputMaybe<ResourcesFiltering>;
}>;


export type GetResourcesForTimeLineQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcesResult', data: Array<{ __typename?: 'Resource', id: string, name: string, shortName: string, logoUrl?: string | null, popularity: number, type: { __typename?: 'ResourceType', id: string, name: string, category: { __typename?: 'ResourceCategory', id: string, name: string, weekdayOpenTime: Array<string>, weekendOpenTime: Array<string> } }, location: { __typename?: 'Location', id: string, name: string, company: { __typename?: 'Company', id: string, timezone: Timezone } } }> } };

export type GetResourcesGetAvailableQueryVariables = Exact<{
  location: Scalars['ID'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetResourcesGetAvailableQuery = { __typename?: 'Query', resourcesGetAvailable: Array<{ __typename?: 'Resource', id: string, name: string }> };

export type GetResourcesLocationTimelineQueryVariables = Exact<{
  resourceCategory?: InputMaybe<Scalars['ID']>;
  date: Scalars['DateTime'];
  location: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetResourcesLocationTimelineQuery = { __typename?: 'Query', resourcesLocationTimeline: { __typename?: 'ResourcesLocationTimelineData', openTimeUtc: string, closeTimeUtc: string, reservationTypeColors: string, latestDateForBooking: any, resourceTypes: Array<{ __typename?: 'ResourceType', id: string, name: string, pricesForDate: Array<{ __typename?: 'ResourceTypePriceForDate', startDate: any, endDate: any, pricePerHourString: string, priceType: ResourceTypePriceType }> }>, resources: Array<{ __typename?: 'Resource', id: string, name: string, shortName: string, logoUrl?: string | null, popularity: number, typeId: string }>, resourceBookings: Array<{ __typename?: 'ResourceBookingTimeline', id: string, startDate: any, endDate: any, resourceId: string, description: string, color: string, hasInternalNotes: boolean }> } };

export type GetResourcesSimpleQueryVariables = Exact<{
  filtering?: InputMaybe<ResourcesFiltering>;
}>;


export type GetResourcesSimpleQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcesResult', data: Array<{ __typename?: 'Resource', id: string, name: string, shortName: string, logoUrl?: string | null, isActive: boolean, popularity: number }> } };

export type GetResourceBookingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, createdAt: any, startDate: any, endDate: any, status: BookingStatus, duractionMinuts: number, comments?: string | null, internalNotes?: string | null, userCanCancelBooking: boolean, allowAddingAttendees: boolean, attendeesCount: number, lightsWillTurnOn: boolean, reservationType?: ReservationType | null, resourceBookingAttendeesTokenData: string, additionalService?: { __typename?: 'AdditionalService', id: string, name?: string | null } | null, dynamicPriceUsages: Array<{ __typename?: 'PriceffDynamicPriceResourceUsage', id: string, quantity: number, price: { __typename?: 'PriceffDynamicPriceResourcePrice', id: string, price: number }, priceffDynamicPriceResource: { __typename?: 'PriceffDynamicPriceResource', id: string } }>, partOfRecurringResourceBooking?: { __typename?: 'ResourceBookingRecurring', id: string, name: string } | null, workshopDay?: { __typename?: 'WorkshopDay', id: string, workshop: { __typename?: 'Workshop', id: string, title: string } } | null, myAttendee?: { __typename?: 'ResourceBookingAttendee', id: string, accessCodeAccessTime?: { __typename?: 'AccessCodeAccessTime', id: string, accessCode: { __typename?: 'AccessCode', id: string, pinCode: string } } | null } | null, accessCodeAccessTime?: { __typename?: 'AccessCodeAccessTime', id: string, accessCode: { __typename?: 'AccessCode', pinCode: string, id: string } } | null, owner: { __typename?: 'User', id: string, name?: string | null }, payment?: { __typename?: 'Payment', id: string, moneyValue?: number | null, paymentMethod: PaymentMethod, status: PaymentStatus, currency: Currency, platformFeeAmount: number, connectedPayments: Array<{ __typename?: 'Payment', paymentMethod: PaymentMethod, platformFeeAmount: number }> } | null, bookingAttendees: Array<{ __typename?: 'ResourceBookingAttendee', id: string, canBeDeleted: boolean, ableToPayDiscountedPayment?: string | null, user: { __typename?: 'User', id: string, name?: string | null, isFriends: boolean }, accessCodeAccessTime?: { __typename?: 'AccessCodeAccessTime', id: string, accessCode: { __typename?: 'AccessCode', id: string } } | null, payments: Array<{ __typename?: 'Payment', id: string, paymentMethod: PaymentMethod, moneyValue?: number | null, status: PaymentStatus }> }>, resource: { __typename?: 'Resource', id: string, name: string, maxAttendees: number, type: { __typename?: 'ResourceType', id: string, name: string, description: string, category: { __typename?: 'ResourceCategory', id: string, maxMinutsBeforeCancellation: number } }, company: { __typename?: 'Company', id: string, name: string, phoneNumber: string }, location: { __typename?: 'Location', id: string, name: string } } } };

export type GetResourceBookingAttendeesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingAttendeesQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, attendeesCount: number, bookingAttendees: Array<{ __typename?: 'ResourceBookingAttendee', id: string, user: { __typename?: 'User', id: string, name?: string | null }, accessCodeAccessTime?: { __typename?: 'AccessCodeAccessTime', id: string, accessCode: { __typename?: 'AccessCode', id: string } } | null, payments: Array<{ __typename?: 'Payment', id: string, paymentMethod: PaymentMethod, moneyValue?: number | null, status: PaymentStatus }> }>, resource: { __typename?: 'Resource', id: string, maxAttendees: number } } };

export type GetResourceBookingCanCreateSmallQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResourceBookingCanCreateSmallQuery = { __typename?: 'Query', resourceBookingCanCreateSmall?: { __typename?: 'CanCreateSmallResult', startDate: any, endDate: any, resource: { __typename?: 'Resource', id: string, name: string } } | null };

export type GetResourceBookingCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingCardQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, additionalService?: { __typename?: 'AdditionalService', id: string, name?: string | null } | null, resource: { __typename?: 'Resource', id: string, name: string, shortName: string, type: { __typename?: 'ResourceType', id: string, name: string }, location: { __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string } } } };

export type GetResourceBookingCreatedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingCreatedQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any } };

export type GetResourceBookingForBookliVideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingForBookliVideoQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, canGenerateBookliVideo: ResourceBookingCanGenerateBookliVideo, bookliVideo?: { __typename?: 'BookliVideo', id: string } | null } };

export type GetResourceBookingForCalendarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingForCalendarQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, duractionMinuts: number, bookingAttendees: Array<{ __typename?: 'ResourceBookingAttendee', id: string, accessCodeAccessTime?: { __typename?: 'AccessCodeAccessTime', id: string, accessCode: { __typename?: 'AccessCode', id: string, pinCode: string } } | null, user: { __typename?: 'User', id: string, name?: string | null } }>, resource: { __typename?: 'Resource', id: string, name: string, location: { __typename?: 'Location', id: string, lat?: string | null, lng?: string | null, name: string, streetName: string, zipCode: string, city: string } } } };

export type GetResourceBookingForShareQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingForShareQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, createdAt: any, startDate: any, endDate: any, duractionMinuts: number, resource: { __typename?: 'Resource', id: string, name: string, location: { __typename?: 'Location', id: string, name: string } } } };

export type GetResourceBookingIsValidQueryVariables = Exact<{
  resource: Scalars['ID'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetResourceBookingIsValidQuery = { __typename?: 'Query', resourceBookingIsValid: boolean };

export type GetResourceBookingPaymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingPaymentsQuery = { __typename?: 'Query', resourceBooking: { __typename?: 'ResourceBooking', id: string, internalNotes?: string | null, additionalService?: { __typename?: 'AdditionalService', id: string, name?: string | null } | null, attendeesTokenData: Array<{ __typename?: 'ResourceBookingAttendeeTokenData', userId?: string | null, isUser: boolean, restMoneyValue: number, value: number, discountValue: number, messageLines: Array<string>, number: number, user?: { __typename?: 'User', id: string, name?: string | null } | null }>, paymentsFormated: Array<{ __typename?: 'ResourceBookingPaymentFormated', additionalServiceValue: number, displayName: string, paidFormated: string, payment: { __typename?: 'Payment', id: string, status: PaymentStatus, createdAt: any, paymentMethod: PaymentMethod, additionalServiceValue: number, pointBounty?: { __typename?: 'PointTransaction', id: string, amount: number, pointAccountId: string } | null } }> } };

export type ResourceBookingValidateCancellationQueryVariables = Exact<{
  id: Scalars['ID'];
  refundPayment?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResourceBookingValidateCancellationQuery = { __typename?: 'Query', resourceBookingValidateCancellation: { __typename?: 'ResourceBookingValidateCancellationResult', canCancel: boolean, canGetFullRefund?: boolean | null, deductedAmount?: number | null, refundAmount?: number | null } };

export type GetResourceBookingsQueryVariables = Exact<{
  filtering?: InputMaybe<ResourceBookingsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetResourceBookingsQuery = { __typename?: 'Query', resourceBookings: { __typename?: 'ResourceBookingsResult', data: Array<{ __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, status: BookingStatus, comments?: string | null, reservationType?: ReservationType | null, owner: { __typename?: 'User', id: string, name?: string | null }, resource: { __typename?: 'Resource', id: string, maxAttendees: number } }> } };

export type ResourceBookingsConflictingQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceBookingsConflictingQuery = { __typename?: 'Query', resourceBookingsConflicting: Array<{ __typename?: 'ResourceBooking', id: string, startDate: any, comments?: string | null, owner: { __typename?: 'User', id: string, name?: string | null } }> };

export type GetResourceBookingsTimelinePublicQueryVariables = Exact<{
  filtering?: InputMaybe<ResourceBookingsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetResourceBookingsTimelinePublicQuery = { __typename?: 'Query', resourceBookings: { __typename?: 'ResourceBookingsResult', data: Array<{ __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, resource: { __typename?: 'Resource', id: string } }> } };

export type GetResourceBookingRecurringQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceBookingRecurringQuery = { __typename?: 'Query', resourceBookingRecurring: { __typename?: 'ResourceBookingRecurring', id: string, name: string, createdAt: any, startTimeDate: any, endTimeDate: any, startTime: string, endTime: string, startCreateDate?: any | null, endCreateDate?: any | null, createCyclesInAdvance: number, days: Array<Day>, active: boolean, reservationType?: ReservationType | null, resources: Array<{ __typename?: 'Resource', id: string, name: string }>, resourceBookings: Array<{ __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any }>, creator: { __typename?: 'User', id: string, name?: string | null }, connectedToUser?: { __typename?: 'User', id: string, name?: string | null } | null, connectedToUserGroup?: { __typename?: 'UserGroup', id: string, name: string } | null, attendees: Array<{ __typename?: 'User', id: string, name?: string | null }> } };

export type GetResourceBookingRecurringsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<ResourceBookingRecurringsFiltering>;
}>;


export type GetResourceBookingRecurringsQuery = { __typename?: 'Query', resourceBookingRecurrings: { __typename?: 'ResourceBookingRecurringsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'ResourceBookingRecurring', id: string, name: string, startTimeDate: any, endTimeDate: any, active: boolean }> } };

export type GetAllShortStringMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllShortStringMappingsQuery = { __typename?: 'Query', getAllShortStringMappings: Array<{ __typename?: 'ShortStringMapping', shortString: string, fullString: string }> };

export type GetStripeConnectLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeConnectLinkQuery = { __typename?: 'Query', stripeConnectLink: string };

export type GetStripeConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeConnectionQuery = { __typename?: 'Query', stripeDashboardLink: string };

export type GetStripeGetSetupIntentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeGetSetupIntentQuery = { __typename?: 'Query', stripeGetSetupIntent: { __typename?: 'StripeGetSetupIntentType', stripeEphemeralKey: string, stripeIntentClientSecret: string, stripeCustomerId: string } };

export type GetStripeInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStripeInvoiceQuery = { __typename?: 'Query', stripeInvoice: { __typename?: 'StripeInvoice', id: string, status: StripeInvoiceStatus, user: { __typename?: 'User', id: string, name?: string | null }, payments: Array<{ __typename?: 'Payment', id: string }> } };

export type GetStripeReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStripeReportQuery = { __typename?: 'Query', stripeReport: { __typename?: 'StripeReport', id: string, intervalStart: any, intervalEnd: any, status: StripeReportStatus, fileName?: string | null, createdAt: any, result?: string | null, generatedByUser?: { __typename?: 'User', id: string, firstName?: string | null } | null } };

export type GetStripeReportsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetStripeReportsQuery = { __typename?: 'Query', stripeReports: { __typename?: 'StripeReportsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'StripeReport', id: string, intervalStart: any, intervalEnd: any, type: StripeReportType, status: StripeReportStatus, createdAt: any }> } };

export type GetSubscriptionProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionProductCategoriesQuery = { __typename?: 'Query', subscriptionProductCategories: { __typename?: 'SubscriptionProductCategoriesResult', data: Array<{ __typename?: 'SubscriptionProductCategory', id: string, name: string }> } };

export type GetSubscriptionProductCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSubscriptionProductCategoryQuery = { __typename?: 'Query', subscriptionProductCategory: { __typename?: 'SubscriptionProductCategory', id: string, name: string } };

export type GetSubscriptionProductGiftCardValidateQueryVariables = Exact<{
  subscriptionProductGiftCardCode: Scalars['String'];
  subscriptionProduct: Scalars['ID'];
}>;


export type GetSubscriptionProductGiftCardValidateQuery = { __typename?: 'Query', subscriptionProductGiftCardValidate?: any | null };

export type GetSubscriptionProductGiftCardsQueryVariables = Exact<{
  subscriptionProduct: Scalars['ID'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetSubscriptionProductGiftCardsQuery = { __typename?: 'Query', subscriptionProductGiftCards: { __typename?: 'SubscriptionProductGiftCardsResult', totalCount: number, hasMore: boolean, data: Array<{ __typename?: 'SubscriptionProductGiftCard', id: string, code: string, validUntil?: any | null, isActive: boolean, startAfterPeriods: number, note?: string | null }> } };

export type GetSubscriptionProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSubscriptionProductQuery = { __typename?: 'Query', subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string, accessCodeDoorGroup?: string | null, description: string, countUserSubscriptions: number, allowPublicSignUp: boolean, paymentOnTheFirstOfMonth: boolean, daysBeforeFirstPayment?: number | null, startDateForFirstPayment?: any | null, activeBeforeFirstPayment: boolean, paymentMaxCoverType: SubscriptionProductPaymentMaxCoverType, paymentMaxHoursCovered?: number | null, paymentMaxValueCovered?: number | null, paymentMaxActiveBookingsPerMonth?: number | null, paymentDiscountType: SubscriptionProducPaymentDiscountType, paymentDiscountAmount?: number | null, paymentDiscountPercentage?: number | null, paymentDiscountAmountPrBookingInterval?: number | null, paymentCyclesAfterCancele: number, maxActiveBookings: number, maxNumberOfActiveSubscriptions?: number | null, maxDaysCreateResourceBookingAhead: number, paymentDiscountIsOnlyInBTime: boolean, paymentTimesPrYear: number, canBeUsedOnWorkshops: boolean, category: { __typename?: 'SubscriptionProductCategory', id: string, name: string }, couponOnOtherPayments?: { __typename?: 'Coupon', id: string, percentOff?: number | null, resourceBookingTimeRanges: Array<{ __typename?: 'CouponResourceBookingTimeRange', startTime: string, endTime: string, days: Array<Day> }> } | null, couponOnEvents?: { __typename?: 'Coupon', id: string, percentOff?: number | null, maximumUsagesPrCustomer?: number | null, maximumUsagesPrCustomerPrMonth?: boolean | null } | null, signUpRules: Array<{ __typename?: 'SubscriptionProductSignUpRule', type: SubscriptionProductSignUpRuleType, ruleAgeType?: SubscriptionProductSignUpRuleAgeType | null, ruleAge?: number | null }>, usageRules: Array<{ __typename?: 'SubscriptionProductUsageRule', type: SubscriptionProductUsageRuleType, resourceBookingStartTime?: string | null, resourceBookingEndTime?: string | null, resourceBookingDays: Array<Day> }>, product: { __typename?: 'Product', id: string, price: number }, company?: { __typename?: 'Company', id: string, name: string } | null, signUpFeeProduct: { __typename?: 'Product', id: string, price: number }, startDateForFirstPaymentCompanies: Array<{ __typename?: 'SubscriptionProductStartDateForFirstPayment', id: string, startAfterPeriods?: number | null, validStartDate: any, validEndDate: any, toDate?: any | null, companies: Array<{ __typename?: 'Company', id: string, name: string }> }>, onlyPayOnResourceTypes: Array<{ __typename?: 'ResourceType', id: string, name: string }> } };

export type GetSubscriptionProductForUserCreateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionProductForUserCreateQuery = { __typename?: 'Query', subscriptionProducts: { __typename?: 'SubscriptionProductsResult', data: Array<{ __typename?: 'SubscriptionProduct', id: string, name: string, product: { __typename?: 'Product', id: string, price: number } }> } };

export type GetSubscriptionProductForUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSubscriptionProductForUserQuery = { __typename?: 'Query', subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string, description: string, countUserSubscriptions: number, activeBeforeFirstPayment: boolean, startDateForFirstPayment?: any | null, startDateForFirstPaymentUser?: any | null, userProductSubscription?: { __typename?: 'UserProductSubscription', id: string, status: UserProductSubscriptionStatus, createdAt: any, userCanCancel: boolean, cancelDate?: any | null, posibleCancelDate?: any | null, company?: { __typename?: 'Company', id: string, name: string } | null, latestPayment?: { __typename?: 'Payment', id: string, status: PaymentStatus, invoiceUrl?: string | null } | null } | null, couponOnOtherPayments?: { __typename?: 'Coupon', id: string, percentOff?: number | null } | null, product: { __typename?: 'Product', id: string, price: number }, signUpFeeProduct: { __typename?: 'Product', id: string, price: number } } };

export type GetSubscriptionProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionProductsQuery = { __typename?: 'Query', subscriptionProducts: { __typename?: 'SubscriptionProductsResult', totalCount: number, hasMore: boolean, data: Array<{ __typename?: 'SubscriptionProduct', id: string, name: string, description: string, paymentMaxCoverType: SubscriptionProductPaymentMaxCoverType, paymentMaxHoursCovered?: number | null, paymentMaxValueCovered?: number | null, paymentDiscountType: SubscriptionProducPaymentDiscountType, paymentDiscountAmount?: number | null, paymentDiscountAmountPrBookingInterval?: number | null, paymentDiscountPercentage?: number | null, userAllowedToSignUp: boolean, paymentTimesPrYear: number, maxActiveBookings: number, startDateForFirstPaymentUser?: any | null, company?: { __typename?: 'Company', id: string, name: string } | null, signUpFeeProduct: { __typename?: 'Product', id: string, price: number }, userProductSubscription?: { __typename?: 'UserProductSubscription', id: string, status: UserProductSubscriptionStatus, cancelDate?: any | null, latestPayment?: { __typename?: 'Payment', status: PaymentStatus } | null } | null, couponOnOtherPayments?: { __typename?: 'Coupon', id: string, percentOff?: number | null } | null, product: { __typename?: 'Product', id: string, price: number } }> } };

export type GetTrinityEComGetProductQueryVariables = Exact<{
  product: Scalars['Int'];
  country: SupportedCountries;
}>;


export type GetTrinityEComGetProductQuery = { __typename?: 'Query', trinityEComGetProduct: { __typename?: 'TrinityEcomProduct', id: number, name: string, basePrice: number, catalogueId: number, deliverableStockValue: number, deliveryDaysMax: number, deliveryDaysMin: number, images: Array<string>, price: number, primaryImageSmallUrl?: string | null, sku?: string | null, shippingGroupId: number, storeStockValue: number, articles?: Array<{ __typename?: 'TrinityEcomProductArticles', sku: string, name: string, deliverableStockValue: number, storeStockValue: number }> | null, description: { __typename?: 'TrinityEcomProductDescription', lead?: string | null, fullDescription?: string | null }, filterData: { __typename?: 'TrinityEcomProductFilterData', categories?: Array<number> | null, propertyItems?: string | null, stockOnHand?: string | null }, ribbon?: { __typename?: 'TrinityEcomProductRibbon', title?: string | null } | null, propertyValues: Array<{ __typename?: 'TrinityEcomProductPropertyValues', id: number, type: number, name?: string | null, value?: string | null, valueItems: Array<{ __typename?: 'TrinityEcomProductPropertyValueItems', id: number, name?: string | null }> }>, stockValues: Array<{ __typename?: 'TrinityEcomStockValues', stockId: number, productId: number, sku: string, value: number }> } };

export type GetTrinityEComGetProductCatalogQueryVariables = Exact<{
  category: Scalars['Int'];
  categoryType: TrinityEcomCategoryType;
  parameters: TrinityEComProductCatalogParameters;
  country: SupportedCountries;
}>;


export type GetTrinityEComGetProductCatalogQuery = { __typename?: 'Query', trinityEComGetProductCatalog: { __typename?: 'TrinityEComProductCatalog', totalCount: number, totalPageCount: number, currentPage: number, pageSize: number, products: Array<{ __typename?: 'TrinityEcomProduct', id: number, catalogueId: number, name: string, sku?: string | null, primaryImageSmallUrl?: string | null, price: number, basePrice: number }> } };

export type TrinityEComGetTermsAndConditionsQueryVariables = Exact<{
  country: SupportedCountries;
}>;


export type TrinityEComGetTermsAndConditionsQuery = { __typename?: 'Query', trinityEComGetTermsAndConditions: { __typename?: 'TrinityEComPageContent', bodyHtml?: string | null } };

export type GetTrinityEComReferenceDataQueryVariables = Exact<{
  country: SupportedCountries;
}>;


export type GetTrinityEComReferenceDataQuery = { __typename?: 'Query', trinityEComReferenceData: { __typename?: 'TrinityEComReferenceData', currencyCode: string, categories: Array<{ __typename?: 'TrinityEComCategory', id: number, parentId?: number | null, name: string, type: TrinityEcomCategoryType }>, stocks: Array<{ __typename?: 'TrinityEComStock', id: number, name: string }>, shippingTypes: Array<{ __typename?: 'TrinityEComShippingType', id: number, shippingGroupId: number, name: string, description: string, imageFileName: string, sortOrder: number, shippingFees: Array<{ __typename?: 'TrinityEComShippingFee', thresholdOrderAmount: number, price: number, name?: string | null, vatPercent?: number | null, vatSum?: number | null }> }> } };

export type GetTrinityEComGetCheckoutOrderQueryVariables = Exact<{
  checkoutToken: Scalars['String'];
  country: SupportedCountries;
}>;


export type GetTrinityEComGetCheckoutOrderQuery = { __typename?: 'Query', trinityEcomCheckoutOrder: Array<{ __typename?: 'TrinityEComCheckout', success: boolean, customerOrder: { __typename?: 'CustomerOrderType', id: number, customerName?: string | null, totalSum: number, createdUtc?: string | null, discountCode?: string | null, items?: Array<{ __typename?: 'TrinityItems', name?: string | null, quantity: number, itemTotalSum: number, type: CustomerOrderItemType }> | null, addressContainer: { __typename?: 'TrinityAddressContainer', hasSeparateDeliveryAddress: boolean, billingAddress: { __typename?: 'TrinityBillingAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null }, deliveryAddress?: { __typename?: 'TrinityBillingAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null } } }> };

export type GetTrinityEComGetOrderHistoryQueryVariables = Exact<{
  country: SupportedCountries;
}>;


export type GetTrinityEComGetOrderHistoryQuery = { __typename?: 'Query', trinityEcomOrderHistory: Array<{ __typename?: 'TrinityEComOrderHistory', id: number, checkoutToken?: string | null, handlingStatus: OrderHandlingStatusType, totalSum: number, createdUtc?: string | null, items?: Array<{ __typename?: 'TrinityItems', name?: string | null, quantity: number, itemTotalSum: number, type: CustomerOrderItemType }> | null, deliveries?: Array<{ __typename?: 'TrinityDeliveryInfo', id: number, erpDeliveryNumber?: string | null, createdUtc: string, deliveryDate: string, shipmentReference?: string | null, trackingReference?: string | null, trackingUrl?: string | null }> | null, addressContainer: { __typename?: 'TrinityAddressContainer', hasSeparateDeliveryAddress: boolean, billingAddress: { __typename?: 'TrinityBillingAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null }, deliveryAddress?: { __typename?: 'TrinityBillingAddress', companyName?: string | null, recipient?: string | null, address1?: string | null, address2?: string | null, postCode?: string | null, city?: string | null, country?: string | null } | null } }> };

export type CheckForSavedStripeSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckForSavedStripeSourceQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, haveSavedStripeSource: boolean } } };

export type GetPointAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointAmountQuery = { __typename?: 'Query', me: { __typename?: 'Me', pointAccount: { __typename?: 'PointAccount', id: string, pointsAmount: number } } };

export type GetUserAccountPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountPageQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string } } };

export type GetUserAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAuthQuery = { __typename?: 'Query', me: { __typename?: 'Me', role: UserRole, hasAdminRole: boolean, country: SupportedCountries, currency?: Currency | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, language: Language }, company?: { __typename?: 'Company', id: string, usingEcom: boolean } | null, userPlatformConnection: { __typename?: 'UserPlatformConnection', id: string } } };

export type GetUserInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInformationQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', email?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, zipCode?: string | null, city?: string | null, country: SupportedCountries, phoneCountryCode?: string | null, phoneNumberWithoutCountryCode?: string | null, businessUser?: { __typename?: 'BusinessUser', businessName: string, vatNumber: string } | null } } };

export type GetMeWelcomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeWelcomePageQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, accessCode?: { __typename?: 'AccessCode', id: string, pinCode: string, fullAccessToDoors: Array<{ __typename?: 'ControllerDoor', id: string }>, fullAccessToDoorGroups: Array<{ __typename?: 'ControllerDoorGroup', id: string }> } | null, bookingNext?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, resource: { __typename?: 'Resource', name: string, type: { __typename?: 'ResourceType', id: string, name: string }, location: { __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string } } } | { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', id: string, title: string, location: { __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string }, nextDay?: { __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any } | null } } | null }, franchise?: { __typename?: 'Franchise', id: string, name: string } | null, company?: { __typename?: 'Company', id: string, name: string, usingPointProducts: boolean, usingSubscriptionProducts: boolean, usingEcom: boolean } | null, pointAccount: { __typename?: 'PointAccount', id: string, pointsAmount: number }, userGroupsPointAccount: Array<{ __typename?: 'PointAccount', id: string, pointsAmount: number, company?: { __typename?: 'Company', id: string, name: string } | null, userGroup?: { __typename?: 'UserGroup', id: string, name: string, company?: { __typename?: 'Company', id: string, name: string } | null } | null }>, pointAccountsOutsideOfCurrentCompany: Array<{ __typename?: 'PointAccount', id: string, pointsAmount: number, company?: { __typename?: 'Company', id: string, name: string } | null }>, userActiveProductSubscription: Array<{ __typename?: 'UserProductSubscription', id: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string } }> } };

export type GetUpdateUserInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetUpdateUserInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, zipCode?: string | null, city?: string | null, streetName?: string | null, phoneNumber?: string | null, email?: string | null, country: SupportedCountries, businessUser?: { __typename?: 'BusinessUser', businessName: string, vatNumber: string } | null } };

export type GetUpdateUserInfoAdminQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetUpdateUserInfoAdminQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, country: SupportedCountries, businessUser?: { __typename?: 'BusinessUser', businessName: string, vatNumber: string } | null } };

export type GetUserActivitiesQueryVariables = Exact<{
  filtering?: InputMaybe<UserActivitiesFiltering>;
}>;


export type GetUserActivitiesQuery = { __typename?: 'Query', userActivities: { __typename?: 'UserActivitiesResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'UserActivity', id: string, type: UserActivityType, value?: string | null, createdAt: any }> } };

export type GetUserBasicQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  idEmailPhone?: InputMaybe<Scalars['String']>;
}>;


export type GetUserBasicQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name?: string | null } };

export type GetUserSignInMethodQueryVariables = Exact<{
  emailAddress?: InputMaybe<Scalars['String']>;
}>;


export type GetUserSignInMethodQuery = { __typename?: 'Query', signInMethod: { __typename?: 'SignInMethod', userSignInMethod: string } };

export type GetUserStripeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserStripeQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, haveSavedStripeSource: boolean, stripeSources: Array<{ __typename?: 'StripeSource', id: string, last4: number, expMonth: number, expYear: number, brand: string, isDefaultCard: boolean }> } };

export type AgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgreementsQuery = { __typename?: 'Query', agreements: { __typename?: 'AgreementsResult', data: Array<{ __typename?: 'Agreement', id: string, name: string, type: AgreementType, createdAt: any, documentUrl: string, userAccptedAgreementsCount: number, userAgreementsCount: number, usersTotal: number }> } };

export type GetAgreementsForCompanyIsUpdatedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsForCompanyIsUpdatedQuery = { __typename?: 'Query', agreementsForCompanyIsUpdated?: Array<{ __typename?: 'Agreement', id: string, name: string, requiredAccept: boolean, documentUrl: string } | null> | null };

export type GetAgreementsForCompanySignUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsForCompanySignUpQuery = { __typename?: 'Query', agreementsForCompanySignUp: Array<{ __typename?: 'Agreement', id: string, name: string, requiredAccept: boolean, documentUrl: string, description?: string | null }> };

export type GetAgreementsForUserQueryVariables = Exact<{
  filtering?: InputMaybe<AgreementsForUserFiltering>;
}>;


export type GetAgreementsForUserQuery = { __typename?: 'Query', agreementsForUser: Array<{ __typename?: 'Agreement', id: string, name: string, type: AgreementType, requiredAccept: boolean, documentUrl: string, description?: string | null }> };

export type GetAgreementsForCreateUserProductSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsForCreateUserProductSubscriptionQuery = { __typename?: 'Query', agreementsForCreateUserProductSubscription: Array<{ __typename?: 'Agreement', id: string, name: string, requiredAccept: boolean, documentUrl: string, description?: string | null }> };

export type GetUserAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAgreementsQuery = { __typename?: 'Query', userAgreements: { __typename?: 'UserAgreementsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'UserAgreement', id: string, accepted: boolean, agreement: { __typename?: 'Agreement', name: string, createdAt: any, documentUrl: string, description?: string | null } }> } };

export type GetUserBasicsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetUserBasicsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, city?: string | null, zipCode?: string | null, email?: string | null, phoneNumber?: string | null, country: SupportedCountries, createdAt: any, isDeleted: boolean, lat?: string | null, lng?: string | null, userSignInMethod: UserSingInMethod, stripeCustomerUrl?: string | null, haveSavedStripeSource: boolean, accessCode?: { __typename?: 'AccessCode', id: string, pinCode: string } | null, resourceBookingsPrWeek: { __typename?: 'UserResourceBookingsPrWeek', prWeekRatio: Array<number>, pastWeekRatio: number, averageRatio: number, diffBetweenPastWeekAndAverageRatio: number }, recurringBookingsAttendee: Array<{ __typename?: 'ResourceBookingRecurring', id: string, name: string }>, groups: Array<{ __typename?: 'UserGroup', id: string, name: string }>, userProductSubscriptions: Array<{ __typename?: 'UserProductSubscription', id: string, status: UserProductSubscriptionStatus, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string } }>, businessUser?: { __typename?: 'BusinessUser', businessName: string, vatNumber: string } | null } };

export type GetUserCompaniesQueryVariables = Exact<{
  userAuthToken: Scalars['String'];
}>;


export type GetUserCompaniesQuery = { __typename?: 'Query', userCompanies: Array<{ __typename?: 'Company', id: string, name: string, streetName: string, zipCode: string }> };

export type GetUserGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserGroupQuery = { __typename?: 'Query', userGroup: { __typename?: 'UserGroup', id: string, name: string, usersCount: number, createdAt: any, automaticAddUsersWithEmailEnding?: string | null, maxDaysCreateResourceBookingAhead?: number | null, maxUserLimit?: number | null, adminsCanHandleUsers: boolean, automaticSubscriptionProduct?: { __typename?: 'SubscriptionProduct', id: string, name: string } | null, pointAccount?: { __typename?: 'PointAccount', id: string, active: boolean } | null, coupons: Array<{ __typename?: 'Coupon', id: string, slug: string, active: boolean }>, users: Array<{ __typename?: 'UserGroupUser', isGroupAdmin: boolean, user: { __typename?: 'User', id: string, name?: string | null } }> } };

export type UserGroupUserAdminQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UserGroupUserAdminQuery = { __typename?: 'Query', userGroup: { __typename?: 'UserGroup', id: string, name: string, adminsCanHandleUsers: boolean, maxUserLimit?: number | null, usersCount: number, pointAccount?: { __typename?: 'PointAccount', id: string, pointsAmount: number } | null, users: Array<{ __typename?: 'UserGroupUser', pointUsage: number, user: { __typename?: 'User', id: string, name?: string | null } }> } };

export type GetUserGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<UserGroupsFiltering>;
}>;


export type GetUserGroupsQuery = { __typename?: 'Query', userGroups: { __typename?: 'UserGroupsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'UserGroup', id: string, name: string, usersCount: number, pointAccount?: { __typename?: 'PointAccount', id: string, active: boolean, pointsAmount: number, usedTheLastXDays: number } | null, automaticSubscriptionProduct?: { __typename?: 'SubscriptionProduct', id: string, name: string } | null, coupons: Array<{ __typename?: 'Coupon', id: string, slug: string }> }> } };

export type GetUserGroupsUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGroupsUserQuery = { __typename?: 'Query', userGroups: { __typename?: 'UserGroupsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'UserGroup', id: string, name: string, userIsGroupAdmin: boolean }> } };

export type GetUserPlatformConnectionsQueryVariables = Exact<{
  filtering?: InputMaybe<UserPlatformConnectionsFiltering>;
}>;


export type GetUserPlatformConnectionsQuery = { __typename?: 'Query', userPlatformConnections: { __typename?: 'UserPlatformConnectionsResult', data: Array<{ __typename?: 'UserPlatformConnection', id: string, user: { __typename?: 'User', id: string, email?: string | null, name?: string | null } }> } };

export type GetUserPlatformConnectionsBySignedInUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetUserPlatformConnectionsBySignedInUserQuery = { __typename?: 'Query', userPlatformConnectionsBySignedInUser: Array<{ __typename?: 'UserPlatformConnection', id: string, company?: { __typename?: 'Company', id: string, name: string } | null }> };

export type GetUserPlatformConnectionTokensQueryVariables = Exact<{
  filtering?: InputMaybe<UserPlatformConnectionTokensFiltering>;
}>;


export type GetUserPlatformConnectionTokensQuery = { __typename?: 'Query', userPlatformConnectionTokens: { __typename?: 'UserPlatformConnectionTokensResult', data: Array<{ __typename?: 'UserPlatformConnectionToken', id: string, email: string, createdAt: any }> } };

export type GetUserProductSubscriptionPaymentUserCanDoResultQueryVariables = Exact<{
  product: Scalars['ID'];
}>;


export type GetUserProductSubscriptionPaymentUserCanDoResultQuery = { __typename?: 'Query', userProductSubscriptionPaymentUserCanDo: { __typename?: 'UserProductSubscriptionPaymentUserCanDoResult', canDo: boolean, userProductSubscriptionId?: string | null, userProductSubscription?: { __typename?: 'UserProductSubscription', id: string, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string } } | null } };

export type GetUserProductSubscriptionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserProductSubscriptionQuery = { __typename?: 'Query', userProductSubscription: { __typename?: 'UserProductSubscription', id: string, createdAt: any, status: UserProductSubscriptionStatus, paymentsSum: number, usedOnPaymentsCount: number, posibleCancelDate?: any | null, subscriptionPlatform: SubscriptionPlatform, cancelDate?: any | null, connectedTo: FranchiseOrCompany, company?: { __typename?: 'Company', id: string, name: string } | null, latestSuccessfulPayment?: { __typename?: 'Payment', id: string, moneyValue?: number | null } | null, addedByUserGroup?: { __typename?: 'UserGroup', id: string, name: string } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string }, usedOnPayments: Array<{ __typename?: 'Payment', id: string, createdAt: any }>, payments: Array<{ __typename?: 'Payment', id: string, status: PaymentStatus, moneyValue?: number | null, createdAt: any }>, user: { __typename?: 'User', id: string, name?: string | null }, createdByAdmin?: { __typename?: 'User', id: string, name?: string | null } | null } };

export type GetUserProductSubscriptionActivityQueryVariables = Exact<{
  userProductSubscription: Scalars['ID'];
}>;


export type GetUserProductSubscriptionActivityQuery = { __typename?: 'Query', userProductSubscriptionActivity: { __typename?: 'UserProductSubscriptionActivityResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'UserProductSubscriptionActivity', id: string, type: UserProductSubscriptionActivityType, createdAt: any }> } };

export type GetUserProductSubscriptionsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<UserProductSubscriptionsFiltering>;
}>;


export type GetUserProductSubscriptionsQuery = { __typename?: 'Query', userProductSubscriptions: { __typename?: 'UserProductSubscriptionsResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'UserProductSubscription', id: string, status: UserProductSubscriptionStatus, subscriptionPlatform: SubscriptionPlatform, createdAt: any, cancelDate?: any | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', id: string, name: string }, user: { __typename?: 'User', id: string, name?: string | null } }> } };

export type GetUsersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  company?: InputMaybe<Scalars['ID']>;
  filtering?: InputMaybe<UsersFiltering>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'User', id: string, email?: string | null, name?: string | null, phoneNumber?: string | null, createdAt: any, businessUser?: { __typename?: 'BusinessUser', id: string } | null }> } };

export type GetUsersBasicQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  company?: InputMaybe<Scalars['ID']>;
  filtering?: InputMaybe<UsersFiltering>;
}>;


export type GetUsersBasicQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'User', id: string, name?: string | null }> } };

export type GetWannasportConnectionQueryVariables = Exact<{
  location: Scalars['ID'];
}>;


export type GetWannasportConnectionQuery = { __typename?: 'Query', wannasportConnection?: { __typename?: 'WannasportConnection', id: string, pointAccount: { __typename?: 'PointAccount', id: string, pointsAmount: number }, possibleTimeSlotsFormated: Array<{ __typename?: 'WannasportPossibleTimeSlot', days: Array<Day>, times: Array<Array<string>> }> } | null };

export type GetWannasportPointCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWannasportPointCheckQuery = { __typename?: 'Query', wannasportPointCheck?: boolean | null };

export type GetWorkshopBookingForCalendarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkshopBookingForCalendarQuery = { __typename?: 'Query', workshopBooking: { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', title: string, location: { __typename?: 'Location', id: string, name: string, lat?: string | null, lng?: string | null, streetName: string, zipCode: string, city: string }, nextDay?: { __typename?: 'WorkshopDay', id: string, startDate: any, endDate: any, userWorkshopBookingAccessCode?: { __typename?: 'AccessCode', id: string, pinCode: string } | null } | null } } };

export type GetWorkshopQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkshopQuery = { __typename?: 'Query', workshop: { __typename?: 'Workshop', id: string, title: string, status: WorkshopStatus, type: WorkshopType, waitlistCount: number, lastRegistrationDate: any, allowUserProductSubscriptionPayment: boolean, description: string, userCanCreateBooking: boolean, maxRegistrations: number, daysCount: number, paymentsSum: number, bookingsCount: number, privateWorkshop: boolean, privateWorkshopKey?: string | null, product: { __typename?: 'Product', id: string, price: number, payWithSubscriptionIsOfAType: boolean }, userBooking?: { __typename?: 'WorkshopBooking', id: string, userCanCancelBooking: boolean } | null, days: Array<{ __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any, description?: string | null, resourceBookings: Array<{ __typename?: 'ResourceBooking', id: string, resource: { __typename?: 'Resource', id: string, name: string } }> }> } };

export type GetWorkshopBookingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkshopBookingQuery = { __typename?: 'Query', workshopBooking: { __typename?: 'WorkshopBooking', id: string } };

export type GetWorkshopBookingButtonQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkshopBookingButtonQuery = { __typename?: 'Query', workshop: { __typename?: 'Workshop', id: string, maxRegistrations: number, userCanCreateBooking: boolean, title: string, userIsOnWaitlist?: boolean | null, bookingsCount: number, requireUserBookingNote: boolean, requiredUserBookingNoteTitle?: string | null, privateWorkshop: boolean, privateWorkshopKey?: string | null, userBooking?: { __typename?: 'WorkshopBooking', id: string, userCanCancelBooking: boolean } | null, product: { __typename?: 'Product', id: string, price: number } } };

export type GetWorkshopBookingCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkshopBookingCardQuery = { __typename?: 'Query', workshopBooking: { __typename?: 'WorkshopBooking', id: string, workshop: { __typename?: 'Workshop', id: string, title: string, location: { __typename?: 'Location', id: string, name: string, streetName: string, zipCode: string, city: string }, nextDay?: { __typename?: 'WorkshopDay', id: string, startDate: any, endDate: any } | null, days: Array<{ __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any }> } } };

export type GetWorkshopBookingsQueryVariables = Exact<{
  workshop: Scalars['ID'];
  pagination?: InputMaybe<PaginationInput>;
  filtering?: InputMaybe<WorkshopBookingsFiltering>;
}>;


export type GetWorkshopBookingsQuery = { __typename?: 'Query', workshopBookings: { __typename?: 'WorkshopBookingsResult', totalCount: number, hasMore: boolean, data: Array<{ __typename?: 'WorkshopBooking', id: string, status: BookingStatus, createdAt: any, userBookingNote?: string | null, payment?: { __typename?: 'Payment', id: string, paymentMethod: PaymentMethod } | null, user: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null } }> } };

export type GetWorkshopUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWorkshopUserQuery = { __typename?: 'Query', workshop: { __typename?: 'Workshop', id: string, title: string, type: WorkshopType, lastRegistrationDate: any, description: string, maxRegistrations: number, privateWorkshop: boolean, product: { __typename?: 'Product', id: string, price: number }, days: Array<{ __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any, description?: string | null }>, participantList: Array<{ __typename?: 'WorkshopBooking', user: { __typename?: 'User', firstName?: string | null, lastName?: string | null } }> } };

export type GetWorkshopsQueryVariables = Exact<{
  filtering?: InputMaybe<WorkshopsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetWorkshopsQuery = { __typename?: 'Query', workshops: { __typename?: 'WorkshopsResult', data: Array<{ __typename?: 'Workshop', id: string, title: string, lastRegistrationDate: any, maxRegistrations: number, type: WorkshopType, bookingsCount: number, waitlistCount: number, userCanCreateBooking: boolean, userIsOnWaitlist?: boolean | null, requireUserBookingNote: boolean, requiredUserBookingNoteTitle?: string | null, privateWorkshop: boolean, privateWorkshopKey?: string | null, userBooking?: { __typename?: 'WorkshopBooking', id: string, userCanCancelBooking: boolean } | null, nextDay?: { __typename?: 'WorkshopDay', id: string, startDate: any, endDate: any } | null, days: Array<{ __typename?: 'WorkshopDay', id: string, title?: string | null, startDate: any, endDate: any }>, product: { __typename?: 'Product', id: string, price: number } }> } };

export type GetWorkshopsForCalendarQueryVariables = Exact<{
  filtering?: InputMaybe<WorkshopsFiltering>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetWorkshopsForCalendarQuery = { __typename?: 'Query', workshops: { __typename?: 'WorkshopsResult', data: Array<{ __typename?: 'Workshop', id: string, title: string, maxRegistrations: number, type: WorkshopType, bookingsCount: number, waitlistCount: number, typeColor: string, days: Array<{ __typename?: 'WorkshopDay', id: string, startDate: any, endDate: any }> }> } };

export type GetWorkshopWaitlistQueryVariables = Exact<{
  workshop: Scalars['ID'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetWorkshopWaitlistQuery = { __typename?: 'Query', workshopWaitlist: { __typename?: 'WorkshopWaitlistResult', hasMore: boolean, totalCount: number, data: Array<{ __typename?: 'WorkshopWaitlistItem', id: string, createdAt: any, user: { __typename?: 'User', id: string, name?: string | null } }> } };

export type BookliScreenHealthSubscriptionVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
}>;


export type BookliScreenHealthSubscription = { __typename?: 'Subscription', bookliScreenHealth: { __typename?: 'BookliScreenHealthSubscriptionPayload', shouldReload: boolean } };

export type BookliVideoSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookliVideoSubscriptionSubscription = { __typename?: 'Subscription', bookliVideo: { __typename?: 'BookliVideo', id: string, streamUrl?: string | null, state: BookliVideoState, type: BookliVideoType, downloadUrl?: string | null } };

export type AccessCodeUsageSubscriptionSubscriptionVariables = Exact<{
  controllerDoor?: InputMaybe<Scalars['ID']>;
}>;


export type AccessCodeUsageSubscriptionSubscription = { __typename?: 'Subscription', accessCodeUsage: { __typename?: 'AccessCodeUsageSubscriptionPayload', dataForMessage: { __typename?: 'AccessCodeDataMessage', name: string, currentBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, resource: { __typename?: 'Resource', id: string, name: string } } | null, nextBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, resource: { __typename?: 'Resource', id: string, name: string } } | null } } };

export type SubscribeControllerOnOffNoxStateChangeSubscriptionVariables = Exact<{
  controllerUrl: Scalars['String'];
}>;


export type SubscribeControllerOnOffNoxStateChangeSubscription = { __typename?: 'Subscription', controllerOnOffNoxStateChange: { __typename?: 'ControllerOnOffNoxStateChangeSubscriptionPayload', controllerUnitUrl: string, timeOfLastAreaStateChange: any } };

export type SubscribeInvoicePaidSubscriptionVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type SubscribeInvoicePaidSubscription = { __typename?: 'Subscription', invoicePaid: { __typename?: 'InvoicePaidSubscriptionPayload', invoiceId: string, subscriptionId: string, paymentIntentId: string, status: string } };

export type SubscribeLocationOverviewResourcesSubscriptionVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  onlyForActiveBookings?: InputMaybe<Scalars['Boolean']>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type SubscribeLocationOverviewResourcesSubscription = { __typename?: 'Subscription', resourceChange: { __typename?: 'ResourceChangeSubscriptionPayload', changeType: ResourceChangeTypeSubscription, resource: { __typename?: 'Resource', id: string, name: string, logoUrl?: string | null, location: { __typename?: 'Location', id: string, overviewSvg?: string | null }, currentBooking?: { __typename?: 'ResourceBooking', id: string, status: BookingStatus, owner: { __typename?: 'User', id: string, name?: string | null, firstName?: string | null } } | null } } };

export type SubscribeLocationOverviewResourcesV2SubscriptionVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  onlyForActiveBookings?: InputMaybe<Scalars['Boolean']>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  showCurrentBooking?: InputMaybe<Scalars['Boolean']>;
  showResourceName?: InputMaybe<Scalars['Boolean']>;
  highlightResourceId?: InputMaybe<Scalars['String']>;
}>;


export type SubscribeLocationOverviewResourcesV2Subscription = { __typename?: 'Subscription', resourceChange: { __typename?: 'ResourceChangeSubscriptionPayload', changeType: ResourceChangeTypeSubscription, resource: { __typename?: 'Resource', id: string, location: { __typename?: 'Location', id: string, overviewSvg?: string | null } } } };

export type SubscribeLocationScreenWelcomeMessageSubscriptionVariables = Exact<{
  location: Scalars['ID'];
}>;


export type SubscribeLocationScreenWelcomeMessageSubscription = { __typename?: 'Subscription', locationScreenWelcomeMessage: string };

export type PaymentTokenSubscriptionSubscriptionVariables = Exact<{
  paymentToken: Scalars['ID'];
}>;


export type PaymentTokenSubscriptionSubscription = { __typename?: 'Subscription', paymentToken: { __typename?: 'PaymentTokenSubscriptionPayload', paymentToken: { __typename?: 'PaymentToken', id: string, state: PaymentTokenState, failedReason?: PaymentTokenFaildReason | null, amountToPay: number, lastFailureReason?: string | null, attemptCount: number } } };

export type QuickInfoUserChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type QuickInfoUserChangeSubscription = { __typename?: 'Subscription', quickInfoUserChange: { __typename?: 'QuickInfoUserChangeSubscriptionPayload', user: string } };

export type SubscribeResourceChangeSubscriptionVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  onlyForActiveBookings?: InputMaybe<Scalars['Boolean']>;
  resources?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SubscribeResourceChangeSubscription = { __typename?: 'Subscription', resourceChange: { __typename?: 'ResourceChangeSubscriptionPayload', changeType: ResourceChangeTypeSubscription, resource: { __typename?: 'Resource', id: string, name: string, logoUrl?: string | null, location: { __typename?: 'Location', id: string, overviewSvg?: string | null }, currentBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, comments?: string | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, workshopDay?: { __typename?: 'WorkshopDay', id: string, workshop: { __typename?: 'Workshop', id: string, title: string } } | null } | null, nextBooking?: { __typename?: 'ResourceBooking', id: string, startDate: any, endDate: any, comments?: string | null, owner: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, workshopDay?: { __typename?: 'WorkshopDay', id: string, workshop: { __typename?: 'Workshop', id: string, title: string } } | null } | null } } };

export type SubscribeWorkshopsFutureChangedSubscriptionVariables = Exact<{
  location: Scalars['ID'];
}>;


export type SubscribeWorkshopsFutureChangedSubscription = { __typename?: 'Subscription', workshopsFutureChanged: { __typename?: 'WorkshopsFutureSubscriptionPayload', workshops: Array<{ __typename?: 'Workshop', id: string, title: string, lastRegistrationDate: any, maxRegistrations: number, nextDay?: { __typename?: 'WorkshopDay', id: string, startDate: any, endDate: any } | null, product: { __typename?: 'Product', id: string, price: number } }> } };


export const AccessCodeCreate = gql`
    mutation AccessCodeCreate($data: AccessCodeCreate!) {
  accessCodeCreate(data: $data) {
    id
  }
}
    `;
export const AccessCodeDelete = gql`
    mutation AccessCodeDelete($accessCode: ID!, $noxVersion: NoxVersion) {
  accessCodeDelete(accessCode: $accessCode, noxVersion: $noxVersion)
}
    `;
export const AccessCodeUpdate = gql`
    mutation AccessCodeUpdate($id: ID!, $data: AccessCodeUpdate!) {
  accessCodeUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const AdditionalServiceCreate = gql`
    mutation AdditionalServiceCreate($additionalServiceData: AdditionalServiceCreate!) {
  additionalServiceCreate(additionalServiceData: $additionalServiceData) {
    success
    message
  }
}
    `;
export const AdditionalServiceUpdate = gql`
    mutation AdditionalServiceUpdate($additionalServiceData: AdditionalServiceUpdate!) {
  additionalServiceUpdate(additionalServiceData: $additionalServiceData) {
    success
    message
  }
}
    `;
export const AnalyticCreateKpiExport = gql`
    mutation AnalyticCreateKPIExport($periodStart: DateTime!, $periodEnd: DateTime!, $periodType: KpiExportPeriodType!, $sendToEmail: String!) {
  analyticCreateKPIExport(
    periodStart: $periodStart
    periodEnd: $periodEnd
    periodType: $periodType
    sendToEmail: $sendToEmail
  ) {
    success
  }
}
    `;
export const AuthChangePassword = gql`
    mutation AuthChangePassword($token: String!, $newPassword: String!) {
  authChangePassword(token: $token, newPassword: $newPassword) {
    success
  }
}
    `;
export const AuthSendPasswordResetEmail = gql`
    mutation AuthSendPasswordResetEmail($email: String!) {
  authSendPasswordResetEmail(email: $email) {
    message
    success
  }
}
    `;
export const AuthSignInPlatform = gql`
    mutation AuthSignInPlatform($userPlatformConnection: ID!) {
  authSignInPlatform(userPlatformConnection: $userPlatformConnection)
}
    `;
export const AuthSignInUser = gql`
    mutation AuthSignInUser($emailAndPassword: EmailAndPasswordInput, $facebookAuthToken: String, $appleSignIn: AppleSignInInput) {
  authSignInUser(
    emailAndPassword: $emailAndPassword
    facebookAuthToken: $facebookAuthToken
    appleSignIn: $appleSignIn
  )
}
    `;
export const AuthUpdatePassword = gql`
    mutation AuthUpdatePassword($password: String!) {
  authUpdatePassword(password: $password)
}
    `;
export const AuthVerifyEmail = gql`
    mutation authVerifyEmail($token: String!) {
  authVerifyEmail(token: $token) {
    success
  }
}
    `;
export const BookingReportCreate = gql`
    mutation BookingReportCreate($periodStart: DateTime!, $periodEnd: DateTime!, $sendToEmail: String!) {
  bookingReportCreate(
    periodStart: $periodStart
    periodEnd: $periodEnd
    sendToEmail: $sendToEmail
  ) {
    success
    message
  }
}
    `;
export const BookliCameraCreate = gql`
    mutation BookliCameraCreate($data: BookliCameraCreate!) {
  bookliCameraCreate(data: $data) {
    id
  }
}
    `;
export const BookliCameraUpdate = gql`
    mutation BookliCameraUpdate($id: ID!, $data: BookliCameraUpdate!) {
  bookliCameraUpdate(id: $id, data: $data) {
    id
    name
  }
}
    `;
export const BookliCameraServerCreate = gql`
    mutation BookliCameraServerCreate($data: BookliCameraServerCreate!) {
  bookliCameraServerCreate(data: $data) {
    id
  }
}
    `;
export const BookliCameraServerReloadCameras = gql`
    mutation BookliCameraServerReloadCameras($id: ID!) {
  bookliCameraServerReloadCameras(id: $id) {
    id
  }
}
    `;
export const BookliDeviceRegister = gql`
    mutation BookliDeviceRegister($token: String!) {
  bookliDeviceRegister(token: $token) {
    id
  }
}
    `;
export const BookliSoundCreate = gql`
    mutation BookliSoundCreate($data: BookliSoundCreate!) {
  bookliSoundCreate(data: $data) {
    id
  }
}
    `;
export const BookliVideoCreateSubClip = gql`
    mutation BookliVideoCreateSubClip($data: BookliVideoCreateSubClip!) {
  bookliVideoCreateSubClip(data: $data) {
    id
  }
}
    `;
export const CompanyCreate = gql`
    mutation CompanyCreate($userAuthToken: String, $companyCreateInvitationToken: String, $companyData: CompanyCreate!, $franchiseData: FranchiseCreate, $userData: UserCreate) {
  companyCreate(
    userAuthToken: $userAuthToken
    companyCreateInvitationToken: $companyCreateInvitationToken
    companyData: $companyData
    franchiseData: $franchiseData
    userData: $userData
  ) {
    id
  }
}
    `;
export const CompanyCreateInvitationSend = gql`
    mutation CompanyCreateInvitationSend($data: CompanyCreateInvitationSend!) {
  companyCreateInvitationSend(data: $data) {
    success
  }
}
    `;
export const CompanyCreateInvitationDelete = gql`
    mutation CompanyCreateInvitationDelete($id: ID!) {
  companyCreateInvitationDelete(id: $id) {
    success
  }
}
    `;
export const CompanySettingUpdate = gql`
    mutation CompanySettingUpdate($data: CompanySettingUpdate!) {
  companySettingUpdate(data: $data) {
    id
  }
}
    `;
export const CompanyUpdate = gql`
    mutation CompanyUpdate($data: CompanyUpdate!) {
  companyUpdate(data: $data) {
    id
  }
}
    `;
export const CompanyUploadAppImage = gql`
    mutation companyUploadAppImage($file: Upload!) {
  companyUploadAppImage(file: $file) {
    id
  }
}
    `;
export const CompanyUploadLogo = gql`
    mutation CompanyUploadLogo($file: Upload!) {
  companyUploadLogo(file: $file) {
    id
  }
}
    `;
export const ControllerDoorCreate = gql`
    mutation ControllerDoorCreate($data: ControllerDoorCreate!) {
  controllerDoorCreate(data: $data) {
    id
  }
}
    `;
export const ControllerDoorSetState = gql`
    mutation ControllerDoorSetState($data: ControllerDoorSetState!) {
  controllerDoorSetState(data: $data) {
    success
  }
}
    `;
export const ControllerDoorGroupUpdate = gql`
    mutation ControllerDoorGroupUpdate($id: ID!, $data: ControllerDoorGroupUpdate!) {
  controllerDoorGroupUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const ControllerDoorGroupCreate = gql`
    mutation ControllerDoorGroupCreate($data: ControllerDoorGroupCreate!) {
  controllerDoorGroupCreate(data: $data) {
    id
  }
}
    `;
export const AddLightControllerResource = gql`
    mutation AddLightControllerResource($resource: ID!, $noxAreaId: Int!, $noxTimeprofileId: Int!) {
  resourceAddLightController(
    resource: $resource
    noxAreaId: $noxAreaId
    noxTimeProfileId: $noxTimeprofileId
  ) {
    id
  }
}
    `;
export const ControllerOnOffSetState = gql`
    mutation ControllerOnOffSetState($controllerOnOff: ID!, $newState: Boolean) {
  controllerOnOffSetState(controllerOnOff: $controllerOnOff, newState: $newState) {
    success
  }
}
    `;
export const ControllerOnOffUpdate = gql`
    mutation ControllerOnOffUpdate($id: ID!, $data: ControllerOnOffUpdate!) {
  controllerOnOffUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const ControllerUnitCreate = gql`
    mutation ControllerUnitCreate($data: ControllerUnitCreate!) {
  controllerUnitCreate(data: $data) {
    id
  }
}
    `;
export const CouponCreate = gql`
    mutation CouponCreate($data: CouponCreate!) {
  couponCreate(data: $data) {
    id
  }
}
    `;
export const CouponDisable = gql`
    mutation CouponDisable($id: ID!) {
  couponDisable(id: $id) {
    id
  }
}
    `;
export const CouponUpdate = gql`
    mutation CouponUpdate($coupon: ID!, $data: CouponUpdate!) {
  couponUpdate(coupon: $coupon, data: $data) {
    id
  }
}
    `;
export const DineroConnectionCreate = gql`
    mutation DineroConnectionCreate($data: DineroConnectionCreate!) {
  dineroConnectionCreate(data: $data) {
    id
  }
}
    `;
export const DeleteUserFcmToken = gql`
    mutation DeleteUserFCMToken($userId: ID!) {
  deleteUserFCMToken(userId: $userId)
}
    `;
export const SetUserFcmToken = gql`
    mutation SetUserFCMToken($fcmToken: String!) {
  setUserFCMToken(fcmToken: $fcmToken) {
    id
  }
}
    `;
export const FeedbackCreate = gql`
    mutation feedbackCreate($data: FeedbackCreate!) {
  feedbackCreate(data: $data) {
    id
  }
}
    `;
export const FranchiseCompanyInvitationSend = gql`
    mutation franchiseCompanyInvitationSend($data: FranchiseCompanyInvitationSend!) {
  franchiseCompanyInvitationSend(data: $data) {
    success
  }
}
    `;
export const FranchiseUploadLogo = gql`
    mutation FranchiseUploadLogo($file: Upload!) {
  franchiseUploadLogo(file: $file) {
    id
  }
}
    `;
export const FriendshipCreate = gql`
    mutation FriendshipCreate($friendUserId: ID!) {
  friendshipCreate(friendUserId: $friendUserId) {
    id
  }
}
    `;
export const FriendshipDelete = gql`
    mutation FriendshipDelete($friendUserId: ID!) {
  friendshipDelete(friendUserId: $friendUserId)
}
    `;
export const GiftCardCreate = gql`
    mutation GiftCardCreate($data: GiftCardCreate!) {
  giftCardCreate(data: $data) {
    id
    code
  }
}
    `;
export const GiftCardUse = gql`
    mutation GiftCardUse($giftCardCode: String!) {
  giftCardUse(giftCardCode: $giftCardCode)
}
    `;
export const LocationCreate = gql`
    mutation LocationCreate($data: LocationCreate!) {
  locationCreate(data: $data) {
    id
  }
}
    `;
export const LocationUpdate = gql`
    mutation LocationUpdate($location: ID!, $data: LocationUpdate!) {
  locationUpdate(location: $location, data: $data) {
    id
  }
}
    `;
export const LocationUserDefaultChange = gql`
    mutation LocationUserDefaultChange($newDefaultLocation: ID!) {
  locationUserDefaultChange(newDefaultLocation: $newDefaultLocation) {
    id
  }
}
    `;
export const MessageCreate = gql`
    mutation MessageCreate($data: MessageCreate!) {
  messageCreate(data: $data) {
    id
  }
}
    `;
export const MessageCreateSendTest = gql`
    mutation MessageCreateSendTest($data: MessageCreate!, $sendTo: [String!]!) {
  messageCreateSendTest(data: $data, sendTo: $sendTo) {
    id
  }
}
    `;
export const PayPalConfirmPayment = gql`
    mutation PayPalConfirmPayment($payPalInvoiceId: String!, $payPalOrderId: String!) {
  payPalConfirmPayment(
    payPalInvoiceId: $payPalInvoiceId
    payPalOrderId: $payPalOrderId
  )
}
    `;
export const PayPalCreateConnection = gql`
    mutation PayPalCreateConnection($clientId: String!, $clientSecret: String!) {
  payPalCreateConnection(clientId: $clientId, clientSecret: $clientSecret) {
    success
  }
}
    `;
export const PaymentCancelReservedProduct = gql`
    mutation PaymentCancelReservedProduct($data: PaymentCancelReservedProduct!) {
  paymentCancelReservedProduct(data: $data)
}
    `;
export const PaymentGetXlsxList = gql`
    mutation PaymentGetXlsxList($createdAtStartDate: DateTime!, $createdAtEndDate: DateTime!, $sendToEmail: String!) {
  paymentGetXlsxList(
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    sendToEmail: $sendToEmail
  ) {
    success
  }
}
    `;
export const GetPaymentInvoice = gql`
    mutation GetPaymentInvoice($payment: ID!) {
  paymentInvoice(payment: $payment)
}
    `;
export const PaymentRefund = gql`
    mutation PaymentRefund($id: ID!, $canceleProduct: Boolean, $refundPayment: Boolean, $forceRefundAsPoints: Boolean, $refundPartialPayment: Boolean, $refundPartialPaymentAmount: Float, $cancelAdditionalService: Boolean, $refundServiceFee: Boolean, $refundRemainingAmount: Boolean) {
  paymentRefund(
    id: $id
    canceleProduct: $canceleProduct
    refundPayment: $refundPayment
    forceRefundAsPoints: $forceRefundAsPoints
    refundPartialPaymentAmount: $refundPartialPaymentAmount
    refundPartialPayment: $refundPartialPayment
    cancelAdditionalService: $cancelAdditionalService
    refundServiceFee: $refundServiceFee
    refundRemainingAmount: $refundRemainingAmount
  ) {
    id
  }
}
    `;
export const PaymentReserveProduct = gql`
    mutation PaymentReserveProduct($paymentPriceToken: String!) {
  paymentReserveProduct(paymentPriceToken: $paymentPriceToken) {
    resourceBooking {
      id
      resourceBookingAttendeesToken
    }
    workshopBooking {
      id
    }
  }
}
    `;
export const UpdatePaymentStatus = gql`
    mutation UpdatePaymentStatus($id: ID!, $status: PaymentStatus!) {
  updatePaymentStatus(id: $id, status: $status) {
    id
  }
}
    `;
export const PaymentTokenCreate = gql`
    mutation PaymentTokenCreate($paymentType: PaymentTokenPaymentType!, $data: PaymentTokenCreate!) {
  paymentTokenCreate(paymentType: $paymentType, data: $data) {
    id
    state
    stripePaymentIntentId
    stripePaymentMethod
    stripeClientSecret
    payPalInvoiceId
    failedReason
    currency
    country
    label
    amountToPay
    mobilePayConnection {
      invoicePayBeforeMinutes
    }
    user {
      id
      stripeCustomerId
      stripeEphemeralKey
    }
    company {
      id
      name
    }
    lastFailureReason
    attemptCount
  }
}
    `;
export const PaymentTokenFailed = gql`
    mutation PaymentTokenFailed($id: ID!, $failedReason: PaymentTokenFaildReason!, $cancelReservation: Boolean!) {
  paymentTokenFailed(
    id: $id
    failedReason: $failedReason
    cancelReservation: $cancelReservation
  ) {
    id
  }
}
    `;
export const PlatformInvoiceGetForPeriod = gql`
    mutation PlatformInvoiceGetForPeriod($data: PlatformInvoiceGetForPeriod!) {
  platformInvoiceGetForPeriod(data: $data)
}
    `;
export const PointAccountGetNumbersXlsx = gql`
    mutation PointAccountGetNumbersXlsx($pointAccount: ID!, $toDate: DateTime!) {
  pointAccountGetNumbersXlsx(pointAccount: $pointAccount, toDate: $toDate)
}
    `;
export const PointAccountUpdate = gql`
    mutation PointAccountUpdate($pointAccount: ID!, $data: PointAccountUpdate!) {
  pointAccountUpdate(pointAccount: $pointAccount, data: $data) {
    id
  }
}
    `;
export const PointAccountsCompanyGetNumbers = gql`
    mutation PointAccountsCompanyGetNumbers($toDate: DateTime!, $sendToEmail: String!) {
  pointAccountsCompanyGetNumbers(toDate: $toDate, sendToEmail: $sendToEmail) {
    success
  }
}
    `;
export const DoPointTransactionUpdate = gql`
    mutation DoPointTransactionUpdate($id: ID!, $data: PointTransactionUpdate!) {
  pointTransactionUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const PointsAddOrRemove = gql`
    mutation PointsAddOrRemove($pointAccount: ID!, $amount: Int!, $notes: String, $isOneToOne: Boolean!, $realValue: Float, $skipPlatformFees: Boolean) {
  pointsAddOrRemove(
    pointAccount: $pointAccount
    amount: $amount
    notes: $notes
    isOneToOne: $isOneToOne
    realValue: $realValue
    skipPlatformFees: $skipPlatformFees
  ) {
    id
  }
}
    `;
export const PointProductCreate = gql`
    mutation PointProductCreate($data: PointProductCreate!) {
  pointProductCreate(data: $data) {
    id
  }
}
    `;
export const PointProductDelete = gql`
    mutation PointProductDelete($id: ID!) {
  pointProductDelete(id: $id) {
    id
  }
}
    `;
export const PointProductUpdate = gql`
    mutation PointProductUpdate($id: ID!, $data: PointProductUpdate!) {
  pointProductUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const PriceffModelCreate = gql`
    mutation PriceffModelCreate($data: PriceffModelCreate!) {
  priceffModelCreate(data: $data) {
    id
  }
}
    `;
export const PriceffModelUpdate = gql`
    mutation PriceffModelUpdate($id: ID!, $data: PriceffModelUpdate!) {
  priceffModelUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const PriceffParameterCreate = gql`
    mutation PriceffParameterCreate($data: PriceffParameterCreate!) {
  priceffParameterCreate(data: $data) {
    id
  }
}
    `;
export const PriceffParameterUpdate = gql`
    mutation PriceffParameterUpdate($id: ID!, $data: PriceffParameterUpdate!) {
  priceffParameterUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const ResourceTypeConnectPriceffModel = gql`
    mutation ResourceTypeConnectPriceffModel($priceffModel: ID!, $resourceType: ID!) {
  resourceTypeConnectPriceffModel(
    priceffModel: $priceffModel
    resourceType: $resourceType
  ) {
    id
  }
}
    `;
export const ResourceTypePriceffUpdate = gql`
    mutation ResourceTypePriceffUpdate($id: ID!, $data: ResourceTypePriceffUpdate!) {
  resourceTypePriceffUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const ResourceCategoryCreate = gql`
    mutation ResourceCategoryCreate($data: ResourceCategoryCreate!) {
  resourceCategoryCreate(data: $data) {
    id
  }
}
    `;
export const ResourceCategoryUpdate = gql`
    mutation ResourceCategoryUpdate($resourceCategory: ID!, $data: ResourceCategoryUpdate!) {
  resourceCategoryUpdate(resourceCategory: $resourceCategory, data: $data) {
    id
  }
}
    `;
export const ResourceCreate = gql`
    mutation ResourceCreate($data: ResourceCreate!) {
  resourceCreate(data: $data) {
    id
  }
}
    `;
export const ResourceTypeCreate = gql`
    mutation ResourceTypeCreate($data: ResourceTypeCreate!) {
  resourceTypeCreate(data: $data) {
    id
  }
}
    `;
export const ResourceTypeUpdate = gql`
    mutation ResourceTypeUpdate($resourceType: ID!, $data: ResourceTypeUpdate!) {
  resourceTypeUpdate(resourceType: $resourceType, data: $data) {
    id
  }
}
    `;
export const ResourceUpdate = gql`
    mutation ResourceUpdate($resource: ID!, $data: ResourceUpdate!) {
  resourceUpdate(resource: $resource, data: $data) {
    id
  }
}
    `;
export const ResourceBookingAttendeeAdd = gql`
    mutation ResourceBookingAttendeeAdd($resourceBooking: ID!, $users: [ID!]!) {
  resourceBookingAttendeeAdd(resourceBooking: $resourceBooking, users: $users) {
    id
  }
}
    `;
export const ResourceBookingAttendeeDelete = gql`
    mutation ResourceBookingAttendeeDelete($resourceBooking: ID!, $resourceBookingAttendees: [ID!]!) {
  resourceBookingAttendeeDelete(
    resourceBooking: $resourceBooking
    resourceBookingAttendees: $resourceBookingAttendees
  ) {
    id
  }
}
    `;
export const ResourceBookingBookliVideoCreate = gql`
    mutation ResourceBookingBookliVideoCreate($resourceBooking: ID!) {
  resourceBookingBookliVideoCreate(resourceBooking: $resourceBooking) {
    id
  }
}
    `;
export const ResourceBookingCancel = gql`
    mutation ResourceBookingCancel($id: ID!, $refundPayment: Boolean) {
  resourceBookingCancel(id: $id, refundPayment: $refundPayment) {
    id
  }
}
    `;
export const ResourceBookingUpdate = gql`
    mutation ResourceBookingUpdate($resourceBooking: ID!, $data: ResourceBookingUpdateData!) {
  resourceBookingUpdate(resourceBooking: $resourceBooking, data: $data) {
    id
  }
}
    `;
export const ResourceBookingCreateCompanyReservation = gql`
    mutation ResourceBookingCreateCompanyReservation($data: ResourceBookingCreateCompanyReservation!) {
  resourceBookingCreateCompanyReservation(data: $data) {
    successfulCreatedBookings {
      id
    }
    errorWhileCreating {
      id
      name
    }
  }
}
    `;
export const ResourceBookingRecurringCreate = gql`
    mutation ResourceBookingRecurringCreate($data: ResourceBookingRecurringCreate!) {
  resourceBookingRecurringCreate(data: $data) {
    id
  }
}
    `;
export const ResourceBookingRecurringDelete = gql`
    mutation ResourceBookingRecurringDelete($resourceBookingRecurring: ID!, $deleteAllFutureBookings: Boolean) {
  resourceBookingRecurringDelete(
    resourceBookingRecurring: $resourceBookingRecurring
    deleteAllFutureBookings: $deleteAllFutureBookings
  ) {
    id
  }
}
    `;
export const ResourceBookingRecurringUpdate = gql`
    mutation ResourceBookingRecurringUpdate($id: ID!, $data: ResourceBookingRecurringUpdate!) {
  resourceBookingRecurringUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const ResourceTypePriceCreate = gql`
    mutation ResourceTypePriceCreate($data: ResourceTypePriceCreate!) {
  resourceTypePriceCreate(data: $data) {
    id
  }
}
    `;
export const ResourceTypePriceDateAdd = gql`
    mutation ResourceTypePriceDateAdd($resourceTypePriceId: ID!, $date: CreateResourceTypePriceDate!) {
  resourceTypePriceDateAdd(resourceTypePriceId: $resourceTypePriceId, date: $date) {
    id
  }
}
    `;
export const ResourceTypePriceDateDelete = gql`
    mutation ResourceTypePriceDateDelete($id: ID!) {
  resourceTypePriceDateDelete(id: $id)
}
    `;
export const ResourceTypePriceDelete = gql`
    mutation ResourceTypePriceDelete($id: ID!) {
  resourceTypePriceDelete(id: $id)
}
    `;
export const ResourceTypePriceUpdate = gql`
    mutation ResourceTypePriceUpdate($id: ID!, $data: ResourceTypePriceUpdate!) {
  resourceTypePriceUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const SaEvent = gql`
    mutation SaEvent($event: String!, $value: Float!, $dimension: String) {
  saEvent(event: $event, value: $value, dimension: $dimension)
}
    `;
export const ConfirmPaymentIntent = gql`
    mutation ConfirmPaymentIntent($paymentIntentId: String!, $confirmationTokenId: String!) {
  nextActionUrl(
    paymentIntentId: $paymentIntentId
    confirmationTokenId: $confirmationTokenId
  )
}
    `;
export const StripePaymentMetodAdded = gql`
    mutation StripePaymentMetodAdded {
  stripePaymentMetodAdded
}
    `;
export const StripeUserRemovePaymentMethod = gql`
    mutation StripeUserRemovePaymentMethod($paymentMethodId: ID!) {
  stripeUserRemovePaymentMethod(id: $paymentMethodId) {
    success
  }
}
    `;
export const StripeReportGenerate = gql`
    mutation StripeReportGenerate($data: StripeReportGenerate!) {
  stripeReportGenerate(data: $data) {
    id
  }
}
    `;
export const SubscriptionProductCreate = gql`
    mutation SubscriptionProductCreate($data: SubscriptionProductCreate!) {
  subscriptionProductCreate(data: $data) {
    id
  }
}
    `;
export const SubscriptionProductStartDateForFirstPaymentCreate = gql`
    mutation SubscriptionProductStartDateForFirstPaymentCreate($data: SubscriptionProductStartDateForFirstPaymentCreate!) {
  subscriptionProductStartDateForFirstPaymentCreate(data: $data) {
    id
  }
}
    `;
export const SubscriptionProductUpdate = gql`
    mutation SubscriptionProductUpdate($id: ID!, $data: SubscriptionProductUpdate!) {
  subscriptionProductUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const SubscriptionProductCategoryCreate = gql`
    mutation SubscriptionProductCategoryCreate($data: SubscriptionProductCategoryCreate!) {
  subscriptionProductCategoryCreate(data: $data) {
    id
  }
}
    `;
export const SubscriptionProductGiftCardCreate = gql`
    mutation SubscriptionProductGiftCardCreate($data: SubscriptionProductGiftCardCreate!) {
  subscriptionProductGiftCardCreate(data: $data) {
    id
    code
  }
}
    `;
export const SupportTicketCreate = gql`
    mutation SupportTicketCreate($data: SupportTicketCreate!) {
  supportTicketCreate(data: $data) {
    success
  }
}
    `;
export const TrinityEComCreateCheckout = gql`
    mutation TrinityEComCreateCheckout($postCode: String!, $cartItems: [TrinityEComCartItem]!, $country: SupportedCountries!) {
  trinityEComCreateCheckout(
    postCode: $postCode
    cartItems: $cartItems
    country: $country
  ) {
    checkoutToken
    paymentMode
    totalSum
    paymentServiceContainer {
      serviceType
      embeddedCheckoutHtmlSnippet
      externalRedirectUrl
      errorMessage
      paymentReferenceCode
      methodType
      properties {
        clientId
      }
    }
    deliveryCheckoutServiceConfiguration {
      id
      postCode
      postCodeIsValid
      options {
        id
        name
        title
        description
        sku
        agentId
        deliveryInterval
        price
        vatPercent
        imageUrl
        agents {
          id
          name
          address {
            companyName
            recipient
            address1
            address2
            postCode
            city
            country
          }
          mapLatitude
          mapLongitude
          phone
          estimatedDeliveryDate
        }
      }
    }
    deliveryCheckoutVendor
    paymentTypes {
      paymentTypeId
      vendor
      name
      description
      shortDescription
      logoImageUrl
      supportsZeroSum
    }
    shoppingCart {
      id
      token
      totalQuantity
    }
  }
}
    `;
export const TrinityEComCreateCheckoutPayPal = gql`
    mutation TrinityEComCreateCheckoutPayPal($token: String!, $country: SupportedCountries!, $customerEmail: String!, $customerTelephone: String!, $customerBillingAddress: TrinityCustomerBillingAddressInput!) {
  trinityEComCreateCheckoutPayPal(
    token: $token
    country: $country
    customerEmail: $customerEmail
    customerTelephone: $customerTelephone
    customerBillingAddress: $customerBillingAddress
  ) {
    checkoutToken
    paymentMode
    totalSum
    paymentServiceContainer {
      serviceType
      embeddedCheckoutHtmlSnippet
      externalRedirectUrl
      errorMessage
      paymentReferenceCode
      methodType
      properties {
        clientId
      }
    }
    deliveryCheckoutServiceConfiguration {
      id
      postCode
      postCodeIsValid
      options {
        id
        name
        title
        description
        sku
        agentId
        deliveryInterval
        price
        vatPercent
        imageUrl
        agents {
          id
          name
          address {
            companyName
            recipient
            address1
            address2
            postCode
            city
            country
          }
          mapLatitude
          mapLongitude
          phone
          estimatedDeliveryDate
        }
      }
    }
    deliveryCheckoutVendor
    paymentTypes {
      paymentTypeId
      vendor
      name
      description
      shortDescription
      logoImageUrl
      supportsZeroSum
    }
    shoppingCart {
      id
      token
      totalQuantity
    }
  }
}
    `;
export const TrinityEComUpdateCheckoutDeliveryOption = gql`
    mutation TrinityEComUpdateCheckoutDeliveryOption($token: String!, $selectedDeliveryOptionId: String!, $selectedAgentId: String, $country: SupportedCountries!, $configurationId: String!, $vendor: Int!) {
  trinityEComUpdateCheckoutDeliveryOption(
    token: $token
    deliveryOptionId: $selectedDeliveryOptionId
    agentId: $selectedAgentId
    country: $country
    configurationId: $configurationId
    vendor: $vendor
  ) {
    checkoutToken
    paymentMode
    totalSum
    paymentServiceContainer {
      serviceType
      embeddedCheckoutHtmlSnippet
      externalRedirectUrl
      errorMessage
      paymentReferenceCode
      methodType
      properties {
        clientId
      }
    }
    deliveryCheckoutServiceConfiguration {
      id
      postCode
      postCodeIsValid
      options {
        id
        name
        title
        description
        sku
        agentId
        deliveryInterval
        price
        vatPercent
        imageUrl
        agents {
          id
          name
          address {
            companyName
            recipient
            address1
            address2
            postCode
            city
            country
          }
          mapLatitude
          mapLongitude
          phone
          estimatedDeliveryDate
        }
      }
    }
    deliveryCheckoutVendor
    paymentTypes {
      paymentTypeId
      vendor
      name
      description
      shortDescription
      logoImageUrl
      supportsZeroSum
    }
    shoppingCart {
      id
      token
      totalQuantity
    }
  }
}
    `;
export const TrinityEComUpdateCheckoutDeliveryOptionsPostCode = gql`
    mutation TrinityEComUpdateCheckoutDeliveryOptionsPostCode($token: String!, $postCode: String!, $country: SupportedCountries!, $vendor: Int!) {
  trinityEComUpdateCheckoutDeliveryOptionsPostCode(
    token: $token
    postCode: $postCode
    country: $country
    vendor: $vendor
  ) {
    deliveryCheckoutServiceConfiguration {
      id
      postCode
      postCodeIsValid
      options {
        id
        name
        title
        description
        sku
        agentId
        deliveryInterval
        price
        vatPercent
        imageUrl
        agents {
          id
          name
          address {
            companyName
            recipient
            address1
            address2
            postCode
            city
            country
          }
          mapLatitude
          mapLongitude
          phone
          estimatedDeliveryDate
        }
      }
    }
  }
}
    `;
export const TrinityEComUpdateCheckoutPaymentType = gql`
    mutation TrinityEComUpdateCheckoutPaymentType($token: String!, $country: SupportedCountries!, $paymentTypeId: Int!) {
  trinityEComUpdateCheckoutPaymentType(
    token: $token
    country: $country
    paymentTypeId: $paymentTypeId
  ) {
    checkoutToken
    paymentMode
    totalSum
    paymentServiceContainer {
      serviceType
      embeddedCheckoutHtmlSnippet
      externalRedirectUrl
      errorMessage
      paymentReferenceCode
      methodType
      properties {
        clientId
      }
    }
    deliveryCheckoutServiceConfiguration {
      id
      postCode
      postCodeIsValid
      options {
        id
        name
        title
        description
        sku
        agentId
        deliveryInterval
        price
        vatPercent
        imageUrl
        agents {
          id
          name
          address {
            companyName
            recipient
            address1
            address2
            postCode
            city
            country
          }
          mapLatitude
          mapLongitude
          phone
          estimatedDeliveryDate
        }
      }
    }
    deliveryCheckoutVendor
    paymentTypes {
      paymentTypeId
      vendor
      name
      description
      shortDescription
      logoImageUrl
      supportsZeroSum
    }
    shoppingCart {
      id
      token
      totalQuantity
    }
  }
}
    `;
export const UserCreate = gql`
    mutation UserCreate($company: ID, $userPlatformConnectionToken: String, $defaultLocation: ID, $userData: UserCreate!, $ref: String) {
  userCreate(
    userData: $userData
    company: $company
    userPlatformConnectionToken: $userPlatformConnectionToken
    defaultLocation: $defaultLocation
    ref: $ref
  ) {
    id
  }
}
    `;
export const UserDelete = gql`
    mutation UserDelete($id: ID) {
  userDelete(id: $id) {
    success
  }
}
    `;
export const UserUpdate = gql`
    mutation UserUpdate($data: UserUpdate!, $user: ID) {
  userUpdate(data: $data, user: $user) {
    id
  }
}
    `;
export const AgreementCreate = gql`
    mutation AgreementCreate($data: AgreementCreate!) {
  agreementCreate(data: $data) {
    id
  }
}
    `;
export const AgreementUpdate = gql`
    mutation AgreementUpdate($agreement: ID!, $data: AgreementUpdate!) {
  agreementUpdate(agreement: $agreement, data: $data) {
    id
  }
}
    `;
export const UserAcceptAgreements = gql`
    mutation UserAcceptAgreements($acceptedAgreements: [ID!]!, $declinedAgreements: [ID!]!) {
  userAcceptAgreements(
    acceptedAgreements: $acceptedAgreements
    declinedAgreements: $declinedAgreements
  ) {
    id
  }
}
    `;
export const UserAgreementAcceptUpdatedAgreements = gql`
    mutation UserAgreementAcceptUpdatedAgreements {
  userAgreementAcceptUpdatedAgreements {
    id
  }
}
    `;
export const UserGroupAddAutomaticSubscriptionProduct = gql`
    mutation UserGroupAddAutomaticSubscriptionProduct($userGroup: ID!, $subscriptionProduct: ID!) {
  userGroupAddAutomaticSubscriptionProduct(
    userGroup: $userGroup
    subscriptionProduct: $subscriptionProduct
  ) {
    id
  }
}
    `;
export const UserGroupAddPointAccount = gql`
    mutation UserGroupAddPointAccount($userGroup: ID!) {
  userGroupAddPointAccount(userGroup: $userGroup) {
    id
  }
}
    `;
export const UserGroupAddUsers = gql`
    mutation UserGroupAddUsers($userGroup: ID!, $users: [ID!]!) {
  userGroupAddUsers(userGroup: $userGroup, users: $users) {
    id
  }
}
    `;
export const UserGroupCreate = gql`
    mutation UserGroupCreate($data: UserGroupCreate!) {
  userGroupCreate(data: $data) {
    id
  }
}
    `;
export const UserGroupDelete = gql`
    mutation UserGroupDelete($id: ID!) {
  userGroupDelete(id: $id)
}
    `;
export const UserGroupRemoveAutomaticSubscriptionProduct = gql`
    mutation UserGroupRemoveAutomaticSubscriptionProduct($userGroup: ID!) {
  userGroupRemoveAutomaticSubscriptionProduct(userGroup: $userGroup) {
    id
  }
}
    `;
export const UserGroupRemovePointAccount = gql`
    mutation UserGroupRemovePointAccount($userGroup: ID!) {
  userGroupRemovePointAccount(userGroup: $userGroup) {
    id
  }
}
    `;
export const UserGroupRemoveUsers = gql`
    mutation UserGroupRemoveUsers($userGroup: ID!, $users: [ID!]!) {
  userGroupRemoveUsers(userGroup: $userGroup, users: $users) {
    id
  }
}
    `;
export const UserGroupUpdate = gql`
    mutation UserGroupUpdate($id: ID!, $data: UserGroupUpdate!) {
  userGroupUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const UserGroupAdminAdd = gql`
    mutation UserGroupAdminAdd($userGroup: ID!, $user: ID!) {
  userGroupAdminAdd(userGroup: $userGroup, user: $user) {
    id
  }
}
    `;
export const UserGroupAdminRemove = gql`
    mutation UserGroupAdminRemove($userGroup: ID!, $user: ID!) {
  userGroupAdminRemove(userGroup: $userGroup, user: $user) {
    id
  }
}
    `;
export const UserPlatformConnectionCreate = gql`
    mutation UserPlatformConnectionCreate($userAuthToken: String, $userPlatformConnectionToken: String, $location: ID) {
  userPlatformConnectionCreate(
    userAuthToken: $userAuthToken
    userPlatformConnectionToken: $userPlatformConnectionToken
    location: $location
  ) {
    id
  }
}
    `;
export const UserPlatformConnectionCreateMultiple = gql`
    mutation UserPlatformConnectionCreateMultiple($data: UserPlatformConnectionCreateMultiple!) {
  UserPlatformConnectionCreateMultiple(data: $data) {
    success
  }
}
    `;
export const UserPlatformConnectionDelete = gql`
    mutation UserPlatformConnectionDelete($id: ID!) {
  userPlatformConnectionDelete(id: $id) {
    success
  }
}
    `;
export const UserPlatformConnectionTokenCreate = gql`
    mutation UserPlatformConnectionTokenCreate($data: UserPlatformConnectionTokenCreate!) {
  userPlatformConnectionTokenCreate(data: $data) {
    ... on UserPlatformConnectionToken {
      id
    }
    ... on UserPlatformConnection {
      id
    }
  }
}
    `;
export const UserPlatformConnectionTokenDelete = gql`
    mutation UserPlatformConnectionTokenDelete($id: ID!) {
  userPlatformConnectionTokenDelete(id: $id) {
    success
  }
}
    `;
export const UserProductSubscriptionCancel = gql`
    mutation UserProductSubscriptionCancel($userProductSubscription: ID!, $cancelImmediately: Boolean, $refundLatestPayment: Boolean, $deleteBookings: Boolean) {
  userProductSubscriptionCancel(
    userProductSubscription: $userProductSubscription
    cancelImmediately: $cancelImmediately
    refundLatestPayment: $refundLatestPayment
    deleteBookings: $deleteBookings
  ) {
    id
  }
}
    `;
export const UserProductSubscriptionCanceleByAdmin = gql`
    mutation UserProductSubscriptionCanceleByAdmin($userProductSubscription: ID!, $deleteBookings: Boolean) {
  userProductSubscriptionCanceleByAdmin(
    userProductSubscription: $userProductSubscription
    deleteBookings: $deleteBookings
  ) {
    id
  }
}
    `;
export const UserProductSubscriptionCreateByAdmin = gql`
    mutation UserProductSubscriptionCreateByAdmin($subscriptionProduct: ID!, $user: ID!, $endDate: DateTime, $shouldBePaidSubscription: Boolean) {
  userProductSubscriptionCreateByAdmin(
    subscriptionProduct: $subscriptionProduct
    user: $user
    endDate: $endDate
    shouldBePaidSubscription: $shouldBePaidSubscription
  ) {
    id
  }
}
    `;
export const UserProductSubscriptionReactivate = gql`
    mutation UserProductSubscriptionReactivate($userProductSubscription: ID!) {
  userProductSubscriptionReactivate(
    userProductSubscription: $userProductSubscription
  ) {
    success
  }
}
    `;
export const UserProductSubscriptionsToExcel = gql`
    mutation UserProductSubscriptionsToExcel($filtering: UserProductSubscriptionsFiltering) {
  userProductSubscriptionsToExcel(filtering: $filtering)
}
    `;
export const WannasportConnectionChangePossibleTimeSlots = gql`
    mutation WannasportConnectionChangePossibleTimeSlots($wannasportConnection: ID!, $timeSlots: [WannasportPossibleTimeSlotInput]!) {
  wannasportConnectionChangePossibleTimeSlots(
    wannasportConnection: $wannasportConnection
    timeSlots: $timeSlots
  ) {
    id
  }
}
    `;
export const WannasportConnectionCreate = gql`
    mutation WannasportConnectionCreate($data: WannasportConnectionCreate!) {
  wannasportConnectionCreate(data: $data) {
    token
    wannasportConnection {
      id
    }
  }
}
    `;
export const WorkshopBookingCancel = gql`
    mutation WorkshopBookingCancel($workshopBooking: ID!, $refundPayment: Boolean) {
  workshopBookingCancel(
    workshopBooking: $workshopBooking
    refundPayment: $refundPayment
  ) {
    id
    status
  }
}
    `;
export const WorkshopCancele = gql`
    mutation WorkshopCancele($id: ID!) {
  workshopCancele(id: $id) {
    id
  }
}
    `;
export const WorkshopCreate = gql`
    mutation WorkshopCreate($data: WorkshopCreate!) {
  workshopCreate(data: $data) {
    id
  }
}
    `;
export const WorkshopUpdate = gql`
    mutation WorkshopUpdate($id: ID!, $data: WorkshopUpdate!) {
  workshopUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const WorkshopBookingCreateAdmin = gql`
    mutation WorkshopBookingCreateAdmin($users: [ID!]!, $workshop: ID!) {
  workshopBookingCreateAdmin(users: $users, workshop: $workshop) {
    id
  }
}
    `;
export const WorkshopDayCreate = gql`
    mutation WorkshopDayCreate($workshop: ID!, $data: WorkshopDayCreate!) {
  workshopDayCreate(workshop: $workshop, data: $data) {
    id
  }
}
    `;
export const WorkshopDayDelete = gql`
    mutation WorkshopDayDelete($id: ID!) {
  workshopDayDelete(id: $id) {
    id
  }
}
    `;
export const WorkshopDayUpdate = gql`
    mutation WorkshopDayUpdate($id: ID!, $data: WorkshopDayUpdate!) {
  workshopDayUpdate(id: $id, data: $data) {
    id
  }
}
    `;
export const WorkshopWaitlistCancel = gql`
    mutation WorkshopWaitlistCancel($workshop: ID!) {
  workshopWaitlistCancel(workshopId: $workshop) {
    success
  }
}
    `;
export const WorkshopWaitlistJoin = gql`
    mutation WorkshopWaitlistJoin($workshop: ID!) {
  workshopWaitlistJoin(workshop: $workshop) {
    id
  }
}
    `;
export const GetRanglistenSignUpLink = gql`
    query getRanglistenSignUpLink($userId: ID!, $locationId: ID!, $userFirstName: String!, $userLastName: String!) {
  ranglisten(
    userId: $userId
    locationId: $locationId
    userFirstName: $userFirstName
    userLastName: $userLastName
  ) {
    signUpLink
  }
}
    `;
export const GetAccessCode = gql`
    query GetAccessCode($id: ID!) {
  accessCode(id: $id) {
    id
    name
    pinCode
    cardCode
    createdAt
    usedCount
    latestSyncAt
    type
    createdByUser {
      id
      name
    }
    user {
      id
      name
    }
    fullAccessToDoors {
      id
      name
    }
    fullAccessToDoorGroups {
      id
      name
      doors {
        id
        name
      }
    }
    controllerUnitAccessCodes {
      id
      startDate
      endDate
      activatedOnUnitAt
      status
      doors {
        id
        name
      }
      controllerUnit {
        id
        location {
          id
          name
        }
      }
      syncedToControllerUnit
    }
  }
}
    `;
export const GetAccessCodes = gql`
    query GetAccessCodes($pagination: PaginationInput, $filtering: AccessCodesFiltering) {
  accessCodes(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      name
      pinCode
    }
  }
}
    `;
export const GetMyAccessCode = gql`
    query GetMyAccessCode {
  myAccessCode {
    id
  }
}
    `;
export const GetAccessCodeAccessTimes = gql`
    query GetAccessCodeAccessTimes($accessCode: ID!) {
  accessCodeAccessTimes(accessCode: $accessCode) {
    data {
      id
      startDate
      endDate
      createdAt
      resourceBookingAttendee {
        id
        resourceBooking {
          id
        }
      }
      resourceBooking {
        id
      }
      doors {
        id
        name
      }
      doorGroups {
        id
        name
      }
      workshopDay {
        id
        workshop {
          id
        }
      }
    }
  }
}
    `;
export const AccessCodeUsages = gql`
    query AccessCodeUsages($pagination: PaginationInput, $filtering: AccessCodeUsagesFiltering) {
  accessCodeUsages(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      createdAt
      door {
        id
        name
        controller {
          id
          location {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const GetAdditionalService = gql`
    query GetAdditionalService($id: ID!) {
  additionalService(additionalServiceId: $id) {
    id
    name
    hidden
    product {
      description
    }
  }
}
    `;
export const GetAdditionalServiceReservation = gql`
    mutation GetAdditionalServiceReservation($additionalServiceId: ID!, $resourceBookingStartDate: String!, $resourceBookingEndDate: String!) {
  additionalService(
    additionalServiceId: $additionalServiceId
    resourceBookingStartDate: $resourceBookingStartDate
    resourceBookingEndDate: $resourceBookingEndDate
  )
}
    `;
export const GetAdditionalServices = gql`
    query GetAdditionalServices($companyId: String, $resourceCategoryId: String) {
  additionalServices(
    companyId: $companyId
    resourceCategoryId: $resourceCategoryId
  ) {
    id
    name
    capacity
    additionalInfoRequired
    additionalInfo
    hidden
    product {
      price
      description
    }
    resourceCategory {
      id
      name
    }
  }
}
    `;
export const GetScriptableIntegrationCode = gql`
    query GetScriptableIntegrationCode {
  scriptableIntegrationCode
}
    `;
export const GetAnalyticBookingSlots = gql`
    query GetAnalyticBookingSlots($data: AnalyticBookingSlots!) {
  analyticBookingSlots(data: $data) {
    x
    y
  }
}
    `;
export const GetAnalyticCompanySinceCreatedAt = gql`
    query GetAnalyticCompanySinceCreatedAt {
  analyticCompanySinceCreatedAt {
    for
    result
  }
}
    `;
export const GetAnalyticSmart = gql`
    query GetAnalyticSmart($datePeriodStart: DateTime!, $datePeriodEnd: DateTime!) {
  analyticSmart(datePeriodStart: $datePeriodStart, datePeriodEnd: $datePeriodEnd) {
    for
    result
  }
}
    `;
export const GetAuthPlacesForSignIn = gql`
    query GetAuthPlacesForSignIn {
  authPlacesForSignIn {
    id
    company {
      id
      name
      streetName
      zipCode
      city
      currency
    }
    role
    niceRole
    franchise {
      id
      name
      streetName
      zipCode
      city
      currency
    }
  }
}
    `;
export const GetAuthPlacesForSignUp = gql`
    query GetAuthPlacesForSignUp {
  authPlacesForSignUp {
    ... on CompanyForSignUp {
      isCompany
      id
      name
      streetName
      zipCode
      locations {
        id
        name
        streetName
        zipCode
        city
      }
    }
    ... on FranchiseForSignUp {
      isFranchise
      id
      name
      streetName
      zipCode
      locations {
        id
        name
        streetName
        zipCode
        city
        company {
          id
        }
      }
    }
  }
}
    `;
export const GetUserPlatformConnectionTokenData = gql`
    query GetUserPlatformConnectionTokenData($token: String!) {
  userPlatformConnectionTokenData(token: $token) {
    id
    email
  }
}
    `;
export const GetAuthUrlSlugData = gql`
    query GetAuthUrlSlugData($slug: String!) {
  authUrlSlugData(slug: $slug) {
    ... on Franchise {
      id
      name
    }
    ... on Company {
      id
      name
    }
  }
}
    `;
export const GetUserUsingPasswordV2 = gql`
    query GetUserUsingPasswordV2 {
  me {
    user {
      id
      usingPasswordV2
    }
  }
}
    `;
export const GetBookings = gql`
    query GetBookings($filtering: BookingsFiltering) {
  bookings(filtering: $filtering) {
    ... on ResourceBooking {
      id
      startDate
      endDate
      resource {
        id
        name
        type {
          id
          name
        }
        location {
          id
          name
          streetName
          zipCode
          city
        }
      }
    }
    ... on WorkshopBooking {
      id
      workshop {
        id
        title
        location {
          id
          name
          streetName
          zipCode
          city
        }
        days {
          id
          title
          startDate
          endDate
        }
      }
    }
  }
}
    `;
export const GetBookingsForUserCalendar = gql`
    query GetBookingsForUserCalendar($filtering: BookingsFiltering) {
  bookings(filtering: $filtering) {
    ... on ResourceBooking {
      id
      startDate
    }
    ... on WorkshopBooking {
      id
      workshop {
        id
        days {
          id
          startDate
        }
      }
    }
  }
}
    `;
export const GetBookliSound = gql`
    query GetBookliSound($id: ID!) {
  bookliSound(id: $id) {
    id
    youtubePlayId
    play
    volume
  }
}
    `;
export const GetBookliCameras = gql`
    query GetBookliCameras($filtering: BookliCamerasFiltering) {
  bookliCameras(filtering: $filtering) {
    data {
      milestoneWebClientCamUrl
      name
      stillImageUrl
    }
  }
}
    `;
export const GetBookliCamerasLocationMilestoneView = gql`
    query GetBookliCamerasLocationMilestoneView($id: ID!) {
  location(id: $id) {
    id
    bookliCameraServer {
      id
      milestoneClientUrl
      milestoneServerUrl
      milestoneServerUsername
      milestoneServerPassword
      cameras {
        id
        name
        milestoneCameraId
        stillImageUrl
      }
    }
  }
}
    `;
export const GetBookliDeviceGetLink = gql`
    query GetBookliDeviceGetLink {
  bookliDeviceGetLink
}
    `;
export const GetBookliDevices = gql`
    query GetBookliDevices {
  bookliDevices {
    data {
      id
    }
  }
}
    `;
export const GetLocationForScreen = gql`
    query GetLocationForScreen($id: ID!) {
  location(id: $id) {
    id
    name
    overviewSvgImageUrl
    company {
      id
      logoUrl
      phoneNumber
    }
  }
}
    `;
export const GetResourcesForScreen = gql`
    query GetResourcesForScreen($filtering: ResourcesFiltering) {
  resources(filtering: $filtering) {
    data {
      id
      name
      logoUrl
      currentBooking {
        id
        startDate
        endDate
        workshopDay {
          id
          workshop {
            id
            title
          }
        }
        owner {
          id
          firstName
          lastName
        }
      }
      nextBooking {
        id
        startDate
        endDate
        workshopDay {
          id
          workshop {
            id
            title
          }
        }
        owner {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const GetWorkshopsForScreen = gql`
    query GetWorkshopsForScreen($filtering: WorkshopsFiltering) {
  workshops(filtering: $filtering) {
    data {
      id
      title
      lastRegistrationDate
      maxRegistrations
      type
      bookingsCount
      nextDay {
        id
        startDate
        endDate
      }
      days {
        id
        title
        startDate
        endDate
      }
      product {
        id
        price
      }
    }
  }
}
    `;
export const GetBookliVideo = gql`
    query GetBookliVideo($id: ID!) {
  bookliVideo(id: $id) {
    id
    videoReadyAt
    streamUrl
    state
    type
    downloadUrl
  }
}
    `;
export const GetBookliVideoMain = gql`
    query GetBookliVideoMain($id: ID!) {
  bookliVideo(id: $id) {
    id
    subClips {
      id
    }
  }
}
    `;
export const GetCompaniesForSignUp = gql`
    query GetCompaniesForSignUp {
  companies(filtering: {allowSignUps: true}) {
    data {
      id
      name
    }
  }
}
    `;
export const GetCompanies = gql`
    query GetCompanies($pagination: PaginationInput, $filtering: CompaniesFiltering) {
  companies(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      slug
      name
      phoneNumber
      locations {
        id
      }
      franchise {
        id
        name
      }
    }
  }
}
    `;
export const GetCompaniesAnalytic = gql`
    query GetCompaniesAnalytic($fromDate: DateTime!, $toDate: DateTime!) {
  companies {
    data {
      id
      name
      analyticApplicationFee(fromDate: $fromDate, toDate: $toDate) {
        sum
        avgPrResource
      }
      analyticPaymentRevenue(fromDate: $fromDate, toDate: $toDate) {
        sum
        avgPrResource
      }
      analyticUsers(fromDate: $fromDate, toDate: $toDate) {
        sum
        avgPrResource
      }
    }
  }
}
    `;
export const GetCompaniesForPriceff = gql`
    query GetCompaniesForPriceff($pagination: PaginationInput, $filtering: CompaniesFiltering) {
  companies(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      slug
      name
      resourceTypes {
        id
        name
        priceffGearing
        priceffGeneratedPricesTo
        usePriceffDynamicPricing
        standardPriceA {
          id
          price
        }
        standardPriceB {
          id
          price
        }
        priceffModel {
          id
        }
      }
    }
  }
}
    `;
export const GetCompany = gql`
    query GetCompany($id: ID!) {
  company(id: $id) {
    id
    name
    streetName
    email
    currency
    timezone
    locations {
      id
      name
      streetName
      zipCode
      city
    }
  }
}
    `;
export const GetAppBackgrundImage = gql`
    query GetAppBackgrundImage {
  me {
    appBackgroundImageUrl
  }
}
    `;
export const GetCompanyAppImages = gql`
    query GetCompanyAppImages {
  companySettings {
    userHomeAdSpace1ImgUrl
    userHomeAdSpace1Link
    appBackgroundImageUrl
  }
}
    `;
export const GetCompanyCreateInvitationData = gql`
    query GetCompanyCreateInvitationData($token: String!) {
  companyCreateInvitationData(token: $token) {
    id
    createFranchise
    connectToFranchise
  }
}
    `;
export const GetCompanyCreateInvitations = gql`
    query GetCompanyCreateInvitations($filtering: CompanyCreateInvitationsFiltering) {
  companyCreateInvitations(filtering: $filtering) {
    data {
      id
      email
      createdAt
      createFranchise
      connectToFranchise
      token
    }
  }
}
    `;
export const GetCompanyDefaultMessages = gql`
    query GetCompanyDefaultMessages {
  companySettings {
    messageUserWelcome
    messageResourceBookingCreated
    messagePointBuy
    messageResourceBookingReminder
  }
}
    `;
export const GetCompanyLanguage = gql`
    query GetCompanyLanguage($id: ID!) {
  companyLanguage(id: $id) {
    language
  }
}
    `;
export const GetCompanyLogo = gql`
    query GetCompanyLogo {
  me {
    company {
      id
      logoUrl
    }
  }
}
    `;
export const GetCompanyPrimaryColor = gql`
    query GetCompanyPrimaryColor {
  companySettings {
    primaryColor
  }
}
    `;
export const GetCompanyBasics = gql`
    query GetCompanyBasics($id: ID) {
  company(id: $id) {
    id
    name
    slug
    email
    phoneNumber
    streetName
    zipCode
    owner {
      id
      user {
        id
        name
      }
    }
  }
}
    `;
export const GetCompanyEssentials = gql`
    query GetCompanyEssentials($id: ID!) {
  company(id: $id) {
    id
    name
  }
}
    `;
export const GetControllerDoorLogs = gql`
    query GetControllerDoorLogs($controllerUnitId: ID!) {
  controllerDoorLogs(controllerUnitId: $controllerUnitId) {
    createdAt
    changedBy
    newState
    door {
      id
      name
    }
  }
}
    `;
export const GetControllerDoors = gql`
    query GetControllerDoors($filtering: ControllerDoorsFiltering) {
  controllerDoors(filtering: $filtering) {
    data {
      id
      name
      defaultOpenSeconds
      noxAreaDoorId
    }
  }
}
    `;
export const GetControllerDoorGroups = gql`
    query GetControllerDoorGroups {
  controllerDoorGroups {
    data {
      id
      name
      doors {
        id
      }
    }
  }
}
    `;
export const GetControllerNoxAreas = gql`
    query GetControllerNoxAreas($controllerUnit: ID!) {
  controllerNoxAreas(controllerUnit: $controllerUnit) {
    areaId
    name
    areaStateId
    allowedAreaStates
    areasLastUpdatedAt
  }
}
    `;
export const GetControllerNoxTimeprofiles = gql`
    query GetControllerNoxTimeprofiles($controllerUnitUrl: String!) {
  controllerNoxTimeprofiles(controllerUnitUrl: $controllerUnitUrl) {
    noxTimeprofileId
    noxTimeprofileName
  }
}
    `;
export const GetControllerOnOffLogs = gql`
    query GetControllerOnOffLogs($controllerUnitId: ID!) {
  controllerOnOffLogs(controllerUnitId: $controllerUnitId) {
    newState
    changedBy
    createdAt
    controllerOnOff {
      id
      noxAreaId
      resource {
        id
        name
      }
    }
  }
}
    `;
export const GetControllerOnOffStatuses = gql`
    query GetControllerOnOffStatuses($controller: String) {
  controllerOnOffStatuses(controller: $controller) {
    id
    changedBy
    state
  }
}
    `;
export const GetControllerUnit = gql`
    query GetControllerUnit($location: ID!) {
  controllerUnit(location: $location) {
    id
    url
    noxVersion
  }
}
    `;
export const ControllerUnitUpdate = gql`
    mutation ControllerUnitUpdate($controllerId: ID!, $data: ControllerUnitUpdate!) {
  controllerUnitUpdate(controllerId: $controllerId, data: $data) {
    id
  }
}
    `;
export const GetControllerUnits = gql`
    query GetControllerUnits($filtering: ControllerUnitsFiltering) {
  controllerUnits(filtering: $filtering) {
    data {
      id
      location {
        id
        name
      }
      isOnline
    }
  }
}
    `;
export const GetCoupon = gql`
    query GetCoupon($id: ID!, $fromDate: DateTime, $toDate: DateTime) {
  coupon(id: $id) {
    id
    createdAt
    active
    maximumUsages
    maximumUsagesPrCustomer
    maximumUsagesPrCustomerPrMonth
    percentOff
    amountOff
    bookingHoursOff
    slug
    type
    mode
    endDate
    resourceBookingEndDateAfter
    resourceBookingEndDateBefore
    maximumResourceBookingHoursPrMonthUsage
    discountIsOnlyForBuyer
    usagesCount(fromDate: $fromDate, toDate: $toDate)
    totalUsedDiscountAmount(fromDate: $fromDate, toDate: $toDate)
    resourceBookingTimeRanges {
      id
      startTime
      endTime
      days
    }
    onlyForUserGroups {
      id
      name
    }
    subscriptionProductCoupon {
      id
      name
    }
    subscriptionProductCouponEvents {
      id
      name
    }
  }
}
    `;
export const GetCouponGetUserAutoCoupons = gql`
    query GetCouponGetUserAutoCoupons($amountToPay: Float!, $couponPurchaseDetails: CouponPurchaseDetails) {
  couponGetUserAutoCoupons(
    amountToPay: $amountToPay
    couponPurchaseDetails: $couponPurchaseDetails
  ) {
    amountWithCoupon
    amountWithoutCoupon
    coupon {
      id
      slug
    }
  }
}
    `;
export const GetCouponIsValid = gql`
    query GetCouponIsValid($couponSlug: String!, $couponPurchaseDetails: CouponPurchaseDetails!) {
  couponIsValid(
    couponSlug: $couponSlug
    couponPurchaseDetails: $couponPurchaseDetails
  )
}
    `;
export const GetCouponUsages = gql`
    query GetCouponUsages($filtering: CouponUseagesFiltering, $pagination: PaginationInput) {
  couponUsages(filtering: $filtering, pagination: $pagination) {
    hasMore
    totalCount
    data {
      id
      createdAt
      discountAmount
      payment {
        id
        paymentMethod
      }
      user {
        id
        name
      }
    }
  }
}
    `;
export const GetCoupons = gql`
    query GetCoupons($pagination: PaginationInput) {
  coupons(pagination: $pagination) {
    hasMore
    totalCount
    data {
      id
      maximumUsages
      active
      slug
      type
      maximumUsagesPrCustomer
      maximumUsages
      amountOff
      percentOff
      endDate
      mode
      bookingHoursOff
      resourceBookingTimeRanges {
        id
        startTime
        endTime
        days
      }
    }
  }
}
    `;
export const UserHasFcmToken = gql`
    query UserHasFcmToken {
  userHasFcmToken
}
    `;
export const GetFranchiseLogo = gql`
    query GetFranchiseLogo {
  me {
    franchise {
      id
      logoUrl
    }
  }
}
    `;
export const GetFriends = gql`
    query GetFriends($filtering: FriendsFiltering) {
  friends(filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      name
      firstName
      lastName
    }
  }
}
    `;
export const GetFriendsPossibleToAdd = gql`
    query GetFriendsPossibleToAdd($search: String!) {
  friendsPossibleToAdd(search: $search) {
    data {
      id
      name
      isFriends
    }
  }
}
    `;
export const GetGiftCards = gql`
    query GetGiftCards($pagination: PaginationInput) {
  giftCards(pagination: $pagination) {
    data {
      id
      createdAt
      updatedAt
      code
      pointsAmount
      createdBy {
        id
        name
      }
      usedBy {
        id
        name
      }
      expiryDate
    }
    totalCount
    hasMore
  }
}
    `;
export const GetSignedUrl = gql`
    query GetSignedUrl($fileName: String!) {
  signedUrl(fileName: $fileName)
}
    `;
export const GetLocation = gql`
    query GetLocation($id: ID!) {
  location(id: $id) {
    id
    name
    nameShort
    logoImageUrl
    userWelcomeMessage
    userWelcomeMessageLastUpdated
    company {
      id
      name
      country
      pointAccountUsingFranchise
      userPlatformConnection(prefereUserRole: true) {
        id
      }
      franchise {
        id
        name
      }
    }
  }
}
    `;
export const GetLocationAdmin = gql`
    query GetLocationAdmin($id: ID!) {
  location(id: $id) {
    id
    streetName
    zipCode
    name
    city
    bookliCameraServer {
      id
      milestoneServerUrl
    }
    resources {
      id
      name
      camera {
        id
      }
      lightController {
        id
        noxAreaId
        onOffTimeprofile {
          id
          noxTimeprofileId
        }
      }
    }
    controllerUnit {
      id
      url
      type
      noxVersion
      isOnline
      doorControllers {
        id
        name
        noxAreaDoorId
        noxAreaDoorName
      }
    }
    bookliNetwork {
      id
    }
    bookliCameras {
      id
      name
      type
      stillImageUrl
      milestoneWebClientCamUrl
      milestoneCameraId
    }
    bookliSounds {
      id
      name
      youtubePlayId
    }
  }
}
    `;
export const LocationChangeUser = gql`
    mutation LocationChangeUser($newLocation: ID!) {
  locationChangeUser(newLocation: $newLocation) {
    changePlatformToken
    location {
      id
    }
    userPlatformConnection
  }
}
    `;
export const GetLocationOverview = gql`
    query GetLocationOverview($id: ID!) {
  location(id: $id) {
    id
    overviewSvg
    overviewSvgImageUrl
    resources {
      id
      logoUrl
      name
      shortName
      currentBooking {
        id
        status
        comments
        owner {
          id
          firstName
        }
      }
    }
  }
}
    `;
export const GetLocationOverviewV2 = gql`
    query GetLocationOverviewV2($id: ID!, $showCurrentBooking: Boolean, $showResourceName: Boolean, $highlightResourceId: String) {
  location(id: $id) {
    id
    overviewSvg(
      showCurrentBooking: $showCurrentBooking
      showResourceName: $showResourceName
      highlightResourceId: $highlightResourceId
    )
  }
}
    `;
export const GetLocationScreenWelcomeMessage = gql`
    query GetLocationScreenWelcomeMessage($location: ID) {
  locationScreenWelcomeMessage(location: $location)
}
    `;
export const GetLocationUserDefault = gql`
    query GetLocationUserDefault {
  locationUserDefault {
    id
    name
    nameShort
    logoImageUrl
    userWelcomeMessage
    userWelcomeMessageLastUpdated
    company {
      id
      name
      currency
      pointAccountUsingFranchise
      userPlatformConnection(prefereUserRole: true) {
        id
      }
      franchise {
        id
        name
      }
    }
  }
}
    `;
export const GetLocations = gql`
    query GetLocations($inFranchise: Boolean, $showAll: Boolean, $pagination: PaginationInput, $filtering: LocationsFiltering) {
  locations(
    inFranchise: $inFranchise
    showAll: $showAll
    pagination: $pagination
    filtering: $filtering
  ) {
    totalCount
    hasMore
    data {
      id
      streetName
      zipCode
      name
      nameShort
      userWelcomeMessage
      city
      screenWelcomeMessage
      lat
      lng
      logoImageUrl
      resourcesCount
      allowSignUps
      company {
        id
      }
    }
  }
}
    `;
export const GetLocationsForSignUp = gql`
    query GetLocationsForSignUp($search: String) {
  locationsForSignUp(search: $search) {
    data {
      id
      streetName
      zipCode
      name
      nameShort
      city
      lat
      lng
      logoImageUrl
      company {
        id
        name
        logoUrl
        country
        mapIconUrl
        franchise {
          id
          name
          logoUrl
        }
      }
    }
  }
}
    `;
export const GetEmailOptions = gql`
    query GetEmailOptions {
  emailOptions {
    id
    name
    description
  }
}
    `;
export const GetMessages = gql`
    query GetMessages($pagination: PaginationInput, $filtering: MessagesFiltering) {
  messages(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      emailOpensCount
      sender {
        id
        firstName
      }
      source
      status
    }
  }
}
    `;
export const GetUserMigrationInformation = gql`
    query getUserMigrationInformation($encryptedData: String!) {
  migration(encryptedData: $encryptedData) {
    userInformation
  }
}
    `;
export const SendMigrationFile = gql`
    mutation SendMigrationFile($fileNameGCP: String!, $messageEmail: String!, $sendToTest: String) {
  sendMigrationFile(
    fileNameGCP: $fileNameGCP
    messageEmail: $messageEmail
    sendToTest: $sendToTest
  )
}
    `;
export const UploadMigrationFile = gql`
    mutation UploadMigrationFile($file: Upload!) {
  uploadMigrationFile(file: $file) {
    fileName
    invalidColumns
  }
}
    `;
export const GetPayPalGetClientData = gql`
    query GetPayPalGetClientData {
  payPalGetClientData {
    clientId
    currency
  }
}
    `;
export const GetPaymentToken = gql`
    query GetPaymentToken($id: ID!) {
  paymentToken(id: $id) {
    id
    state
    failedReason
    amountToPay
    attemptCount
  }
}
    `;
export const GetPayment = gql`
    query GetPayment($id: ID!) {
  payment(id: $id) {
    id
    createdAt
    paymentMethod
    status
    value
    additionalServiceId
    productValue
    additionalServiceValue
    moneyValue
    stripePaymentIntentId
    pointValue
    pointBounty {
      id
      amount
      pointAccountId
    }
    priceffDynamicPriceUsages {
      id
      quantity
      price {
        id
        price
      }
      priceffDynamicPriceResource {
        id
      }
    }
    userProductSubscription {
      id
    }
    stripeInvoiceId
    coupon {
      id
      isUsed
      coupon {
        id
        slug
      }
    }
    pointTransaction {
      id
      pointAccount {
        id
        pointAccountConnectedTo
      }
    }
    connectedPayment {
      id
    }
    connectedPayments {
      id
    }
    product {
      id
      name
      type
    }
    customer {
      id
      name
    }
    productResourceBooking {
      id
      startDate
      endDate
    }
    productPointTransaction {
      id
      pointAccount {
        id
      }
    }
    productWorkshopBooking {
      id
      workshop {
        title
        id
      }
    }
    productUserProductSubscription {
      id
      subscriptionProduct {
        id
        name
      }
    }
  }
}
    `;
export const PaymentCalculatePrice = gql`
    query PaymentCalculatePrice($data: PaymentCalculatePriceInput!) {
  paymentCalculatePrice(data: $data) {
    amountToPay
    amountWithoutCoupon
    amountWithoutRestPoints
    amountWithoutAdditionalServices
    discount
    productId
    validToUseCoupon
    paymentPriceToken
    resourceBookingInfo {
      resourceBookingAttendeesToken
      attendees {
        isUser
        isOwner
        value
        discountValue
        restMoneyValue
        coupon
        messageLines
        user {
          id
          firstName
        }
        userProductSubscription {
          id
        }
      }
    }
    platformFee
  }
}
    `;
export const GetPaymentForRefund = gql`
    query GetPaymentForRefund($id: ID!) {
  payment(id: $id) {
    id
    moneyValue
    paymentMethod
    status
    stripePaymentIntentId
    platformFeeAmount
    additionalServiceValue
    productValue
    pointTransaction {
      id
      amount
    }
    productResourceBooking {
      id
      startDate
      endDate
      status
      additionalService {
        id
        name
      }
    }
    productWorkshopBooking {
      id
      status
      workshop {
        id
        days {
          id
          endDate
        }
      }
    }
    lines {
      type
      value
    }
    connectedPayment {
      paymentMethod
      platformFeeAmount
      productResourceBooking {
        id
      }
      productWorkshopBooking {
        id
      }
      lines {
        type
        value
      }
    }
    connectedPayments {
      paymentMethod
      platformFeeAmount
      productResourceBooking {
        id
      }
      productWorkshopBooking {
        id
      }
      lines {
        type
        value
      }
    }
  }
}
    `;
export const GetPaymentLines = gql`
    query GetPaymentLines($filtering: PaymentLinesFiltering) {
  paymentLines(filtering: $filtering) {
    data {
      id
      value
      type
      createdAt
      accountingLine {
        id
        accountingProgramExternalUrl
        registeredInAccountingProgram
      }
    }
  }
}
    `;
export const PaymentUserAllowedPaymentTypes = gql`
    query PaymentUserAllowedPaymentTypes($paymentPriceToken: String!) {
  paymentUserAllowedPaymentTypes(paymentPriceToken: $paymentPriceToken) {
    paymentTypes {
      paymentType
      paymentMethod
    }
    pointAccounts {
      id
      pointsAmount
      userGroup {
        id
        name
      }
      company {
        id
        name
      }
      franchise {
        id
        name
      }
      removeDiscountToDoPayment
      enoughPointsForPayment
    }
    selectedUserProductSubscription
  }
}
    `;
export const GetPayments = gql`
    query GetPayments($pagination: PaginationInput, $filtering: PaymentsFiltering) {
  payments(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      status
      value
      currency
      moneyValue
      pointValue
      createdAt
      invoiceUrl
      company {
        id
        name
      }
      customer {
        id
        name
      }
      paymentMethod
      connectedPayment {
        id
        productResourceBooking {
          id
        }
      }
      connectedPayments {
        id
        value
        moneyValue
        paymentMethod
        status
        customer {
          id
          firstName
        }
      }
      product {
        id
        name
        type
      }
      productResourceBooking {
        id
        startDate
        endDate
      }
      productPointTransaction {
        id
        pointAccount {
          id
        }
      }
      productWorkshopBooking {
        id
        workshop {
          title
          id
        }
      }
      productUserProductSubscription {
        id
        subscriptionProduct {
          id
          name
        }
      }
    }
  }
}
    `;
export const GetPlatformFees = gql`
    query GetPlatformFees {
  platformFees {
    companies {
      id
      name
      currency
      companySettings {
        id
        companyId
        pointTransactionPlatformFeePercentage
        pointTransactionPlatformStatic
      }
      stripeConnection {
        id
        companyId
        connectedTo
        paymentPlatformFeeStatic
        paymentPlatformFeePercentage
        invoicePaymentPlatformFeeStatic
        invoicePaymentPlatformFeePercentage
        subscriptionPlatformFeePrimaryStatic
        subscriptionPlatformFeePrimaryPercentage
        subscriptionPlarformFeeSecondaryStatic
        subscriptionPlarformFeeSecondaryPercentage
      }
    }
    franchises {
      id
      name
      currency
      franchiseSettings {
        id
        franchiseId
        pointTransactionPlatformFeePercentage
        pointTransactionPlatformStatic
      }
      stripeConnection {
        id
        franchsieId
        connectedTo
        paymentPlatformFeeStatic
        paymentPlatformFeePercentage
        invoicePaymentPlatformFeeStatic
        invoicePaymentPlatformFeePercentage
        subscriptionPlatformFeePrimaryStatic
        subscriptionPlatformFeePrimaryPercentage
        subscriptionPlarformFeeSecondaryStatic
        subscriptionPlarformFeeSecondaryPercentage
      }
    }
  }
}
    `;
export const UpdatePlatformFees = gql`
    mutation UpdatePlatformFees($companySettings: CompanySettingUpdate, $franchiseSettings: FranchiseSettingUpdate, $stripeConnection: StripeConnectionUpdate) {
  platformFeesUpdate(
    companySettings: $companySettings
    franchiseSettings: $franchiseSettings
    stripeConnection: $stripeConnection
  )
}
    `;
export const GetPlatformInvoices = gql`
    query GetPlatformInvoices($pagination: PaginationInput) {
  platformInvoices(pagination: $pagination) {
    totalCount
    hasMore
    data {
      id
      startDate
      endDate
      invoiceNumber
      fileName
    }
  }
}
    `;
export const GetPointAccount = gql`
    query GetPointAccount($user: ID, $company: ID, $id: ID) {
  pointAccount(user: $user, company: $company, id: $id) {
    id
    pointsAmount
    pointAccountConnectedTo
    automaticPointsActive
    automaticAddPointsAmount
    resetPointsOnAutomaticRecharge
    automaticPointsInsertTimesPrYear
    automaticPointsInsertOnTheFirstOfMonth
    accountNumbers {
      pointAmountOtOTrue
      pointAmountOtOFalse
      pointAmountOtOFalseRatio
      pointAmountOtOMixRatio
    }
    user {
      id
      name
    }
    userGroup {
      id
      name
    }
    company {
      id
      name
    }
    franchise {
      id
      name
    }
  }
}
    `;
export const GetPointAccountBasic = gql`
    query GetPointAccountBasic($user: ID, $company: ID, $id: ID) {
  pointAccount(user: $user, company: $company, id: $id) {
    id
    pointsAmount
    userGroup {
      id
      name
    }
    user {
      id
      name
    }
  }
}
    `;
export const GetPointAccountCanUseRestPointsForPayment = gql`
    query GetPointAccountCanUseRestPointsForPayment($product: ID!, $paymentAmount: Float!, $paymentMethod: PaymentMethod!) {
  pointAccountCanUseRestPointsForPayment(
    product: $product
    paymentAmount: $paymentAmount
    paymentMethod: $paymentMethod
  ) {
    canDo
    pointsAmount
    pointAccountId
  }
}
    `;
export const GetPointAccountTransactions = gql`
    query GetPointAccountTransactions($pointAccount: ID!, $pagination: PaginationInput, $filtering: PointAccountTransactionsFiltering) {
  pointAccountTransactions(
    pointAccount: $pointAccount
    pagination: $pagination
    filtering: $filtering
  ) {
    hasMore
    totalCount
    data {
      id
      createdAt
      type
      notes
      platformFeeAmount
      isOneToOne
      valueRatio
      type
      usedOnCompany {
        id
        name
      }
      paymentPointBounty {
        id
      }
      connectedToPaymentLine {
        id
        payment {
          id
        }
      }
      user {
        id
        name
      }
      manualTransactionBy {
        id
        name
      }
      paidWithPoints {
        id
      }
      payment {
        id
      }
      amount
    }
  }
}
    `;
export const GetPointsAnalytic = gql`
    query GetPointsAnalytic {
  analytic {
    pointsTotalAmount
    pointsRatio
  }
}
    `;
export const GetPointProduct = gql`
    query GetPointProduct($id: ID!) {
  pointProduct(id: $id) {
    id
    connectedTo
    pointsAmount
    discountPercent
    product {
      id
      price
    }
  }
}
    `;
export const GetPointProducts = gql`
    query GetPointProducts {
  pointProducts {
    data {
      id
      connectedTo
      pointsAmount
      discountPercent
      title
      order
      product {
        id
        price
      }
    }
  }
}
    `;
export const GetPriceffDynamicPriceResource = gql`
    query GetPriceffDynamicPriceResource($id: ID!) {
  priceffDynamicPriceResource(id: $id) {
    id
    capacityLeft
    createdAt
    maxCapacity
    usagesCount
    pricesCount
    priceffSalesBatchId
    priceffDashboardLink
    parameters {
      id
      name
    }
    dates {
      id
      startDate
      endDate
    }
    currentPrice {
      id
      price
      createdAt
    }
    priceUsageChart
  }
}
    `;
export const PriceffDynamicPriceResourceDatesGrouped = gql`
    query PriceffDynamicPriceResourceDatesGrouped($dateFrom: DateTime!, $dateTo: DateTime!, $resourceType: ID!) {
  priceffDynamicPriceResourceDatesGrouped(
    dateFrom: $dateFrom
    dateTo: $dateTo
    resourceType: $resourceType
  ) {
    date
    dates {
      id
      startDate
      endDate
      dynamicPriceResource {
        id
        capacityLeft
        maxCapacity
        utilizationPercentage
        currentPrice {
          id
          price
          orginalPriceDiff
          toNextLimit
        }
      }
    }
  }
}
    `;
export const GetPriceffModel = gql`
    query GetPriceffModel($id: ID!) {
  priceffModel(id: $id) {
    id
    name
    data {
      startDayOfYear
      endDayOfYear
      daySlots {
        days
        timeSlots {
          startTime
          endTime
          asOneSalesBatch
          priceffParameterId
          priceffParameter {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const GetPriceffModels = gql`
    query GetPriceffModels($pagination: PaginationInput) {
  priceffModels(pagination: $pagination) {
    hasMore
    totalCount
    data {
      id
      name
      data {
        startDayOfYear
        endDayOfYear
        daySlots {
          days
          timeSlots {
            startTime
            endTime
            asOneSalesBatch
            priceffParameterId
            priceffParameter {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const GetPriceffModelsSimple = gql`
    query GetPriceffModelsSimple {
  priceffModels {
    data {
      id
      name
    }
  }
}
    `;
export const GetPriceffParameter = gql`
    query GetPriceffParameter($id: ID!) {
  priceffParameter(id: $id) {
    id
    name
    priceffParameters {
      priceType
      minPriceIndex
      startPriceIndex
      maxPriceIndex
      targetAmountIndex
      acvExpected
      amountRolling
      customProfile
      discovery
      elasticity
      elasticity2
      profile
      round
      roundingOffset
      weight
    }
  }
}
    `;
export const GetPriceffParameters = gql`
    query GetPriceffParameters($pagination: PaginationInput) {
  priceffParameters(pagination: $pagination) {
    hasMore
    totalCount
    data {
      id
      name
    }
  }
}
    `;
export const PriceffResourceTypesForPrices = gql`
    query PriceffResourceTypesForPrices($filtering: ResourceTypesFiltering) {
  resourceTypes(filtering: $filtering) {
    data {
      id
      name
      company {
        id
        name
      }
      priceffModel {
        id
        name
      }
    }
  }
}
    `;
export const GetPriceffAnalyticChart = gql`
    query GetPriceffAnalyticChart($startDate: DateTime!, $endDate: DateTime!, $parameterIds: [ID!], $timeType: ChartTimeType) {
  priceffAnalyticSummaryChart(
    startDate: $startDate
    endDate: $endDate
    parameterIds: $parameterIds
    timeType: $timeType
  ) {
    parameters {
      id
      sales {
        avgIndex
        targetIndex
        chart {
          series {
            value
            data
          }
          categories
        }
      }
      price {
        maxPriceIndex
        minPriceIndex
        orginalPriceIndex
        avgPriceIndex
        chart {
          series {
            value
            data
          }
          categories
        }
      }
      conversions {
        avgProcentage
        chart {
          series {
            value
            data
          }
          categories
        }
      }
    }
  }
}
    `;
export const GetPriceffAnalyticKpi = gql`
    query GetPriceffAnalyticKPI($startDate: DateTime!, $endDate: DateTime!, $parameterIds: [ID!]) {
  priceffAnalyticKPI(
    startDate: $startDate
    endDate: $endDate
    parameterIds: $parameterIds
  ) {
    text
    sales {
      salesCount
      totalRevenue
      avgIndex
      avgDiffPrice
    }
    price {
      avgIndex
      percentageAtMin
      percentageAtMax
    }
  }
}
    `;
export const GetProductForPay = gql`
    query GetProductForPay($id: ID!) {
  product(id: $id) {
    id
    category {
      id
      allowedPaymentMethods
    }
  }
}
    `;
export const ProductVaildForCoupon = gql`
    query ProductVaildForCoupon($id: ID!) {
  product(id: $id) {
    validToUseCoupon
  }
}
    `;
export const GetQuickInfoLocation = gql`
    query GetQuickInfoLocation($id: ID!) {
  location(id: $id) {
    id
    quickInfoUrlFull
  }
}
    `;
export const GetResourceCategories = gql`
    query GetResourceCategories($isPublic: Boolean, $locationId: String) {
  resourceCategories(isPublic: $isPublic, locationId: $locationId) {
    data {
      id
      name
      description
      weekdayOpenTime
      weekendOpenTime
      maxDaysCreateResourceBookingAhead
      maxDaysCreateResourceBookingAheadUser
      durationMinutesIntervals
      defaultDurationMinutes
      company {
        id
        usingPointProducts
      }
    }
  }
}
    `;
export const GetResourceCategoriesFull = gql`
    query GetResourceCategoriesFull {
  resourceCategories {
    data {
      id
      name
      description
      weekdayOpenTime
      weekendOpenTime
      maxMinutsBeforeCancellation
      durationMinutesIntervals
      maxGapIntervalsCount
      bookingsAllowedDurationTimeGaps
      accessMinutsBeforeBooking
      accessMinutesAfterBooking
      maxDaysCreateResourceBookingAhead
      durationIntervalMinutes
      defaultToATime
      popularity
      types {
        id
        name
        description
        popularity
        priceTableAWeekdayTabel
        priceTableAWeekendTabel
        standardPriceA {
          id
          price
        }
        standardPriceB {
          id
          price
        }
        resources {
          id
          name
          shortName
          logoUrl
          popularity
          location {
            id
            name
          }
        }
        prices {
          id
          isActive
          startTime
          endTime
          isUsingDates
          type
          product {
            id
            price
          }
          days
          dates {
            id
            periodStart
            periodEnd
            isActive
          }
        }
      }
    }
  }
}
    `;
export const GetResourceTypes = gql`
    query GetResourceTypes($filtering: ResourceTypesFiltering) {
  resourceTypes(filtering: $filtering) {
    data {
      id
      name
      popularity
      priceTableAWeekdayTabel
      priceTableAWeekendTabel
      standardPriceA {
        id
        price
      }
      standardPriceB {
        id
        price
      }
    }
  }
}
    `;
export const GetResourceTypesPriceff = gql`
    query GetResourceTypesPriceff($filtering: ResourceTypesFiltering) {
  resourceTypes(filtering: $filtering) {
    data {
      id
      name
      usePriceffDynamicPricing
      standardPriceA {
        id
        price
      }
      standardPriceB {
        id
        price
      }
    }
  }
}
    `;
export const GetResourceTypesSimple = gql`
    query GetResourceTypesSimple($filtering: ResourceTypesFiltering) {
  resourceTypes(filtering: $filtering) {
    data {
      id
      name
      popularity
      company {
        id
        name
      }
    }
  }
}
    `;
export const GetResources = gql`
    query GetResources($filtering: ResourcesFiltering) {
  resources(filtering: $filtering) {
    data {
      id
      name
      currentBooking {
        id
        status
        comments
        owner {
          id
          firstName
          name
        }
      }
      lightController {
        id
      }
    }
  }
}
    `;
export const GetResourcesAvailableTimeSchema = gql`
    query GetResourcesAvailableTimeSchema($resourceType: ID!, $location: ID!, $date: DateTime!, $durationMinuts: Int!) {
  resourcesAvailableTimeSchema(
    resourceType: $resourceType
    location: $location
    date: $date
    durationMinuts: $durationMinuts
  ) {
    durationMinuts
    location
    times {
      startDate
      endDate
      price {
        price
        isDynamicPrice
      }
      utcTime
      availableForBooking
      priceWithActiveCoupon
      availableResources {
        id
        name
        logoUrl
        maxAttendees
      }
    }
  }
}
    `;
export const GetResourcesBasic = gql`
    query GetResourcesBasic($filtering: ResourcesFiltering) {
  resources(filtering: $filtering) {
    data {
      id
      name
      location {
        id
        name
      }
    }
  }
}
    `;
export const GetResourcesBookliScreen = gql`
    query GetResourcesBookliScreen($filtering: ResourcesFiltering) {
  resources(filtering: $filtering) {
    data {
      id
      name
      logoUrl
      currentBooking {
        id
        startDate
        endDate
        owner {
          firstName
        }
      }
      nextBooking {
        id
        startDate
        endDate
        owner {
          firstName
        }
      }
    }
  }
}
    `;
export const GetResourcesForTimeLine = gql`
    query GetResourcesForTimeLine($filtering: ResourcesFiltering) {
  resources(filtering: $filtering) {
    data {
      id
      name
      shortName
      logoUrl
      popularity
      type {
        id
        name
        category {
          id
          name
          weekdayOpenTime
          weekendOpenTime
        }
      }
      location {
        id
        name
        company {
          id
          timezone
        }
      }
    }
  }
}
    `;
export const GetResourcesGetAvailable = gql`
    query GetResourcesGetAvailable($location: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  resourcesGetAvailable(
    location: $location
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    name
  }
}
    `;
export const GetResourcesLocationTimeline = gql`
    query GetResourcesLocationTimeline($resourceCategory: ID, $date: DateTime!, $location: ID!, $isPublic: Boolean) {
  resourcesLocationTimeline(
    resourceCategory: $resourceCategory
    date: $date
    location: $location
    isPublic: $isPublic
  ) {
    openTimeUtc
    closeTimeUtc
    reservationTypeColors
    latestDateForBooking
    resourceTypes {
      id
      name
      pricesForDate(date: $date) {
        startDate
        endDate
        pricePerHourString
        priceType
      }
    }
    resources {
      id
      name
      shortName
      logoUrl
      popularity
      typeId
    }
    resourceBookings {
      id
      startDate
      endDate
      resourceId
      description
      color
      hasInternalNotes
    }
  }
}
    `;
export const GetResourcesSimple = gql`
    query GetResourcesSimple($filtering: ResourcesFiltering) {
  resources(filtering: $filtering) {
    data {
      id
      name
      shortName
      logoUrl
      isActive
      popularity
    }
  }
}
    `;
export const GetResourceBooking = gql`
    query GetResourceBooking($id: ID!) {
  resourceBooking(id: $id) {
    id
    createdAt
    startDate
    endDate
    status
    duractionMinuts
    comments
    internalNotes
    userCanCancelBooking
    allowAddingAttendees
    attendeesCount
    lightsWillTurnOn
    reservationType
    additionalService {
      id
      name
    }
    resourceBookingAttendeesTokenData
    dynamicPriceUsages {
      id
      quantity
      price {
        id
        price
      }
      priceffDynamicPriceResource {
        id
      }
    }
    partOfRecurringResourceBooking {
      id
      name
    }
    workshopDay {
      id
      workshop {
        id
        title
      }
    }
    myAttendee {
      id
      accessCodeAccessTime {
        id
        accessCode {
          id
          pinCode
        }
      }
    }
    accessCodeAccessTime {
      id
      accessCode {
        pinCode
        id
      }
    }
    owner {
      id
      name
    }
    payment {
      id
      moneyValue
      paymentMethod
      status
      currency
      platformFeeAmount
      connectedPayments {
        paymentMethod
        platformFeeAmount
      }
    }
    bookingAttendees {
      id
      user {
        id
        name
        isFriends
      }
      accessCodeAccessTime {
        id
        accessCode {
          id
        }
      }
      payments {
        id
        paymentMethod
        moneyValue
        status
      }
      canBeDeleted
      ableToPayDiscountedPayment
    }
    resource {
      id
      name
      maxAttendees
      type {
        id
        name
        description
        category {
          id
          maxMinutsBeforeCancellation
        }
      }
      company {
        id
        name
        phoneNumber
      }
      location {
        id
        name
      }
    }
  }
}
    `;
export const GetResourceBookingAttendees = gql`
    query GetResourceBookingAttendees($id: ID!) {
  resourceBooking(id: $id) {
    id
    attendeesCount
    bookingAttendees {
      id
      user {
        id
        name
      }
      accessCodeAccessTime {
        id
        accessCode {
          id
        }
      }
      payments {
        id
        paymentMethod
        moneyValue
        status
      }
    }
    resource {
      id
      maxAttendees
    }
  }
}
    `;
export const GetResourceBookingCanCreateSmall = gql`
    query GetResourceBookingCanCreateSmall {
  resourceBookingCanCreateSmall {
    startDate
    endDate
    resource {
      id
      name
    }
  }
}
    `;
export const GetResourceBookingCard = gql`
    query GetResourceBookingCard($id: ID!) {
  resourceBooking(id: $id) {
    id
    startDate
    endDate
    additionalService {
      id
      name
    }
    resource {
      id
      name
      shortName
      type {
        id
        name
      }
      location {
        id
        name
        streetName
        zipCode
        city
      }
    }
  }
}
    `;
export const GetResourceBookingCreated = gql`
    query GetResourceBookingCreated($id: ID!) {
  resourceBooking(id: $id) {
    id
    startDate
    endDate
  }
}
    `;
export const GetResourceBookingForBookliVideo = gql`
    query GetResourceBookingForBookliVideo($id: ID!) {
  resourceBooking(id: $id) {
    id
    canGenerateBookliVideo
    bookliVideo {
      id
    }
  }
}
    `;
export const GetResourceBookingForCalendar = gql`
    query GetResourceBookingForCalendar($id: ID!) {
  resourceBooking(id: $id) {
    id
    startDate
    endDate
    duractionMinuts
    bookingAttendees {
      id
      accessCodeAccessTime {
        id
        accessCode {
          id
          pinCode
        }
      }
      user {
        id
        name
      }
    }
    resource {
      id
      name
      location {
        id
        lat
        lng
        name
        streetName
        zipCode
        city
      }
    }
  }
}
    `;
export const GetResourceBookingForShare = gql`
    query GetResourceBookingForShare($id: ID!) {
  resourceBooking(id: $id) {
    id
    createdAt
    startDate
    endDate
    duractionMinuts
    resource {
      id
      name
      location {
        id
        name
      }
    }
  }
}
    `;
export const GetResourceBookingIsValid = gql`
    query GetResourceBookingIsValid($resource: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  resourceBookingIsValid(
    resource: $resource
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export const GetResourceBookingPayments = gql`
    query GetResourceBookingPayments($id: ID!) {
  resourceBooking(id: $id) {
    id
    additionalService {
      id
      name
    }
    internalNotes
    attendeesTokenData {
      userId
      isUser
      restMoneyValue
      value
      discountValue
      messageLines
      number
      user {
        id
        name
      }
    }
    paymentsFormated {
      additionalServiceValue
      displayName
      paidFormated
      payment {
        id
        status
        createdAt
        paymentMethod
        additionalServiceValue
        pointBounty {
          id
          amount
          pointAccountId
        }
      }
    }
  }
}
    `;
export const ResourceBookingValidateCancellation = gql`
    query ResourceBookingValidateCancellation($id: ID!, $refundPayment: Boolean) {
  resourceBookingValidateCancellation(id: $id, refundPayment: $refundPayment) {
    canCancel
    canGetFullRefund
    deductedAmount
    refundAmount
  }
}
    `;
export const GetResourceBookings = gql`
    query GetResourceBookings($filtering: ResourceBookingsFiltering, $pagination: PaginationInput) {
  resourceBookings(filtering: $filtering, pagination: $pagination) {
    data {
      id
      startDate
      endDate
      status
      comments
      reservationType
      owner {
        id
        name
      }
      resource {
        id
        maxAttendees
      }
    }
  }
}
    `;
export const ResourceBookingsConflicting = gql`
    query ResourceBookingsConflicting {
  resourceBookingsConflicting {
    id
    startDate
    comments
    owner {
      id
      name
    }
  }
}
    `;
export const GetResourceBookingsTimelinePublic = gql`
    query GetResourceBookingsTimelinePublic($filtering: ResourceBookingsFiltering, $pagination: PaginationInput) {
  resourceBookings(filtering: $filtering, pagination: $pagination) {
    data {
      id
      startDate
      endDate
      resource {
        id
      }
    }
  }
}
    `;
export const GetResourceBookingRecurring = gql`
    query GetResourceBookingRecurring($id: ID!) {
  resourceBookingRecurring(id: $id) {
    id
    name
    createdAt
    startTimeDate
    endTimeDate
    startTime
    endTime
    startCreateDate
    endCreateDate
    createCyclesInAdvance
    days
    active
    reservationType
    resources {
      id
      name
    }
    resourceBookings {
      id
      startDate
      endDate
    }
    creator {
      id
      name
    }
    connectedToUser {
      id
      name
    }
    connectedToUserGroup {
      id
      name
    }
    attendees {
      id
      name
    }
  }
}
    `;
export const GetResourceBookingRecurrings = gql`
    query GetResourceBookingRecurrings($pagination: PaginationInput, $filtering: ResourceBookingRecurringsFiltering) {
  resourceBookingRecurrings(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      name
      startTimeDate
      endTimeDate
      active
    }
  }
}
    `;
export const GetAllShortStringMappings = gql`
    query GetAllShortStringMappings {
  getAllShortStringMappings {
    shortString
    fullString
  }
}
    `;
export const GetStripeConnectLink = gql`
    query GetStripeConnectLink {
  stripeConnectLink
}
    `;
export const GetStripeConnection = gql`
    query GetStripeConnection {
  stripeDashboardLink
}
    `;
export const GetStripeGetSetupIntent = gql`
    query GetStripeGetSetupIntent {
  stripeGetSetupIntent {
    stripeEphemeralKey
    stripeIntentClientSecret
    stripeCustomerId
  }
}
    `;
export const GetStripeInvoice = gql`
    query GetStripeInvoice($id: ID!) {
  stripeInvoice(id: $id) {
    id
    status
    user {
      id
      name
    }
    payments {
      id
    }
  }
}
    `;
export const GetStripeReport = gql`
    query GetStripeReport($id: ID!) {
  stripeReport(id: $id) {
    id
    intervalStart
    intervalEnd
    status
    fileName
    createdAt
    result
    generatedByUser {
      id
      firstName
    }
  }
}
    `;
export const GetStripeReports = gql`
    query GetStripeReports($pagination: PaginationInput) {
  stripeReports(pagination: $pagination) {
    hasMore
    totalCount
    data {
      id
      intervalStart
      intervalEnd
      type
      status
      createdAt
    }
  }
}
    `;
export const GetSubscriptionProductCategories = gql`
    query GetSubscriptionProductCategories {
  subscriptionProductCategories {
    data {
      id
      name
    }
  }
}
    `;
export const GetSubscriptionProductCategory = gql`
    query GetSubscriptionProductCategory($id: ID!) {
  subscriptionProductCategory(id: $id) {
    id
    name
  }
}
    `;
export const GetSubscriptionProductGiftCardValidate = gql`
    query GetSubscriptionProductGiftCardValidate($subscriptionProductGiftCardCode: String!, $subscriptionProduct: ID!) {
  subscriptionProductGiftCardValidate(
    subscriptionProductGiftCardCode: $subscriptionProductGiftCardCode
    subscriptionProduct: $subscriptionProduct
  )
}
    `;
export const GetSubscriptionProductGiftCards = gql`
    query GetSubscriptionProductGiftCards($subscriptionProduct: ID!, $pagination: PaginationInput) {
  subscriptionProductGiftCards(
    subscriptionProduct: $subscriptionProduct
    pagination: $pagination
  ) {
    totalCount
    hasMore
    data {
      id
      code
      validUntil
      isActive
      startAfterPeriods
      note
    }
  }
}
    `;
export const GetSubscriptionProduct = gql`
    query GetSubscriptionProduct($id: ID!) {
  subscriptionProduct(id: $id) {
    id
    name
    accessCodeDoorGroup
    description
    countUserSubscriptions
    allowPublicSignUp
    paymentOnTheFirstOfMonth
    category {
      id
      name
    }
    couponOnOtherPayments {
      id
      percentOff
      resourceBookingTimeRanges {
        startTime
        endTime
        days
      }
    }
    couponOnEvents {
      id
      percentOff
      maximumUsagesPrCustomer
      maximumUsagesPrCustomerPrMonth
    }
    signUpRules {
      type
      ruleAgeType
      ruleAge
    }
    usageRules {
      type
      resourceBookingStartTime
      resourceBookingEndTime
      resourceBookingDays
    }
    product {
      id
      price
    }
    company {
      id
      name
    }
    signUpFeeProduct {
      id
      price
    }
    daysBeforeFirstPayment
    startDateForFirstPayment
    activeBeforeFirstPayment
    startDateForFirstPaymentCompanies {
      id
      startAfterPeriods
      validStartDate
      validEndDate
      companies {
        id
        name
      }
      toDate
    }
    paymentMaxCoverType
    paymentMaxHoursCovered
    paymentMaxValueCovered
    paymentMaxActiveBookingsPerMonth
    paymentDiscountType
    paymentDiscountAmount
    paymentDiscountPercentage
    paymentDiscountAmountPrBookingInterval
    paymentCyclesAfterCancele
    onlyPayOnResourceTypes {
      id
      name
    }
    maxActiveBookings
    maxNumberOfActiveSubscriptions
    maxDaysCreateResourceBookingAhead
    paymentDiscountIsOnlyInBTime
    paymentTimesPrYear
    canBeUsedOnWorkshops
  }
}
    `;
export const GetSubscriptionProductForUserCreate = gql`
    query GetSubscriptionProductForUserCreate {
  subscriptionProducts {
    data {
      id
      name
      product {
        id
        price
      }
    }
  }
}
    `;
export const GetSubscriptionProductForUser = gql`
    query GetSubscriptionProductForUser($id: ID!) {
  subscriptionProduct(id: $id) {
    id
    name
    description
    countUserSubscriptions
    userProductSubscription {
      id
      status
      createdAt
      userCanCancel
      cancelDate
      posibleCancelDate
      company {
        id
        name
      }
      latestPayment {
        id
        status
        invoiceUrl
      }
    }
    couponOnOtherPayments {
      id
      percentOff
    }
    product {
      id
      price
    }
    activeBeforeFirstPayment
    startDateForFirstPayment
    startDateForFirstPaymentUser
    signUpFeeProduct {
      id
      price
    }
  }
}
    `;
export const GetSubscriptionProducts = gql`
    query GetSubscriptionProducts {
  subscriptionProducts {
    totalCount
    hasMore
    data {
      id
      name
      description
      paymentMaxCoverType
      paymentMaxHoursCovered
      paymentMaxValueCovered
      paymentDiscountType
      paymentDiscountAmount
      paymentDiscountAmountPrBookingInterval
      paymentDiscountPercentage
      userAllowedToSignUp
      paymentTimesPrYear
      maxActiveBookings
      startDateForFirstPaymentUser
      company {
        id
        name
      }
      signUpFeeProduct {
        id
        price
      }
      userProductSubscription {
        id
        status
        cancelDate
        latestPayment {
          status
        }
      }
      couponOnOtherPayments {
        id
        percentOff
      }
      product {
        id
        price
      }
    }
  }
}
    `;
export const GetTrinityEComGetProduct = gql`
    query GetTrinityEComGetProduct($product: Int!, $country: SupportedCountries!) {
  trinityEComGetProduct(product: $product, country: $country) {
    id
    name
    articles {
      sku
      name
      deliverableStockValue
      storeStockValue
    }
    basePrice
    catalogueId
    deliverableStockValue
    deliveryDaysMax
    deliveryDaysMin
    description {
      lead
      fullDescription
    }
    filterData {
      categories
      propertyItems
      stockOnHand
    }
    images
    price
    primaryImageSmallUrl
    ribbon {
      title
    }
    sku
    shippingGroupId
    storeStockValue
    propertyValues {
      id
      type
      name
      value
      valueItems {
        id
        name
      }
    }
    stockValues {
      stockId
      productId
      sku
      value
    }
  }
}
    `;
export const GetTrinityEComGetProductCatalog = gql`
    query GetTrinityEComGetProductCatalog($category: Int!, $categoryType: TrinityEcomCategoryType!, $parameters: TrinityEComProductCatalogParameters!, $country: SupportedCountries!) {
  trinityEComGetProductCatalog(
    category: $category
    categoryType: $categoryType
    parameters: $parameters
    country: $country
  ) {
    totalCount
    totalPageCount
    currentPage
    pageSize
    products {
      id
      catalogueId
      name
      sku
      primaryImageSmallUrl
      price
      basePrice
    }
  }
}
    `;
export const TrinityEComGetTermsAndConditions = gql`
    query TrinityEComGetTermsAndConditions($country: SupportedCountries!) {
  trinityEComGetTermsAndConditions(country: $country) {
    bodyHtml
  }
}
    `;
export const GetTrinityEComReferenceData = gql`
    query GetTrinityEComReferenceData($country: SupportedCountries!) {
  trinityEComReferenceData(country: $country) {
    currencyCode
    categories {
      id
      parentId
      name
      type
    }
    stocks {
      id
      name
    }
    shippingTypes {
      id
      shippingGroupId
      name
      description
      imageFileName
      sortOrder
      shippingFees {
        thresholdOrderAmount
        price
        name
        vatPercent
        vatSum
      }
    }
  }
}
    `;
export const GetTrinityEComGetCheckoutOrder = gql`
    query GetTrinityEComGetCheckoutOrder($checkoutToken: String!, $country: SupportedCountries!) {
  trinityEcomCheckoutOrder(checkoutToken: $checkoutToken, country: $country) {
    success
    customerOrder {
      id
      customerName
      items {
        name
        quantity
        itemTotalSum
        type
      }
      totalSum
      createdUtc
      discountCode
      addressContainer {
        billingAddress {
          companyName
          recipient
          address1
          address2
          postCode
          city
          country
        }
        deliveryAddress {
          companyName
          recipient
          address1
          address2
          postCode
          city
          country
        }
        hasSeparateDeliveryAddress
      }
    }
  }
}
    `;
export const GetTrinityEComGetOrderHistory = gql`
    query GetTrinityEComGetOrderHistory($country: SupportedCountries!) {
  trinityEcomOrderHistory(country: $country) {
    id
    checkoutToken
    handlingStatus
    items {
      name
      quantity
      itemTotalSum
      type
    }
    deliveries {
      id
      erpDeliveryNumber
      createdUtc
      deliveryDate
      shipmentReference
      trackingReference
      trackingUrl
    }
    totalSum
    createdUtc
    addressContainer {
      billingAddress {
        companyName
        recipient
        address1
        address2
        postCode
        city
        country
      }
      deliveryAddress {
        companyName
        recipient
        address1
        address2
        postCode
        city
        country
      }
      hasSeparateDeliveryAddress
    }
  }
}
    `;
export const CheckForSavedStripeSource = gql`
    query CheckForSavedStripeSource {
  me {
    user {
      id
      haveSavedStripeSource
    }
  }
}
    `;
export const GetPointAmount = gql`
    query GetPointAmount {
  me {
    pointAccount {
      id
      pointsAmount
    }
  }
}
    `;
export const GetUserAccountPage = gql`
    query GetUserAccountPage {
  me {
    user {
      id
    }
  }
}
    `;
export const GetUserAuth = gql`
    query GetUserAuth {
  me {
    role
    hasAdminRole
    country
    currency
    user {
      id
      firstName
      lastName
      language
    }
    company {
      id
      usingEcom
    }
    userPlatformConnection {
      id
    }
  }
}
    `;
export const GetUserInformation = gql`
    query GetUserInformation {
  me {
    user {
      email
      firstName
      lastName
      streetName
      zipCode
      city
      country
      phoneCountryCode
      phoneNumberWithoutCountryCode
      businessUser {
        businessName
        vatNumber
      }
    }
  }
}
    `;
export const GetMeWelcomePage = gql`
    query GetMeWelcomePage {
  me {
    user {
      id
      firstName
      lastName
      email
      accessCode {
        id
        pinCode
        fullAccessToDoors {
          id
        }
        fullAccessToDoorGroups {
          id
        }
      }
      bookingNext {
        ... on ResourceBooking {
          id
          startDate
          endDate
          resource {
            name
            type {
              id
              name
            }
            location {
              id
              name
              streetName
              zipCode
              city
            }
          }
        }
        ... on WorkshopBooking {
          id
          workshop {
            id
            title
            location {
              id
              name
              streetName
              zipCode
              city
            }
            nextDay {
              id
              title
              startDate
              endDate
            }
          }
        }
      }
    }
    franchise {
      id
      name
    }
    company {
      id
      name
      usingPointProducts
      usingSubscriptionProducts
      usingEcom
    }
    pointAccount {
      id
      pointsAmount
    }
    userGroupsPointAccount {
      id
      pointsAmount
      company {
        id
        name
      }
      userGroup {
        id
        name
        company {
          id
          name
        }
      }
    }
    pointAccountsOutsideOfCurrentCompany {
      id
      pointsAmount
      company {
        id
        name
      }
    }
    userActiveProductSubscription {
      id
      subscriptionProduct {
        id
        name
      }
    }
  }
}
    `;
export const GetUpdateUserInfo = gql`
    query GetUpdateUserInfo($id: ID) {
  user(id: $id) {
    id
    firstName
    lastName
    zipCode
    city
    streetName
    phoneNumber
    email
    country
    businessUser {
      businessName
      vatNumber
    }
  }
}
    `;
export const GetUpdateUserInfoAdmin = gql`
    query GetUpdateUserInfoAdmin($id: ID) {
  user(id: $id) {
    id
    firstName
    lastName
    phoneNumber
    email
    country
    businessUser {
      businessName
      vatNumber
    }
  }
}
    `;
export const GetUserActivities = gql`
    query GetUserActivities($filtering: UserActivitiesFiltering) {
  userActivities(filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      type
      value
      createdAt
    }
  }
}
    `;
export const GetUserBasic = gql`
    query GetUserBasic($id: ID, $idEmailPhone: String) {
  user(id: $id, idEmailPhone: $idEmailPhone) {
    id
    name
  }
}
    `;
export const GetUserSignInMethod = gql`
    query GetUserSignInMethod($emailAddress: String) {
  signInMethod(emailAddress: $emailAddress) {
    userSignInMethod
  }
}
    `;
export const GetUserStripe = gql`
    query GetUserStripe {
  user {
    id
    haveSavedStripeSource
    stripeSources {
      id
      last4
      expMonth
      expYear
      brand
      isDefaultCard
    }
  }
}
    `;
export const Agreements = gql`
    query Agreements {
  agreements {
    data {
      id
      name
      type
      createdAt
      documentUrl
      userAccptedAgreementsCount
      userAgreementsCount
      usersTotal
    }
  }
}
    `;
export const GetAgreementsForCompanyIsUpdated = gql`
    query GetAgreementsForCompanyIsUpdated {
  agreementsForCompanyIsUpdated {
    id
    name
    requiredAccept
    documentUrl
  }
}
    `;
export const GetAgreementsForCompanySignUp = gql`
    query GetAgreementsForCompanySignUp {
  agreementsForCompanySignUp {
    id
    name
    requiredAccept
    documentUrl
    description
  }
}
    `;
export const GetAgreementsForUser = gql`
    query GetAgreementsForUser($filtering: AgreementsForUserFiltering) {
  agreementsForUser(filtering: $filtering) {
    id
    name
    type
    requiredAccept
    documentUrl
    description
  }
}
    `;
export const GetAgreementsForCreateUserProductSubscription = gql`
    query GetAgreementsForCreateUserProductSubscription {
  agreementsForCreateUserProductSubscription {
    id
    name
    requiredAccept
    documentUrl
    description
  }
}
    `;
export const GetUserAgreements = gql`
    query GetUserAgreements {
  userAgreements {
    hasMore
    totalCount
    data {
      id
      accepted
      agreement {
        name
        createdAt
        documentUrl
        description
      }
    }
  }
}
    `;
export const GetUserBasics = gql`
    query GetUserBasics($id: ID) {
  user(id: $id) {
    id
    name
    firstName
    lastName
    city
    zipCode
    email
    phoneNumber
    country
    createdAt
    isDeleted
    lat
    lng
    userSignInMethod
    stripeCustomerUrl
    haveSavedStripeSource
    accessCode {
      id
      pinCode
    }
    resourceBookingsPrWeek {
      prWeekRatio
      pastWeekRatio
      averageRatio
      diffBetweenPastWeekAndAverageRatio
    }
    recurringBookingsAttendee {
      id
      name
    }
    groups {
      id
      name
    }
    userProductSubscriptions {
      id
      status
      subscriptionProduct {
        id
        name
      }
    }
    businessUser {
      businessName
      vatNumber
    }
  }
}
    `;
export const GetUserCompanies = gql`
    query GetUserCompanies($userAuthToken: String!) {
  userCompanies(userAuthToken: $userAuthToken) {
    id
    name
    streetName
    zipCode
  }
}
    `;
export const GetUserGroup = gql`
    query GetUserGroup($id: ID!) {
  userGroup(id: $id) {
    id
    name
    usersCount
    createdAt
    automaticAddUsersWithEmailEnding
    maxDaysCreateResourceBookingAhead
    maxUserLimit
    adminsCanHandleUsers
    automaticSubscriptionProduct {
      id
      name
    }
    pointAccount {
      id
      active
    }
    coupons {
      id
      slug
      active
    }
    users {
      isGroupAdmin
      user {
        id
        name
      }
    }
  }
}
    `;
export const UserGroupUserAdmin = gql`
    query UserGroupUserAdmin($id: ID!, $startDate: DateTime, $endDate: DateTime) {
  userGroup(id: $id) {
    id
    name
    adminsCanHandleUsers
    maxUserLimit
    usersCount
    pointAccount {
      id
      pointsAmount
    }
    users {
      user {
        id
        name
      }
      pointUsage(startDate: $startDate, endDate: $endDate)
    }
  }
}
    `;
export const GetUserGroups = gql`
    query GetUserGroups($pagination: PaginationInput, $filtering: UserGroupsFiltering) {
  userGroups(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      name
      usersCount
      pointAccount {
        id
        active
        pointsAmount
        usedTheLastXDays
      }
      automaticSubscriptionProduct {
        id
        name
      }
      coupons {
        id
        slug
      }
    }
  }
}
    `;
export const GetUserGroupsUser = gql`
    query GetUserGroupsUser {
  userGroups {
    hasMore
    totalCount
    data {
      id
      name
      userIsGroupAdmin
    }
  }
}
    `;
export const GetUserPlatformConnections = gql`
    query GetUserPlatformConnections($filtering: UserPlatformConnectionsFiltering) {
  userPlatformConnections(filtering: $filtering) {
    data {
      id
      user {
        id
        email
        name
      }
    }
  }
}
    `;
export const GetUserPlatformConnectionsBySignedInUser = gql`
    query GetUserPlatformConnectionsBySignedInUser($userId: ID!) {
  userPlatformConnectionsBySignedInUser(userId: $userId) {
    id
    company {
      id
      name
    }
  }
}
    `;
export const GetUserPlatformConnectionTokens = gql`
    query GetUserPlatformConnectionTokens($filtering: UserPlatformConnectionTokensFiltering) {
  userPlatformConnectionTokens(filtering: $filtering) {
    data {
      id
      email
      createdAt
    }
  }
}
    `;
export const GetUserProductSubscriptionPaymentUserCanDoResult = gql`
    query GetUserProductSubscriptionPaymentUserCanDoResult($product: ID!) {
  userProductSubscriptionPaymentUserCanDo(product: $product) {
    canDo
    userProductSubscriptionId
    userProductSubscription {
      id
      subscriptionProduct {
        id
        name
      }
    }
  }
}
    `;
export const GetUserProductSubscription = gql`
    query GetUserProductSubscription($id: ID!) {
  userProductSubscription(id: $id) {
    id
    createdAt
    status
    paymentsSum
    usedOnPaymentsCount
    posibleCancelDate
    subscriptionPlatform
    cancelDate
    connectedTo
    company {
      id
      name
    }
    latestSuccessfulPayment {
      id
      moneyValue
    }
    addedByUserGroup {
      id
      name
    }
    subscriptionProduct {
      id
      name
    }
    usedOnPayments {
      id
      createdAt
    }
    payments {
      id
      status
      moneyValue
      createdAt
    }
    user {
      id
      name
    }
    createdByAdmin {
      id
      name
    }
  }
}
    `;
export const GetUserProductSubscriptionActivity = gql`
    query GetUserProductSubscriptionActivity($userProductSubscription: ID!) {
  userProductSubscriptionActivity(
    userProductSubscription: $userProductSubscription
  ) {
    hasMore
    totalCount
    data {
      id
      type
      createdAt
    }
  }
}
    `;
export const GetUserProductSubscriptions = gql`
    query GetUserProductSubscriptions($pagination: PaginationInput, $filtering: UserProductSubscriptionsFiltering) {
  userProductSubscriptions(pagination: $pagination, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      status
      subscriptionPlatform
      createdAt
      cancelDate
      subscriptionProduct {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
}
    `;
export const GetUsers = gql`
    query GetUsers($pagination: PaginationInput, $company: ID, $filtering: UsersFiltering) {
  users(pagination: $pagination, company: $company, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      email
      name
      phoneNumber
      createdAt
      businessUser {
        id
      }
    }
  }
}
    `;
export const GetUsersBasic = gql`
    query GetUsersBasic($pagination: PaginationInput, $company: ID, $filtering: UsersFiltering) {
  users(pagination: $pagination, company: $company, filtering: $filtering) {
    hasMore
    totalCount
    data {
      id
      name
    }
  }
}
    `;
export const GetWannasportConnection = gql`
    query GetWannasportConnection($location: ID!) {
  wannasportConnection(location: $location) {
    id
    pointAccount {
      id
      pointsAmount
    }
    possibleTimeSlotsFormated {
      days
      times
    }
  }
}
    `;
export const GetWannasportPointCheck = gql`
    query GetWannasportPointCheck {
  wannasportPointCheck
}
    `;
export const GetWorkshopBookingForCalendar = gql`
    query GetWorkshopBookingForCalendar($id: ID!) {
  workshopBooking(id: $id) {
    id
    workshop {
      title
      location {
        id
        name
        lat
        lng
        streetName
        zipCode
        city
      }
      nextDay {
        id
        startDate
        endDate
        userWorkshopBookingAccessCode {
          id
          pinCode
        }
      }
    }
  }
}
    `;
export const GetWorkshop = gql`
    query GetWorkshop($id: ID!) {
  workshop(id: $id) {
    id
    title
    status
    type
    waitlistCount
    product {
      id
      price
      payWithSubscriptionIsOfAType
    }
    lastRegistrationDate
    allowUserProductSubscriptionPayment
    description
    userCanCreateBooking
    maxRegistrations
    daysCount
    paymentsSum
    bookingsCount
    privateWorkshop
    privateWorkshopKey
    userBooking {
      id
      userCanCancelBooking
    }
    days {
      id
      title
      startDate
      endDate
      description
      resourceBookings {
        id
        resource {
          id
          name
        }
      }
    }
  }
}
    `;
export const GetWorkshopBooking = gql`
    query GetWorkshopBooking($id: ID!) {
  workshopBooking(id: $id) {
    id
  }
}
    `;
export const GetWorkshopBookingButton = gql`
    query GetWorkshopBookingButton($id: ID!) {
  workshop(id: $id) {
    id
    maxRegistrations
    userCanCreateBooking
    title
    userIsOnWaitlist
    bookingsCount
    requireUserBookingNote
    requiredUserBookingNoteTitle
    privateWorkshop
    privateWorkshopKey
    userBooking {
      id
      userCanCancelBooking
    }
    product {
      id
      price
    }
  }
}
    `;
export const GetWorkshopBookingCard = gql`
    query GetWorkshopBookingCard($id: ID!) {
  workshopBooking(id: $id) {
    id
    workshop {
      id
      title
      location {
        id
        name
        streetName
        zipCode
        city
      }
      nextDay {
        id
        startDate
        endDate
      }
      days {
        id
        title
        startDate
        endDate
      }
    }
  }
}
    `;
export const GetWorkshopBookings = gql`
    query GetWorkshopBookings($workshop: ID!, $pagination: PaginationInput, $filtering: WorkshopBookingsFiltering) {
  workshopBookings(
    workshop: $workshop
    pagination: $pagination
    filtering: $filtering
  ) {
    totalCount
    hasMore
    data {
      id
      status
      createdAt
      userBookingNote
      payment {
        id
        paymentMethod
      }
      user {
        id
        name
        email
        phoneNumber
      }
    }
  }
}
    `;
export const GetWorkshopUser = gql`
    query GetWorkshopUser($id: ID!) {
  workshop(id: $id) {
    id
    title
    type
    product {
      id
      price
    }
    lastRegistrationDate
    description
    maxRegistrations
    privateWorkshop
    days {
      id
      title
      startDate
      endDate
      description
    }
    participantList {
      user {
        firstName
        lastName
      }
    }
  }
}
    `;
export const GetWorkshops = gql`
    query GetWorkshops($filtering: WorkshopsFiltering, $pagination: PaginationInput) {
  workshops(filtering: $filtering, pagination: $pagination) {
    data {
      id
      title
      lastRegistrationDate
      maxRegistrations
      type
      bookingsCount
      waitlistCount
      userCanCreateBooking
      userIsOnWaitlist
      requireUserBookingNote
      requiredUserBookingNoteTitle
      privateWorkshop
      privateWorkshopKey
      userBooking {
        id
        userCanCancelBooking
      }
      nextDay {
        id
        startDate
        endDate
      }
      days {
        id
        title
        startDate
        endDate
      }
      product {
        id
        price
      }
    }
  }
}
    `;
export const GetWorkshopsForCalendar = gql`
    query GetWorkshopsForCalendar($filtering: WorkshopsFiltering, $pagination: PaginationInput) {
  workshops(filtering: $filtering, pagination: $pagination) {
    data {
      id
      title
      maxRegistrations
      type
      bookingsCount
      waitlistCount
      typeColor
      days {
        id
        startDate
        endDate
      }
    }
  }
}
    `;
export const GetWorkshopWaitlist = gql`
    query GetWorkshopWaitlist($workshop: ID!, $pagination: PaginationInput) {
  workshopWaitlist(workshop: $workshop, pagination: $pagination) {
    hasMore
    totalCount
    data {
      id
      createdAt
      user {
        id
        name
      }
    }
  }
}
    `;
export const BookliScreenHealth = gql`
    subscription BookliScreenHealth($location: ID) {
  bookliScreenHealth(location: $location) {
    shouldReload
  }
}
    `;
export const BookliVideoSubscription = gql`
    subscription BookliVideoSubscription($id: ID!) {
  bookliVideo(id: $id) {
    id
    streamUrl
    state
    type
    downloadUrl
  }
}
    `;
export const AccessCodeUsageSubscription = gql`
    subscription AccessCodeUsageSubscription($controllerDoor: ID) {
  accessCodeUsage(controllerDoor: $controllerDoor) {
    dataForMessage {
      name
      currentBooking {
        id
        startDate
        endDate
        resource {
          id
          name
        }
      }
      nextBooking {
        id
        startDate
        endDate
        resource {
          id
          name
        }
      }
    }
  }
}
    `;
export const SubscribeControllerOnOffNoxStateChange = gql`
    subscription SubscribeControllerOnOffNoxStateChange($controllerUrl: String!) {
  controllerOnOffNoxStateChange(controllerUnitUrl: $controllerUrl) {
    controllerUnitUrl
    timeOfLastAreaStateChange
  }
}
    `;
export const SubscribeInvoicePaid = gql`
    subscription SubscribeInvoicePaid($subscriptionId: String!) {
  invoicePaid(subscriptionId: $subscriptionId) {
    invoiceId
    subscriptionId
    paymentIntentId
    status
  }
}
    `;
export const SubscribeLocationOverviewResources = gql`
    subscription SubscribeLocationOverviewResources($location: ID, $onlyForActiveBookings: Boolean, $resources: [ID]) {
  resourceChange(
    location: $location
    onlyForActiveBookings: $onlyForActiveBookings
    resources: $resources
  ) {
    changeType
    resource {
      id
      location {
        id
        overviewSvg
      }
      name
      logoUrl
      currentBooking {
        id
        status
        owner {
          id
          name
          firstName
        }
      }
    }
  }
}
    `;
export const SubscribeLocationOverviewResourcesV2 = gql`
    subscription SubscribeLocationOverviewResourcesV2($location: ID, $onlyForActiveBookings: Boolean, $resources: [ID], $showCurrentBooking: Boolean, $showResourceName: Boolean, $highlightResourceId: String) {
  resourceChange(
    location: $location
    onlyForActiveBookings: $onlyForActiveBookings
    resources: $resources
  ) {
    changeType
    resource {
      id
      location {
        id
        overviewSvg(
          showCurrentBooking: $showCurrentBooking
          showResourceName: $showResourceName
          highlightResourceId: $highlightResourceId
        )
      }
    }
  }
}
    `;
export const SubscribeLocationScreenWelcomeMessage = gql`
    subscription SubscribeLocationScreenWelcomeMessage($location: ID!) {
  locationScreenWelcomeMessage(location: $location)
}
    `;
export const PaymentTokenSubscription = gql`
    subscription PaymentTokenSubscription($paymentToken: ID!) {
  paymentToken(paymentToken: $paymentToken) {
    paymentToken {
      id
      state
      failedReason
      amountToPay
      lastFailureReason
      attemptCount
    }
  }
}
    `;
export const QuickInfoUserChange = gql`
    subscription QuickInfoUserChange {
  quickInfoUserChange {
    user
  }
}
    `;
export const SubscribeResourceChange = gql`
    subscription SubscribeResourceChange($location: ID, $onlyForActiveBookings: Boolean, $resources: [ID!]) {
  resourceChange(
    location: $location
    onlyForActiveBookings: $onlyForActiveBookings
    resources: $resources
  ) {
    changeType
    resource {
      id
      location {
        id
        overviewSvg
      }
      name
      logoUrl
      currentBooking {
        id
        startDate
        endDate
        comments
        owner {
          id
          firstName
          lastName
        }
        workshopDay {
          id
          workshop {
            id
            title
          }
        }
      }
      nextBooking {
        id
        startDate
        endDate
        comments
        owner {
          id
          firstName
          lastName
        }
        workshopDay {
          id
          workshop {
            id
            title
          }
        }
      }
    }
  }
}
    `;
export const SubscribeWorkshopsFutureChanged = gql`
    subscription SubscribeWorkshopsFutureChanged($location: ID!) {
  workshopsFutureChanged(location: $location) {
    workshops {
      id
      title
      lastRegistrationDate
      maxRegistrations
      nextDay {
        id
        startDate
        endDate
      }
      product {
        id
        price
      }
    }
  }
}
    `;
export const SendPhoneVerificationCode = gql`
    mutation SendPhoneVerificationCode($phoneNumber: String!, $userData: UserCreateForVerification, $reCaptchaToken: String) {
  sendPhoneVerificationCode(
    phoneNumber: $phoneNumber
    userData: $userData
    reCaptchaToken: $reCaptchaToken
  ) {
    success
    message
  }
}
    `;
export const VerifyPhoneAndUpdateUser = gql`
    mutation VerifyPhoneAndUpdateUser($phoneNumber: String!, $code: String!, $companyId: ID, $userPlatformConnectionToken: String, $defaultLocation: ID) {
  verifyPhoneAndUpdateUser(
    phoneNumber: $phoneNumber
    code: $code
    companyId: $companyId
    userPlatformConnectionToken: $userPlatformConnectionToken
    defaultLocation: $defaultLocation
  ) {
    success
    user {
      id
      email
      firstName
      lastName
    }
    authToken
  }
}
    `;
export const VerifyPhone = gql`
    mutation VerifyPhone($phoneNumber: String!, $code: String!) {
  verifyPhone(phoneNumber: $phoneNumber, code: $code) {
    success
    existingUser {
      id
      email
      firstName
      lastName
      phoneNumber
      city
      streetName
      zipCode
      country
      language
      birthday
      gender
      businessUser {
        businessName
        vatNumber
      }
    }
    newUserData
    phoneNumber
  }
}
    `;
export const ConfirmPhoneVerificationUpdate = gql`
    mutation ConfirmPhoneVerificationUpdate($phoneNumber: String!, $code: String!, $confirmed: Boolean!, $companyId: ID, $userPlatformConnectionToken: String, $defaultLocation: ID) {
  confirmPhoneVerificationUpdate(
    phoneNumber: $phoneNumber
    code: $code
    confirmed: $confirmed
    companyId: $companyId
    userPlatformConnectionToken: $userPlatformConnectionToken
    defaultLocation: $defaultLocation
  ) {
    success
    user {
      id
      email
      firstName
      lastName
    }
    authToken
    message
  }
}
    `;